var gc = Object.defineProperty;
var fc = (t, e, n) => e in t ? gc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var U = (t, e, n) => (fc(t, typeof e != "symbol" ? e + "" : e, n), n);
import { SWAN_STYLE_KEY_MAP as ze, Typography as De, SkeletonText as yc, SkeletonTextLine as bc, Box as de, ErrorBoundary as vc, useScreenClass as gs, ModalDialog as Nr, ModalDialogContent as Tr, ModalDialogNav as Er, ModalDialogCloseButton as wr, ModalDialogBody as _r, UncustomizableMarkup as xr, Link as Je, Icon as fs, StandardForm as Sc, FormField as di, FormInputGroup as pi, DropdownWithFloatingLabel as Cc, Dropdown as Mc, DropdownOption as Dc, DropdownFloatingLabel as Nc, FlexBox as $t, TextInputWithFloatingLabel as Tc, TextInput as Ec, TextInputFloatingLabel as wc, FormError as hi, Button as _c, Spinner as xc, SelectionSet as kc, SelectionSetInput as Ac, SelectionSetLabel as Lc, ModalDialogHeader as Ic, ModalDialogTitle as Pc, H3 as Oc, H2 as Rc } from "@vp/swan";
import { jsx as N, Fragment as se, jsxs as oe } from "react/jsx-runtime";
import * as Ce from "react";
import mi, { createContext as _t, useContext as on, useState as ne, useRef as Ra, useEffect as Q, useCallback as Te, useMemo as Ye, memo as ue } from "react";
import * as pn from "@vp/ab-reader";
import { initialize as Fc, whenAvailable as jc, isFeatureEnabled as gi } from "@vp/ab-reader";
import { PresentationProvider as Bc, TokenEngine as Gc } from "@vp/vp-js-token-engine";
import { getTracking as Yc } from "@vp/tracking";
import Vc from "@vp/auth";
const Mf = [ze.button, ze.icon, ze.modalDialog, ze.popover, ze.pricing, ze.selectionSet, ze.spinner, ze.table], H = (t) => typeof t == "string", At = () => {
  let t, e;
  const n = new Promise((a, r) => {
    t = a, e = r;
  });
  return n.resolve = t, n.reject = e, n;
}, fi = (t) => t == null ? "" : "" + t, Hc = /###/g, yi = (t) => t && t.indexOf("###") > -1 ? t.replace(Hc, ".") : t, bi = (t) => !t || H(t), Vt = (t, e, n) => {
  const a = H(e) ? e.split(".") : e;
  let r = 0;
  for (; r < a.length - 1; ) {
    if (bi(t))
      return {};
    const i = yi(a[r]);
    !t[i] && n && (t[i] = new n()), t = Object.prototype.hasOwnProperty.call(t, i) ? t[i] : {}, ++r;
  }
  return bi(t) ? {} : { obj: t, k: yi(a[r]) };
}, vi = (t, e, n) => {
  const { obj: a, k: r } = Vt(t, e, Object);
  if (a !== void 0 || e.length === 1)
    return void (a[r] = n);
  let i = e[e.length - 1], o = e.slice(0, e.length - 1), s = Vt(t, o, Object);
  for (; s.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), s = Vt(t, o, Object), s?.obj && s.obj[`${s.k}.${i}`] !== void 0 && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = n;
}, Yn = (t, e) => {
  const { obj: n, k: a } = Vt(t, e);
  if (n && Object.prototype.hasOwnProperty.call(n, a))
    return n[a];
}, ys = (t, e, n) => {
  for (const a in e)
    a !== "__proto__" && a !== "constructor" && (a in t ? H(t[a]) || t[a] instanceof String || H(e[a]) || e[a] instanceof String ? n && (t[a] = e[a]) : ys(t[a], e[a], n) : t[a] = e[a]);
  return t;
}, yt = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Uc = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;" };
const $c = (t) => H(t) ? t.replace(/[&<>"'\/]/g, (e) => Uc[e]) : t, zc = [" ", ",", "?", "!", ";"], qc = new class {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const e = this.regExpMap.get(t);
    if (e !== void 0)
      return e;
    const n = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, n), this.regExpQueue.push(t), n;
  }
}(20), Fa = (t, e, n = ".") => {
  if (!t)
    return;
  if (t[e])
    return Object.prototype.hasOwnProperty.call(t, e) ? t[e] : void 0;
  const a = e.split(n);
  let r = t;
  for (let i = 0; i < a.length; ) {
    if (!r || typeof r != "object")
      return;
    let o, s = "";
    for (let l = i; l < a.length; ++l)
      if (l !== i && (s += n), s += a[l], o = r[s], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < a.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    r = o;
  }
  return r;
}, zt = (t) => t?.replace("_", "-"), Kc = { type: "logger", log(t) {
  this.output("log", t);
}, warn(t) {
  this.output("warn", t);
}, error(t) {
  this.output("error", t);
}, output(t, e) {
  console?.[t]?.apply?.(console, e);
} };
class Vn {
  constructor(e, n = {}) {
    this.init(e, n);
  }
  init(e, n = {}) {
    this.prefix = n.prefix || "i18next:", this.logger = e || Kc, this.options = n, this.debug = n.debug;
  }
  log(...e) {
    return this.forward(e, "log", "", !0);
  }
  warn(...e) {
    return this.forward(e, "warn", "", !0);
  }
  error(...e) {
    return this.forward(e, "error", "");
  }
  deprecate(...e) {
    return this.forward(e, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, n, a, r) {
    return r && !this.debug ? null : (H(e[0]) && (e[0] = `${a}${this.prefix} ${e[0]}`), this.logger[n](e));
  }
  create(e) {
    return new Vn(this.logger, { prefix: `${this.prefix}:${e}:`, ...this.options });
  }
  clone(e) {
    return (e = e || this.options).prefix = e.prefix || this.prefix, new Vn(this.logger, e);
  }
}
var Ae = new Vn();
class na {
  constructor() {
    this.observers = {};
  }
  on(e, n) {
    return e.split(" ").forEach((a) => {
      this.observers[a] || (this.observers[a] = /* @__PURE__ */ new Map());
      const r = this.observers[a].get(n) || 0;
      this.observers[a].set(n, r + 1);
    }), this;
  }
  off(e, n) {
    this.observers[e] && (n ? this.observers[e].delete(n) : delete this.observers[e]);
  }
  emit(e, ...n) {
    this.observers[e] && Array.from(this.observers[e].entries()).forEach(([a, r]) => {
      for (let i = 0; i < r; i++)
        a(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([a, r]) => {
      for (let i = 0; i < r; i++)
        a.apply(a, [e, ...n]);
    });
  }
}
class Si extends na {
  constructor(e, n = { ns: ["translation"], defaultNS: "translation" }) {
    super(), this.data = e || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const n = this.options.ns.indexOf(e);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(e, n, a, r = {}) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, o = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    e.indexOf(".") > -1 ? s = e.split(".") : (s = [e, n], a && (Array.isArray(a) ? s.push(...a) : H(a) && i ? s.push(...a.split(i)) : s.push(a)));
    const l = Yn(this.data, s);
    return !l && !n && !a && e.indexOf(".") > -1 && (e = s[0], n = s[1], a = s.slice(2).join(".")), !l && o && H(a) ? Fa(this.data?.[e]?.[n], a, i) : l;
  }
  addResource(e, n, a, r, i = { silent: !1 }) {
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [e, n];
    a && (s = s.concat(o ? a.split(o) : a)), e.indexOf(".") > -1 && (s = e.split("."), r = n, n = s[1]), this.addNamespaces(n), vi(this.data, s, r), i.silent || this.emit("added", e, n, a, r);
  }
  addResources(e, n, a, r = { silent: !1 }) {
    for (const i in a)
      (H(a[i]) || Array.isArray(a[i])) && this.addResource(e, n, i, a[i], { silent: !0 });
    r.silent || this.emit("added", e, n, a);
  }
  addResourceBundle(e, n, a, r, i, o = { silent: !1, skipCopy: !1 }) {
    let s = [e, n];
    e.indexOf(".") > -1 && (s = e.split("."), r = a, a = n, n = s[1]), this.addNamespaces(n);
    let l = Yn(this.data, s) || {};
    o.skipCopy || (a = JSON.parse(JSON.stringify(a))), r ? ys(l, a, i) : l = { ...l, ...a }, vi(this.data, s, l), o.silent || this.emit("added", e, n, a);
  }
  removeResourceBundle(e, n) {
    this.hasResourceBundle(e, n) && delete this.data[e][n], this.removeNamespaces(n), this.emit("removed", e, n);
  }
  hasResourceBundle(e, n) {
    return this.getResource(e, n) !== void 0;
  }
  getResourceBundle(e, n) {
    return n || (n = this.options.defaultNS), this.getResource(e, n);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const n = this.getDataByLanguage(e);
    return !!(n && Object.keys(n) || []).find((a) => n[a] && Object.keys(n[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var bs = { processors: {}, addPostProcessor(t) {
  this.processors[t.name] = t;
}, handle(t, e, n, a, r) {
  return t.forEach((i) => {
    e = this.processors[i]?.process(e, n, a, r) ?? e;
  }), e;
} };
const Ci = {}, Mi = (t) => !H(t) && typeof t != "boolean" && typeof t != "number";
class Hn extends na {
  constructor(e, n = {}) {
    var a, r;
    super(), a = e, r = this, ["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"].forEach((i) => {
      a[i] && (r[i] = a[i]);
    }), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ae.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e, n = { interpolation: {} }) {
    const a = { ...n };
    return e == null ? !1 : this.resolve(e, a)?.res !== void 0;
  }
  extractFromKey(e, n) {
    let a = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    a === void 0 && (a = ":");
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const o = a && e.indexOf(a) > -1, s = !(this.options.userDefinedKeySeparator || n.keySeparator || this.options.userDefinedNsSeparator || n.nsSeparator || ((l, u, c) => {
      u = u || "", c = c || "";
      const d = zc.filter((f) => u.indexOf(f) < 0 && c.indexOf(f) < 0);
      if (d.length === 0)
        return !0;
      const p = qc.getRegExp(`(${d.map((f) => f === "?" ? "\\?" : f).join("|")})`);
      let g = !p.test(l);
      if (!g) {
        const f = l.indexOf(c);
        f > 0 && !p.test(l.substring(0, f)) && (g = !0);
      }
      return g;
    })(e, a, r));
    if (o && !s) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return { key: e, namespaces: H(i) ? [i] : i };
      const u = e.split(a);
      (a !== r || a === r && this.options.ns.indexOf(u[0]) > -1) && (i = u.shift()), e = u.join(r);
    }
    return { key: e, namespaces: H(i) ? [i] : i };
  }
  translate(e, n, a) {
    let r = typeof n == "object" ? { ...n } : n;
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof options == "object" && (r = { ...r }), r || (r = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const i = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, o = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, { key: s, namespaces: l } = this.extractFromKey(e[e.length - 1], r), u = l[l.length - 1];
    let c = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    c === void 0 && (c = ":");
    const d = r.lng || this.language, p = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return p ? i ? { res: `${u}${c}${s}`, usedKey: s, exactUsedKey: s, usedLng: d, usedNS: u, usedParams: this.getUsedParamsDetails(r) } : `${u}${c}${s}` : i ? { res: s, usedKey: s, exactUsedKey: s, usedLng: d, usedNS: u, usedParams: this.getUsedParamsDetails(r) } : s;
    const g = this.resolve(e, r);
    let f = g?.res;
    const h = g?.usedKey || s, D = g?.exactUsedKey || s, L = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, _ = !this.i18nFormat || this.i18nFormat.handleAsObject, x = r.count !== void 0 && !H(r.count), T = Hn.hasDefaultValue(r), b = x ? this.pluralResolver.getSuffix(d, r.count, r) : "", S = r.ordinal && x ? this.pluralResolver.getSuffix(d, r.count, { ordinal: !1 }) : "", w = x && !r.ordinal && r.count === 0, E = w && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${b}`] || r[`defaultValue${S}`] || r.defaultValue;
    let k = f;
    _ && !f && T && (k = E);
    const O = Mi(k), $ = Object.prototype.toString.apply(k);
    if (!(_ && k && O && ["[object Number]", "[object Function]", "[object RegExp]"].indexOf($) < 0) || H(L) && Array.isArray(k))
      if (_ && H(L) && Array.isArray(f))
        f = f.join(L), f && (f = this.extendTranslation(f, e, r, a));
      else {
        let v = !1, y = !1;
        !this.isValidLookup(f) && T && (v = !0, f = E), this.isValidLookup(f) || (y = !0, f = s);
        const m = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && y ? void 0 : f, M = T && E !== f && this.options.updateMissing;
        if (y || v || M) {
          if (this.logger.log(M ? "updateKey" : "missingKey", d, u, s, M ? E : f), o) {
            const P = this.resolve(s, { ...r, keySeparator: !1 });
            P && P.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          let C = [];
          const I = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && I && I[0])
            for (let P = 0; P < I.length; P++)
              C.push(I[P]);
          else
            this.options.saveMissingTo === "all" ? C = this.languageUtils.toResolveHierarchy(r.lng || this.language) : C.push(r.lng || this.language);
          const A = (P, B, V) => {
            const j = T && V !== f ? V : m;
            this.options.missingKeyHandler ? this.options.missingKeyHandler(P, u, B, j, M, r) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(P, u, B, j, M, r), this.emit("missingKey", P, u, B, f);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && x ? C.forEach((P) => {
            const B = this.pluralResolver.getSuffixes(P, r);
            w && r[`defaultValue${this.options.pluralSeparator}zero`] && B.indexOf(`${this.options.pluralSeparator}zero`) < 0 && B.push(`${this.options.pluralSeparator}zero`), B.forEach((V) => {
              A([P], s + V, r[`defaultValue${V}`] || E);
            });
          }) : A(C, s, E));
        }
        f = this.extendTranslation(f, e, r, g, a), y && f === s && this.options.appendNamespaceToMissingKey && (f = `${u}${c}${s}`), (y || v) && this.options.parseMissingKeyHandler && (f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${u}${c}${s}` : s, v ? f : void 0, r));
      }
    else {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const v = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, k, { ...r, ns: l }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return i ? (g.res = v, g.usedParams = this.getUsedParamsDetails(r), g) : v;
      }
      if (o) {
        const v = Array.isArray(k), y = v ? [] : {}, m = v ? D : h;
        for (const M in k)
          if (Object.prototype.hasOwnProperty.call(k, M)) {
            const C = `${m}${o}${M}`;
            y[M] = T && !f ? this.translate(C, { ...r, defaultValue: Mi(E) ? E[M] : void 0, joinArrays: !1, ns: l }) : this.translate(C, { ...r, joinArrays: !1, ns: l }), y[M] === C && (y[M] = k[M]);
          }
        f = y;
      }
    }
    return i ? (g.res = f, g.usedParams = this.getUsedParamsDetails(r), g) : f;
  }
  extendTranslation(e, n, a, r, i) {
    if (this.i18nFormat?.parse)
      e = this.i18nFormat.parse(e, { ...this.options.interpolation.defaultVariables, ...a }, a.lng || this.language || r.usedLng, r.usedNS, r.usedKey, { resolved: r });
    else if (!a.skipInterpolation) {
      a.interpolation && this.interpolator.init({ ...a, interpolation: { ...this.options.interpolation, ...a.interpolation } });
      const l = H(e) && (a?.interpolation?.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (l) {
        const d = e.match(this.interpolator.nestingRegexp);
        u = d && d.length;
      }
      let c = a.replace && !H(a.replace) ? a.replace : a;
      if (this.options.interpolation.defaultVariables && (c = { ...this.options.interpolation.defaultVariables, ...c }), e = this.interpolator.interpolate(e, c, a.lng || this.language || r.usedLng, a), l) {
        const d = e.match(this.interpolator.nestingRegexp);
        u < (d && d.length) && (a.nest = !1);
      }
      !a.lng && r && r.res && (a.lng = this.language || r.usedLng), a.nest !== !1 && (e = this.interpolator.nest(e, (...d) => i?.[0] !== d[0] || a.context ? this.translate(...d, n) : (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${n[0]}`), null), a)), a.interpolation && this.interpolator.reset();
    }
    const o = a.postProcess || this.options.postProcess, s = H(o) ? [o] : o;
    return e != null && s?.length && a.applyPostProcessor !== !1 && (e = bs.handle(s, e, n, this.options && this.options.postProcessPassResolved ? { i18nResolved: { ...r, usedParams: this.getUsedParamsDetails(a) }, ...a } : a, this)), e;
  }
  resolve(e, n = {}) {
    let a, r, i, o, s;
    return H(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(a))
        return;
      const u = this.extractFromKey(l, n), c = u.key;
      r = c;
      let d = u.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !H(n.count), g = p && !n.ordinal && n.count === 0, f = n.context !== void 0 && (H(n.context) || typeof n.context == "number") && n.context !== "", h = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((D) => {
        this.isValidLookup(a) || (s = D, Ci[`${h[0]}-${D}`] || !this.utils?.hasLoadedNamespace || this.utils?.hasLoadedNamespace(s) || (Ci[`${h[0]}-${D}`] = !0, this.logger.warn(`key "${r}" for languages "${h.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), h.forEach((L) => {
          if (this.isValidLookup(a))
            return;
          o = L;
          const _ = [c];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, c, L, D, n);
          else {
            let T;
            p && (T = this.pluralResolver.getSuffix(L, n.count, n));
            const b = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (n.ordinal && T.indexOf(S) === 0 && _.push(c + T.replace(S, this.options.pluralSeparator)), _.push(c + T), g && _.push(c + b)), f) {
              const w = `${c}${this.options.contextSeparator}${n.context}`;
              _.push(w), p && (_.push(w + T), n.ordinal && T.indexOf(S) === 0 && _.push(w + T.replace(S, this.options.pluralSeparator)), g && _.push(w + b));
            }
          }
          let x;
          for (; x = _.pop(); )
            this.isValidLookup(a) || (i = x, a = this.getResource(L, D, x, n));
        }));
      });
    }), { res: a, usedKey: r, exactUsedKey: i, usedLng: o, usedNS: s };
  }
  isValidLookup(e) {
    return !(e === void 0 || !this.options.returnNull && e === null || !this.options.returnEmptyString && e === "");
  }
  getResource(e, n, a, r = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(e, n, a, r) : this.resourceStore.getResource(e, n, a, r);
  }
  getUsedParamsDetails(e = {}) {
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], a = e.replace && !H(e.replace);
    let r = a ? e.replace : e;
    if (a && e.count !== void 0 && (r.count = e.count), this.options.interpolation.defaultVariables && (r = { ...this.options.interpolation.defaultVariables, ...r }), !a) {
      r = { ...r };
      for (const i of n)
        delete r[i];
    }
    return r;
  }
  static hasDefaultValue(e) {
    const n = "defaultValue";
    for (const a in e)
      if (Object.prototype.hasOwnProperty.call(e, a) && n === a.substring(0, 12) && e[a] !== void 0)
        return !0;
    return !1;
  }
}
class Di {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ae.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (!(e = zt(e)) || e.indexOf("-") < 0)
      return null;
    const n = e.split("-");
    return n.length === 2 ? null : (n.pop(), n[n.length - 1].toLowerCase() === "x" ? null : this.formatLanguageCode(n.join("-")));
  }
  getLanguagePartFromCode(e) {
    if (!(e = zt(e)) || e.indexOf("-") < 0)
      return e;
    const n = e.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(e) {
    if (H(e) && e.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let n;
    return e.forEach((a) => {
      if (n)
        return;
      const r = this.formatLanguageCode(a);
      this.options.supportedLngs && !this.isSupportedCode(r) || (n = r);
    }), !n && this.options.supportedLngs && e.forEach((a) => {
      if (n)
        return;
      const r = this.getScriptPartFromCode(a);
      if (this.isSupportedCode(r))
        return n = r;
      const i = this.getLanguagePartFromCode(a);
      if (this.isSupportedCode(i))
        return n = i;
      n = this.options.supportedLngs.find((o) => o === i ? o : o.indexOf("-") < 0 && i.indexOf("-") < 0 ? void 0 : o.indexOf("-") > 0 && i.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === i || o.indexOf(i) === 0 && i.length > 1 ? o : void 0);
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(e, n) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(n)), H(e) && (e = [e]), Array.isArray(e))
      return e;
    if (!n)
      return e.default || [];
    let a = e[n];
    return a || (a = e[this.getScriptPartFromCode(n)]), a || (a = e[this.formatLanguageCode(n)]), a || (a = e[this.getLanguagePartFromCode(n)]), a || (a = e.default), a || [];
  }
  toResolveHierarchy(e, n) {
    const a = this.getFallbackCodes((n === !1 ? [] : n) || this.options.fallbackLng || [], e), r = [], i = (o) => {
      o && (this.isSupportedCode(o) ? r.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return H(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : H(e) && i(this.formatLanguageCode(e)), a.forEach((o) => {
      r.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), r;
  }
}
const Ni = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 }, Ti = { select: (t) => t === 1 ? "one" : "other", resolvedOptions: () => ({ pluralCategories: ["one", "other"] }) };
class Zc {
  constructor(e, n = {}) {
    this.languageUtils = e, this.options = n, this.logger = Ae.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, n) {
    this.rules[e] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e, n = {}) {
    const a = zt(e === "dev" ? "en" : e), r = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({ cleanedCode: a, type: r });
    if (i in this.pluralRulesCache)
      return this.pluralRulesCache[i];
    let o;
    try {
      o = new Intl.PluralRules(a, { type: r });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Ti;
      if (!e.match(/-|_/))
        return Ti;
      const l = this.languageUtils.getLanguagePartFromCode(e);
      o = this.getRule(l, n);
    }
    return this.pluralRulesCache[i] = o, o;
  }
  needsPlural(e, n = {}) {
    let a = this.getRule(e, n);
    return a || (a = this.getRule("dev", n)), a?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(e, n, a = {}) {
    return this.getSuffixes(e, a).map((r) => `${n}${r}`);
  }
  getSuffixes(e, n = {}) {
    let a = this.getRule(e, n);
    return a || (a = this.getRule("dev", n)), a ? a.resolvedOptions().pluralCategories.sort((r, i) => Ni[r] - Ni[i]).map((r) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : [];
  }
  getSuffix(e, n, a = {}) {
    const r = this.getRule(e, a);
    return r ? `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(n)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", n, a));
  }
}
const Ei = (t, e, n, a = ".", r = !0) => {
  let i = ((o, s, l) => {
    const u = Yn(o, l);
    return u !== void 0 ? u : Yn(s, l);
  })(t, e, n);
  return !i && r && H(n) && (i = Fa(t, n, a), i === void 0 && (i = Fa(e, n, a))), i;
}, ba = (t) => t.replace(/\$/g, "$$$$");
class Wc {
  constructor(e = {}) {
    this.logger = Ae.create("interpolator"), this.options = e, this.format = e?.interpolation?.format || ((n) => n), this.init(e);
  }
  init(e = {}) {
    e.interpolation || (e.interpolation = { escapeValue: !0 });
    const { escape: n, escapeValue: a, useRawValueToEscape: r, prefix: i, prefixEscaped: o, suffix: s, suffixEscaped: l, formatSeparator: u, unescapeSuffix: c, unescapePrefix: d, nestingPrefix: p, nestingPrefixEscaped: g, nestingSuffix: f, nestingSuffixEscaped: h, nestingOptionsSeparator: D, maxReplaces: L, alwaysFormat: _ } = e.interpolation;
    this.escape = n !== void 0 ? n : $c, this.escapeValue = a === void 0 || a, this.useRawValueToEscape = r !== void 0 && r, this.prefix = i ? yt(i) : o || "{{", this.suffix = s ? yt(s) : l || "}}", this.formatSeparator = u || ",", this.unescapePrefix = c ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : c || "", this.nestingPrefix = p ? yt(p) : g || yt("$t("), this.nestingSuffix = f ? yt(f) : h || yt(")"), this.nestingOptionsSeparator = D || ",", this.maxReplaces = L || 1e3, this.alwaysFormat = _ !== void 0 && _, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (n, a) => n?.source === a ? (n.lastIndex = 0, n) : new RegExp(a, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(e, n, a, r) {
    let i, o, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const D = Ei(n, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(D, void 0, a, { ...r, ...n, interpolationkey: p }) : D;
      }
      const g = p.split(this.formatSeparator), f = g.shift().trim(), h = g.join(this.formatSeparator).trim();
      return this.format(Ei(n, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), h, a, { ...r, ...n, interpolationkey: f });
    };
    this.resetRegExp();
    const c = r?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = r?.interpolation?.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{ regex: this.regexpUnescape, safeValue: (p) => ba(p) }, { regex: this.regexp, safeValue: (p) => this.escapeValue ? ba(this.escape(p)) : ba(p) }].forEach((p) => {
      for (s = 0; i = p.regex.exec(e); ) {
        const g = i[1].trim();
        if (o = u(g), o === void 0)
          if (typeof c == "function") {
            const h = c(e, i, r);
            o = H(h) ? h : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, g))
            o = "";
          else {
            if (d) {
              o = i[0];
              continue;
            }
            this.logger.warn(`missed to pass in variable ${g} for interpolating ${e}`), o = "";
          }
        else
          H(o) || this.useRawValueToEscape || (o = fi(o));
        const f = p.safeValue(o);
        if (e = e.replace(i[0], f), d ? (p.regex.lastIndex += o.length, p.regex.lastIndex -= i[0].length) : p.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, n, a = {}) {
    let r, i, o;
    const s = (l, u) => {
      const c = this.nestingOptionsSeparator;
      if (l.indexOf(c) < 0)
        return l;
      const d = l.split(new RegExp(`${c}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, o);
      const g = p.match(/'/g), f = p.match(/"/g);
      ((g?.length ?? 0) % 2 == 0 && !f || f.length % 2 != 0) && (p = p.replace(/'/g, '"'));
      try {
        o = JSON.parse(p), u && (o = { ...u, ...o });
      } catch (h) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, h), `${l}${c}${p}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; r = this.nestingRegexp.exec(e); ) {
      let l = [];
      o = { ...a }, o = o.replace && !H(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      const u = /{.*}/.test(r[1]) ? r[1].lastIndexOf("}") + 1 : r[1].indexOf(this.formatSeparator);
      if (u !== -1 && (l = r[1].slice(u).split(this.formatSeparator).map((c) => c.trim()).filter(Boolean), r[1] = r[1].slice(0, u)), i = n(s.call(this, r[1].trim(), o), o), i && r[0] === e && !H(i))
        return i;
      H(i) || (i = fi(i)), i || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${e}`), i = ""), l.length && (i = l.reduce((c, d) => this.format(c, d, a.lng, { ...a, interpolationkey: r[1].trim() }), i.trim())), e = e.replace(r[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const wi = (t) => {
  const e = {};
  return (n, a, r) => {
    let i = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (i = { ...i, [r.interpolationkey]: void 0 });
    const o = a + JSON.stringify(i);
    let s = e[o];
    return s || (s = t(zt(a), r), e[o] = s), s(n);
  };
}, Jc = (t) => (e, n, a) => t(zt(n), a)(e);
class Qc {
  constructor(e = {}) {
    this.logger = Ae.create("formatter"), this.options = e, this.init(e);
  }
  init(e, n = { interpolation: {} }) {
    this.formatSeparator = n.interpolation.formatSeparator || ",";
    const a = n.cacheInBuiltFormats ? wi : Jc;
    this.formats = { number: a((r, i) => {
      const o = new Intl.NumberFormat(r, { ...i });
      return (s) => o.format(s);
    }), currency: a((r, i) => {
      const o = new Intl.NumberFormat(r, { ...i, style: "currency" });
      return (s) => o.format(s);
    }), datetime: a((r, i) => {
      const o = new Intl.DateTimeFormat(r, { ...i });
      return (s) => o.format(s);
    }), relativetime: a((r, i) => {
      const o = new Intl.RelativeTimeFormat(r, { ...i });
      return (s) => o.format(s, i.range || "day");
    }), list: a((r, i) => {
      const o = new Intl.ListFormat(r, { ...i });
      return (s) => o.format(s);
    }) };
  }
  add(e, n) {
    this.formats[e.toLowerCase().trim()] = n;
  }
  addCached(e, n) {
    this.formats[e.toLowerCase().trim()] = wi(n);
  }
  format(e, n, a, r = {}) {
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((s) => s.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, s) => {
      const { formatName: l, formatOptions: u } = ((c) => {
        let d = c.toLowerCase().trim();
        const p = {};
        if (c.indexOf("(") > -1) {
          const g = c.split("(");
          d = g[0].toLowerCase().trim();
          const f = g[1].substring(0, g[1].length - 1);
          d === "currency" && f.indexOf(":") < 0 ? p.currency || (p.currency = f.trim()) : d === "relativetime" && f.indexOf(":") < 0 ? p.range || (p.range = f.trim()) : f.split(";").forEach((h) => {
            if (h) {
              const [D, ...L] = h.split(":"), _ = L.join(":").trim().replace(/^'+|'+$/g, ""), x = D.trim();
              p[x] || (p[x] = _), _ === "false" && (p[x] = !1), _ === "true" && (p[x] = !0), isNaN(_) || (p[x] = parseInt(_, 10));
            }
          });
        }
        return { formatName: d, formatOptions: p };
      })(s);
      if (this.formats[l]) {
        let c = o;
        try {
          const d = r?.formatParams?.[r.interpolationkey] || {}, p = d.locale || d.lng || r.locale || r.lng || a;
          c = this.formats[l](o, p, { ...u, ...r, ...d });
        } catch (d) {
          this.logger.warn(d);
        }
        return c;
      }
      return this.logger.warn(`there was no format function for ${l}`), o;
    }, e);
  }
}
class Xc extends na {
  constructor(e, n, a, r = {}) {
    super(), this.backend = e, this.store = n, this.services = a, this.languageUtils = a.languageUtils, this.options = r, this.logger = Ae.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(a, r.backend, r);
  }
  queueLoad(e, n, a, r) {
    const i = {}, o = {}, s = {}, l = {};
    return e.forEach((u) => {
      let c = !0;
      n.forEach((d) => {
        const p = `${u}|${d}`;
        !a.reload && this.store.hasResourceBundle(u, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? o[p] === void 0 && (o[p] = !0) : (this.state[p] = 1, c = !1, o[p] === void 0 && (o[p] = !0), i[p] === void 0 && (i[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), c || (s[u] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({ pending: o, pendingCount: Object.keys(o).length, loaded: {}, errors: [], callback: r }), { toLoad: Object.keys(i), pending: Object.keys(o), toLoadLanguages: Object.keys(s), toLoadNamespaces: Object.keys(l) };
  }
  loaded(e, n, a) {
    const r = e.split("|"), i = r[0], o = r[1];
    n && this.emit("failedLoading", i, o, n), !n && a && this.store.addResourceBundle(i, o, a, void 0, void 0, { skipCopy: !0 }), this.state[e] = n ? -1 : 2, n && a && (this.state[e] = 0);
    const s = {};
    this.queue.forEach((l) => {
      ((u, c, d) => {
        const { obj: p, k: g } = Vt(u, c, Object);
        p[g] = p[g] || [], p[g].push(d);
      })(l.loaded, [i], o), ((u, c) => {
        u.pending[c] !== void 0 && (delete u.pending[c], u.pendingCount--);
      })(l, e), n && l.errors.push(n), l.pendingCount !== 0 || l.done || (Object.keys(l.loaded).forEach((u) => {
        s[u] || (s[u] = {});
        const c = l.loaded[u];
        c.length && c.forEach((d) => {
          s[u][d] === void 0 && (s[u][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, n, a, r = 0, i = this.retryTimeout, o) {
    if (!e.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads)
      return void this.waitingReads.push({ lng: e, ns: n, fcName: a, tried: r, wait: i, callback: o });
    this.readingCalls++;
    const s = (u, c) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      u && c && r < this.maxRetries ? setTimeout(() => {
        this.read.call(this, e, n, a, r + 1, 2 * i, o);
      }, i) : o(u, c);
    }, l = this.backend[a].bind(this.backend);
    if (l.length !== 2)
      return l(e, n, s);
    try {
      const u = l(e, n);
      u && typeof u.then == "function" ? u.then((c) => s(null, c)).catch(s) : s(null, u);
    } catch (u) {
      s(u);
    }
  }
  prepareLoading(e, n, a = {}, r) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    H(e) && (e = this.languageUtils.toResolveHierarchy(e)), H(n) && (n = [n]);
    const i = this.queueLoad(e, n, a, r);
    if (!i.toLoad.length)
      return i.pending.length || r(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(e, n, a) {
    this.prepareLoading(e, n, {}, a);
  }
  reload(e, n, a) {
    this.prepareLoading(e, n, { reload: !0 }, a);
  }
  loadOne(e, n = "") {
    const a = e.split("|"), r = a[0], i = a[1];
    this.read(r, i, "read", void 0, void 0, (o, s) => {
      o && this.logger.warn(`${n}loading namespace ${i} for language ${r} failed`, o), !o && s && this.logger.log(`${n}loaded namespace ${i} for language ${r}`, s), this.loaded(e, o, s);
    });
  }
  saveMissing(e, n, a, r, i, o = {}, s = () => {
  }) {
    if (!this.services?.utils?.hasLoadedNamespace || this.services?.utils?.hasLoadedNamespace(n)) {
      if (a != null && a !== "") {
        if (this.backend?.create) {
          const l = { ...o, isUpdate: i }, u = this.backend.create.bind(this.backend);
          if (u.length < 6)
            try {
              let c;
              c = u.length === 5 ? u(e, n, a, r, l) : u(e, n, a, r), c && typeof c.then == "function" ? c.then((d) => s(null, d)).catch(s) : s(null, c);
            } catch (c) {
              s(c);
            }
          else
            u(e, n, a, r, s, l);
        }
        e && e[0] && this.store.addResource(e[0], n, a, r);
      }
    } else
      this.logger.warn(`did not save key "${a}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
  }
}
const _i = () => ({ debug: !1, initAsync: !0, ns: ["translation"], defaultNS: ["translation"], fallbackLng: ["dev"], fallbackNS: !1, supportedLngs: !1, nonExplicitSupportedLngs: !1, load: "all", preload: !1, simplifyPluralSuffix: !0, keySeparator: ".", nsSeparator: ":", pluralSeparator: "_", contextSeparator: "_", partialBundledLanguages: !1, saveMissing: !1, updateMissing: !1, saveMissingTo: "fallback", saveMissingPlurals: !0, missingKeyHandler: !1, missingInterpolationHandler: !1, postProcess: !1, postProcessPassResolved: !1, returnNull: !1, returnEmptyString: !0, returnObjects: !1, joinArrays: !1, returnedObjectHandler: !1, parseMissingKeyHandler: !1, appendNamespaceToMissingKey: !1, appendNamespaceToCIMode: !1, overloadTranslationOptionHandler: (t) => {
  let e = {};
  if (typeof t[1] == "object" && (e = t[1]), H(t[1]) && (e.defaultValue = t[1]), H(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
    const n = t[3] || t[2];
    Object.keys(n).forEach((a) => {
      e[a] = n[a];
    });
  }
  return e;
}, interpolation: { escapeValue: !0, format: (t) => t, prefix: "{{", suffix: "}}", formatSeparator: ",", unescapePrefix: "-", nestingPrefix: "$t(", nestingSuffix: ")", nestingOptionsSeparator: ",", maxReplaces: 1e3, skipOnVariables: !0 }, cacheInBuiltFormats: !0 }), xi = (t) => (H(t.ns) && (t.ns = [t.ns]), H(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), H(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs?.indexOf?.("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), typeof t.initImmediate == "boolean" && (t.initAsync = t.initImmediate), t), hn = () => {
};
class qt extends na {
  constructor(e = {}, n) {
    var a;
    if (super(), this.options = xi(e), this.services = {}, this.logger = Ae, this.modules = { external: [] }, a = this, Object.getOwnPropertyNames(Object.getPrototypeOf(a)).forEach((r) => {
      typeof a[r] == "function" && (a[r] = a[r].bind(a));
    }), n && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, n), this;
      setTimeout(() => {
        this.init(e, n);
      }, 0);
    }
  }
  init(e = {}, n) {
    this.isInitializing = !0, typeof e == "function" && (n = e, e = {}), e.defaultNS == null && e.ns && (H(e.ns) ? e.defaultNS = e.ns : e.ns.indexOf("translation") < 0 && (e.defaultNS = e.ns[0]));
    const a = _i();
    this.options = { ...a, ...this.options, ...xi(e) }, this.options.interpolation = { ...a.interpolation, ...this.options.interpolation }, e.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = e.keySeparator), e.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = e.nsSeparator);
    const r = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      let s;
      this.modules.logger ? Ae.init(r(this.modules.logger), this.options) : Ae.init(null, this.options), s = this.modules.formatter ? this.modules.formatter : Qc;
      const l = new Di(this.options);
      this.store = new Si(this.options.resources, this.options);
      const u = this.services;
      u.logger = Ae, u.resourceStore = this.store, u.languageUtils = l, u.pluralResolver = new Zc(l, { prepend: this.options.pluralSeparator, simplifyPluralSuffix: this.options.simplifyPluralSuffix }), this.options.interpolation.format && this.options.interpolation.format !== a.interpolation.format && this.logger.warn("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), !s || this.options.interpolation.format && this.options.interpolation.format !== a.interpolation.format || (u.formatter = r(s), u.formatter.init && u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new Wc(this.options), u.utils = { hasLoadedNamespace: this.hasLoadedNamespace.bind(this) }, u.backendConnector = new Xc(r(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", (c, ...d) => {
        this.emit(c, ...d);
      }), this.modules.languageDetector && (u.languageDetector = r(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = r(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new Hn(this.services, this.options), this.translator.on("*", (c, ...d) => {
        this.emit(c, ...d);
      }), this.modules.external.forEach((c) => {
        c.init && c.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = hn), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...l) => this.store[s](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...l) => (this.store[s](...l), this);
    });
    const i = At(), o = () => {
      const s = (l, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), i.resolve(u), n(l, u);
      };
      if (this.languages && !this.isInitialized)
        return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? o() : setTimeout(o, 0), i;
  }
  loadResources(e, n = hn) {
    let a = n;
    const r = H(e) ? e : this.language;
    if (typeof e == "function" && (a = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (r?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return a();
      const i = [], o = (s) => {
        s && s !== "cimode" && this.services.languageUtils.toResolveHierarchy(s).forEach((l) => {
          l !== "cimode" && i.indexOf(l) < 0 && i.push(l);
        });
      };
      r ? o(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((s) => o(s)), this.options.preload?.forEach?.((s) => o(s)), this.services.backendConnector.load(i, this.options.ns, (s) => {
        s || this.resolvedLanguage || !this.language || this.setResolvedLanguage(this.language), a(s);
      });
    } else
      a(null);
  }
  reloadResources(e, n, a) {
    const r = At();
    return typeof e == "function" && (a = e, e = void 0), typeof n == "function" && (a = n, n = void 0), e || (e = this.languages), n || (n = this.options.ns), a || (a = hn), this.services.backendConnector.reload(e, n, (i) => {
      r.resolve(), a(i);
    }), r;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && bs.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (e && this.languages && !(["cimode", "dev"].indexOf(e) > -1)) {
      for (let n = 0; n < this.languages.length; n++) {
        const a = this.languages[n];
        if (!(["cimode", "dev"].indexOf(a) > -1) && this.store.hasLanguageSomeTranslations(a)) {
          this.resolvedLanguage = a;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(e) < 0 && this.store.hasLanguageSomeTranslations(e) && (this.resolvedLanguage = e, this.languages.unshift(e));
    }
  }
  changeLanguage(e, n) {
    this.isLanguageChangingTo = e;
    const a = At();
    this.emit("languageChanging", e);
    const r = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, i = (s, l) => {
      l ? this.isLanguageChangingTo === e && (r(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, a.resolve((...u) => this.t(...u)), n && n(s, (...u) => this.t(...u));
    }, o = (s) => {
      e || s || !this.services.languageDetector || (s = []);
      const l = H(s) ? s : s && s[0], u = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(H(s) ? [s] : s);
      u && (this.language || r(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector?.cacheUserLanguage?.(u)), this.loadResources(u, (c) => {
        i(c, u);
      });
    };
    return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e) : o(this.services.languageDetector.detect()), a;
  }
  getFixedT(e, n, a) {
    const r = (i, o, ...s) => {
      let l;
      l = typeof o != "object" ? this.options.overloadTranslationOptionHandler([i, o].concat(s)) : { ...o }, l.lng = l.lng || r.lng, l.lngs = l.lngs || r.lngs, l.ns = l.ns || r.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || a || r.keyPrefix);
      const u = this.options.keySeparator || ".";
      let c;
      return c = l.keyPrefix && Array.isArray(i) ? i.map((d) => `${l.keyPrefix}${u}${d}`) : l.keyPrefix ? `${l.keyPrefix}${u}${i}` : i, this.t(c, l);
    };
    return H(e) ? r.lng = e : r.lngs = e, r.ns = n, r.keyPrefix = a, r;
  }
  t(...e) {
    return this.translator?.translate(...e);
  }
  exists(...e) {
    return this.translator?.exists(...e);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e, n = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const a = n.lng || this.resolvedLanguage || this.languages[0], r = !!this.options && this.options.fallbackLng, i = this.languages[this.languages.length - 1];
    if (a.toLowerCase() === "cimode")
      return !0;
    const o = (s, l) => {
      const u = this.services.backendConnector.state[`${s}|${l}`];
      return u === -1 || u === 0 || u === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, o);
      if (s !== void 0)
        return s;
    }
    return !!this.hasResourceBundle(a, e) || !(this.services.backendConnector.backend && (!this.options.resources || this.options.partialBundledLanguages)) || !(!o(a, e) || r && !o(i, e));
  }
  loadNamespaces(e, n) {
    const a = At();
    return this.options.ns ? (H(e) && (e = [e]), e.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      a.resolve(), n && n(r);
    }), a) : (n && n(), Promise.resolve());
  }
  loadLanguages(e, n) {
    const a = At();
    H(e) && (e = [e]);
    const r = this.options.preload || [], i = e.filter((o) => r.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = r.concat(i), this.loadResources((o) => {
      a.resolve(), n && n(o);
    }), a) : (n && n(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    try {
      const a = new Intl.Locale(e);
      if (a && a.getTextInfo) {
        const r = a.getTextInfo();
        if (r && r.direction)
          return r.direction;
      }
    } catch {
    }
    const n = this.services?.languageUtils || new Di(_i());
    return e.toLowerCase().indexOf("-latn") > 1 ? "ltr" : ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"].indexOf(n.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(e = {}, n) {
    return new qt(e, n);
  }
  cloneInstance(e = {}, n = hn) {
    const a = e.forkResourceStore;
    a && delete e.forkResourceStore;
    const r = { ...this.options, ...e, isClone: !0 }, i = new qt(r);
    if (e.debug === void 0 && e.prefix === void 0 || (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = { ...this.services }, i.services.utils = { hasLoadedNamespace: i.hasLoadedNamespace.bind(i) }, a) {
      const o = Object.keys(this.store.data).reduce((s, l) => (s[l] = { ...this.store.data[l] }, s[l] = Object.keys(s[l]).reduce((u, c) => (u[c] = { ...s[l][c] }, u), s[l]), s), {});
      i.store = new Si(o, r), i.services.resourceStore = i.store;
    }
    return i.translator = new Hn(i.services, r), i.translator.on("*", (o, ...s) => {
      i.emit(o, ...s);
    }), i.init(r, n), i.translator.options = r, i.translator.backendConnector.services.utils = { hasLoadedNamespace: i.hasLoadedNamespace.bind(i) }, i;
  }
  toJSON() {
    return { options: this.options, store: this.store, language: this.language, languages: this.languages, resolvedLanguage: this.resolvedLanguage };
  }
}
const he = qt.createInstance();
he.createInstance = qt.createInstance, he.createInstance, he.dir, he.init, he.loadResources, he.reloadResources, he.use, he.changeLanguage, he.getFixedT, he.t, he.exists, he.setDefaultNamespace, he.hasLoadedNamespace, he.loadNamespaces, he.loadLanguages;
var Y = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function eu(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(a) {
    var r = Object.getOwnPropertyDescriptor(t, a);
    Object.defineProperty(n, a, r.get ? r : { enumerable: !0, get: function() {
      return t[a];
    } });
  }), n;
}
const ki = {}, va = (t, e, n, a) => {
  dt(n) && ki[n] || (dt(n) && (ki[n] = /* @__PURE__ */ new Date()), ((r, i, o, s) => {
    const l = [o, { code: i, ...s || {} }];
    if (r?.services?.logger?.forward)
      return r.services.logger.forward(l, "warn", "react-i18next::", !0);
    dt(l[0]) && (l[0] = `react-i18next:: ${l[0]}`), r?.services?.logger?.warn ? r.services.logger.warn(...l) : console?.warn && console.warn(...l);
  })(t, e, n, a));
}, vs = (t, e) => () => {
  if (t.isInitialized)
    e();
  else {
    const n = () => {
      setTimeout(() => {
        t.off("initialized", n);
      }, 0), e();
    };
    t.on("initialized", n);
  }
}, ja = (t, e, n) => {
  t.loadNamespaces(e, vs(t, n));
}, Ai = (t, e, n, a) => {
  if (dt(n) && (n = [n]), t.options.preload && t.options.preload.indexOf(e) > -1)
    return ja(t, n, a);
  n.forEach((r) => {
    t.options.ns.indexOf(r) < 0 && t.options.ns.push(r);
  }), t.loadLanguages(e, vs(t, a));
}, dt = (t) => typeof t == "string", tu = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, nu = { "&amp;": "&", "&#38;": "&", "&lt;": "<", "&#60;": "<", "&gt;": ">", "&#62;": ">", "&apos;": "'", "&#39;": "'", "&quot;": '"', "&#34;": '"', "&nbsp;": " ", "&#160;": " ", "&copy;": "©", "&#169;": "©", "&reg;": "®", "&#174;": "®", "&hellip;": "…", "&#8230;": "…", "&#x2F;": "/", "&#47;": "/" }, au = (t) => nu[t];
let Ba = { bindI18n: "languageChanged", bindI18nStore: "", transEmptyNodeValue: "", transSupportBasicHtmlNodes: !0, transWrapTextNodes: "", transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"], useSuspense: !0, unescape: (t) => t.replace(tu, au) }, Ss;
const ru = { type: "3rdParty", init(t) {
  ((e = {}) => {
    Ba = { ...Ba, ...e };
  })(t.options.react), ((e) => {
    Ss = e;
  })(t);
} }, iu = _t();
class ou {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Li = (t, e, n, a) => t.getFixedT(e, n, a), aa = (t, e = {}) => {
  const { i18n: n } = e, { i18n: a, defaultNS: r } = on(iu) || {}, i = n || a || Ss;
  if (i && !i.reportNamespaces && (i.reportNamespaces = new ou()), !i) {
    va(i, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const T = (S, w) => {
      return dt(w) ? w : typeof (E = w) == "object" && E !== null && dt(w.defaultValue) ? w.defaultValue : Array.isArray(S) ? S[S.length - 1] : S;
      var E;
    }, b = [T, {}, !1];
    return b.t = T, b.i18n = {}, b.ready = !1, b;
  }
  i.options.react?.wait && va(i, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const o = { ...Ba, ...i.options.react, ...e }, { useSuspense: s, keyPrefix: l } = o;
  let u = t || r || i.options?.defaultNS;
  u = dt(u) ? [u] : u || ["translation"], i.reportNamespaces.addUsedNamespaces?.(u);
  const c = (i.isInitialized || i.initializedStoreOnce) && u.every((T) => ((b, S, w = {}) => S.languages && S.languages.length ? S.hasLoadedNamespace(b, { lng: w.lng, precheck: (E, k) => {
    if (w.bindI18n && w.bindI18n.indexOf("languageChanging") > -1 && E.services.backendConnector.backend && E.isLanguageChangingTo && !k(E.isLanguageChangingTo, b))
      return !1;
  } }) : (va(S, "NO_LANGUAGES", "i18n.languages were undefined or empty", { languages: S.languages }), !0))(T, i, o)), d = ((T, b, S, w) => Te(Li(T, b, S, w), [T, b, S, w]))(i, e.lng || null, o.nsMode === "fallback" ? u : u[0], l), p = () => d, g = () => Li(i, e.lng || null, o.nsMode === "fallback" ? u : u[0], l), [f, h] = ne(p);
  let D = u.join();
  e.lng && (D = `${e.lng}${D}`);
  const L = ((T, b) => {
    const S = Ra();
    return Q(() => {
      S.current = b ? S.current : T;
    }, [T, b]), S.current;
  })(D), _ = Ra(!0);
  Q(() => {
    const { bindI18n: T, bindI18nStore: b } = o;
    _.current = !0, c || s || (e.lng ? Ai(i, e.lng, u, () => {
      _.current && h(g);
    }) : ja(i, u, () => {
      _.current && h(g);
    })), c && L && L !== D && _.current && h(g);
    const S = () => {
      _.current && h(g);
    };
    return T && i?.on(T, S), b && i?.store.on(b, S), () => {
      _.current = !1, i && T && T?.split(" ").forEach((w) => i.off(w, S)), b && i && b.split(" ").forEach((w) => i.store.off(w, S));
    };
  }, [i, D]), Q(() => {
    _.current && c && h(p);
  }, [i, l, c]);
  const x = [f, i, c];
  if (x.t = f, x.i18n = i, x.ready = c, c || !c && !s)
    return x;
  throw new Promise((T) => {
    e.lng ? Ai(i, e.lng, u, () => T()) : ja(i, u, () => T());
  });
};
var F = ((t) => (t.deDE = "de-DE", t.esES = "es-ES", t.enUS = "en-US", t.enGB = "en-GB", t.fiFI = "fi-FI", t.nlNL = "nl-NL", t.itIT = "it-IT", t.svSE = "sv-SE", t.nbNO = "nb-NO", t.ptPT = "pt-PT", t.daDK = "da-DK", t.frCA = "fr-CA", t.esUS = "es-US", t.enCA = "en-CA", t.nlBE = "nl-BE", t.enIE = "en-IE", t.frBE = "fr-BE", t.frFR = "fr-FR", t.frCH = "fr-CH", t.deAT = "de-AT", t.deCH = "de-CH", t.itCH = "it-CH", t.enAU = "en-AU", t.enNZ = "en-NZ", t.enSG = "en-SG", t.enIN = "en-IN", t))(F || {});
const su = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Anvend", "close-modal-aria-label": "Luk modalen Forsendelsesmuligheder", "content-aria-label": "Dialogboks Forsendelsesmuligheder", "country-label": "Land", "delivery-options-title-label": "Leveringstid", "delivery-today-message": "I dag", "delivery-tomorrow-message": "I morgen", "disclaimer-label": "Pris- og leveringsmuligheder gælder kun for dette valgte produkt. Den samlede pris bliver beregnet i indkøbsvognen.", "disclaimer-point-1-text": "Nogle VistaPrint-produkter og destinationer kan ikke fås med alle leveringshastigheder. Hvis din bestilling indeholder produkter med forskellige leveringshastigheder, kan den opdeles i særskilte pakker.", "free-shipping-label": "Gratis på bestillinger over {{{ Price }}}", "free-shipping-qualified-label": "Du er berettiget til gratis fragt!", "helper-text": "Læs mere", "loader-text": "Opdaterer leveringsmuligheder", "no-delivery-message": "Levering til {{{ PostalCode }}} er ikke mulig", "not-found-message": "Der blev ikke fundet leveringsmuligheder til {{{ PostalCode }}}", "postal-code-label": "Postnummer", "postal-code-validation-error-message": "Ugyldigt postnummer. Prøv igen.", "selected-option-message": "Levering inden {{{ DeliveryDate }}} til {{{ PostalCode }}} for {{{ Price }}}", "selected-option-message-for-free-delivery": "Levering inden {{{ DeliveryDate }}} til {{{ PostalCode }}}", "selected-option-message-without-price": "Få det allerede fra {{{ DeliveryDate }}} til {{{ PostalCode }}}", "title-label": "Leveringsmuligheder", "update-postal-code-message": "Opdater postnummer", "zero-pricing-text": "Gratis", "cheapest-shipping-option": "Levering fra {{{ Price }}}", "free-shipping-message": "<u><b>Gratis forsendelse</b></u> på bestillinger over {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Gratis forsendelse</b></u> inden {{{ DeliveryDate }}} til {{{ PostalCode }}}", "estimated-delivery-title-lable": "Forventet levering", "estimated-delivery-disclaimer-label": "Pris- og leveringsmuligheder gælder kun for dette valgte produkt. Den samlede pris bliver beregnet i indkøbsvognen. Bemærk: Datoerne er anslåede", "selected-option-estimated-message-without-price": "Forventet levering {{{ FastestDeliveryDate }}} – {{{SlowestDeliveryDate}}}  til {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Forventet levering: {{{ DeliveryDate }}} til {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Se detaljer om leveringsmuligheder" }, "country-localization-map": { AE: "Forenede Arabiske Emirater", AT: "Østrig", AU: "Australien", BB: "Barbados", BE: "Belgien", BM: "Bermuda", BR: "Brazil rejsekrus", BS: "Bahamas", CA: "Canada", CH: "Schweiz", CR: "Costa Rica", CY: "Cypern", CZ: "Tjekkiet", DE: "Tyskland", DK: "Danmark", ES: "Spanien", FI: "Finland", FR: "Frankrig", GB: "Storbritannien", GF: "Fransk Guinea", GI: "Gibraltar", GL: "Grønland", GP: "Guadeloupe", GR: "Grækenland", GU: "Guam", GY: "Guyana", HK: "Hong Kong", HU: "Ungarn", IE: "Irland", IL: "Israel", IN: "Indien", IS: "Island", IT: "Italien", JM: "Jamaica", JP: "Japan", KY: "Caymanøerne", LI: "Liechtenstein", LU: "Luxembourg", MC: "Monaco", MF: "Saint Martin", MQ: "Martinique", MT: "Malta", MX: "Mexico", MY: "Malaysia", NC: "Ny Kaledonien", NL: "Nederlandene", NO: "Norge", NZ: "New Zealand", PF: "Fransk Polynesien", PL: "Polen", PR: "Puerto Rico", PT: "Portugal", RE: "Reunion", SE: "Sverige", SG: "Singapore", SK: "Slovakiet", TR: "Tyrkiet", TN: "Tunesien", TT: "Trinidad og Tobago", UA: "Ukraine", US: "USA", VG: "Britiske Jomfruøer", VI: "Jomfruøerne (USA)", YT: "Mayotte", ZA: "Sydafrika" } } }, lu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Anwenden", "close-modal-aria-label": "Versandrechner schließen", "content-aria-label": "Versandinformationen anzeigen", "country-label": "Land", "delivery-options-title-label": "Lieferzeit", "delivery-today-message": "Heute", "delivery-tomorrow-message": "Morgen", "disclaimer-label": "Die Preise und Versandmethoden beziehen sich nur auf dieses von Ihnen ausgewählte Produkt. Der Gesamtpreis wird Ihnen im Warenkorb angezeigt.", "disclaimer-point-1-text": "Für bestimmte VistaPrint-Produkte und bei einigen Ländern sind nicht alle Versandarten verfügbar. Falls Ihre Bestellung Produkte mit unterschiedlichen Lieferzeiten enthält, wird diese eventuell in mehreren Teillieferungen zugestellt.", "free-shipping-label": "Kostenlos bei Bestellungen über {{{ Price }}}", "free-shipping-qualified-label": "Kostenlose Lieferung ist für Ihre Bestellung verfügbar.", "helper-text": "Mehr erfahren", "loader-text": "Versandinformationen werden aktualisiert", "no-delivery-message": "Versand an diese Adresse nicht möglich.", "not-found-message": "Keine Ergebnisse für PLZ {{{ PostalCode }}} gefunden", "postal-code-label": "Postleitzahl", "postal-code-validation-error-message": "Ungültige Postleitzahl. Versuchen Sie es noch einmal.", "selected-option-message": "Lieferung nach PLZ {{{ PostalCode }}} bis zum {{{ DeliveryDate }}}: {{{ Price }}}", "selected-option-message-for-free-delivery": "Gratis-Lieferung nach PLZ {{{ PostalCode }}} bis zum {{{ DeliveryDate }}}", "selected-option-message-without-price": "Schnelle Lieferung nach PLZ {{{ PostalCode }}} bis zum {{{ DeliveryDate }}}", "title-label": "Versandoptionen", "update-postal-code-message": "Postleitzahl aktualisieren", "zero-pricing-text": "Gratis", "cheapest-shipping-option": "Lieferung schon ab {{{ Price }}}", "free-shipping-message": "<u><b>Gratis-Versand</b></u> für Bestellungen ab {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Gratis-Versand</b></u> nach PLZ {{{ PostalCode }}} bis zum {{{ DeliveryDate }}}", "estimated-delivery-title-lable": "Voraussichtliche Lieferung", "estimated-delivery-disclaimer-label": "Die Preise und Versandmethoden beziehen sich nur auf dieses von Ihnen ausgewählte Produkt. Der Gesamtpreis wird Ihnen im Warenkorb angezeigt. Hinweis: Angaben zum Liefertermin sind Schätzungen.", "selected-option-estimated-message-without-price": "Voraussichtliche Lieferung nach PLZ {{{ PostalCode }}} zwischen {{{ FastestDeliveryDate }}} und {{{SlowestDeliveryDate}}}", singleOptionEstimatedMessageWithoutPrice: "Voraussichtliche Lieferung nach PLZ {{{ PostalCode }}} am {{{ DeliveryDate }}}" }, "shipping-information": { "shipping-information-button-text": "Details zu Lieferoptionen ansehen" }, "country-localization-map": { AE: "Vereinigte Arabische Emirate", AT: "Österreich", AU: "Australia", BB: "Barbados", BE: "Belgien", BM: "Bermuda", BR: "Brazil", BS: "Bahamas", CA: "Canada", CH: "Schweiz", CR: "Costa Rica", CY: "Zypern", CZ: "Tschechische Republik", DE: "Deutschland", DK: "Dänemark", ES: "Spanien", FI: "Finnland", FR: "France", GB: "United Kingdom", GF: "Französisch-Guyana", GI: "Gibraltar", GL: "Grönland", GP: "Guadeloupe", GR: "Griechenland", GU: "Guam", GY: "Guyana", HK: "Hongkong", HU: "Ungarn", IE: "Irland", IL: "Israel", IN: "India", IS: "Island", IT: "Italien", JM: "Jamaika", JP: "Japan", KY: "Kaimaninseln", LI: "Liechtenstein", LU: "Luxemburg", MC: "Monaco", MF: "St. Martin", MQ: "Martinique", MT: "Malta", MX: "Mexiko", MY: "Malaysia", NC: "Neukaledonien", NL: "Niederlande", NO: "Norwegen", NZ: "Neuseeland", PF: "Französisch-Polynesien", PL: "Polen", PR: "Puerto Rico", PT: "Portugal", RE: "Réunion", SE: "Schweden", SG: "Singapur", SK: "Slowakei", TR: "Türkei", TN: "Tunesien", TT: "Trinidad und Tobago", UA: "Ukraine", US: "Vereinigte Staaten von Amerika", VG: "Britische Jungferninseln", VI: "Amerikanische Jungferninseln", YT: "Mayotte", ZA: "Südafrika" } } }, cu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Apply", "close-modal-aria-label": "Close Delivery Options Modal", "content-aria-label": "Delivery options dialog box", "country-label": "* Country", "delivery-options-title-label": "Delivery time", "delivery-today-message": "Today", "delivery-tomorrow-message": "Tomorrow", "disclaimer-label": "Price and delivery options apply to the selected product only. Total price will be calculated in your shopping basket.", "disclaimer-point-1-text": "Not all delivery speeds are available for all VistaPrint products and destinations. If your order includes products with different delivery speeds, it’s possible the order will be split into separate packages.", "free-shipping-label": "Free on orders over {{{ Price }}}", "free-shipping-qualified-label": "You qualify for free delivery!", "helper-text": "Learn more", "loader-text": "Updating delivery options", "no-delivery-message": "Delivery to {{{ PostalCode }}} not available", "not-found-message": "There are no delivery options found for {{{ PostalCode }}}", "postal-code-label": "Postcode", "postal-code-validation-error-message": "Invalid postcode. Try again.", "selected-option-message": "Delivery by {{{ DeliveryDate }}} to {{{ PostalCode }}} for {{{ Price }}}", "selected-option-message-for-free-delivery": "Free delivery by {{{ DeliveryDate }}} to {{{ PostalCode }}}", "selected-option-message-without-price": "Get it as soon as {{{ DeliveryDate }}} to {{{ PostalCode }}}", "title-label": "Delivery options", "update-postal-code-message": "Update postcode", "zero-pricing-text": "Free", "cheapest-shipping-option": "Delivery starting at {{{ Price }}}", "free-shipping-message": "<u><b>Free delivery</b></u> on orders over {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Free delivery</b></u> by {{{ DeliveryDate }}} to {{{ PostalCode }}}", "estimated-delivery-title-lable": "Estimated delivery", "estimated-delivery-disclaimer-label": "Price and delivery options apply to the selected product only. Total price will be calculated in your shopping basket. Note: dates are estimated", "selected-option-estimated-message-without-price": "Estimated delivery {{{ FastestDeliveryDate }}} – {{{SlowestDeliveryDate}}}  to {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Estimated delivery {{{ DeliveryDate }}}  to {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "View details about delivery options" }, "country-localization-map": { AE: "United Arab Emirates", AT: "Austria", AU: "Australia", BB: "Barbados", BE: "Belgium", BM: "Bermuda", BR: "Brazil", BS: "Bahamas", CA: "Canada", CH: "Switzerland", CR: "Costa Rica", CY: "Cyprus", CZ: "Czech Republic", DE: "Germany", DK: "Denmark", ES: "Spain", FI: "Finland", FR: "France", GB: "United Kingdom", GF: "French Guiana", GI: "Gibraltar", GL: "Greenland", GP: "Guadeloupe", GR: "Greece", GU: "Guam", GY: "Guyana", HK: "Hong Kong", HU: "Hungary", IE: "Ireland", IL: "Israel", IN: "India", IS: "Iceland", IT: "Italy", JM: "Jamaica", JP: "Japan", KY: "Cayman Islands", LI: "Liechtenstein", LU: "Luxembourg", MC: "Monaco", MF: "Saint Martin", MQ: "Martinique", MT: "Malta", MX: "Mexico", MY: "Malaysia", NC: "New Caledonia", NL: "Netherlands", NO: "Norway", NZ: "New Zealand", PF: "French Polynesia", PL: "Poland", PR: "Puerto Rico", PT: "Portugal", RE: "Reunion", SE: "Sweden", SG: "Singapore", SK: "Slovakia", TR: "Turkey", TN: "Tunisia", TT: "Trinidad and Tobago", UA: "Ukraine", US: "United States of America", VG: "Virgin Islands (British)", VI: "Virgin Islands (US)", YT: "Mayotte", ZA: "South Africa" } } }, uu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Apply", "close-modal-aria-label": "Close Delivery Options Modal", "content-aria-label": "Delivery options dialog box", "country-label": "* Country", "delivery-options-title-label": "Delivery time", "delivery-today-message": "Today", "delivery-tomorrow-message": "Tomorrow", "disclaimer-label": "Price and delivery options apply to the selected product only. Total price will be calculated in your shopping basket.", "disclaimer-point-1-text": "Not all delivery speeds are available for all VistaPrint products and destinations. If your order includes products with different delivery speeds, it’s possible the order will be split into separate packages.", "free-shipping-label": "Free on orders over {{{ Price }}}", "free-shipping-qualified-label": "You qualify for free delivery!", "helper-text": "Learn more", "loader-text": "Updating delivery options", "no-delivery-message": "Delivery to {{{ PostalCode }}} not available", "not-found-message": "There are no delivery options found for {{{ PostalCode }}}", "postal-code-label": "pincode", "postal-code-validation-error-message": "Invalid pincode. Try again.", "selected-option-message": "Delivery by {{{ DeliveryDate }}} to {{{ PostalCode }}} for {{{ Price }}}", "selected-option-message-for-free-delivery": "Free delivery by {{{ DeliveryDate }}} to {{{ PostalCode }}}", "selected-option-message-without-price": "Get it as soon as {{{ DeliveryDate }}} to {{{ PostalCode }}}", "title-label": "Delivery options", "update-postal-code-message": "Update pincode", "zero-pricing-text": "Free", "cheapest-shipping-option": "Delivery starting at {{{ Price }}}", "free-shipping-message": "<u><b>Free delivery</b></u> on orders over {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Free shipping</b></u> by {{{ DeliveryDate }}} to {{{ PostalCode }}}", "estimated-delivery-title-lable": "Estimated delivery", "estimated-delivery-disclaimer-label": "Price and delivery options apply to the selected product only. Total price will be calculated in your shopping basket. Note: dates are estimated", "selected-option-estimated-message-without-price": "Estimated delivery {{{ FastestDeliveryDate }}} – {{{SlowestDeliveryDate}}}  to {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Estimated delivery {{{ DeliveryDate }}}  to {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "View details about delivery options" }, "country-localization-map": { AE: "United Arab Emirates", AT: "Austria", AU: "Australia", BB: "Barbados", BE: "Belgium", BM: "Bermuda", BR: "Brazil", BS: "Bahamas", CA: "Canada", CH: "Switzerland", CR: "Costa Rica", CY: "Cyprus", CZ: "Czech Republic", DE: "Germany", DK: "Denmark", ES: "Spain", FI: "Finland", FR: "France", GB: "United Kingdom", GF: "French Guiana", GI: "Gibraltar", GL: "Greenland", GP: "Guadeloupe", GR: "Greece", GU: "Guam", GY: "Guyana", HK: "Hong Kong", HU: "Hungary", IE: "Ireland", IL: "Israel", IN: "India", IS: "Iceland", IT: "Italy", JM: "Jamaica", JP: "Japan", KY: "Cayman Islands", LI: "Liechtenstein", LU: "Luxembourg", MC: "Monaco", MF: "Saint Martin", MQ: "Martinique", MT: "Malta", MX: "Mexico", MY: "Malaysia", NC: "New Caledonia", NL: "Netherlands", NO: "Norway", NZ: "New Zealand", PF: "French Polynesia", PL: "Poland", PR: "Puerto Rico", PT: "Portugal", RE: "Reunion", SE: "Sweden", SG: "Singapore", SK: "Slovakia", TR: "Turkey", TN: "Tunisia", TT: "Trinidad and Tobago", UA: "Ukraine", US: "United States of America", VG: "Virgin Islands (British)", VI: "Virgin Islands (US)", YT: "Mayotte", ZA: "South Africa" } } }, du = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Apply", "close-modal-aria-label": "Close Shipping Options Modal", "content-aria-label": "Shipping options dialog box", "country-label": "Country", "delivery-options-title-label": "Delivery time", "delivery-today-message": "Today", "delivery-tomorrow-message": "Tomorrow", "disclaimer-label": "Price and shipping options apply to this selected product only. Total price will be calculated in cart.", "disclaimer-point-1-text": "Some VistaPrint products and destinations are not available in all shipping speeds. If your order includes products with different shipping speeds, it can be split into separate packages.", "free-shipping-label": "Free on orders over {{{ Price }}}", "free-shipping-qualified-label": "You qualify for free shipping!", "helper-text": "Learn more", "loader-text": "Updating delivery options", "no-delivery-message": "Delivery to {{{ PostalCode }}} not available", "not-found-message": "There are no delivery options found for {{{ PostalCode }}}", "postal-code-label": "ZIP code", "postal-code-validation-error-message": "Invalid ZIP code. Try again.", "selected-option-message": "Delivery by {{{ DeliveryDate }}} to {{{ PostalCode }}} for {{{ Price }}}", "selected-option-message-for-free-delivery": "Free delivery by {{{ DeliveryDate }}} to {{{ PostalCode }}}", "selected-option-message-without-price": "Get it as soon as {{{ DeliveryDate }}} to {{{ PostalCode }}}", "title-label": "Delivery options", "update-postal-code-message": "Update ZIP code", "zero-pricing-text": "Free", "cheapest-shipping-option": "Delivery starting at {{{ Price }}}", "free-shipping-message": "<u><b>Free shipping</b></u> on orders over {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Free shipping</b></u> by {{{ DeliveryDate }}} to {{{ PostalCode }}}", "estimated-delivery-title-lable": "Estimated delivery", "estimated-delivery-disclaimer-label": "Price and shipping options apply to this selected product only. Total price will be calculated in cart. Note: dates are estimated", "selected-option-estimated-message-without-price": "Estimated delivery {{{ FastestDeliveryDate }}} - {{{SlowestDeliveryDate}}}  to {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Estimated delivery {{{ DeliveryDate }}}  to {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "View details about shipping options" }, "country-localization-map": { AE: "United Arab Emirates", AT: "Austria", AU: "Australia", BB: "Barbados", BE: "Belgium", BM: "Bermuda", BR: "Brazil", BS: "Bahamas", CA: "Canada", CH: "Switzerland", CR: "Costa Rica", CY: "Cyprus", CZ: "Czech Republic", DE: "Germany", DK: "Denmark", ES: "Spain", FI: "Finland", FR: "France", GB: "United Kingdom", GF: "French Guiana", GI: "Gibraltar", GL: "Greenland", GP: "Guadeloupe", GR: "Greece", GU: "Guam", GY: "Guyana", HK: "Hong Kong", HU: "Hungary", IE: "Ireland", IL: "Israel", IN: "India", IS: "Iceland", IT: "Italy", JM: "Jamaica", JP: "Japan", KY: "Cayman Islands", LI: "Liechtenstein", LU: "Luxembourg", MC: "Monaco", MF: "Saint Martin", MQ: "Martinique", MT: "Malta", MX: "Mexico", MY: "Malaysia", NC: "New Caledonia", NL: "Netherlands", NO: "Norway", NZ: "New Zealand", PF: "French Polynesia", PL: "Poland", PR: "Puerto Rico", PT: "Portugal", RE: "Reunion", SE: "Sweden", SG: "Singapore", SK: "Slovakia", TR: "Turkey", TN: "Tunisia", TT: "Trinidad and Tobago", UA: "Ukraine", US: "United States of America", VG: "Virgin Islands (British)", VI: "Virgin Islands (US)", YT: "Mayotte", ZA: "South Africa" } } }, pu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Aplicar", "close-modal-aria-label": "Cerrar modal de opciones de envío", "content-aria-label": "Caja de diálogo de opciones de envío", "country-label": "País", "delivery-options-title-label": "Plazo de entrega", "delivery-today-message": "Hoy", "delivery-tomorrow-message": "Mañana", "disclaimer-label": "Los precios y las opciones de envío corresponden solo al producto seleccionado. El precio total se calculará en la cesta.", "disclaimer-point-1-text": "Algunos destinos y productos de VistaPrint no están disponibles con todas las velocidades de envío. Si tu pedido incluye pedidos con velocidades de envío distintas, se podrá dividir en paquetes distintos.", "free-shipping-label": "Gratis en pedidos superiores a {{{ Price }}}", "free-shipping-qualified-label": "¡Tu envío es gratuito!", "helper-text": "Más información", "loader-text": "Actualizando opciones de envío", "no-delivery-message": "Los envíos a {{{ PostalCode }}} no están disponibles", "not-found-message": "No hemos encontrado opciones de envío para {{{ PostalCode }}}", "postal-code-label": "Código postal", "postal-code-validation-error-message": "Código postal no válido. Vuelve a intentarlo.", "selected-option-message": "Entrega antes del {{{ DeliveryDate }}} al {{{ PostalCode }}} por {{{ Price }}}", "selected-option-message-for-free-delivery": "Entrega gratis antes del {{{ DeliveryDate }}} al {{{ PostalCode }}}", "selected-option-message-without-price": "Recíbelo el {{{ DeliveryDate }}} para {{{ PostalCode }}}", "title-label": "Opciones de envío", "update-postal-code-message": "Actualiza tu código postal", "zero-pricing-text": "Gratis", "cheapest-shipping-option": "Envíos a partir de {{{ Price }}}", "free-shipping-message": "<u><b>Envío gratis</b></u> en pedidos superiores a {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Envío gratis</b></u> antes del {{{ DeliveryDate }}} al {{{ PostalCode }}}", "estimated-delivery-title-lable": "Entrega estimada", "estimated-delivery-disclaimer-label": "Los precios y las opciones de envío corresponden solo al producto seleccionado. El precio total se calculará en la cesta. Importante: las fechas son aproximadas", "selected-option-estimated-message-without-price": "Entrega estimada del {{{ FastestDeliveryDate }}} al {{{SlowestDeliveryDate}}} a {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Entrega estimada el {{{ DeliveryDate }}} a {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Ver detalles sobre las opciones de envío" }, "country-localization-map": { AE: "Emiratos Árabes Unidos", AT: "Austria", AU: "Australia", BB: "Barbados", BE: "Bélgica", BM: "Bermudas", BR: "Brazil", BS: "Bahamas", CA: "Canadá", CH: "Suiza", CR: "Costa Rica", CY: "Chipre", CZ: "República checa", DE: "Alemania", DK: "Dinamarca", ES: "España", FI: "Finlandia", FR: "Francia", GB: "Reino Unido", GF: "Guayana Francesa", GI: "Gibraltar", GL: "Groenlandia", GP: "Guadalupe", GR: "Grecia", GU: "Guam", GY: "Guyana", HK: "Hong Kong", HU: "Hungría", IE: "Irlanda", IL: "Israel", IN: "India", IS: "Islandia", IT: "Italia", JM: "Jamaica", JP: "Japón", KY: "Islas Caimán", LI: "Liechtenstein", LU: "Luxemburgo", MC: "Mónaco", MF: "San Martín", MQ: "Martinica", MT: "Malta", MX: "México", MY: "Malasia", NC: "Nueva Caledonia", NL: "Países Bajos", NO: "Noruega", NZ: "Nueva Zelanda", PF: "Polinesia Francesa", PL: "Polonia", PR: "Puerto Rico", PT: "Portugal", RE: "Reunión", SE: "Suecia", SG: "Singapur", SK: "Eslovaquia", TR: "Turquía", TN: "Túnez", TT: "Trinidad y Tobago", UA: "Ucrania", US: "Estados Unidos de América", VG: "Islas Vírgenes Británicas", VI: "Islas Vírgenes de los Estados Unidos", YT: "Mayotte", ZA: "Sudáfrica" } } }, hu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Aplicar", "close-modal-aria-label": "Cerrar modal de opciones de envío", "content-aria-label": "Casilla de diálogo de opciones de envío", "country-label": "* País", "delivery-options-title-label": "Tiempo de entrega", "delivery-today-message": "Hoy", "delivery-tomorrow-message": "Mañana", "disclaimer-label": "El precio y opciones de envío aplican solamente a este producto seleccionado. El precio total se calculará en el carrito de compras.", "disclaimer-point-1-text": "Algunos productos de VistaPrint y destinos no están disponibles para todas las opciones de envío. Si su pedido incluye productos con diferentes tiempos de entrega, se podrá dividir en varios paquetes.", "free-shipping-label": "Gratis para pedidos de más de {{{ Price }}}", "free-shipping-qualified-label": "¡Su pedido califica para envío gratis!", "helper-text": "Más información", "loader-text": "Actualizando las opciones de entrega", "no-delivery-message": "La entrega en {{{ PostalCode }}} no está disponible", "not-found-message": "No se encontraron opciones para efectuar la entrega en {{{ PostalCode }}}", "postal-code-label": "Código postal", "postal-code-validation-error-message": "Código postal no válido. Vuelva a intentarlo.", "selected-option-message": "Entrega a más tardar el {{{ DeliveryDate }}} en {{{ PostalCode }}} por {{{ Price }}}", "selected-option-message-for-free-delivery": "Entrega gratis a más tardar el {{{ DeliveryDate }}} en {{{ PostalCode }}}", "selected-option-message-without-price": "Recíbala ya desde {{{ DeliveryDate }}} en {{{ PostalCode }}}", "title-label": "Opciones de entrega", "update-postal-code-message": "Actualizar código postal", "zero-pricing-text": "Entrega gratis", "cheapest-shipping-option": "desde {{{ Price }}}", "free-shipping-message": "<u><b>Envío gratis</b></u> en pedidos de más de {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Envío gratis</b></u> para el {{{ DeliveryDate }}} en {{{ PostalCode }}}", "estimated-delivery-title-lable": "Entrega estimada", "estimated-delivery-disclaimer-label": "El precio y opciones de envío aplican solamente a este producto seleccionado. El precio total se calculará en el carrito de compras. Nota: Las fechas son estimadas", "selected-option-estimated-message-without-price": "Entrega estimada {{{ FastestDeliveryDate }}} - {{{SlowestDeliveryDate}}} a {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Entrega estimada para {{{ DeliveryDate }}} a {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Ver detalles de opciones de envío" }, "country-localization-map": { AE: "Emiratos Árabes Unidos", AT: "Austria", AU: "Australia", BB: "Barbados", BE: "Bélgica", BM: "Bermuda", BR: "Brasil", BS: "Bahamas", CA: "Canadá", CH: "Suiza", CR: "Costa Rica", CY: "Chipre", CZ: "República Checa", DE: "Alemania", DK: "Dinamarca", ES: "España", FI: "Finlandia", FR: "Francia", GB: "Reino Unido", GF: "Guayana Francesa", GI: "Gibraltar", GL: "Groenlandia", GP: "Guadalupe", GR: "Grecia", GU: "Guam", GY: "Guyana", HK: "Hong Kong", HU: "Hungría", IE: "Irlanda", IL: "Israel", IN: "India", IS: "Islandia", IT: "Italia", JM: "Jamaica", JP: "Japón", KY: "Islas Caimán", LI: "Liechtenstein", LU: "Luxemburgo", MC: "Mónaco", MF: "San Martín", MQ: "Martinica", MT: "Malta", MX: "México", MY: "Malasia", NC: "Nueva Caledonia", NL: "Países Bajos", NO: "Noruega", NZ: "Nueva Zelanda", PF: "Polinesia Francesa", PL: "Polonia", PR: "Puerto Rico", PT: "Portugal", RE: "Reunión", SE: "Suecia", SG: "Singapur", SK: "Eslovaquia", TR: "Turquía", TN: "Túnez", TT: "Trinidad y Tobago", UA: "Ucrania", US: "Estados Unidos", VG: "Islas Vírgenes (Británicas)", VI: "Islas Vírgenes (Estados Unidos)", YT: "Mayotte", ZA: "Sudáfrica" } } }, mu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Käytä", "close-modal-aria-label": "Sulje toimitusvaihtoehtojen valintaikkuna", "content-aria-label": "Toimitusvaihtoehtojen valintaikkuna", "country-label": "Maa", "delivery-options-title-label": "Toimitusaika", "delivery-today-message": "Tänään", "delivery-tomorrow-message": "Huomenna", "disclaimer-label": "Hinta- ja toimitusvaihtoehdot koskevat vain valitsemaasi tuotetta. Kokonaishinta näkyy ostoskorissa.", "disclaimer-point-1-text": "Joitain toimituskohteita ja VistaPrintin tuotteita koskee poikkeukselliset toimitusnopeudet. Jos tilaukseesi sisältyy tuotteita, joilla on poikkeukselliset toimitusnopeudet, ne saatetaan toimittaa erikseen.", "free-shipping-label": "Ilmainen yli {{{ Price }}} tilauksille", "free-shipping-qualified-label": "Olet oikeutettu ilmaiseen toimitukseen!", "helper-text": "Lue lisää", "loader-text": "Toimitusvaihtoehtojen päivittäminen", "no-delivery-message": "Toimitus osoitteeseen {{{ PostalCode }}} ei ole saatavana", "not-found-message": "Osoitteeseen {{{ PostalCode }}} ei löydy toimitusvaihtoehtoja", "postal-code-label": "Postinumero", "postal-code-validation-error-message": "Virheellinen postinumero. Yritä uudelleen.", "selected-option-message": "Toimitus {{{ DeliveryDate }}} mennessä Postinumero: {{{ PostalCode }}} Hinta: {{{ Price }}}", "selected-option-message-for-free-delivery": "Maksuton toimitus {{{ DeliveryDate }}} mennessä Postinumero: {{{ PostalCode }}}", "selected-option-message-without-price": "Toimitus jo {{{ DeliveryDate }}} ja {{{ PostalCode }}} välillä", "title-label": "Toimitusvaihtoehdot", "update-postal-code-message": "Päivitä postinumero", "zero-pricing-text": "Ilmainen", "cheapest-shipping-option": "Toimitus alkaen {{{ Price }}}", "free-shipping-message": "<u><b>Ilmainen toimitus</b></u> yli {{{ Price }}} tilauksille", "free-shipping-message-with-postalcode": "<u><b>Ilmainen toimitus</b> </u>{{{ DeliveryDate }}} mennessä sijaintiin{{{ PostalCode }}}", "estimated-delivery-title-lable": "Arvioitu toimitusaika", "estimated-delivery-disclaimer-label": "Hinta- ja toimitusvaihtoehdot koskevat vain valitsemaasi tuotetta. Kokonaishinta näkyy ostoskorissa. Huom: päivät ovat arvioita", "selected-option-estimated-message-without-price": "Arvioitu toimitusaika: {{{ FastestDeliveryDate }}}–{{{SlowestDeliveryDate}}} kohteeseen {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Arvioitu toimitusaika: {{{ DeliveryDate }}}–{{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Näytä toimituksen tiedot" }, "country-localization-map": { AE: "Arabiemiirikunnat", AT: "Itävalta", AU: "Australia", BB: "Barbados", BE: "Belgia", BM: "Bermuda", BR: "Brasilia", BS: "Bahama", CA: "Kanada", CH: "Sveitsi", CR: "Costa Rica", CY: "Kypros", CZ: "Tšekin tasavalta", DE: "Saksa", DK: "Tanska", ES: "Espanja", FI: "Suomi", FR: "Ranska", GB: "Yhdistynyt kuningaskunta", GF: "Ranskan Guayana", GI: "Gibraltar", GL: "Grönlanti", GP: "Guadeloupe", GR: "Kreikka", GU: "Guam", GY: "Guyana", HK: "Hongkong", HU: "Unkari", IE: "Irlanti", IL: "Israel", IN: "Intia", IS: "Islanti", IT: "Italia", JM: "Jamaika", JP: "Japani", KY: "Caymansaaret", LI: "Liechtenstein", LU: "Luxemburg", MC: "Monaco", MF: "Saint Martin", MQ: "Martinique", MT: "Malta", MX: "Meksiko", MY: "Malesia", NC: "Uusi-Kaledonia", NL: "Alankomaat", NO: "Norja", NZ: "Uusi Seelanti", PF: "Ranskan Polynesia", PL: "Puola", PR: "Puerto Rico", PT: "Portugali", RE: "Reunion", SE: "Ruotsi", SG: "Singapore", SK: "Slovakia", TR: "Turkki", TN: "Tunisia", TT: "Trinidad ja Tobago", UA: "Ukraina", US: "Yhdysvallat", VG: "Brittiläiset Neitsytsaaret", VI: "Yhdysvaltain Neitsytsaaret", YT: "Mayotte", ZA: "Etelä-Afrikka" } } }, gu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Appliquer", "close-modal-aria-label": "Fermer les options d'expédition", "content-aria-label": "Boîte de dialogue d’options d'expédition", "country-label": "Pays", "delivery-options-title-label": "Heure de livraison", "delivery-today-message": "Aujourd'hui", "delivery-tomorrow-message": "Demain", "disclaimer-label": "Le prix et les options de livraison s’appliquent uniquement à ce produit sélectionné. Le prix total sera calculé dans le panier.", "disclaimer-point-1-text": "Les délais de livraison ne sont pas tous proposés pour certaines destinations et certains produits VistaPrint. Si votre commande comporte des produits dont les délais de livraison diffèrent, elle peut être divisée en plusieurs envois distincts.", "free-shipping-label": "Gratuit avec des commandes de plus de {{{ Price }}}", "free-shipping-qualified-label": "Vous vous qualifiez pour bénéficier de la livraison gratuite!", "helper-text": "En savoir plus", "loader-text": "Mise à jour des options de livraison", "no-delivery-message": "Livraison à {{{ PostalCode }}} non disponible", "not-found-message": "Aucune option de livraison n'a été trouvée pour {{{ PostalCode }}}", "postal-code-label": "Code postal", "postal-code-validation-error-message": "Code postal invalide. Veuillez réessayer.", "selected-option-message": "Livraison {{{ DeliveryDate }}} à {{{ PostalCode }}} pour {{{ Price }}}", "selected-option-message-for-free-delivery": "Livraison offerte {{{ DeliveryDate }}} à {{{ PostalCode }}}", "selected-option-message-without-price": "Recevez votre commande dès le {{{ DeliveryDate }}} jusqu’au {{{ PostalCode }}}", "title-label": "Options de livraison", "update-postal-code-message": "Mettre à jour le code postal", "zero-pricing-text": "Gratuit", "cheapest-shipping-option": "Livraison à partir de {{{ Price }}}", "free-shipping-message": "<u><b>Livraison offerte</b></u> dès {{{ Price }}} d’achats", "free-shipping-message-with-postalcode": "<u><b>Livraison offerte</b></u> jusqu’au {{{ DeliveryDate }}} au {{{ PostalCode }}}", "estimated-delivery-title-lable": "Date de livraison prévue", "estimated-delivery-disclaimer-label": "Le prix et les options de livraison s’appliquent uniquement à ce produit sélectionné. Le prix total sera calculé dans le panier. Note : les dates correspondent à des estimations", "selected-option-estimated-message-without-price": "Date de livraison prévue : {{{ FastestDeliveryDate }}} - {{{SlowestDeliveryDate}}} à {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Date de livraison prévue : {{{ DeliveryDate }}} à {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Afficher les détails des options de livraison" }, "country-localization-map": { AE: "Émirats arabes unis", AT: "Autriche", AU: "Australie", BB: "Barbade", BE: "Belgique", BM: "Bermudes", BR: "Brésil", BS: "Bahamas", CA: "Canada", CH: "Suisse", CR: "Costa Rica", CY: "Chypre", CZ: "République tchèque", DE: "Allemagne", DK: "Danemark", ES: "Espagne", FI: "Finlande", FR: "France", GB: "Royaume-Uni", GF: "Guyane française", GI: "Gibraltar", GL: "Groenland", GP: "Guadeloupe", GR: "Grèce", GU: "Guam", GY: "Guyane", HK: "Hong Kong", HU: "Hongrie", IE: "Irlande", IL: "Israël", IN: "Inde", IS: "Islande", IT: "Italie", JM: "Jamaïque", JP: "Japon", KY: "Îles Caïmans", LI: "Liechtenstein", LU: "Luxembourg", MC: "Monaco", MF: "Saint-Martin", MQ: "Martinique", MT: "Malte", MX: "Mexique", MY: "Malaisie", NC: "Nouvelle-Calédonie", NL: "Pays-Bas", NO: "Norvège", NZ: "Nouvelle-Zélande", PF: "Polynésie française", PL: "Pologne", PR: "Porto Rico", PT: "Portugal", RE: "Réunion", SE: "Suède", SG: "Singapour", SK: "Slovaquie", TR: "Turquie", TN: "Tunisie", TT: "Trinité-et-Tobago", UA: "Ukraine", US: "États-Unis d'Amérique", VG: "Îles Vierges (britanniques)", VI: "Îles Vierges (américaines)", YT: "Mayotte", ZA: "Afrique du Sud" } } }, fu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Appliquer", "close-modal-aria-label": "Fermer la fenêtre des options de livraison", "content-aria-label": "Boîte de dialogue des options de livraison", "country-label": "* Pays", "delivery-options-title-label": "Délais de livraison", "delivery-today-message": "Aujourd’hui", "delivery-tomorrow-message": "Demain", "disclaimer-label": "Le prix et les options de livraison s’appliquent exclusivement au produit sélectionné. Le prix total sera calculé dans le panier d’achat.", "disclaimer-point-1-text": "Certains produits VistaPrint et certaines destinations ne sont pas compatibles avec l’ensemble des délais de livraison. Si votre commande comprend des produits avec des délais de livraison différents, elle peut être livrée en plusieurs fois.", "free-shipping-label": "Gratuit dès {{{ Price }}} d’achats", "free-shipping-qualified-label": "Vous bénéficiez de la livraison offerte !", "helper-text": "En savoir plus", "loader-text": "Mise à jour des options de livraison", "no-delivery-message": "Livraison non disponible pour {{{ PostalCode }}}", "not-found-message": "Il n’existe aucune option de livraison pour {{{ PostalCode }}}", "postal-code-label": "Code postal", "postal-code-validation-error-message": "Code postal non valide. Réessayez.", "selected-option-message": "Livraison le {{{ DeliveryDate }}} à {{{ PostalCode }}} pour {{{ Price }}}", "selected-option-message-for-free-delivery": "Livraison le {{{ DeliveryDate }}} à {{{ PostalCode }}} offerte", "selected-option-message-without-price": "Vous le recevrez le {{{ DeliveryDate }}} à {{{ PostalCode }}}", "title-label": "Options de livraison", "update-postal-code-message": "Mettez à jour le code postal", "zero-pricing-text": "Gratuit", "cheapest-shipping-option": "Livraison à partir de {{{ Price }}}", "free-shipping-message": "<u><b>Livraison offerte</b></u> dès {{{ Price }}} d’achats", "free-shipping-message-with-postalcode": "<u><b>Livraison offerte</b></u> le {{{ DeliveryDate }}} à {{{ PostalCode }}}", "estimated-delivery-title-lable": "Livraison prévue", "estimated-delivery-disclaimer-label": "Le prix et les options de livraison s’appliquent exclusivement au produit sélectionné. Le prix total sera calculé dans le panier d’achat. NB : les dates sont des estimations", "selected-option-estimated-message-without-price": "Livraison prévue : {{{ FastestDeliveryDate }}} - {{{SlowestDeliveryDate}}} à  {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Livraison prévue : {{{ DeliveryDate }}}  à {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Voir plus d’informations sur les options de livraison" }, "country-localization-map": { AE: "Émirats arabes unis", AT: "Autriche", AU: "Australie", BB: "Barbade", BE: "Belgique", BM: "Bermudes", BR: "Brazil", BS: "Bahamas", CA: "Canada", CH: "Suisse", CR: "Costa Rica", CY: "Chypre", CZ: "République tchèque", DE: "Allemagne", DK: "Danemark", ES: "Espagne", FI: "Finlande", FR: "France", GB: "United Kingdom", GF: "Guyane française", GI: "Gibraltar", GL: "Groenland", GP: "Guadeloupe", GR: "Grèce", GU: "Guam", GY: "Guyana", HK: "Hong Kong", HU: "Hongrie", IE: "Irlande", IL: "Israël", IN: "Inde", IS: "Islande", IT: "Italie", JM: "Jamaïque", JP: "Japon", KY: "Îles Caïmans", LI: "Liechtenstein", LU: "Luxembourg", MC: "Monaco", MF: "Saint-Martin", MQ: "Martinique", MT: "Malte", MX: "Mexique", MY: "Malaisie", NC: "Nouvelle-Calédonie", NL: "Pays-Bas", NO: "Norvège", NZ: "Nouvelle-Zélande", PF: "Polynésie française", PL: "Pologne", PR: "Porto Rico", PT: "Portugal", RE: "Réunion", SE: "Suède", SG: "Singapour", SK: "Slovaquie", TR: "Turquie", TN: "Tunisie", TT: "Trinité-et-Tobago", UA: "Ukraine", US: "États-Unis d'Amérique", VG: "Îles Vierges britanniques", VI: "Îles Vierges américaines", YT: "Mayotte", ZA: "Afrique du Sud" } } }, yu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Applica", "close-modal-aria-label": "Chiudi finestra modalità di spedizione", "content-aria-label": "Finestra di dialogo modalità di spedizione", "country-label": "Paese", "delivery-options-title-label": "Tempi di consegna", "delivery-today-message": "Oggi", "delivery-tomorrow-message": "Domani", "disclaimer-label": "Le opzioni relative a prezzi e spedizioni si applicano unicamente al prodotto selezionato. Il prezzo totale verrà calcolato nel carrello.", "disclaimer-point-1-text": "Per alcuni prodotti VistaPrint e destinazioni non sarà possibile scegliere tutti i tempi di spedizione. Se il tuo ordine include prodotti con tempi di spedizione diversi, può essere diviso in pacchi separati.", "free-shipping-label": "Gratis su ordini superiori a {{{ Price }}}", "free-shipping-qualified-label": "Puoi usufruire della spedizione gratuita!", "helper-text": "Ulteriori informazioni", "loader-text": "Aggiornamento modalità di consegna in corso", "no-delivery-message": "Consegna non disponibile per {{{ PostalCode }}}", "not-found-message": "Non abbiamo trovato alcuna modalità di consegna disponibile per {{{ PostalCode }}}", "postal-code-label": "CAP", "postal-code-validation-error-message": "CAP non valido. Riprova.", "selected-option-message": "Consegna entro {{{ DeliveryDate }}} all’indirizzo {{{ PostalCode }}}, al costo di {{{ Price }}}", "selected-option-message-for-free-delivery": "Consegna gratis entro {{{ DeliveryDate }}} all’indirizzo {{{ PostalCode }}}", "selected-option-message-without-price": "Ricevilo subito da {{{ DeliveryDate }}} a {{{ PostalCode }}}", "title-label": "Modalità di consegna", "update-postal-code-message": "Aggiorna CAP", "zero-pricing-text": "Gratis", "cheapest-shipping-option": "Consegna con inizio {{{ Price }}}", "free-shipping-message": "<u><b>Spedizione gratuita</b></u> per ordini superiori a {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Spedizione gratuita</b></u> entro{{{ DeliveryDate }}} fino a {{{ PostalCode }}}", "estimated-delivery-title-lable": "Consegna prevista", "estimated-delivery-disclaimer-label": "Le opzioni relative a prezzi e spedizioni si applicano unicamente al prodotto selezionato. Il prezzo totale verrà calcolato nel carrello. N.B.: le date sono una stima", "selected-option-estimated-message-without-price": "Consegna prevista: {{{ FastestDeliveryDate }}} - {{{SlowestDeliveryDate}}}  a {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Consegna prevista: {{{ DeliveryDate }}}  a {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Visualizza dettagli sulle opzioni di spedizione" }, "country-localization-map": { AE: "Emirati Arabi Uniti", AT: "Austria", AU: "Australia", BB: "Barbados", BE: "Belgio", BM: "Bermuda", BR: "Brazil", BS: "Bahamas", CA: "Canada", CH: "Svizzera", CR: "Costa Rica", CY: "Cipro", CZ: "Repubblica Ceca", DE: "Germania", DK: "Danimarca", ES: "Spagna", FI: "Finlandia", FR: "Francia", GB: "Regno Unito", GF: "Guyana francese", GI: "Gibilterra", GL: "Groenlandia", GP: "Guadalupa", GR: "Grecia", GU: "Guam", GY: "Guyana", HK: "Hong Kong", HU: "Ungheria", IE: "Irlanda", IL: "Israele", IN: "India", IS: "Islanda", IT: "Italia", JM: "Giamaica", JP: "Giappone", KY: "Isole Cayman", LI: "Liechtenstein", LU: "Lussemburgo", MC: "Principato di Monaco", MF: "Saint Martin", MQ: "Martinica", MT: "Malta", MX: "Messico", MY: "Malesia", NC: "Nuova Caledonia", NL: "Paesi Bassi", NO: "Norvegia", NZ: "Nuova Zelanda", PF: "Polinesia francese", PL: "Polonia", PR: "Porto Rico", PT: "Portogallo", RE: "Riunione", SE: "Svezia", SG: "Singapore", SK: "Slovacchia", TR: "Turchia", TN: "Tunisia", TT: "Trinidad e Tobago", UA: "Ucraina", US: "Stati Uniti d’America", VG: "Isole Vergini Britanniche", VI: "Isole Vergini Statunitensi", YT: "Mayotte", ZA: "Sudafrica" } } }, bu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Legg inn", "close-modal-aria-label": "Lukk modalvindu for fraktalternativer", "content-aria-label": "Dialogboks for fraktalternativer", "country-label": "Land", "delivery-options-title-label": "Leveringstid", "delivery-today-message": "I dag", "delivery-tomorrow-message": "I morgen", "disclaimer-label": "Pris- og leveringsalternativer gjelder kun for dette valgte produktet. Totalprisen blir beregnet i handlevognen.", "disclaimer-point-1-text": "Noen VistaPrint-produkter og destinasjoner er ikke tilgjengelige med alle leveringshastigheter. Hvis bestillingen din inneholder produkter med ulike leveringshastigheter, kan den deles opp i separate pakker.", "free-shipping-label": "Gratis for bestillinger over {{{ Price }}}", "free-shipping-qualified-label": "Du er kvalifisert for gratis frakt!", "helper-text": "Les mer", "loader-text": "Oppdaterer leveringsalternativer", "no-delivery-message": "Levering til {{{ PostalCode }}} ikke tilgjengelig", "not-found-message": "Det finnes ingen leveringsalternativer til {{{ PostalCode }}}", "postal-code-label": "Postnummer", "postal-code-validation-error-message": "Ugyldig postnummer. Vennligst prøv igjen.", "selected-option-message": "Levering innen {{{ DeliveryDate }}} til {{{ PostalCode }}} for {{{ Price }}}", "selected-option-message-for-free-delivery": "Gratis levering innen {{{ DeliveryDate }}} til {{{ PostalCode }}}", "selected-option-message-without-price": "Få det levert så snart som {{{ DeliveryDate }}} til {{{ PostalCode }}}", "title-label": "Leveringsalternativer", "update-postal-code-message": "Oppdater postnummer", "zero-pricing-text": "Gratis", "cheapest-shipping-option": "Frakt fra {{{ Price }}}", "free-shipping-message": "<u><b>Gratis levering</b></u> på bestillinger over {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Gratis levering</b></u> innen {{{ DeliveryDate }}} til {{{ PostalCode }}}", "estimated-delivery-title-lable": "Forventet levering", "estimated-delivery-disclaimer-label": "Pris- og leveringsalternativer gjelder kun for dette valgte produktet. Totalprisen blir beregnet i handlevognen. Merk: datoene er estimerte", "selected-option-estimated-message-without-price": "Estimert levering {{{ FastestDeliveryDate }}} - {{{SlowestDeliveryDate}}}  til {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Estimert levering {{{ DeliveryDate }}}  til {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Se informasjon om fraktalternativer" }, "country-localization-map": { AE: "Forente arabiske emirater", AT: "Østerrike", AU: "Australia", BB: "Barbados", BE: "Belgia", BM: "Bermuda", BR: "Brasil", BS: "Bahamas", CA: "Canada", CH: "Sveits", CR: "Costa Rica", CY: "Kypros", CZ: "Tsjekkia", DE: "Tyskland", DK: "Danmark", ES: "Spania", FI: "Finland", FR: "Frankrike", GB: "Storbritannia", GF: "Fransk Guyana", GI: "Gibraltar", GL: "Grønnland", GP: "Guadeloupe", GR: "Hellas", GU: "Guam", GY: "Guyana", HK: "Hongkong", HU: "Ungarn", IE: "Irland", IL: "Israel", IN: "India", IS: "Island", IT: "Italia", JM: "Jamaica", JP: "Japan", KY: "Caymanøyene", LI: "Liechtenstein", LU: "Luxembourg", MC: "Monaco", MF: "Saint Martin", MQ: "Martinique", MT: "Malta", MX: "Mexico", MY: "Malaysia", NC: "New Caledonia", NL: "Nederland", NO: "Norge", NZ: "New Zealand", PF: "Fransk Polynesia", PL: "Polen", PR: "Puerto Rico", PT: "Portugal", RE: "Reunion", SE: "Sverige", SG: "Singapore", SK: "Slovakia", TR: "Tyrkia", TN: "Tunisia", TT: "Trinidad og Tobago", UA: "Ukraina", US: "USA", VG: "Jomfruøyene (britisk)", VI: "Jomfruøyene (USA)", YT: "Mayotte", ZA: "Sør-Afrika" } } }, vu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Toepassen", "close-modal-aria-label": "Modaal verzendopties sluiten", "content-aria-label": "Dialoogvenster verzendopties", "country-label": "Land", "delivery-options-title-label": "Levertijd", "delivery-today-message": "Vandaag", "delivery-tomorrow-message": "Morgen", "disclaimer-label": "Prijzen en verzendopties gelden alleen voor dit geselecteerde product. De totaalprijs wordt berekend in het winkelwagentje.", "disclaimer-point-1-text": "Voor een aantal producten en bestemmingen van VistaPrint zijn niet alle levertijden beschikbaar. Als je bestelling producten met verschillende levertijden bevat, kan die opgesplitst worden in meerdere pakketten.", "free-shipping-label": "Gratis bestellingen vanaf {{{ Price }}}", "free-shipping-qualified-label": "Je komt in aanmerking voor gratis verzending!", "helper-text": "Meer weten?", "loader-text": "Leveringsopties worden bijgewerkt", "no-delivery-message": "Levering naar {{{ PostalCode }}} niet beschikbaar", "not-found-message": "Er zijn geen leveringsopties gevonden voor {{{ PostalCode }}}", "postal-code-label": "Postcode", "postal-code-validation-error-message": "Ongeldige postcode. Probeer het opnieuw.", "selected-option-message": "Bezorgd voor {{{ DeliveryDate }}} in {{{ PostalCode }}} voor {{{ Price }}}", "selected-option-message-for-free-delivery": "Gratis bezorgd voor {{{ DeliveryDate }}} in {{{ PostalCode }}}", "selected-option-message-without-price": "Ontvang het al op {{{ DeliveryDate }}} in {{{ PostalCode }}}", "title-label": "Verzendopties", "update-postal-code-message": "Postcode bijwerken", "zero-pricing-text": "Gratis", "cheapest-shipping-option": "Bezorging vanaf {{{ Price }}}", "free-shipping-message": "<u><b>Gratis bezorging</b></u> voor bestellingen vanaf {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Gratis bezorging</b></u> op {{{ DeliveryDate }}} in {{{ PostalCode }}}", "estimated-delivery-title-lable": "Geschatte bezorgdatum", "estimated-delivery-disclaimer-label": "Prijzen en verzendopties gelden alleen voor dit geselecteerde product. De totaalprijs wordt berekend in het winkelwagentje. Opmerking: datums zijn een schatting", "selected-option-estimated-message-without-price": "Geschatte bezorgdatum {{{ FastestDeliveryDate }}} - {{{SlowestDeliveryDate}}}  in {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Geschatte bezorgdatum {{{ DeliveryDate }}} in {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Bekijk meer informatie over verzendopties" }, "country-localization-map": { AE: "Verenigde Arabische Emiraten", AT: "Oostenrijk", AU: "Australië", BB: "Barbados", BE: "België", BM: "Bermuda", BR: "Brazil", BS: "Bahama's", CA: "Canada", CH: "Zwitserland", CR: "Costa Rica", CY: "Cyprus", CZ: "Tsjechië", DE: "Duitsland", DK: "Denemarken", ES: "Spanje", FI: "Finland", FR: "Frankrijk", GB: "Verenigd Koninkrijk", GF: "Frans-Guyana", GI: "Gibraltar", GL: "Groenland", GP: "Guadeloupe", GR: "Griekenland", GU: "Guam", GY: "Guyana", HK: "Hongkong", HU: "Hongarije", IE: "Ierland", IL: "Israël", IN: "India", IS: "IJsland", IT: "Italië", JM: "Jamaica", JP: "Japan", KY: "Kaaimaneilanden", LI: "Liechtenstein", LU: "Luxemburg", MC: "Monaco", MF: "Sint-Maarten", MQ: "Martinique", MT: "Malta", MX: "Mexico", MY: "Maleisië", NC: "Nieuw-Caledonië", NL: "Nederland", NO: "Noorwegen", NZ: "Nieuw-Zeeland", PF: "Frans-Polynesië", PL: "Polen", PR: "Puerto Rico", PT: "Portugal", RE: "Réunion", SE: "Zweden", SG: "Singapore", SK: "Slowakije", TR: "Turkije", TN: "Tunesië", TT: "Trinidad en Tobago", UA: "Oekraïne", US: "Verenigde Staten van Amerika", VG: "Maagdeneilanden (Britse)", VI: "Maagdeneilanden (VS)", YT: "Mayotte", ZA: "Zuid-Afrika" } } }, Su = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Aplicar", "close-modal-aria-label": "Fechar caixa de diálogo modal Opções de envio", "content-aria-label": "Caixa de diálogo Opções de envio", "country-label": "País", "delivery-options-title-label": "Prazo de entrega", "delivery-today-message": "Hoje", "delivery-tomorrow-message": "Amanhã", "disclaimer-label": "Os preços e as opções de envio aplicam-se apenas ao produto selecionado. O preço total será calculado no cesto.", "disclaimer-point-1-text": "Alguns produtos da VistaPrint e destinos não estão disponíveis em todas as velocidades de envio. Se a sua encomenda incluir produtos com diferentes velocidades de envio, poderá ser dividida em embalagens separadas.", "free-shipping-label": "Gratuito em encomendas superiores a {{{ Price }}}", "free-shipping-qualified-label": "Qualifica-se para o envio gratuito!", "helper-text": "Saiba mais", "loader-text": "A atualizar as opções de entrega", "no-delivery-message": "A entrega em {{{ PostalCode }}} não está disponível", "not-found-message": "Não foram encontradas opções de entrega para {{{ PostalCode }}}", "postal-code-label": "Código postal", "postal-code-validation-error-message": "Código postal inválido. Tente novamente.", "selected-option-message": "Entrega até {{{ DeliveryDate }}} em {{{ PostalCode }}} por {{{ Price }}}", "selected-option-message-for-free-delivery": "Entrega gratuita até {{{ DeliveryDate }}} em {{{ PostalCode }}}", "selected-option-message-without-price": "Receba já a {{{ DeliveryDate }}} em {{{ PostalCode }}}", "title-label": "Opções de entrega", "update-postal-code-message": "Atualize o código postal", "zero-pricing-text": "Grátis", "cheapest-shipping-option": "Entrega desde {{{ Price }}}", "free-shipping-message": "<u><b>Envio gratuito</b></u> em encomendas superiores a {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Envio gratuito</b></u> até {{{ DeliveryDate }}} para {{{ PostalCode }}}", "estimated-delivery-title-lable": "Data de entrega prevista", "estimated-delivery-disclaimer-label": "Os preços e as opções de envio aplicam-se apenas ao produto selecionado. O preço total será calculado no cesto. Nota: as datas são uma previsão", "selected-option-estimated-message-without-price": "Data de entrega prevista {{{ FastestDeliveryDate }}} - {{{SlowestDeliveryDate}}} para {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Data de entrega estimada: {{{ DeliveryDate }}} para {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Ver detalhes sobre opções de envio" }, "country-localization-map": { AE: "Emirados Árabes Unidos", AT: "Áustria", AU: "Austrália", BB: "Barbados", BE: "Bélgica", BM: "Bermudas", BR: "Brasil", BS: "Baamas", CA: "Canadá", CH: "Suíça", CR: "Costa Rica", CY: "Chipre", CZ: "República Checa", DE: "Alemanha", DK: "Dinamarca", ES: "Espanha", FI: "Finlândia", FR: "França", GB: "Reino Unido", GF: "Guiana Francesa", GI: "Gibraltar", GL: "Gronelândia", GP: "Guadalupe", GR: "Grécia", GU: "Guam", GY: "Guiana", HK: "Hong Kong", HU: "Hungria", IE: "Irlanda", IL: "Israel", IN: "Índia", IS: "Islândia", IT: "Itália", JM: "Jamaica", JP: "Japão", KY: "Ilhas Caimão", LI: "Listenstaine", LU: "Luxemburgo", MC: "Mónaco", MF: "Ilha de São Martinho", MQ: "Martinica", MT: "Malta", MX: "México", MY: "Malásia", NC: "Nova Caledónia", NL: "Países Baixos", NO: "Noruega", NZ: "Nova Zelândia", PF: "Polinésia Francesa", PL: "Polónia", PR: "Porto Rico", PT: "Portugal", RE: "Reunião", SE: "Suécia", SG: "Singapura", SK: "Eslováquia", TR: "Turquia", TN: "Tunísia", TT: "Trindade e Tobago", UA: "Ucrânia", US: "Estados Unidos da América", VG: "Ilhas Virgens (Britânicas)", VI: "Ilhas Virgens (EUA)", YT: "Mayotte", ZA: "África do Sul" } } }, Cu = { translation: { "shipping-calculator-experiment": {}, "shipping-calculator": { "apply-cta-text": "Tillämpa", "close-modal-aria-label": "Stäng det modala fönstret för leveransalternativ", "content-aria-label": "Dialogruta för leveransalternativ", "country-label": "Land", "delivery-options-title-label": "Leveranstid", "delivery-today-message": "Idag", "delivery-tomorrow-message": "Imorgon", "disclaimer-label": "Pris och leveransalternativ gäller endast för den här produkten. Totalsumman beräknas i kundvagnen.", "disclaimer-point-1-text": "Vissa VistaPrint-produkter och vissa leveransadresser är inte tillgängliga för alla typer av leveranser. Om din beställning innehåller produkter med olika leveranstider kan den delas upp i flera paket.", "free-shipping-label": "Gratis på beställningar över {{{ Price }}}", "free-shipping-qualified-label": "Du är kvalificerad för gratis leverans!", "helper-text": "Mer info", "loader-text": "Leveransalternativ uppdateras", "no-delivery-message": "Leverans till {{{ PostalCode }}} är inte möjlig", "not-found-message": "Inga leveransalternativ hittades för {{{ PostalCode }}}", "postal-code-label": "Postnummer", "postal-code-validation-error-message": "Ogiltigt postnummer. Försök igen.", "selected-option-message": "Leverans senast {{{ DeliveryDate }}} till {{{ PostalCode }}} för {{{ Price }}}", "selected-option-message-for-free-delivery": "Gratis leverans senast {{{ DeliveryDate }}} till {{{ PostalCode }}}", "selected-option-message-without-price": "Kan fås redan {{{ DeliveryDate }}} till {{{ PostalCode }}}", "title-label": "Leveransalternativ", "update-postal-code-message": "Uppdatera postnummer", "zero-pricing-text": "Kostnadsfritt", "cheapest-shipping-option": "Leverans från {{{ Price }}}", "free-shipping-message": "<u><b>Gratis leverans</b></u> på beställningar över {{{ Price }}}", "free-shipping-message-with-postalcode": "<u><b>Gratis leverans</b></u>senast {{{ DeliveryDate }}} till {{{ PostalCode }}}", "estimated-delivery-title-lable": "Beräknad leverans", "estimated-delivery-disclaimer-label": "Pris och leveransalternativ gäller endast för den här produkten. Totalsumman beräknas i kundvagnen. Obs! Uppskattat datum.", "selected-option-estimated-message-without-price": "Beräknad leverans {{{ FastestDeliveryDate }}}–{{{SlowestDeliveryDate}}} till {{{ PostalCode }}}", singleOptionEstimatedMessageWithoutPrice: "Beräknad leverans {{{ DeliveryDate }}} till {{{ PostalCode }}}" }, "shipping-information": { "shipping-information-button-text": "Visa detaljer om leveransalternativ" }, "country-localization-map": { AE: "Förenade Arabemiraten", AT: "Österrike", AU: "Australien", BB: "Barbados", BE: "Belgien", BM: "Bermuda", BR: "Brazil", BS: "Bahamas", CA: "Kanada", CH: "Schweiz", CR: "Costa Rica", CY: "Cypern", CZ: "Tjeckien", DE: "Tyskland", DK: "Danmark", ES: "Spanien", FI: "Finland", FR: "Frankrike", GB: "Storbritannien", GF: "Franska Guyana", GI: "Gibraltar", GL: "Grönland", GP: "Guadeloupe", GR: "Grekland", GU: "Guam", GY: "Guyana", HK: "Hongkong", HU: "Ungern", IE: "Irland", IL: "Israel", IN: "India", IS: "Island", IT: "Italien", JM: "Jamaica", JP: "Japan", KY: "Caymanöarna", LI: "Liechtenstein", LU: "Luxemburg", MC: "Monaco", MF: "Saint-Martin", MQ: "Martinique", MT: "Malta", MX: "Mexiko", MY: "Malaysia", NC: "Nya Kaledonien", NL: "Nederländerna", NO: "Norge", NZ: "Nya Zeeland", PF: "Franska Polynesien", PL: "Polen", PR: "Puerto Rico", PT: "Portugal", RE: "Réunion", SE: "Sverige", SG: "Singapore", SK: "Slovakien", TR: "Turkiet", TN: "Tunisien", TT: "Trinidad och Tobago", UA: "Ukraina", US: "Amerikas förenta stater", VG: "Jungfruöarna (brittiska)", VI: "Jungfruöarna (amerikanska)", YT: "Mayotte", ZA: "Sydafrika" } } }, Mu = { [F.deDE]: lu, [F.esES]: pu, [F.enUS]: du, [F.enGB]: cu, [F.fiFI]: mu, [F.frFR]: fu, [F.nlNL]: vu, [F.itIT]: yu, [F.svSE]: Cu, [F.nbNO]: bu, [F.ptPT]: Su, [F.daDK]: su, [F.frCA]: gu, [F.esUS]: hu, [F.enIN]: uu };
he.use(ru).init({ resources: Mu, fallbackLng: { [F.enIE]: [F.enGB, F.enUS], [F.enGB]: [F.enUS], [F.frBE]: [F.frFR, F.enUS], [F.frCA]: [F.frFR, F.enUS], [F.nlBE]: [F.nlNL, F.enUS], [F.deAT]: [F.deDE, F.enUS], [F.deCH]: [F.deDE, F.enUS], [F.itCH]: [F.itIT, F.enUS], [F.frCH]: [F.frFR, F.enUS], [F.enAU]: [F.enGB, F.enUS], [F.enCA]: [F.enUS], [F.esUS]: [F.enUS], [F.enIN]: [F.enIN, F.enGB], [F.enNZ]: [F.enAU, F.enUS], [F.enSG]: [F.enAU, F.enUS], default: [F.enUS] }, debug: !1, react: { useSuspense: !1 } });
var Du = typeof Element < "u", Nu = typeof Map == "function", Tu = typeof Set == "function", Eu = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function In(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor)
      return !1;
    var n, a, r, i;
    if (Array.isArray(t)) {
      if ((n = t.length) != e.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (!In(t[a], e[a]))
          return !1;
      return !0;
    }
    if (Nu && t instanceof Map && e instanceof Map) {
      if (t.size !== e.size)
        return !1;
      for (i = t.entries(); !(a = i.next()).done; )
        if (!e.has(a.value[0]))
          return !1;
      for (i = t.entries(); !(a = i.next()).done; )
        if (!In(a.value[1], e.get(a.value[0])))
          return !1;
      return !0;
    }
    if (Tu && t instanceof Set && e instanceof Set) {
      if (t.size !== e.size)
        return !1;
      for (i = t.entries(); !(a = i.next()).done; )
        if (!e.has(a.value[0]))
          return !1;
      return !0;
    }
    if (Eu && ArrayBuffer.isView(t) && ArrayBuffer.isView(e)) {
      if ((n = t.length) != e.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (t[a] !== e[a])
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf && typeof t.valueOf == "function" && typeof e.valueOf == "function")
      return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString && typeof t.toString == "function" && typeof e.toString == "function")
      return t.toString() === e.toString();
    if ((n = (r = Object.keys(t)).length) !== Object.keys(e).length)
      return !1;
    for (a = n; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, r[a]))
        return !1;
    if (Du && t instanceof Element)
      return !1;
    for (a = n; a-- !== 0; )
      if ((r[a] !== "_owner" && r[a] !== "__v" && r[a] !== "__o" || !t.$$typeof) && !In(t[r[a]], e[r[a]]))
        return !1;
    return !0;
  }
  return t != t && e != e;
}
var wu = function(t, e) {
  try {
    return In(t, e);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const Cs = kr(wu);
var Ii, Ga = { exports: {} }, Sa = {}, Pi, Oi = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
process.env.NODE_ENV === "production" ? Ga.exports = function() {
  if (Ii)
    return Sa;
  Ii = 1;
  var t = mi, e = typeof Object.is == "function" ? Object.is : function(s, l) {
    return s === l && (s !== 0 || 1 / s == 1 / l) || s != s && l != l;
  }, n = t.useSyncExternalStore, a = t.useRef, r = t.useEffect, i = t.useMemo, o = t.useDebugValue;
  return Sa.useSyncExternalStoreWithSelector = function(s, l, u, c, d) {
    var p = a(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else
      g = p.current;
    p = i(function() {
      function h(T) {
        if (!_) {
          if (_ = !0, D = T, T = c(T), d !== void 0 && g.hasValue) {
            var b = g.value;
            if (d(b, T))
              return L = b;
          }
          return L = T;
        }
        if (b = L, e(D, T))
          return b;
        var S = c(T);
        return d !== void 0 && d(b, S) ? (D = T, b) : (D = T, L = S);
      }
      var D, L, _ = !1, x = u === void 0 ? null : u;
      return [function() {
        return h(l());
      }, x === null ? void 0 : function() {
        return h(x());
      }];
    }, [l, u, c, d]);
    var f = n(s, p[0], p[1]);
    return r(function() {
      g.hasValue = !0, g.value = f;
    }, [f]), o(f), f;
  }, Sa;
}() : Ga.exports = (Pi || (Pi = 1, process.env.NODE_ENV !== "production" && function() {
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
  var t = mi, e = typeof Object.is == "function" ? Object.is : function(s, l) {
    return s === l && (s !== 0 || 1 / s == 1 / l) || s != s && l != l;
  }, n = t.useSyncExternalStore, a = t.useRef, r = t.useEffect, i = t.useMemo, o = t.useDebugValue;
  Oi.useSyncExternalStoreWithSelector = function(s, l, u, c, d) {
    var p = a(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else
      g = p.current;
    p = i(function() {
      function h(T) {
        if (!_) {
          if (_ = !0, D = T, T = c(T), d !== void 0 && g.hasValue) {
            var b = g.value;
            if (d(b, T))
              return L = b;
          }
          return L = T;
        }
        if (b = L, e(D, T))
          return b;
        var S = c(T);
        return d !== void 0 && d(b, S) ? (D = T, b) : (D = T, L = S);
      }
      var D, L, _ = !1, x = u === void 0 ? null : u;
      return [function() {
        return h(l());
      }, x === null ? void 0 : function() {
        return h(x());
      }];
    }, [l, u, c, d]);
    var f = n(s, p[0], p[1]);
    return r(function() {
      g.hasValue = !0, g.value = f;
    }, [f]), o(f), f;
  }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
}()), Oi);
var _u = Ga.exports, Ri = { notify() {
}, get: () => [] }, xu = (() => !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0))(), ku = (() => typeof navigator < "u" && navigator.product === "ReactNative")(), Au = (() => xu || ku ? Ce.useLayoutEffect : Ce.useEffect)(), Ca = Symbol.for("react-redux-context"), Ma = typeof globalThis < "u" ? globalThis : {};
function Lu() {
  if (!Ce.createContext)
    return {};
  const t = Ma[Ca] ?? (Ma[Ca] = /* @__PURE__ */ new Map());
  let e = t.get(Ce.createContext);
  return e || (e = Ce.createContext(null), process.env.NODE_ENV !== "production" && (e.displayName = "ReactRedux"), t.set(Ce.createContext, e)), e;
}
var Qe = Lu(), Ar = function(t) {
  const { children: e, context: n, serverState: a, store: r } = t, i = Ce.useMemo(() => {
    const l = function(c, d) {
      let p, g = Ri, f = 0, h = !1;
      function D() {
        x.onStateChange && x.onStateChange();
      }
      function L() {
        f++, p || (p = d ? d.addNestedSub(D) : c.subscribe(D), g = function() {
          let T = null, b = null;
          return { clear() {
            T = null, b = null;
          }, notify() {
            (() => {
              let S = T;
              for (; S; )
                S.callback(), S = S.next;
            })();
          }, get() {
            const S = [];
            let w = T;
            for (; w; )
              S.push(w), w = w.next;
            return S;
          }, subscribe(S) {
            let w = !0;
            const E = b = { callback: S, next: null, prev: b };
            return E.prev ? E.prev.next = E : T = E, function() {
              w && T !== null && (w = !1, E.next ? E.next.prev = E.prev : b = E.prev, E.prev ? E.prev.next = E.next : T = E.next);
            };
          } };
        }());
      }
      function _() {
        f--, p && f === 0 && (p(), p = void 0, g.clear(), g = Ri);
      }
      const x = { addNestedSub: function(T) {
        L();
        const b = g.subscribe(T);
        let S = !1;
        return () => {
          S || (S = !0, b(), _());
        };
      }, notifyNestedSubs: function() {
        g.notify();
      }, handleChangeWrapper: D, isSubscribed: function() {
        return h;
      }, trySubscribe: function() {
        h || (h = !0, L());
      }, tryUnsubscribe: function() {
        h && (h = !1, _());
      }, getListeners: () => g };
      return x;
    }(r), u = { store: r, subscription: l, getServerState: a ? () => a : void 0 };
    if (process.env.NODE_ENV === "production")
      return u;
    {
      const { identityFunctionCheck: c = "once", stabilityCheck: d = "once" } = t;
      return Object.assign(u, { stabilityCheck: d, identityFunctionCheck: c });
    }
  }, [r, a]), o = Ce.useMemo(() => r.getState(), [r]);
  Au(() => {
    const { subscription: l } = i;
    return l.onStateChange = l.notifyNestedSubs, l.trySubscribe(), o !== r.getState() && l.notifyNestedSubs(), () => {
      l.tryUnsubscribe(), l.onStateChange = void 0;
    };
  }, [i, o]);
  const s = n || Qe;
  return Ce.createElement(s.Provider, { value: i }, e);
};
function Lr(t = Qe) {
  return function() {
    const e = Ce.useContext(t);
    if (process.env.NODE_ENV !== "production" && !e)
      throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return e;
  };
}
var Ms = Lr();
function Ds(t = Qe) {
  const e = t === Qe ? Ms : Lr(t), n = () => {
    const { store: a } = e();
    return a;
  };
  return Object.assign(n, { withTypes: () => n }), n;
}
var Iu = Ds();
function Pu(t = Qe) {
  const e = t === Qe ? Iu : Ds(t), n = () => e().dispatch;
  return Object.assign(n, { withTypes: () => n }), n;
}
var Ir = Pu(), Ou = (t, e) => t === e;
function Ru(t = Qe) {
  const e = t === Qe ? Ms : Lr(t), n = (a, r = {}) => {
    const { equalityFn: i = Ou } = typeof r == "function" ? { equalityFn: r } : r;
    if (process.env.NODE_ENV !== "production") {
      if (!a)
        throw new Error("You must pass a selector to useSelector");
      if (typeof a != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof i != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const o = e(), { store: s, subscription: l, getServerState: u } = o, c = Ce.useRef(!0), d = Ce.useCallback({ [a.name](g) {
      const f = a(g);
      if (process.env.NODE_ENV !== "production") {
        const { devModeChecks: h = {} } = typeof r == "function" ? {} : r, { identityFunctionCheck: D, stabilityCheck: L } = o, { identityFunctionCheck: _, stabilityCheck: x } = { stabilityCheck: L, identityFunctionCheck: D, ...h };
        if (x === "always" || x === "once" && c.current) {
          const T = a(g);
          if (!i(f, T)) {
            let b;
            try {
              throw new Error();
            } catch (S) {
              ({ stack: b } = S);
            }
            console.warn("Selector " + (a.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`, { state: g, selected: f, selected2: T, stack: b });
          }
        }
        if ((_ === "always" || _ === "once" && c.current) && f === g) {
          let T;
          try {
            throw new Error();
          } catch (b) {
            ({ stack: T } = b);
          }
          console.warn("Selector " + (a.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`, { stack: T });
        }
        c.current && (c.current = !1);
      }
      return f;
    } }[a.name], [a]), p = _u.useSyncExternalStoreWithSelector(l.addNestedSub, s.getState, u || s.getState, d, i);
    return Ce.useDebugValue(p), p;
  };
  return Object.assign(n, { withTypes: () => n }), n;
}
var Pr = Ru();
const be = ({ lines: t = 1 }) => N(De, { component: "div", fontSize: "small", marginTop: 1, role: "status", className: "shipping-calculator-skeleton", children: Array.from({ length: t }, (e, n) => N(yc, { "aria-label": "loading", marginTop: n > 0 ? 1 : 0, children: N(bc, {}) }, n)) }), Or = ({ children: t }) => {
  const [e, n] = ne(!1), [a, r] = ne(null);
  return Q(() => {
    n(!0), r(Math.random());
  }, []), e ? N(de, { children: t }, `shipping-calculator-${a}`) : N(be, { lines: 2 });
}, Rr = ({ children: t, fallbackUi: e }) => N(vc, { fallback: e, children: t }), Fu = [F.enAU, F.enSG, F.enNZ, F.enIN], ju = [F.enAU, F.enSG, F.enNZ], Ns = _t({ isFeatureFlagEnabled: () => !1 }), Bu = ({ children: t, loadingComponent: e }) => {
  const [n, a] = ne(), r = !!n;
  return Q(() => {
    typeof window > "u" || !window?.document || (async () => (Fc(), jc((i) => {
      i ? (console.log("AB reader Available."), a("available"), console.log("isFeatureEnabled(show_estimated_delivery_messaging_for_anzs)", gi("show_estimated_delivery_messaging_for_anzs"))) : console.log("AB reader is not available.");
    }, 3e3)))();
  }, []), r ? N(Ns.Provider, { value: { isFeatureFlagEnabled: (i) => !!n && gi(i) }, children: t }) : N(se, { children: e });
}, ra = Ir, G = Pr, sn = () => {
  const t = G((n) => n.tenantConfiguration.locale), { isFeatureFlagEnabled: e } = (() => {
    const n = on(Ns);
    if (!n)
      throw Error("FeatureFlagContext could not be initialized");
    return n;
  })();
  return e("show_estimated_delivery_messaging_for_anzs") && ju.includes(t);
}, Gu = "PCXT", Yu = (new RegExp(`(^| )${Gu}=([^;]+)`), "PCXT-V3-ScriptLoaded"), Vu = "PCXT-V3-ModuleInitialized", Hu = { SCRIPT_LOADED_EVENT: Yu, INITIALIZED_EVENT: Vu, CONTEXT_CHANGE_EVENT: "PCXT-V3-ContextChanged", COUPON_CHANGE_EVENT: "PCXT-V3-CouponCodeChanged", VAT_INCLUSIVITY_CHANGE_EVENT: "PCXT-V3-VatInclusivityChanged", DATE_TIME_CHANGE_EVENT: "PCXT-V3-EffectiveDateTimeChanged" };
var mn = Hu;
function pe(t) {
  return `Minified Redux error #${t}; visit https://redux.js.org/Errors?code=${t} for the full message or use the non-minified dev environment for full errors. `;
}
var Fi = (() => typeof Symbol == "function" && Symbol.observable || "@@observable")(), Da = () => Math.random().toString(36).substring(7).split("").join("."), ot = { INIT: `@@redux/INIT${Da()}`, REPLACE: `@@redux/REPLACE${Da()}`, PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${Da()}` };
function ln(t) {
  if (typeof t != "object" || t === null)
    return !1;
  let e = t;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e || Object.getPrototypeOf(t) === null;
}
function Uu(t) {
  if (t === void 0)
    return "undefined";
  if (t === null)
    return "null";
  const e = typeof t;
  switch (e) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return e;
  }
  if (Array.isArray(t))
    return "array";
  if (function(a) {
    return a instanceof Date || typeof a.toDateString == "function" && typeof a.getDate == "function" && typeof a.setDate == "function";
  }(t))
    return "date";
  if (function(a) {
    return a instanceof Error || typeof a.message == "string" && a.constructor && typeof a.constructor.stackTraceLimit == "number";
  }(t))
    return "error";
  const n = function(a) {
    return typeof a.constructor == "function" ? a.constructor.name : null;
  }(t);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return Object.prototype.toString.call(t).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function qe(t) {
  let e = typeof t;
  return process.env.NODE_ENV !== "production" && (e = Uu(t)), e;
}
function Ts(t, e, n) {
  if (typeof t != "function")
    throw new Error(process.env.NODE_ENV === "production" ? pe(2) : `Expected the root reducer to be a function. Instead, received: '${qe(t)}'`);
  if (typeof e == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? pe(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof e == "function" && n === void 0 && (n = e, e = void 0), n !== void 0) {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? pe(1) : `Expected the enhancer to be a function. Instead, received: '${qe(n)}'`);
    return n(Ts)(t, e);
  }
  let a = t, r = e, i = /* @__PURE__ */ new Map(), o = i, s = 0, l = !1;
  function u() {
    o === i && (o = /* @__PURE__ */ new Map(), i.forEach((g, f) => {
      o.set(f, g);
    }));
  }
  function c() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? pe(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return r;
  }
  function d(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? pe(4) : `Expected the listener to be a function. Instead, received: '${qe(g)}'`);
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? pe(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let f = !0;
    u();
    const h = s++;
    return o.set(h, g), function() {
      if (f) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? pe(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        f = !1, u(), o.delete(h), i = null;
      }
    };
  }
  function p(g) {
    if (!ln(g))
      throw new Error(process.env.NODE_ENV === "production" ? pe(7) : `Actions must be plain objects. Instead, the actual type was: '${qe(g)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (g.type === void 0)
      throw new Error(process.env.NODE_ENV === "production" ? pe(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof g.type != "string")
      throw new Error(process.env.NODE_ENV === "production" ? pe(17) : `Action "type" property must be a string. Instead, the actual type was: '${qe(g.type)}'. Value was: '${g.type}' (stringified)`);
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? pe(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, r = a(r, g);
    } finally {
      l = !1;
    }
    return (i = o).forEach((f) => {
      f();
    }), g;
  }
  return p({ type: ot.INIT }), { dispatch: p, subscribe: d, getState: c, replaceReducer: function(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? pe(10) : `Expected the nextReducer to be a function. Instead, received: '${qe(g)}`);
    a = g, p({ type: ot.REPLACE });
  }, [Fi]: function() {
    const g = d;
    return { subscribe(f) {
      if (typeof f != "object" || f === null)
        throw new Error(process.env.NODE_ENV === "production" ? pe(11) : `Expected the observer to be an object. Instead, received: '${qe(f)}'`);
      function h() {
        const D = f;
        D.next && D.next(c());
      }
      return h(), { unsubscribe: g(h) };
    }, [Fi]() {
      return this;
    } };
  } };
}
function ji(t) {
  typeof console < "u" && typeof console.error == "function" && console.error(t);
  try {
    throw new Error(t);
  } catch {
  }
}
function $u(t) {
  const e = Object.keys(t), n = {};
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    process.env.NODE_ENV !== "production" && t[s] === void 0 && ji(`No reducer provided for key "${s}"`), typeof t[s] == "function" && (n[s] = t[s]);
  }
  const a = Object.keys(n);
  let r, i;
  process.env.NODE_ENV !== "production" && (r = {});
  try {
    (function(o) {
      Object.keys(o).forEach((s) => {
        const l = o[s];
        if (l(void 0, { type: ot.INIT }) === void 0)
          throw new Error(process.env.NODE_ENV === "production" ? pe(12) : `The slice reducer for key "${s}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
        if (l(void 0, { type: ot.PROBE_UNKNOWN_ACTION() }) === void 0)
          throw new Error(process.env.NODE_ENV === "production" ? pe(13) : `The slice reducer for key "${s}" returned undefined when probed with a random type. Don't try to handle '${ot.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
      });
    })(n);
  } catch (o) {
    i = o;
  }
  return function(o = {}, s) {
    if (i)
      throw i;
    if (process.env.NODE_ENV !== "production") {
      const c = function(d, p, g, f) {
        const h = Object.keys(p), D = g && g.type === ot.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
        if (h.length === 0)
          return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
        if (!ln(d))
          return `The ${D} has unexpected type of "${qe(d)}". Expected argument to be an object with the following keys: "${h.join('", "')}"`;
        const L = Object.keys(d).filter((_) => !p.hasOwnProperty(_) && !f[_]);
        return L.forEach((_) => {
          f[_] = !0;
        }), g && g.type === ot.REPLACE ? void 0 : L.length > 0 ? `Unexpected ${L.length > 1 ? "keys" : "key"} "${L.join('", "')}" found in ${D}. Expected to find one of the known reducer keys instead: "${h.join('", "')}". Unexpected keys will be ignored.` : void 0;
      }(o, n, s, r);
      c && ji(c);
    }
    let l = !1;
    const u = {};
    for (let c = 0; c < a.length; c++) {
      const d = a[c], p = n[d], g = o[d], f = p(g, s);
      if (f === void 0) {
        const h = s && s.type;
        throw new Error(process.env.NODE_ENV === "production" ? pe(14) : `When called with an action of type ${h ? `"${String(h)}"` : "(unknown type)"}, the slice reducer for key "${d}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      u[d] = f, l = l || f !== g;
    }
    return l = l || a.length !== Object.keys(o).length, l ? u : o;
  };
}
function Un(...t) {
  return t.length === 0 ? (e) => e : t.length === 1 ? t[0] : t.reduce((e, n) => (...a) => e(n(...a)));
}
function Es(t) {
  return ln(t) && "type" in t && typeof t.type == "string";
}
var ws = Symbol.for("immer-nothing"), Bi = Symbol.for("immer-draftable"), Me = Symbol.for("immer-state"), zu = process.env.NODE_ENV !== "production" ? [function(t) {
  return `The plugin for '${t}' has not been loaded into Immer. To enable the plugin, import and call \`enable${t}()\` when initializing your application.`;
}, function(t) {
  return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${t}'`;
}, "This object has been frozen and should not be mutated", function(t) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + t;
}, "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", "Immer forbids circular references", "The first or second argument to `produce` must be a function", "The third argument to `produce` must be a function or undefined", "First argument to `createDraft` must be a plain object, an array, or an immerable object", "First argument to `finishDraft` must be a draft returned by `createDraft`", function(t) {
  return `'current' expects a draft, got: ${t}`;
}, "Object.defineProperty() cannot be used on an Immer draft", "Object.setPrototypeOf() cannot be used on an Immer draft", "Immer only supports deleting array indices", "Immer only supports setting array indices and the 'length' property", function(t) {
  return `'original' expects a draft, got: ${t}`;
}] : [];
function fe(t, ...e) {
  if (process.env.NODE_ENV !== "production") {
    const n = zu[t], a = typeof n == "function" ? n.apply(null, e) : n;
    throw new Error(`[Immer] ${a}`);
  }
  throw new Error(`[Immer] minified error nr: ${t}. Full error at: https://bit.ly/3cXEKWf`);
}
var Tt = Object.getPrototypeOf;
function pt(t) {
  return !!t && !!t[Me];
}
function Ue(t) {
  return !!t && (_s(t) || Array.isArray(t) || !!t[Bi] || !!t.constructor?.[Bi] || oa(t) || sa(t));
}
var qu = Object.prototype.constructor.toString();
function _s(t) {
  if (!t || typeof t != "object")
    return !1;
  const e = Tt(t);
  if (e === null)
    return !0;
  const n = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return n === Object || typeof n == "function" && Function.toString.call(n) === qu;
}
function $n(t, e) {
  ia(t) === 0 ? Reflect.ownKeys(t).forEach((n) => {
    e(n, t[n], t);
  }) : t.forEach((n, a) => e(a, n, t));
}
function ia(t) {
  const e = t[Me];
  return e ? e.type_ : Array.isArray(t) ? 1 : oa(t) ? 2 : sa(t) ? 3 : 0;
}
function Ya(t, e) {
  return ia(t) === 2 ? t.has(e) : Object.prototype.hasOwnProperty.call(t, e);
}
function xs(t, e, n) {
  const a = ia(t);
  a === 2 ? t.set(e, n) : a === 3 ? t.add(n) : t[e] = n;
}
function oa(t) {
  return t instanceof Map;
}
function sa(t) {
  return t instanceof Set;
}
function at(t) {
  return t.copy_ || t.base_;
}
function Va(t, e) {
  if (oa(t))
    return new Map(t);
  if (sa(t))
    return new Set(t);
  if (Array.isArray(t))
    return Array.prototype.slice.call(t);
  const n = _s(t);
  if (e === !0 || e === "class_only" && !n) {
    const a = Object.getOwnPropertyDescriptors(t);
    delete a[Me];
    let r = Reflect.ownKeys(a);
    for (let i = 0; i < r.length; i++) {
      const o = r[i], s = a[o];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (a[o] = { configurable: !0, writable: !0, enumerable: s.enumerable, value: t[o] });
    }
    return Object.create(Tt(t), a);
  }
  {
    const a = Tt(t);
    if (a !== null && n)
      return { ...t };
    const r = Object.create(a);
    return Object.assign(r, t);
  }
}
function Fr(t, e = !1) {
  return la(t) || pt(t) || !Ue(t) || (ia(t) > 1 && (t.set = t.add = t.clear = t.delete = Ku), Object.freeze(t), e && Object.entries(t).forEach(([n, a]) => Fr(a, !0))), t;
}
function Ku() {
  fe(2);
}
function la(t) {
  return Object.isFrozen(t);
}
var Kt, Zu = {};
function ht(t) {
  const e = Zu[t];
  return e || fe(0, t), e;
}
function Gi() {
  return Kt;
}
function Yi(t, e) {
  e && (ht("Patches"), t.patches_ = [], t.inversePatches_ = [], t.patchListener_ = e);
}
function Ha(t) {
  Ua(t), t.drafts_.forEach(Wu), t.drafts_ = null;
}
function Ua(t) {
  t === Kt && (Kt = t.parent_);
}
function Vi(t) {
  return Kt = { drafts_: [], parent_: Kt, immer_: t, canAutoFreeze_: !0, unfinalizedDrafts_: 0 };
}
function Wu(t) {
  const e = t[Me];
  e.type_ === 0 || e.type_ === 1 ? e.revoke_() : e.revoked_ = !0;
}
function Hi(t, e) {
  e.unfinalizedDrafts_ = e.drafts_.length;
  const n = e.drafts_[0];
  return t !== void 0 && t !== n ? (n[Me].modified_ && (Ha(e), fe(4)), Ue(t) && (t = zn(e, t), e.parent_ || qn(e, t)), e.patches_ && ht("Patches").generateReplacementPatches_(n[Me].base_, t, e.patches_, e.inversePatches_)) : t = zn(e, n, []), Ha(e), e.patches_ && e.patchListener_(e.patches_, e.inversePatches_), t !== ws ? t : void 0;
}
function zn(t, e, n) {
  if (la(e))
    return e;
  const a = e[Me];
  if (!a)
    return $n(e, (r, i) => Ui(t, a, e, r, i, n)), e;
  if (a.scope_ !== t)
    return e;
  if (!a.modified_)
    return qn(t, a.base_, !0), a.base_;
  if (!a.finalized_) {
    a.finalized_ = !0, a.scope_.unfinalizedDrafts_--;
    const r = a.copy_;
    let i = r, o = !1;
    a.type_ === 3 && (i = new Set(r), r.clear(), o = !0), $n(i, (s, l) => Ui(t, a, r, s, l, n, o)), qn(t, r, !1), n && t.patches_ && ht("Patches").generatePatches_(a, n, t.patches_, t.inversePatches_);
  }
  return a.copy_;
}
function Ui(t, e, n, a, r, i, o) {
  if (process.env.NODE_ENV !== "production" && r === n && fe(5), pt(r)) {
    const s = zn(t, r, i && e && e.type_ !== 3 && !Ya(e.assigned_, a) ? i.concat(a) : void 0);
    if (xs(n, a, s), !pt(s))
      return;
    t.canAutoFreeze_ = !1;
  } else
    o && n.add(r);
  if (Ue(r) && !la(r)) {
    if (!t.immer_.autoFreeze_ && t.unfinalizedDrafts_ < 1)
      return;
    zn(t, r), e && e.scope_.parent_ || typeof a == "symbol" || !Object.prototype.propertyIsEnumerable.call(n, a) || qn(t, r);
  }
}
function qn(t, e, n = !1) {
  !t.parent_ && t.immer_.autoFreeze_ && t.canAutoFreeze_ && Fr(e, n);
}
var $a = { get(t, e) {
  if (e === Me)
    return t;
  const n = at(t);
  if (!Ya(n, e))
    return function(r, i, o) {
      const s = $i(i, o);
      return s ? "value" in s ? s.value : s.get?.call(r.draft_) : void 0;
    }(t, n, e);
  const a = n[e];
  return t.finalized_ || !Ue(a) ? a : a === Na(t.base_, e) ? (Ta(t), t.copy_[e] = qa(a, t)) : a;
}, has: (t, e) => e in at(t), ownKeys: (t) => Reflect.ownKeys(at(t)), set(t, e, n) {
  const a = $i(at(t), e);
  if (a?.set)
    return a.set.call(t.draft_, n), !0;
  if (!t.modified_) {
    const r = Na(at(t), e), i = r?.[Me];
    if (i && i.base_ === n)
      return t.copy_[e] = n, t.assigned_[e] = !1, !0;
    if (function(o, s) {
      return o === s ? o !== 0 || 1 / o == 1 / s : o != o && s != s;
    }(n, r) && (n !== void 0 || Ya(t.base_, e)))
      return !0;
    Ta(t), za(t);
  }
  return t.copy_[e] === n && (n !== void 0 || e in t.copy_) || Number.isNaN(n) && Number.isNaN(t.copy_[e]) || (t.copy_[e] = n, t.assigned_[e] = !0), !0;
}, deleteProperty: (t, e) => (Na(t.base_, e) !== void 0 || e in t.base_ ? (t.assigned_[e] = !1, Ta(t), za(t)) : delete t.assigned_[e], t.copy_ && delete t.copy_[e], !0), getOwnPropertyDescriptor(t, e) {
  const n = at(t), a = Reflect.getOwnPropertyDescriptor(n, e);
  return a && { writable: !0, configurable: t.type_ !== 1 || e !== "length", enumerable: a.enumerable, value: n[e] };
}, defineProperty() {
  fe(11);
}, getPrototypeOf: (t) => Tt(t.base_), setPrototypeOf() {
  fe(12);
} }, Bt = {};
function Na(t, e) {
  const n = t[Me];
  return (n ? at(n) : t)[e];
}
function $i(t, e) {
  if (!(e in t))
    return;
  let n = Tt(t);
  for (; n; ) {
    const a = Object.getOwnPropertyDescriptor(n, e);
    if (a)
      return a;
    n = Tt(n);
  }
}
function za(t) {
  t.modified_ || (t.modified_ = !0, t.parent_ && za(t.parent_));
}
function Ta(t) {
  t.copy_ || (t.copy_ = Va(t.base_, t.scope_.immer_.useStrictShallowCopy_));
}
$n($a, (t, e) => {
  Bt[t] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
}), Bt.deleteProperty = function(t, e) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(e)) && fe(13), Bt.set.call(this, t, e, void 0);
}, Bt.set = function(t, e, n) {
  return process.env.NODE_ENV !== "production" && e !== "length" && isNaN(parseInt(e)) && fe(14), $a.set.call(this, t[0], e, n, t[0]);
};
function qa(t, e) {
  const n = oa(t) ? ht("MapSet").proxyMap_(t, e) : sa(t) ? ht("MapSet").proxySet_(t, e) : function(a, r) {
    const i = Array.isArray(a), o = { type_: i ? 1 : 0, scope_: r ? r.scope_ : Gi(), modified_: !1, finalized_: !1, assigned_: {}, parent_: r, base_: a, draft_: null, copy_: null, revoke_: null, isManual_: !1 };
    let s = o, l = $a;
    i && (s = [o], l = Bt);
    const { revoke: u, proxy: c } = Proxy.revocable(s, l);
    return o.draft_ = c, o.revoke_ = u, c;
  }(t, e);
  return (e ? e.scope_ : Gi()).drafts_.push(n), n;
}
function ks(t) {
  if (!Ue(t) || la(t))
    return t;
  const e = t[Me];
  let n;
  if (e) {
    if (!e.modified_)
      return e.base_;
    e.finalized_ = !0, n = Va(t, e.scope_.immer_.useStrictShallowCopy_);
  } else
    n = Va(t, !0);
  return $n(n, (a, r) => {
    xs(n, a, ks(r));
  }), e && (e.finalized_ = !1), n;
}
var Se = new class {
  constructor(t) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (e, n, a) => {
      if (typeof e == "function" && typeof n != "function") {
        const i = n;
        n = e;
        const o = this;
        return function(s = i, ...l) {
          return o.produce(s, (u) => n.call(this, u, ...l));
        };
      }
      let r;
      if (typeof n != "function" && fe(6), a !== void 0 && typeof a != "function" && fe(7), Ue(e)) {
        const i = Vi(this), o = qa(e, void 0);
        let s = !0;
        try {
          r = n(o), s = !1;
        } finally {
          s ? Ha(i) : Ua(i);
        }
        return Yi(i, a), Hi(r, i);
      }
      if (!e || typeof e != "object") {
        if (r = n(e), r === void 0 && (r = e), r === ws && (r = void 0), this.autoFreeze_ && Fr(r, !0), a) {
          const i = [], o = [];
          ht("Patches").generateReplacementPatches_(e, r, i, o), a(i, o);
        }
        return r;
      }
      fe(1, e);
    }, this.produceWithPatches = (e, n) => {
      if (typeof e == "function")
        return (i, ...o) => this.produceWithPatches(i, (s) => e(s, ...o));
      let a, r;
      return [this.produce(e, n, (i, o) => {
        a = i, r = o;
      }), a, r];
    }, typeof t?.autoFreeze == "boolean" && this.setAutoFreeze(t.autoFreeze), typeof t?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(t.useStrictShallowCopy);
  }
  createDraft(t) {
    Ue(t) || fe(8), pt(t) && (t = function(a) {
      return pt(a) || fe(10, a), ks(a);
    }(t));
    const e = Vi(this), n = qa(t, void 0);
    return n[Me].isManual_ = !0, Ua(e), n;
  }
  finishDraft(t, e) {
    const n = t && t[Me];
    n && n.isManual_ || fe(9);
    const { scope_: a } = n;
    return Yi(a, e), Hi(void 0, a);
  }
  setAutoFreeze(t) {
    this.autoFreeze_ = t;
  }
  setUseStrictShallowCopy(t) {
    this.useStrictShallowCopy_ = t;
  }
  applyPatches(t, e) {
    let n;
    for (n = e.length - 1; n >= 0; n--) {
      const r = e[n];
      if (r.path.length === 0 && r.op === "replace") {
        t = r.value;
        break;
      }
    }
    n > -1 && (e = e.slice(n + 1));
    const a = ht("Patches").applyPatches_;
    return pt(t) ? a(t, e) : this.produce(t, (r) => a(r, e));
  }
}(), As = Se.produce;
function Ls(t) {
  return ({ dispatch: e, getState: n }) => (a) => (r) => typeof r == "function" ? r(e, n, t) : a(r);
}
Se.produceWithPatches.bind(Se), Se.setAutoFreeze.bind(Se), Se.setUseStrictShallowCopy.bind(Se), Se.applyPatches.bind(Se), Se.createDraft.bind(Se), Se.finishDraft.bind(Se);
var Ju = Ls(), Qu = Ls, Xu = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? Un : Un.apply(null, arguments);
};
function zi(t, e) {
  function n(...a) {
    if (e) {
      let r = e(...a);
      if (!r)
        throw new Error(process.env.NODE_ENV === "production" ? re(0) : "prepareAction did not return an object");
      return { type: t, payload: r.payload, ..."meta" in r && { meta: r.meta }, ..."error" in r && { error: r.error } };
    }
    return { type: t, payload: a[0] };
  }
  return n.toString = () => `${t}`, n.type = t, n.match = (a) => Es(a) && a.type === t, n;
}
function ed(t) {
  return typeof t == "function" && "type" in t && ((e) => e && typeof e.match == "function")(t);
}
function qi(t, e) {
  let n = 0;
  return { measureTime(a) {
    const r = Date.now();
    try {
      return a();
    } finally {
      const i = Date.now();
      n += i - r;
    }
  }, warnIfExceeded() {
    n > t && console.warn(`${e} took ${n}ms, which is more than the warning threshold of ${t}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
  } };
}
var Is = class Gt extends Array {
  constructor(...e) {
    super(...e), Object.setPrototypeOf(this, Gt.prototype);
  }
  static get [Symbol.species]() {
    return Gt;
  }
  concat(...e) {
    return super.concat.apply(this, e);
  }
  prepend(...e) {
    return e.length === 1 && Array.isArray(e[0]) ? new Gt(...e[0].concat(this)) : new Gt(...e.concat(this));
  }
};
function Ki(t) {
  return Ue(t) ? As(t, () => {
  }) : t;
}
function gn(t, e, n) {
  return t.has(e) ? t.get(e) : t.set(e, n(e)).get(e);
}
function td(t) {
  return typeof t != "object" || t == null || Object.isFrozen(t);
}
function nd(t, e, n) {
  const a = Ps(t, e, n);
  return { detectMutations: () => Os(t, e, a, n) };
}
function Ps(t, e = [], n, a = "", r = /* @__PURE__ */ new Set()) {
  const i = { value: n };
  if (!t(n) && !r.has(n)) {
    r.add(n), i.children = {};
    for (const o in n) {
      const s = a ? a + "." + o : o;
      e.length && e.indexOf(s) !== -1 || (i.children[o] = Ps(t, e, n[o], s));
    }
  }
  return i;
}
function Os(t, e = [], n, a, r = !1, i = "") {
  const o = n ? n.value : void 0, s = o === a;
  if (r && !s && !Number.isNaN(a))
    return { wasMutated: !0, path: i };
  if (t(o) || t(a))
    return { wasMutated: !1 };
  const l = {};
  for (let c in n.children)
    l[c] = !0;
  for (let c in a)
    l[c] = !0;
  const u = e.length > 0;
  for (let c in l) {
    const d = i ? i + "." + c : c;
    if (u && e.some((g) => g instanceof RegExp ? g.test(d) : d === g))
      continue;
    const p = Os(t, e, n.children[c], a[c], s, d);
    if (p.wasMutated)
      return p;
  }
  return { wasMutated: !1 };
}
function Rs(t) {
  const e = typeof t;
  return t == null || e === "string" || e === "boolean" || e === "number" || Array.isArray(t) || ln(t);
}
function Ka(t, e = "", n = Rs, a, r = [], i) {
  let o;
  if (!n(t))
    return { keyPath: e || "<root>", value: t };
  if (typeof t != "object" || t === null || i?.has(t))
    return !1;
  const s = a != null ? a(t) : Object.entries(t), l = r.length > 0;
  for (const [u, c] of s) {
    const d = e ? e + "." + u : u;
    if (!(l && r.some((p) => p instanceof RegExp ? p.test(d) : d === p))) {
      if (!n(c))
        return { keyPath: d, value: c };
      if (typeof c == "object" && (o = Ka(c, d, n, a, r, i), o))
        return o;
    }
  }
  return i && Fs(t) && i.add(t), !1;
}
function Fs(t) {
  if (!Object.isFrozen(t))
    return !1;
  for (const e of Object.values(t))
    if (typeof e == "object" && e !== null && !Fs(e))
      return !1;
  return !0;
}
function fn(t) {
  return typeof t == "boolean";
}
var ad = () => function(t) {
  const { thunk: e = !0, immutableCheck: n = !0, serializableCheck: a = !0, actionCreatorCheck: r = !0 } = t ?? {};
  let i = new Is();
  if (e && (fn(e) ? i.push(Ju) : i.push(Qu(e.extraArgument))), process.env.NODE_ENV !== "production") {
    if (n) {
      let o = {};
      fn(n) || (o = n), i.unshift(function(s = {}) {
        if (process.env.NODE_ENV === "production")
          return () => (l) => (u) => l(u);
        {
          let l = function(f, h, D, L) {
            return JSON.stringify(f, u(h, L), D);
          }, u = function(f, h) {
            let D = [], L = [];
            return h || (h = function(_, x) {
              return D[0] === x ? "[Circular ~]" : "[Circular ~." + L.slice(0, D.indexOf(x)).join(".") + "]";
            }), function(_, x) {
              if (D.length > 0) {
                var T = D.indexOf(this);
                ~T ? D.splice(T + 1) : D.push(this), ~T ? L.splice(T, 1 / 0, _) : L.push(_), ~D.indexOf(x) && (x = h.call(this, _, x));
              } else
                D.push(x);
              return f == null ? x : f.call(this, _, x);
            };
          }, { isImmutable: c = td, ignoredPaths: d, warnAfter: p = 32 } = s;
          const g = nd.bind(null, c, d);
          return ({ getState: f }) => {
            let h, D = f(), L = g(D);
            return (_) => (x) => {
              const T = qi(p, "ImmutableStateInvariantMiddleware");
              T.measureTime(() => {
                if (D = f(), h = L.detectMutations(), L = g(D), h.wasMutated)
                  throw new Error(process.env.NODE_ENV === "production" ? re(19) : `A state mutation was detected between dispatches, in the path '${h.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
              });
              const b = _(x);
              return T.measureTime(() => {
                if (D = f(), h = L.detectMutations(), L = g(D), h.wasMutated)
                  throw new Error(process.env.NODE_ENV === "production" ? re(20) : `A state mutation was detected inside a dispatch, in the path: ${h.path || ""}. Take a look at the reducer(s) handling the action ${l(x)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
              }), T.warnIfExceeded(), b;
            };
          };
        }
      }(o));
    }
    if (a) {
      let o = {};
      fn(a) || (o = a), i.push(function(s = {}) {
        if (process.env.NODE_ENV === "production")
          return () => (l) => (u) => l(u);
        {
          const { isSerializable: l = Rs, getEntries: u, ignoredActions: c = [], ignoredActionPaths: d = ["meta.arg", "meta.baseQueryMeta"], ignoredPaths: p = [], warnAfter: g = 32, ignoreState: f = !1, ignoreActions: h = !1, disableCache: D = !1 } = s, L = !D && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
          return (_) => (x) => (T) => {
            if (!Es(T))
              return x(T);
            const b = x(T), S = qi(g, "SerializableStateInvariantMiddleware");
            return h || c.length && c.indexOf(T.type) !== -1 || S.measureTime(() => {
              const w = Ka(T, "", l, u, d, L);
              if (w) {
                const { keyPath: E, value: k } = w;
                console.error(`A non-serializable value was detected in an action, in the path: \`${E}\`. Value:`, k, `
Take a look at the logic that dispatched this action: `, T, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
              }
            }), f || (S.measureTime(() => {
              const w = Ka(_.getState(), "", l, u, p, L);
              if (w) {
                const { keyPath: E, value: k } = w;
                console.error(`A non-serializable value was detected in the state, in the path: \`${E}\`. Value:`, k, `
Take a look at the reducer(s) handling this action type: ${T.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
              }
            }), S.warnIfExceeded()), b;
          };
        }
      }(o));
    }
    if (r) {
      let o = {};
      fn(r) || (o = r), i.unshift(function(s = {}) {
        if (process.env.NODE_ENV === "production")
          return () => (u) => (c) => u(c);
        const { isActionCreator: l = ed } = s;
        return () => (u) => (c) => (l(c) && console.warn(function(d) {
          const p = d ? `${d}`.split("/") : [], g = p[p.length - 1] || "actionCreator";
          return `Detected an action creator with type "${d || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${g}())\` instead of \`dispatch(${g})\`. This is necessary even if the action has no payload.`;
        }(c.type)), u(c));
      }(o));
    }
  }
  return i;
}, Zi = (t) => (e) => {
  setTimeout(e, t);
}, rd = (t) => function(e) {
  const { autoBatch: n = !0 } = e ?? {};
  let a = new Is(t);
  return n && a.push(((r = { type: "raf" }) => (i) => (...o) => {
    const s = i(...o);
    let l = !0, u = !1, c = !1;
    const d = /* @__PURE__ */ new Set(), p = r.type === "tick" ? queueMicrotask : r.type === "raf" ? typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : Zi(10) : r.type === "callback" ? r.queueNotification : Zi(r.timeout), g = () => {
      c = !1, u && (u = !1, d.forEach((f) => f()));
    };
    return Object.assign({}, s, { subscribe(f) {
      const h = s.subscribe(() => l && f());
      return d.add(f), () => {
        h(), d.delete(f);
      };
    }, dispatch(f) {
      try {
        return l = !f?.meta?.RTK_autoBatch, u = !l, u && (c || (c = !0, p(g))), s.dispatch(f);
      } finally {
        l = !0;
      }
    } });
  })(typeof n == "object" ? n : void 0)), a;
};
function id(t) {
  const e = ad(), { reducer: n, middleware: a, devTools: r = !0, duplicateMiddlewareCheck: i = !0, preloadedState: o, enhancers: s } = t || {};
  let l, u;
  if (typeof n == "function")
    l = n;
  else {
    if (!ln(n))
      throw new Error(process.env.NODE_ENV === "production" ? re(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
    l = $u(n);
  }
  if (process.env.NODE_ENV !== "production" && a && typeof a != "function")
    throw new Error(process.env.NODE_ENV === "production" ? re(2) : "`middleware` field must be a callback");
  if (typeof a == "function") {
    if (u = a(e), process.env.NODE_ENV !== "production" && !Array.isArray(u))
      throw new Error(process.env.NODE_ENV === "production" ? re(3) : "when using a middleware builder function, an array of middleware must be returned");
  } else
    u = e();
  if (process.env.NODE_ENV !== "production" && u.some((f) => typeof f != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? re(4) : "each middleware provided to configureStore must be a function");
  if (process.env.NODE_ENV !== "production" && i) {
    let f = /* @__PURE__ */ new Set();
    u.forEach((h) => {
      if (f.has(h))
        throw new Error(process.env.NODE_ENV === "production" ? re(42) : "Duplicate middleware references found when creating the store. Ensure that each middleware is only included once.");
      f.add(h);
    });
  }
  let c = Un;
  r && (c = Xu({ trace: process.env.NODE_ENV !== "production", ...typeof r == "object" && r }));
  const d = function(...f) {
    return (h) => (D, L) => {
      const _ = h(D, L);
      let x = () => {
        throw new Error(process.env.NODE_ENV === "production" ? pe(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      };
      const T = { getState: _.getState, dispatch: (S, ...w) => x(S, ...w) }, b = f.map((S) => S(T));
      return x = Un(...b)(_.dispatch), { ..._, dispatch: x };
    };
  }(...u), p = rd(d);
  if (process.env.NODE_ENV !== "production" && s && typeof s != "function")
    throw new Error(process.env.NODE_ENV === "production" ? re(5) : "`enhancers` field must be a callback");
  let g = typeof s == "function" ? s(p) : p();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(g))
    throw new Error(process.env.NODE_ENV === "production" ? re(6) : "`enhancers` callback must return an array");
  if (process.env.NODE_ENV !== "production" && g.some((f) => typeof f != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? re(7) : "each enhancer provided to configureStore must be a function");
  return process.env.NODE_ENV !== "production" && u.length && !g.includes(d) && console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`"), Ts(l, o, c(...g));
}
function Wi(t) {
  const e = {}, n = [];
  let a;
  const r = { addCase(i, o) {
    if (process.env.NODE_ENV !== "production") {
      if (n.length > 0)
        throw new Error(process.env.NODE_ENV === "production" ? re(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
      if (a)
        throw new Error(process.env.NODE_ENV === "production" ? re(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
    }
    const s = typeof i == "string" ? i : i.type;
    if (!s)
      throw new Error(process.env.NODE_ENV === "production" ? re(28) : "`builder.addCase` cannot be called with an empty action type");
    if (s in e)
      throw new Error(process.env.NODE_ENV === "production" ? re(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${s}'`);
    return e[s] = o, r;
  }, addMatcher(i, o) {
    if (process.env.NODE_ENV !== "production" && a)
      throw new Error(process.env.NODE_ENV === "production" ? re(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
    return n.push({ matcher: i, reducer: o }), r;
  }, addDefaultCase(i) {
    if (process.env.NODE_ENV !== "production" && a)
      throw new Error(process.env.NODE_ENV === "production" ? re(31) : "`builder.addDefaultCase` can only be called once");
    return a = i, r;
  } };
  return t(r), [e, n, a];
}
var od = Symbol.for("rtk-slice-createasyncthunk");
function sd(t, e) {
  return `${t}/${e}`;
}
function ld({ creators: t } = {}) {
  const e = t?.asyncThunk?.[od];
  return function(n) {
    const { name: a, reducerPath: r = a } = n;
    if (!a)
      throw new Error(process.env.NODE_ENV === "production" ? re(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && n.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const i = (typeof n.reducers == "function" ? n.reducers(function() {
      function _(x, T) {
        return { _reducerDefinitionType: "asyncThunk", payloadCreator: x, ...T };
      }
      return _.withTypes = () => _, { reducer: (x) => Object.assign({ [x.name]: (...T) => x(...T) }[x.name], { _reducerDefinitionType: "reducer" }), preparedReducer: (x, T) => ({ _reducerDefinitionType: "reducerWithPrepare", prepare: x, reducer: T }), asyncThunk: _ };
    }()) : n.reducers) || {}, o = Object.keys(i), s = { sliceCaseReducersByName: {}, sliceCaseReducersByType: {}, actionCreators: {}, sliceMatchers: [] }, l = { addCase(_, x) {
      const T = typeof _ == "string" ? _ : _.type;
      if (!T)
        throw new Error(process.env.NODE_ENV === "production" ? re(12) : "`context.addCase` cannot be called with an empty action type");
      if (T in s.sliceCaseReducersByType)
        throw new Error(process.env.NODE_ENV === "production" ? re(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + T);
      return s.sliceCaseReducersByType[T] = x, l;
    }, addMatcher: (_, x) => (s.sliceMatchers.push({ matcher: _, reducer: x }), l), exposeAction: (_, x) => (s.actionCreators[_] = x, l), exposeCaseReducer: (_, x) => (s.sliceCaseReducersByName[_] = x, l) };
    function u() {
      if (process.env.NODE_ENV !== "production" && typeof n.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? re(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [_ = {}, x = [], T] = typeof n.extraReducers == "function" ? Wi(n.extraReducers) : [n.extraReducers], b = { ..._, ...s.sliceCaseReducersByType };
      return function(S, w) {
        if (process.env.NODE_ENV !== "production" && typeof w == "object")
          throw new Error(process.env.NODE_ENV === "production" ? re(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
        let E, [k, O, $] = Wi(w);
        if (function(y) {
          return typeof y == "function";
        }(S))
          E = () => Ki(S());
        else {
          const y = Ki(S);
          E = () => y;
        }
        function v(y = E(), m) {
          let M = [k[m.type], ...O.filter(({ matcher: C }) => C(m)).map(({ reducer: C }) => C)];
          return M.filter((C) => !!C).length === 0 && (M = [$]), M.reduce((C, I) => {
            if (I) {
              if (pt(C)) {
                const A = I(C, m);
                return A === void 0 ? C : A;
              }
              if (Ue(C))
                return As(C, (A) => I(A, m));
              {
                const A = I(C, m);
                if (A === void 0) {
                  if (C === null)
                    return C;
                  throw Error("A case reducer on a non-draftable value must not return undefined");
                }
                return A;
              }
            }
            return C;
          }, y);
        }
        return v.getInitialState = E, v;
      }(n.initialState, (S) => {
        for (let w in b)
          S.addCase(w, b[w]);
        for (let w of s.sliceMatchers)
          S.addMatcher(w.matcher, w.reducer);
        for (let w of x)
          S.addMatcher(w.matcher, w.reducer);
        T && S.addDefaultCase(T);
      });
    }
    o.forEach((_) => {
      const x = i[_], T = { reducerName: _, type: sd(a, _), createNotation: typeof n.reducers == "function" };
      (function(b) {
        return b._reducerDefinitionType === "asyncThunk";
      })(x) ? function({ type: b, reducerName: S }, w, E, k) {
        if (!k)
          throw new Error(process.env.NODE_ENV === "production" ? re(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
        const { payloadCreator: O, fulfilled: $, pending: v, rejected: y, settled: m, options: M } = w, C = k(b, O, M);
        E.exposeAction(S, C), $ && E.addCase(C.fulfilled, $), v && E.addCase(C.pending, v), y && E.addCase(C.rejected, y), m && E.addMatcher(C.settled, m), E.exposeCaseReducer(S, { fulfilled: $ || yn, pending: v || yn, rejected: y || yn, settled: m || yn });
      }(T, x, l, e) : function({ type: b, reducerName: S, createNotation: w }, E, k) {
        let O, $;
        if ("reducer" in E) {
          if (w && !function(v) {
            return v._reducerDefinitionType === "reducerWithPrepare";
          }(E))
            throw new Error(process.env.NODE_ENV === "production" ? re(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
          O = E.reducer, $ = E.prepare;
        } else
          O = E;
        k.addCase(b, O).exposeCaseReducer(S, O).exposeAction(S, $ ? zi(b, $) : zi(b));
      }(T, x, l);
    });
    const c = (_) => _, d = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new WeakMap();
    let g;
    function f(_, x) {
      return g || (g = u()), g(_, x);
    }
    function h() {
      return g || (g = u()), g.getInitialState();
    }
    function D(_, x = !1) {
      function T(S) {
        let w = S[_];
        if (w === void 0) {
          if (x)
            w = gn(p, T, h);
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? re(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return w;
      }
      function b(S = c) {
        const w = gn(d, x, () => /* @__PURE__ */ new WeakMap());
        return gn(w, S, () => {
          const E = {};
          for (const [k, O] of Object.entries(n.selectors ?? {}))
            E[k] = cd(O, S, () => gn(p, S, h), x);
          return E;
        });
      }
      return { reducerPath: _, getSelectors: b, get selectors() {
        return b(T);
      }, selectSlice: T };
    }
    const L = { name: a, reducer: f, actions: s.actionCreators, caseReducers: s.sliceCaseReducersByName, getInitialState: h, ...D(r), injectInto(_, { reducerPath: x, ...T } = {}) {
      const b = x ?? r;
      return _.inject({ reducerPath: b, reducer: f }, T), { ...L, ...D(b, !0) };
    } };
    return L;
  };
}
function cd(t, e, n, a) {
  function r(i, ...o) {
    let s = e(i);
    if (s === void 0) {
      if (a)
        s = n();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? re(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return t(s, ...o);
  }
  return r.unwrapped = t, r;
}
var Xe = ld();
function yn() {
}
function re(t) {
  return `Minified Redux Toolkit error #${t}; visit https://redux-toolkit.js.org/Errors?code=${t} for the full message or use the non-minified dev environment for full errors. `;
}
const js = Xe({ name: "userConfiguration", initialState: { country: "", postalCode: "", vatInclusivity: !1 }, reducers: { updateUserConfiguration: (t, e) => ({ ...t, ...e.payload }) } }), { updateUserConfiguration: Et } = js.actions, ud = js.reducer, Ea = (t) => {
  const e = Bs();
  return !!t || (e?.pcxtV3?.isInitialized() ?? !1);
}, Bs = () => typeof document < "u" ? document : void 0, dd = (t, e, n) => {
  const [a, r] = ne(!1), i = Ir();
  return Q(() => {
    const o = () => {
      const l = Ea(n);
      r(l), l && s();
    }, s = () => {
      const l = (() => Bs()?.pcxtV3?.isVatInclusive() ?? !1)();
      i(Et({ vatInclusivity: l }));
    };
    return Ea(n) ? o() : document.addEventListener(mn.INITIALIZED_EVENT, o), document.addEventListener(mn.VAT_INCLUSIVITY_CHANGE_EVENT, s), () => {
      Ea(n) || document.removeEventListener(mn.INITIALIZED_EVENT, o), document.removeEventListener(mn.VAT_INCLUSIVITY_CHANGE_EVENT, s);
    };
  }, [t, e, n, i]), a;
};
var Ve = ((t) => (t.CorePDP = "core-pdp", t.LargeAssortmentsPDP = "lat-pdp", t.Gallery6Client = "gallery-6-client", t.ChecksQuickView = "checks-accessories-quick-view", t.PDC = "post-design-configuration", t.QuickEditor = "quick-editor", t.ShippingCalculatorDev = "shipping-calculator-dev", t.Cart = "cart", t.Checkout = "checkout", t))(Ve || {}), jr = ((t) => (t.NOT_DELIVERABLE = "NOT_DELIVERABLE", t))(jr || {}), Gs = ((t) => (t.ExampleExperiment = "example_experiment", t))(Gs || {});
const Ji = { [Gs.ExampleExperiment]: { supportedRequestorIds: [Ve.CorePDP, Ve.ShippingCalculatorDev, Ve.LargeAssortmentsPDP] } }, pd = _t({ getVariation: () => {
} }), hd = ({ children: t }) => {
  const [e, n] = ne(!1);
  Ye(() => {
    pn.initialize();
  }, []);
  const a = G((l) => l.tenantConfiguration.locale), r = G((l) => l.productConfiguration.productKey), i = G((l) => l.clientConfiguration.requestorId), o = gs(), s = Te((l) => {
    const u = Ji[l];
    if (!u)
      return void console.error(`Experiment ${l} is not registered`);
    if (!(u.supportedLocales && !u.supportedLocales.includes(a) || u.supportedProductKeys && !u.supportedProductKeys.includes(r) || u.supportedScreenClasses && !u.supportedScreenClasses?.includes(o) || u.supportedRequestorIds && !u.supportedRequestorIds?.includes(i)))
      return pn.getVariation(l) || void 0;
  }, [a, r, i, o]);
  return Q(() => {
    pn.whenAvailable((l) => {
      n(!!l);
    }, 1e3);
  }, []), Q(() => {
    if (e)
      for (const l in Ji) {
        const u = s(l);
        u && pn.fireImpression(l, u);
      }
  }, [e, s]), e ? N(pd.Provider, { value: { getVariation: s }, children: t }) : N(be, { lines: 2 });
}, Ys = ["shippingCalculatorCloseModalAriaLabel", "shippingCalculatorCountryLabel", "shippingCalculatorApplyCtaText", "shippingCalculatorDeliveryOptionsTitleLabel", "shippingCalculatorContentAriaLabel", "shippingCalculatorDisclaimerLabel", "shippingCalculatorDisclaimerPoint1Text", "shippingCalculatorHelperText", "shippingCalculatorLoaderText", "shippingCalculatorNoDeliveryMessage", "shippingCalculatorNotFoundMessage", "shippingCalculatorPostalCodeLabel", "shippingCalculatorPostalCodeValidationErrorMessage", "shippingCalculatorFreeShippingLabel", "shippingCalculatorFreeShippingQualifiedLabel", "shippingCalculatorSelectedOptionMessage", "shippingCalculatorSelectedOptionMessageForFreeDelivery", "selectedOptionMessageWithoutPrice", "shippingCalculatorTitleLabel", "shippingCalculatorUpdatePostalCodeMessage", "shippingCalculatorDeliveryTodayMessage", "shippingCalculatorDeliveryTomorrowMessage", "shippingCalculatorZeroPricingText", "shippingCalculatorCheapestSelectedOptionMessage", "shippingCalculatorFreeShippingOptionMessage", "shippingCalculatorFreeShippingOptionMessageWithPostalCode", "shippingCalculatorEstimatedDeliveryTitleLabel", "estimatedDeliveryDisclaimerLabel", "selectedOptionEstimatedMessageWithoutPrice", "singleOptionEstimatedMessageWithoutPrice"], md = { shippingCalculatorCloseModalAriaLabel: "shipping-calculator.close-modal-aria-label", shippingCalculatorCountryLabel: "shipping-calculator.country-label", shippingCalculatorApplyCtaText: "shipping-calculator.apply-cta-text", shippingCalculatorDeliveryOptionsTitleLabel: "shipping-calculator.delivery-options-title-label", shippingCalculatorEstimatedDeliveryTitleLabel: "shipping-calculator.estimated-delivery-title-lable", shippingCalculatorContentAriaLabel: "shipping-calculator.content-aria-label", shippingCalculatorDisclaimerLabel: "shipping-calculator.disclaimer-label", shippingCalculatorDisclaimerPoint1Text: "shipping-calculator.disclaimer-point-1-text", shippingCalculatorHelperText: "shipping-calculator.helper-text", shippingCalculatorLoaderText: "shipping-calculator.loader-text", shippingCalculatorNoDeliveryMessage: "shipping-calculator.no-delivery-message", shippingCalculatorNotFoundMessage: "shipping-calculator.not-found-message", shippingCalculatorPostalCodeLabel: "shipping-calculator.postal-code-label", shippingCalculatorPostalCodeValidationErrorMessage: "shipping-calculator.postal-code-validation-error-message", shippingCalculatorFreeShippingLabel: "shipping-calculator.free-shipping-label", shippingCalculatorFreeShippingQualifiedLabel: "shipping-calculator.free-shipping-qualified-label", shippingCalculatorSelectedOptionMessage: "shipping-calculator.selected-option-message", shippingCalculatorSelectedOptionMessageForFreeDelivery: "shipping-calculator.selected-option-message-for-free-delivery", selectedOptionMessageWithoutPrice: "shipping-calculator.selected-option-message-without-price", shippingCalculatorTitleLabel: "shipping-calculator.title-label", shippingCalculatorUpdatePostalCodeMessage: "shipping-calculator.update-postal-code-message", shippingCalculatorDeliveryTodayMessage: "shipping-calculator.delivery-today-message", shippingCalculatorDeliveryTomorrowMessage: "shipping-calculator.delivery-tomorrow-message", shippingCalculatorZeroPricingText: "shipping-calculator.zero-pricing-text", shippingCalculatorCheapestSelectedOptionMessage: "shipping-calculator.cheapest-shipping-option", shippingCalculatorFreeShippingOptionMessage: "shipping-calculator.free-shipping-message", shippingCalculatorFreeShippingOptionMessageWithPostalCode: "shipping-calculator.free-shipping-message-with-postalcode", estimatedDeliveryDisclaimerLabel: "shipping-calculator.estimated-delivery-disclaimer-label", selectedOptionEstimatedMessageWithoutPrice: "shipping-calculator.selected-option-estimated-message-without-price", singleOptionEstimatedMessageWithoutPrice: "shipping-calculator.singleOptionEstimatedMessageWithoutPrice" };
function Br(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Vs = { exports: {} };
Vs.exports = function() {
  var t = 1e3, e = 6e4, n = 36e5, a = "millisecond", r = "second", i = "minute", o = "hour", s = "day", l = "week", u = "month", c = "quarter", d = "year", p = "date", g = "Invalid Date", f = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, D = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(v) {
    var y = ["th", "st", "nd", "rd"], m = v % 100;
    return "[" + v + (y[(m - 20) % 10] || y[m] || y[0]) + "]";
  } }, L = function(v, y, m) {
    var M = String(v);
    return !M || M.length >= y ? v : "" + Array(y + 1 - M.length).join(m) + v;
  }, _ = { s: L, z: function(v) {
    var y = -v.utcOffset(), m = Math.abs(y), M = Math.floor(m / 60), C = m % 60;
    return (y <= 0 ? "+" : "-") + L(M, 2, "0") + ":" + L(C, 2, "0");
  }, m: function v(y, m) {
    if (y.date() < m.date())
      return -v(m, y);
    var M = 12 * (m.year() - y.year()) + (m.month() - y.month()), C = y.clone().add(M, u), I = m - C < 0, A = y.clone().add(M + (I ? -1 : 1), u);
    return +(-(M + (m - C) / (I ? C - A : A - C)) || 0);
  }, a: function(v) {
    return v < 0 ? Math.ceil(v) || 0 : Math.floor(v);
  }, p: function(v) {
    return { M: u, y: d, w: l, d: s, D: p, h: o, m: i, s: r, ms: a, Q: c }[v] || String(v || "").toLowerCase().replace(/s$/, "");
  }, u: function(v) {
    return v === void 0;
  } }, x = "en", T = {};
  T[x] = D;
  var b = "$isDayjsObject", S = function(v) {
    return v instanceof O || !(!v || !v[b]);
  }, w = function v(y, m, M) {
    var C;
    if (!y)
      return x;
    if (typeof y == "string") {
      var I = y.toLowerCase();
      T[I] && (C = I), m && (T[I] = m, C = I);
      var A = y.split("-");
      if (!C && A.length > 1)
        return v(A[0]);
    } else {
      var P = y.name;
      T[P] = y, C = P;
    }
    return !M && C && (x = C), C || !M && x;
  }, E = function(v, y) {
    if (S(v))
      return v.clone();
    var m = typeof y == "object" ? y : {};
    return m.date = v, m.args = arguments, new O(m);
  }, k = _;
  k.l = w, k.i = S, k.w = function(v, y) {
    return E(v, { locale: y.$L, utc: y.$u, x: y.$x, $offset: y.$offset });
  };
  var O = function() {
    function v(m) {
      this.$L = w(m.locale, null, !0), this.parse(m), this.$x = this.$x || m.x || {}, this[b] = !0;
    }
    var y = v.prototype;
    return y.parse = function(m) {
      this.$d = function(M) {
        var C = M.date, I = M.utc;
        if (C === null)
          return /* @__PURE__ */ new Date(NaN);
        if (k.u(C))
          return /* @__PURE__ */ new Date();
        if (C instanceof Date)
          return new Date(C);
        if (typeof C == "string" && !/Z$/i.test(C)) {
          var A = C.match(f);
          if (A) {
            var P = A[2] - 1 || 0, B = (A[7] || "0").substring(0, 3);
            return I ? new Date(Date.UTC(A[1], P, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, B)) : new Date(A[1], P, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, B);
          }
        }
        return new Date(C);
      }(m), this.init();
    }, y.init = function() {
      var m = this.$d;
      this.$y = m.getFullYear(), this.$M = m.getMonth(), this.$D = m.getDate(), this.$W = m.getDay(), this.$H = m.getHours(), this.$m = m.getMinutes(), this.$s = m.getSeconds(), this.$ms = m.getMilliseconds();
    }, y.$utils = function() {
      return k;
    }, y.isValid = function() {
      return this.$d.toString() !== g;
    }, y.isSame = function(m, M) {
      var C = E(m);
      return this.startOf(M) <= C && C <= this.endOf(M);
    }, y.isAfter = function(m, M) {
      return E(m) < this.startOf(M);
    }, y.isBefore = function(m, M) {
      return this.endOf(M) < E(m);
    }, y.$g = function(m, M, C) {
      return k.u(m) ? this[M] : this.set(C, m);
    }, y.unix = function() {
      return Math.floor(this.valueOf() / 1e3);
    }, y.valueOf = function() {
      return this.$d.getTime();
    }, y.startOf = function(m, M) {
      var C = this, I = !!k.u(M) || M, A = k.p(m), P = function(ce, Z) {
        var le = k.w(C.$u ? Date.UTC(C.$y, Z, ce) : new Date(C.$y, Z, ce), C);
        return I ? le : le.endOf(s);
      }, B = function(ce, Z) {
        return k.w(C.toDate()[ce].apply(C.toDate("s"), (I ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Z)), C);
      }, V = this.$W, j = this.$M, R = this.$D, W = "set" + (this.$u ? "UTC" : "");
      switch (A) {
        case d:
          return I ? P(1, 0) : P(31, 11);
        case u:
          return I ? P(1, j) : P(0, j + 1);
        case l:
          var K = this.$locale().weekStart || 0, ae = (V < K ? V + 7 : V) - K;
          return P(I ? R - ae : R + (6 - ae), j);
        case s:
        case p:
          return B(W + "Hours", 0);
        case o:
          return B(W + "Minutes", 1);
        case i:
          return B(W + "Seconds", 2);
        case r:
          return B(W + "Milliseconds", 3);
        default:
          return this.clone();
      }
    }, y.endOf = function(m) {
      return this.startOf(m, !1);
    }, y.$set = function(m, M) {
      var C, I = k.p(m), A = "set" + (this.$u ? "UTC" : ""), P = (C = {}, C[s] = A + "Date", C[p] = A + "Date", C[u] = A + "Month", C[d] = A + "FullYear", C[o] = A + "Hours", C[i] = A + "Minutes", C[r] = A + "Seconds", C[a] = A + "Milliseconds", C)[I], B = I === s ? this.$D + (M - this.$W) : M;
      if (I === u || I === d) {
        var V = this.clone().set(p, 1);
        V.$d[P](B), V.init(), this.$d = V.set(p, Math.min(this.$D, V.daysInMonth())).$d;
      } else
        P && this.$d[P](B);
      return this.init(), this;
    }, y.set = function(m, M) {
      return this.clone().$set(m, M);
    }, y.get = function(m) {
      return this[k.p(m)]();
    }, y.add = function(m, M) {
      var C, I = this;
      m = Number(m);
      var A = k.p(M), P = function(j) {
        var R = E(I);
        return k.w(R.date(R.date() + Math.round(j * m)), I);
      };
      if (A === u)
        return this.set(u, this.$M + m);
      if (A === d)
        return this.set(d, this.$y + m);
      if (A === s)
        return P(1);
      if (A === l)
        return P(7);
      var B = (C = {}, C[i] = e, C[o] = n, C[r] = t, C)[A] || 1, V = this.$d.getTime() + m * B;
      return k.w(V, this);
    }, y.subtract = function(m, M) {
      return this.add(-1 * m, M);
    }, y.format = function(m) {
      var M = this, C = this.$locale();
      if (!this.isValid())
        return C.invalidDate || g;
      var I = m || "YYYY-MM-DDTHH:mm:ssZ", A = k.z(this), P = this.$H, B = this.$m, V = this.$M, j = C.weekdays, R = C.months, W = C.meridiem, K = function(Z, le, ve, Le) {
        return Z && (Z[le] || Z(M, I)) || ve[le].slice(0, Le);
      }, ae = function(Z) {
        return k.s(P % 12 || 12, Z, "0");
      }, ce = W || function(Z, le, ve) {
        var Le = Z < 12 ? "AM" : "PM";
        return ve ? Le.toLowerCase() : Le;
      };
      return I.replace(h, function(Z, le) {
        return le || function(ve) {
          switch (ve) {
            case "YY":
              return String(M.$y).slice(-2);
            case "YYYY":
              return k.s(M.$y, 4, "0");
            case "M":
              return V + 1;
            case "MM":
              return k.s(V + 1, 2, "0");
            case "MMM":
              return K(C.monthsShort, V, R, 3);
            case "MMMM":
              return K(R, V);
            case "D":
              return M.$D;
            case "DD":
              return k.s(M.$D, 2, "0");
            case "d":
              return String(M.$W);
            case "dd":
              return K(C.weekdaysMin, M.$W, j, 2);
            case "ddd":
              return K(C.weekdaysShort, M.$W, j, 3);
            case "dddd":
              return j[M.$W];
            case "H":
              return String(P);
            case "HH":
              return k.s(P, 2, "0");
            case "h":
              return ae(1);
            case "hh":
              return ae(2);
            case "a":
              return ce(P, B, !0);
            case "A":
              return ce(P, B, !1);
            case "m":
              return String(B);
            case "mm":
              return k.s(B, 2, "0");
            case "s":
              return String(M.$s);
            case "ss":
              return k.s(M.$s, 2, "0");
            case "SSS":
              return k.s(M.$ms, 3, "0");
            case "Z":
              return A;
          }
          return null;
        }(Z) || A.replace(":", "");
      });
    }, y.utcOffset = function() {
      return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
    }, y.diff = function(m, M, C) {
      var I, A = this, P = k.p(M), B = E(m), V = (B.utcOffset() - this.utcOffset()) * e, j = this - B, R = function() {
        return k.m(A, B);
      };
      switch (P) {
        case d:
          I = R() / 12;
          break;
        case u:
          I = R();
          break;
        case c:
          I = R() / 3;
          break;
        case l:
          I = (j - V) / 6048e5;
          break;
        case s:
          I = (j - V) / 864e5;
          break;
        case o:
          I = j / n;
          break;
        case i:
          I = j / e;
          break;
        case r:
          I = j / t;
          break;
        default:
          I = j;
      }
      return C ? I : k.a(I);
    }, y.daysInMonth = function() {
      return this.endOf(u).$D;
    }, y.$locale = function() {
      return T[this.$L];
    }, y.locale = function(m, M) {
      if (!m)
        return this.$L;
      var C = this.clone(), I = w(m, M, !0);
      return I && (C.$L = I), C;
    }, y.clone = function() {
      return k.w(this.$d, this);
    }, y.toDate = function() {
      return new Date(this.valueOf());
    }, y.toJSON = function() {
      return this.isValid() ? this.toISOString() : null;
    }, y.toISOString = function() {
      return this.$d.toISOString();
    }, y.toString = function() {
      return this.$d.toUTCString();
    }, v;
  }(), $ = O.prototype;
  return E.prototype = $, [["$ms", a], ["$s", r], ["$m", i], ["$H", o], ["$W", s], ["$M", u], ["$y", d], ["$D", p]].forEach(function(v) {
    $[v[1]] = function(y) {
      return this.$g(y, v[0], v[1]);
    };
  }), E.extend = function(v, y) {
    return v.$i || (v(y, O, E), v.$i = !0), E;
  }, E.locale = w, E.isDayjs = S, E.unix = function(v) {
    return E(1e3 * v);
  }, E.en = T[x], E.Ls = T, E.p = {}, E;
}();
var ie = Vs.exports, st = Br(ie), Hs = { exports: {} };
Hs.exports = function(t, e) {
  var n = e.prototype, a = n.format;
  n.format = function(r) {
    var i = this, o = this.$locale();
    if (!this.isValid())
      return a.bind(this)(r);
    var s = this.$utils(), l = (r || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(u) {
      switch (u) {
        case "Q":
          return Math.ceil((i.$M + 1) / 3);
        case "Do":
          return o.ordinal(i.$D);
        case "gggg":
          return i.weekYear();
        case "GGGG":
          return i.isoWeekYear();
        case "wo":
          return o.ordinal(i.week(), "W");
        case "w":
        case "ww":
          return s.s(i.week(), u === "w" ? 1 : 2, "0");
        case "W":
        case "WW":
          return s.s(i.isoWeek(), u === "W" ? 1 : 2, "0");
        case "k":
        case "kk":
          return s.s(String(i.$H === 0 ? 24 : i.$H), u === "k" ? 1 : 2, "0");
        case "X":
          return Math.floor(i.$d.getTime() / 1e3);
        case "x":
          return i.$d.getTime();
        case "z":
          return "[" + i.offsetName() + "]";
        case "zzz":
          return "[" + i.offsetName("long") + "]";
        default:
          return u;
      }
    });
    return a.bind(this)(l);
  };
};
var wa, Dt, gd = Br(Hs.exports), fd = { exports: {} }, yd = Br(fd.exports = (wa = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, function(t, e, n) {
  var a = e.prototype, r = a.format;
  n.en.formats = wa, a.format = function(i) {
    i === void 0 && (i = "YYYY-MM-DDTHH:mm:ssZ");
    var o = this.$locale().formats, s = function(l, u) {
      return l.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(c, d, p) {
        var g = p && p.toUpperCase();
        return d || u[p] || wa[p] || u[g].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(f, h, D) {
          return h || D.slice(1);
        });
      });
    }(i, o === void 0 ? {} : o);
    return r.call(this, s);
  };
}));
(function(t) {
  t.SHORT_FMT = "SHORT_DATE_FMT", t.MEDIUM_FMT = "MEDIUM_DATE_FMT", t.LONG_FMT = "LONG_DATE_FMT", t.SHORT_DATE_W_DOW = "SHORT_DATE_W_DOW", t.DEFAULT_FMT = "SHORT_DATE_FMT";
})(Dt || (Dt = {}));
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "da", weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"), weekdaysShort: "søn._man._tirs._ons._tors._fre._lør.".split("_"), weekdaysMin: "sø._ma._ti._on._to._fr._lø.".split("_"), months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"), monthsShort: "jan._feb._mar._apr._maj_juni_juli_aug._sept._okt._nov._dec.".split("_"), weekStart: 1, yearStart: 4, ordinal: function(r) {
    return r + ".";
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm" }, relativeTime: { future: "om %s", past: "%s siden", s: "få sekunder", m: "et minut", mm: "%d minutter", h: "en time", hh: "%d timer", d: "en dag", dd: "%d dage", M: "en måned", MM: "%d måneder", y: "et år", yy: "%d år" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(o) {
    return o && typeof o == "object" && "default" in o ? o : { default: o };
  }
  var n = e(t), a = { s: "ein paar Sekunden", m: ["eine Minute", "einer Minute"], mm: "%d Minuten", h: ["eine Stunde", "einer Stunde"], hh: "%d Stunden", d: ["ein Tag", "einem Tag"], dd: ["%d Tage", "%d Tagen"], M: ["ein Monat", "einem Monat"], MM: ["%d Monate", "%d Monaten"], y: ["ein Jahr", "einem Jahr"], yy: ["%d Jahre", "%d Jahren"] };
  function r(o, s, l) {
    var u = a[l];
    return Array.isArray(u) && (u = u[s ? 0 : 1]), u.replace("%d", o);
  }
  var i = { name: "de", weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"), weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"), weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"), monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"), ordinal: function(o) {
    return o + ".";
  }, weekStart: 1, yearStart: 4, formats: { LTS: "HH:mm:ss", LT: "HH:mm", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd, D. MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "vor %s", s: r, m: r, mm: r, h: r, hh: r, d: r, dd: r, M: r, MM: r, y: r, yy: r } };
  n.default.locale(i, null, !0);
})(ie);
(function(t) {
  function e(o) {
    return o && typeof o == "object" && "default" in o ? o : { default: o };
  }
  var n = e(t), a = { s: "ein paar Sekunden", m: ["eine Minute", "einer Minute"], mm: "%d Minuten", h: ["eine Stunde", "einer Stunde"], hh: "%d Stunden", d: ["ein Tag", "einem Tag"], dd: ["%d Tage", "%d Tagen"], M: ["ein Monat", "einem Monat"], MM: ["%d Monate", "%d Monaten"], y: ["ein Jahr", "einem Jahr"], yy: ["%d Jahre", "%d Jahren"] };
  function r(o, s, l) {
    var u = a[l];
    return Array.isArray(u) && (u = u[s ? 0 : 1]), u.replace("%d", o);
  }
  var i = { name: "de-at", weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"), weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"), weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), months: "Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"), monthsShort: "Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"), ordinal: function(o) {
    return o + ".";
  }, weekStart: 1, formats: { LTS: "HH:mm:ss", LT: "HH:mm", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd, D. MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "vor %s", s: r, m: r, mm: r, h: r, hh: r, d: r, dd: r, M: r, MM: r, y: r, yy: r } };
  n.default.locale(i, null, !0);
})(ie);
(function(t) {
  function e(o) {
    return o && typeof o == "object" && "default" in o ? o : { default: o };
  }
  var n = e(t), a = { s: "ein paar Sekunden", m: ["eine Minute", "einer Minute"], mm: "%d Minuten", h: ["eine Stunde", "einer Stunde"], hh: "%d Stunden", d: ["ein Tag", "einem Tag"], dd: ["%d Tage", "%d Tagen"], M: ["ein Monat", "einem Monat"], MM: ["%d Monate", "%d Monaten"], y: ["ein Jahr", "einem Jahr"], yy: ["%d Jahre", "%d Jahren"] };
  function r(o, s, l) {
    var u = a[l];
    return Array.isArray(u) && (u = u[s ? 0 : 1]), u.replace("%d", o);
  }
  var i = { name: "de-ch", weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"), weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"), monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"), ordinal: function(o) {
    return o + ".";
  }, weekStart: 1, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd, D. MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "vor %s", s: r, m: r, mm: r, h: r, hh: r, d: r, dd: r, M: r, MM: r, y: r, yy: r } };
  n.default.locale(i, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "en-au", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), weekStart: 1, weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), ordinal: function(r) {
    return r;
  }, formats: { LT: "h:mm A", LTS: "h:mm:ss A", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY h:mm A", LLLL: "dddd, D MMMM YYYY h:mm A" }, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "en-ca", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), ordinal: function(r) {
    return r;
  }, formats: { LT: "h:mm A", LTS: "h:mm:ss A", L: "YYYY-MM-DD", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "en-gb", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekStart: 1, yearStart: 4, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd, D MMMM YYYY HH:mm" }, ordinal: function(r) {
    var i = ["th", "st", "nd", "rd"], o = r % 100;
    return "[" + r + (i[(o - 20) % 10] || i[o] || i[0]) + "]";
  } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "en-ie", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), weekStart: 1, weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), ordinal: function(r) {
    return r;
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "en-in", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekStart: 1, yearStart: 4, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd, D MMMM YYYY HH:mm" }, ordinal: function(r) {
    var i = ["th", "st", "nd", "rd"], o = r % 100;
    return "[" + r + (i[(o - 20) % 10] || i[o] || i[0]) + "]";
  } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "en-nz", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), weekStart: 1, weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), ordinal: function(r) {
    var i = ["th", "st", "nd", "rd"], o = r % 100;
    return "[" + r + (i[(o - 20) % 10] || i[o] || i[0]) + "]";
  }, formats: { LT: "h:mm A", LTS: "h:mm:ss A", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY h:mm A", LLLL: "dddd, D MMMM YYYY h:mm A" }, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "en-sg", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), weekStart: 1, weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), ordinal: function(r) {
    return r;
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd, D MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(r) {
    return r + "º";
  } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "es-us", weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(r) {
    return r + "º";
  }, formats: { LT: "h:mm A", LTS: "h:mm:ss A", L: "MM/DD/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY h:mm A", LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(i) {
    return i && typeof i == "object" && "default" in i ? i : { default: i };
  }
  var n = e(t);
  function a(i, o, s, l) {
    var u = { s: "muutama sekunti", m: "minuutti", mm: "%d minuuttia", h: "tunti", hh: "%d tuntia", d: "päivä", dd: "%d päivää", M: "kuukausi", MM: "%d kuukautta", y: "vuosi", yy: "%d vuotta", numbers: "nolla_yksi_kaksi_kolme_neljä_viisi_kuusi_seitsemän_kahdeksan_yhdeksän".split("_") }, c = { s: "muutaman sekunnin", m: "minuutin", mm: "%d minuutin", h: "tunnin", hh: "%d tunnin", d: "päivän", dd: "%d päivän", M: "kuukauden", MM: "%d kuukauden", y: "vuoden", yy: "%d vuoden", numbers: "nollan_yhden_kahden_kolmen_neljän_viiden_kuuden_seitsemän_kahdeksan_yhdeksän".split("_") }, d = l && !o ? c : u, p = d[s];
    return i < 10 ? p.replace("%d", d.numbers[i]) : p.replace("%d", i);
  }
  var r = { name: "fi", weekdays: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"), weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"), weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"), months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"), monthsShort: "tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"), ordinal: function(i) {
    return i + ".";
  }, weekStart: 1, yearStart: 4, relativeTime: { future: "%s päästä", past: "%s sitten", s: a, m: a, mm: a, h: a, hh: a, d: a, dd: a, M: a, MM: a, y: a, yy: a }, formats: { LT: "HH.mm", LTS: "HH.mm.ss", L: "DD.MM.YYYY", LL: "D. MMMM[ta] YYYY", LLL: "D. MMMM[ta] YYYY, [klo] HH.mm", LLLL: "dddd, D. MMMM[ta] YYYY, [klo] HH.mm", l: "D.M.YYYY", ll: "D. MMM YYYY", lll: "D. MMM YYYY, [klo] HH.mm", llll: "ddd, D. MMM YYYY, [klo] HH.mm" } };
  n.default.locale(r, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(r) {
    return r + (r === 1 ? "er" : "");
  } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "fr-ca", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), ordinal: function(r) {
    return r;
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY-MM-DD", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "fr-ch", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), weekStart: 1, weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), ordinal: function(r) {
    return r;
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "it", weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"), weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"), weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"), months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"), weekStart: 1, monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"), formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "tra %s", past: "%s fa", s: "qualche secondo", m: "un minuto", mm: "%d minuti", h: "un' ora", hh: "%d ore", d: "un giorno", dd: "%d giorni", M: "un mese", MM: "%d mesi", y: "un anno", yy: "%d anni" }, ordinal: function(r) {
    return r + "º";
  } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "it-ch", weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"), months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"), weekStart: 1, weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"), monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"), weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"), ordinal: function(r) {
    return r;
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "tra %s", past: "%s fa", s: "alcuni secondi", m: "un minuto", mm: "%d minuti", h: "un'ora", hh: "%d ore", d: "un giorno", dd: "%d giorni", M: "un mese", MM: "%d mesi", y: "un anno", yy: "%d anni" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "ja", weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"), weekdaysShort: "日_月_火_水_木_金_土".split("_"), weekdaysMin: "日_月_火_水_木_金_土".split("_"), months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(r) {
    return r + "日";
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日 dddd HH:mm", l: "YYYY/MM/DD", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日(ddd) HH:mm" }, meridiem: function(r) {
    return r < 12 ? "午前" : "午後";
  }, relativeTime: { future: "%s後", past: "%s前", s: "数秒", m: "1分", mm: "%d分", h: "1時間", hh: "%d時間", d: "1日", dd: "%d日", M: "1ヶ月", MM: "%dヶ月", y: "1年", yy: "%d年" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "nb", weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"), weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"), weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"), months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"), monthsShort: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"), ordinal: function(r) {
    return r + ".";
  }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY [kl.] HH:mm", LLLL: "dddd D. MMMM YYYY [kl.] HH:mm" }, relativeTime: { future: "om %s", past: "%s siden", s: "noen sekunder", m: "ett minutt", mm: "%d minutter", h: "en time", hh: "%d timer", d: "en dag", dd: "%d dager", M: "en måned", MM: "%d måneder", y: "ett år", yy: "%d år" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "nl", weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"), weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"), weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"), months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"), monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), ordinal: function(r) {
    return "[" + r + (r === 1 || r === 8 || r >= 20 ? "ste" : "de") + "]";
  }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD-MM-YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "over %s", past: "%s geleden", s: "een paar seconden", m: "een minuut", mm: "%d minuten", h: "een uur", hh: "%d uur", d: "een dag", dd: "%d dagen", M: "een maand", MM: "%d maanden", y: "een jaar", yy: "%d jaar" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "nl-be", weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"), months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"), monthsShort: "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"), weekStart: 1, weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"), weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"), ordinal: function(r) {
    return r;
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "over %s", past: "%s geleden", s: "een paar seconden", m: "één minuut", mm: "%d minuten", h: "één uur", hh: "%d uur", d: "één dag", dd: "%d dagen", M: "één maand", MM: "%d maanden", y: "één jaar", yy: "%d jaar" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "pt", weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"), weekdaysShort: "dom_seg_ter_qua_qui_sex_sab".split("_"), weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sa".split("_"), months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"), monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"), ordinal: function(r) {
    return r + "º";
  }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY [às] HH:mm", LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm" }, relativeTime: { future: "em %s", past: "há %s", s: "alguns segundos", m: "um minuto", mm: "%d minutos", h: "uma hora", hh: "%d horas", d: "um dia", dd: "%d dias", M: "um mês", MM: "%d meses", y: "um ano", yy: "%d anos" } };
  n.default.locale(a, null, !0);
})(ie);
(function(t) {
  function e(r) {
    return r && typeof r == "object" && "default" in r ? r : { default: r };
  }
  var n = e(t), a = { name: "sv", weekdays: "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"), weekdaysShort: "sön_mån_tis_ons_tor_fre_lör".split("_"), weekdaysMin: "sö_må_ti_on_to_fr_lö".split("_"), months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"), monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"), weekStart: 1, yearStart: 4, ordinal: function(r) {
    var i = r % 10;
    return "[" + r + (i === 1 || i === 2 ? "a" : "e") + "]";
  }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY-MM-DD", LL: "D MMMM YYYY", LLL: "D MMMM YYYY [kl.] HH:mm", LLLL: "dddd D MMMM YYYY [kl.] HH:mm", lll: "D MMM YYYY HH:mm", llll: "ddd D MMM YYYY HH:mm" }, relativeTime: { future: "om %s", past: "för %s sedan", s: "några sekunder", m: "en minut", mm: "%d minuter", h: "en timme", hh: "%d timmar", d: "en dag", dd: "%d dagar", M: "en månad", MM: "%d månader", y: "ett år", yy: "%d år" } };
  n.default.locale(a, null, !0);
})(ie);
var Qi = { SHORT_DATE_FMT: "Do MMM", MEDIUM_DATE_FMT: "DD.MM.YYYY", LONG_DATE_FMT: "dddd, Do. MMMM YYYY", SHORT_DATE_W_DOW: "dddd, Do MMM" }, _a = { SHORT_DATE_FMT: "Do MMM", MEDIUM_DATE_FMT: "Do MMMM YYYY", LONG_DATE_FMT: "dddd Do MMMM YYYY", SHORT_DATE_W_DOW: "dddd, Do MMM" }, Xi = { SHORT_DATE_FMT: "D MMMM", MEDIUM_DATE_FMT: "D MMMM YYYY", LONG_DATE_FMT: "dddd, D MMMM YYYY", SHORT_DATE_W_DOW: "dddd, D MMMM" }, eo = { SHORT_DATE_FMT: "D MMM", MEDIUM_DATE_FMT: "DD-MM-YYYY", LONG_DATE_FMT: "dddd D MMMM YYYY", SHORT_DATE_W_DOW: "dddd, D MMM" };
const tt = { SHORT_DATE_FMT: "Do MMM", MEDIUM_DATE_FMT: "Do MMMM YYYY", LONG_DATE_FMT: "dddd, Do MMMM YYYY", SHORT_DATE_W_DOW: "dddd, Do MMM" };
var to = { "de-CH": Qi, "de-DE": Qi, "en-CA": { SHORT_DATE_FMT: "MMM Do", MEDIUM_DATE_FMT: "MMMM Do YYYY", LONG_DATE_FMT: "dddd, MMMM Do YYYY", SHORT_DATE_W_DOW: "dddd, MMM Do" }, "en-GB": { SHORT_DATE_FMT: "Do MMM", MEDIUM_DATE_FMT: "Do MMMM YYYY", LONG_DATE_FMT: "dddd, Do MMMM YYYY", SHORT_DATE_W_DOW: "dddd, Do MMM" }, "en-IE": { SHORT_DATE_FMT: "Do MMM", MEDIUM_DATE_FMT: "Do MMMM YYYY", LONG_DATE_FMT: "dddd, Do MMMM YYYY", SHORT_DATE_W_DOW: "dddd, Do MMM" }, "en-IN": { SHORT_DATE_FMT: "D MMMM", MEDIUM_DATE_FMT: "DD-MM-YYYY", LONG_DATE_FMT: "dddd D MMMM YYYY", SHORT_DATE_W_DOW: "D MMMM" }, "en-US": { SHORT_DATE_FMT: "MMM Do", MEDIUM_DATE_FMT: "MMMM Do YYYY", LONG_DATE_FMT: "dddd, MMMM Do YYYY", SHORT_DATE_W_DOW: "dddd, MMM Do" }, "es-ES": { SHORT_DATE_FMT: "D [de] MMMM", MEDIUM_DATE_FMT: "D [de] MMMM [de] YYYY", LONG_DATE_FMT: "dddd, D [de] MMMM [de] YYYY", SHORT_DATE_W_DOW: "dddd, D [de] MMMM" }, "es-US": { SHORT_DATE_FMT: "D [de] MMMM", MEDIUM_DATE_FMT: "D [de] MMMM [de] YYYY", LONG_DATE_FMT: "dddd, D [de] MMMM [de] YYYY", SHORT_DATE_W_DOW: "dddd, D [de] MMMM" }, "fr-BE": _a, "fr-CA": { SHORT_DATE_FMT: "MMM Do", MEDIUM_DATE_FMT: "MMMM Do YYYY", LONG_DATE_FMT: "dddd, MMMM Do YYYY", SHORT_DATE_W_DOW: "dddd, MMM Do" }, "fr-CH": _a, "fr-FR": _a, "it-CH": Xi, "it-IT": Xi, "nl-NL": eo, "nl-BE": eo, "pt-PT": { SHORT_DATE_FMT: "Do MMM", MEDIUM_DATE_FMT: "Do/MMMM/YYYY", LONG_DATE_FMT: "dddd, MMMM Do YYYY", SHORT_DATE_W_DOW: "dddd, Do MMM" }, "fi-FI": { SHORT_DATE_FMT: "D.M.", MEDIUM_DATE_FMT: "D. MMMM[ta] YYYY", LONG_DATE_FMT: "dddd D. MMMM[ta] YYYY", SHORT_DATE_W_DOW: "dddd D.M" }, "ja-JP": { SHORT_DATE_FMT: "M月D日", MEDIUM_DATE_FMT: "LL", LONG_DATE_FMT: "LL (ddd)", SHORT_DATE_W_DOW: "M月D日 (ddd)" }, "sv-SE": { SHORT_DATE_FMT: "D MMM", MEDIUM_DATE_FMT: "D MMMM YYYY", LONG_DATE_FMT: "dddd D MMMM YYYY", SHORT_DATE_W_DOW: "dddd D MMM" }, "da-DK": tt, "de-AT": tt, "nb-NO": tt, "en-AU": tt, "en-NZ": tt, "en-SG": tt, default: tt };
st.extend(gd), st.extend(yd);
const no = "en-ie", nt = (t, e = "en-IE", n = Dt.DEFAULT_FMT) => {
  if (!st(st(t).toJSON()).isValid())
    return t;
  const a = ((o) => {
    if (!o)
      return console.error("Empty SiteLocale passed to dateformatter... returning en-ie locale for date formatting"), no;
    switch (o) {
      case "da-DK":
        return "da";
      case "de-AT":
        return "de-at";
      case "de-CH":
        return "de-ch";
      case "de-DE":
        return "de";
      case "en-CA":
        return "en-ca";
      case "en-AU":
        return "en-au";
      case "en-GB":
        return "en-gb";
      case "en-IE":
        return "en-ie";
      case "en-IN":
        return "en-in";
      case "en-NZ":
        return "en-nz";
      case "en-SG":
        return "en-sg";
      case "en-US":
        return "en";
      case "es-ES":
        return "es";
      case "es-US":
        return "es-us";
      case "fi-FI":
        return "fi";
      case "fr-BE":
      case "fr-FR":
        return "fr";
      case "fr-CH":
        return "fr-ch";
      case "fr-CA":
        return "fr-ca";
      case "it-CH":
        return "it-ch";
      case "it-IT":
        return "it";
      case "ja-JP":
        return "ja";
      case "nb-NO":
        return "nb";
      case "nl-BE":
        return "nl-be";
      case "nl-NL":
        return "nl";
      case "pt-PT":
        return "pt";
      case "sv-SE":
        return "sv";
      default:
        console.error("Unrecognized locale, unable to map to a valid dayjs.js locale... returning en-ie fordate formatting");
    }
    return no;
  })(e);
  a !== st.locale() && st.locale(a);
  let r = to[e];
  r || (console.error(`No dateformats found for locale: ${e} using defaults.`), r = to.default);
  const i = r[n];
  return st(t).format(i);
};
var Us = { exports: {} };
Us.exports = function() {
  var t = 1e3, e = 6e4, n = 36e5, a = "millisecond", r = "second", i = "minute", o = "hour", s = "day", l = "week", u = "month", c = "quarter", d = "year", p = "date", g = "Invalid Date", f = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, D = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(v) {
    var y = ["th", "st", "nd", "rd"], m = v % 100;
    return "[" + v + (y[(m - 20) % 10] || y[m] || y[0]) + "]";
  } }, L = function(v, y, m) {
    var M = String(v);
    return !M || M.length >= y ? v : "" + Array(y + 1 - M.length).join(m) + v;
  }, _ = { s: L, z: function(v) {
    var y = -v.utcOffset(), m = Math.abs(y), M = Math.floor(m / 60), C = m % 60;
    return (y <= 0 ? "+" : "-") + L(M, 2, "0") + ":" + L(C, 2, "0");
  }, m: function v(y, m) {
    if (y.date() < m.date())
      return -v(m, y);
    var M = 12 * (m.year() - y.year()) + (m.month() - y.month()), C = y.clone().add(M, u), I = m - C < 0, A = y.clone().add(M + (I ? -1 : 1), u);
    return +(-(M + (m - C) / (I ? C - A : A - C)) || 0);
  }, a: function(v) {
    return v < 0 ? Math.ceil(v) || 0 : Math.floor(v);
  }, p: function(v) {
    return { M: u, y: d, w: l, d: s, D: p, h: o, m: i, s: r, ms: a, Q: c }[v] || String(v || "").toLowerCase().replace(/s$/, "");
  }, u: function(v) {
    return v === void 0;
  } }, x = "en", T = {};
  T[x] = D;
  var b = "$isDayjsObject", S = function(v) {
    return v instanceof O || !(!v || !v[b]);
  }, w = function v(y, m, M) {
    var C;
    if (!y)
      return x;
    if (typeof y == "string") {
      var I = y.toLowerCase();
      T[I] && (C = I), m && (T[I] = m, C = I);
      var A = y.split("-");
      if (!C && A.length > 1)
        return v(A[0]);
    } else {
      var P = y.name;
      T[P] = y, C = P;
    }
    return !M && C && (x = C), C || !M && x;
  }, E = function(v, y) {
    if (S(v))
      return v.clone();
    var m = typeof y == "object" ? y : {};
    return m.date = v, m.args = arguments, new O(m);
  }, k = _;
  k.l = w, k.i = S, k.w = function(v, y) {
    return E(v, { locale: y.$L, utc: y.$u, x: y.$x, $offset: y.$offset });
  };
  var O = function() {
    function v(m) {
      this.$L = w(m.locale, null, !0), this.parse(m), this.$x = this.$x || m.x || {}, this[b] = !0;
    }
    var y = v.prototype;
    return y.parse = function(m) {
      this.$d = function(M) {
        var C = M.date, I = M.utc;
        if (C === null)
          return /* @__PURE__ */ new Date(NaN);
        if (k.u(C))
          return /* @__PURE__ */ new Date();
        if (C instanceof Date)
          return new Date(C);
        if (typeof C == "string" && !/Z$/i.test(C)) {
          var A = C.match(f);
          if (A) {
            var P = A[2] - 1 || 0, B = (A[7] || "0").substring(0, 3);
            return I ? new Date(Date.UTC(A[1], P, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, B)) : new Date(A[1], P, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, B);
          }
        }
        return new Date(C);
      }(m), this.init();
    }, y.init = function() {
      var m = this.$d;
      this.$y = m.getFullYear(), this.$M = m.getMonth(), this.$D = m.getDate(), this.$W = m.getDay(), this.$H = m.getHours(), this.$m = m.getMinutes(), this.$s = m.getSeconds(), this.$ms = m.getMilliseconds();
    }, y.$utils = function() {
      return k;
    }, y.isValid = function() {
      return this.$d.toString() !== g;
    }, y.isSame = function(m, M) {
      var C = E(m);
      return this.startOf(M) <= C && C <= this.endOf(M);
    }, y.isAfter = function(m, M) {
      return E(m) < this.startOf(M);
    }, y.isBefore = function(m, M) {
      return this.endOf(M) < E(m);
    }, y.$g = function(m, M, C) {
      return k.u(m) ? this[M] : this.set(C, m);
    }, y.unix = function() {
      return Math.floor(this.valueOf() / 1e3);
    }, y.valueOf = function() {
      return this.$d.getTime();
    }, y.startOf = function(m, M) {
      var C = this, I = !!k.u(M) || M, A = k.p(m), P = function(ce, Z) {
        var le = k.w(C.$u ? Date.UTC(C.$y, Z, ce) : new Date(C.$y, Z, ce), C);
        return I ? le : le.endOf(s);
      }, B = function(ce, Z) {
        return k.w(C.toDate()[ce].apply(C.toDate("s"), (I ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Z)), C);
      }, V = this.$W, j = this.$M, R = this.$D, W = "set" + (this.$u ? "UTC" : "");
      switch (A) {
        case d:
          return I ? P(1, 0) : P(31, 11);
        case u:
          return I ? P(1, j) : P(0, j + 1);
        case l:
          var K = this.$locale().weekStart || 0, ae = (V < K ? V + 7 : V) - K;
          return P(I ? R - ae : R + (6 - ae), j);
        case s:
        case p:
          return B(W + "Hours", 0);
        case o:
          return B(W + "Minutes", 1);
        case i:
          return B(W + "Seconds", 2);
        case r:
          return B(W + "Milliseconds", 3);
        default:
          return this.clone();
      }
    }, y.endOf = function(m) {
      return this.startOf(m, !1);
    }, y.$set = function(m, M) {
      var C, I = k.p(m), A = "set" + (this.$u ? "UTC" : ""), P = (C = {}, C[s] = A + "Date", C[p] = A + "Date", C[u] = A + "Month", C[d] = A + "FullYear", C[o] = A + "Hours", C[i] = A + "Minutes", C[r] = A + "Seconds", C[a] = A + "Milliseconds", C)[I], B = I === s ? this.$D + (M - this.$W) : M;
      if (I === u || I === d) {
        var V = this.clone().set(p, 1);
        V.$d[P](B), V.init(), this.$d = V.set(p, Math.min(this.$D, V.daysInMonth())).$d;
      } else
        P && this.$d[P](B);
      return this.init(), this;
    }, y.set = function(m, M) {
      return this.clone().$set(m, M);
    }, y.get = function(m) {
      return this[k.p(m)]();
    }, y.add = function(m, M) {
      var C, I = this;
      m = Number(m);
      var A = k.p(M), P = function(j) {
        var R = E(I);
        return k.w(R.date(R.date() + Math.round(j * m)), I);
      };
      if (A === u)
        return this.set(u, this.$M + m);
      if (A === d)
        return this.set(d, this.$y + m);
      if (A === s)
        return P(1);
      if (A === l)
        return P(7);
      var B = (C = {}, C[i] = e, C[o] = n, C[r] = t, C)[A] || 1, V = this.$d.getTime() + m * B;
      return k.w(V, this);
    }, y.subtract = function(m, M) {
      return this.add(-1 * m, M);
    }, y.format = function(m) {
      var M = this, C = this.$locale();
      if (!this.isValid())
        return C.invalidDate || g;
      var I = m || "YYYY-MM-DDTHH:mm:ssZ", A = k.z(this), P = this.$H, B = this.$m, V = this.$M, j = C.weekdays, R = C.months, W = C.meridiem, K = function(Z, le, ve, Le) {
        return Z && (Z[le] || Z(M, I)) || ve[le].slice(0, Le);
      }, ae = function(Z) {
        return k.s(P % 12 || 12, Z, "0");
      }, ce = W || function(Z, le, ve) {
        var Le = Z < 12 ? "AM" : "PM";
        return ve ? Le.toLowerCase() : Le;
      };
      return I.replace(h, function(Z, le) {
        return le || function(ve) {
          switch (ve) {
            case "YY":
              return String(M.$y).slice(-2);
            case "YYYY":
              return k.s(M.$y, 4, "0");
            case "M":
              return V + 1;
            case "MM":
              return k.s(V + 1, 2, "0");
            case "MMM":
              return K(C.monthsShort, V, R, 3);
            case "MMMM":
              return K(R, V);
            case "D":
              return M.$D;
            case "DD":
              return k.s(M.$D, 2, "0");
            case "d":
              return String(M.$W);
            case "dd":
              return K(C.weekdaysMin, M.$W, j, 2);
            case "ddd":
              return K(C.weekdaysShort, M.$W, j, 3);
            case "dddd":
              return j[M.$W];
            case "H":
              return String(P);
            case "HH":
              return k.s(P, 2, "0");
            case "h":
              return ae(1);
            case "hh":
              return ae(2);
            case "a":
              return ce(P, B, !0);
            case "A":
              return ce(P, B, !1);
            case "m":
              return String(B);
            case "mm":
              return k.s(B, 2, "0");
            case "s":
              return String(M.$s);
            case "ss":
              return k.s(M.$s, 2, "0");
            case "SSS":
              return k.s(M.$ms, 3, "0");
            case "Z":
              return A;
          }
          return null;
        }(Z) || A.replace(":", "");
      });
    }, y.utcOffset = function() {
      return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
    }, y.diff = function(m, M, C) {
      var I, A = this, P = k.p(M), B = E(m), V = (B.utcOffset() - this.utcOffset()) * e, j = this - B, R = function() {
        return k.m(A, B);
      };
      switch (P) {
        case d:
          I = R() / 12;
          break;
        case u:
          I = R();
          break;
        case c:
          I = R() / 3;
          break;
        case l:
          I = (j - V) / 6048e5;
          break;
        case s:
          I = (j - V) / 864e5;
          break;
        case o:
          I = j / n;
          break;
        case i:
          I = j / e;
          break;
        case r:
          I = j / t;
          break;
        default:
          I = j;
      }
      return C ? I : k.a(I);
    }, y.daysInMonth = function() {
      return this.endOf(u).$D;
    }, y.$locale = function() {
      return T[this.$L];
    }, y.locale = function(m, M) {
      if (!m)
        return this.$L;
      var C = this.clone(), I = w(m, M, !0);
      return I && (C.$L = I), C;
    }, y.clone = function() {
      return k.w(this.$d, this);
    }, y.toDate = function() {
      return new Date(this.valueOf());
    }, y.toJSON = function() {
      return this.isValid() ? this.toISOString() : null;
    }, y.toISOString = function() {
      return this.$d.toISOString();
    }, y.toString = function() {
      return this.$d.toUTCString();
    }, v;
  }(), $ = O.prototype;
  return E.prototype = $, [["$ms", a], ["$s", r], ["$m", i], ["$H", o], ["$W", s], ["$M", u], ["$y", d], ["$D", p]].forEach(function(v) {
    $[v[1]] = function(y) {
      return this.$g(y, v[0], v[1]);
    };
  }), E.extend = function(v, y) {
    return v.$i || (v(y, O, E), v.$i = !0), E;
  }, E.locale = w, E.isDayjs = S, E.unix = function(v) {
    return E(1e3 * v);
  }, E.en = T[x], E.Ls = T, E.p = {}, E;
}();
const $s = kr(Us.exports), Kn = (t, e) => {
  const n = new Date(t.promisedArrivalDate), a = new Date(e.promisedArrivalDate);
  return n > a ? 1 : n < a ? -1 : 0;
}, bd = (t, e) => t.shippingDiscountedPrice.taxed > e.shippingDiscountedPrice.taxed ? 1 : t.shippingDiscountedPrice.taxed < e.shippingDiscountedPrice.taxed ? -1 : Kn(t, e), zs = (t) => [...t].sort(Kn)[0], qs = (t) => [...t].sort(bd)[0], vd = (t) => {
  const e = qs(t);
  if (e?.shippingDiscountedPrice.taxedInCents === 0)
    return e;
}, ao = (t) => {
  const e = new Date(Date.now());
  return Math.ceil($s(new Date(t)).diff(e, "day", !0));
}, Za = "defaultShippingEstimatePostalCode", Wa = "defaultShippingEstimateCountry", ro = () => typeof window > "u" || !window?.sessionStorage ? { postalCode: void 0, country: void 0 } : { postalCode: window.sessionStorage.getItem(Za) || void 0, country: window.sessionStorage.getItem(Wa) || void 0 }, Gr = ({ country: t, postalCode: e }) => {
  typeof window < "u" && window?.sessionStorage && (e && (localStorage.removeItem(Za), window.sessionStorage.setItem(Za, e)), t && (localStorage.removeItem(Wa), window.sessionStorage.setItem(Wa, t), window.dispatchEvent(new Event("session-storage-country-changed"))));
}, Yr = async (t, e, n, a, r, i, o, s) => {
  const l = n ? "taxed" : "untaxed", u = s || o, c = new Bc(e, t), d = { listPrice: o[l], discountPrice: u[l], minimumFractionDigits: u[l] % 1 == 0 ? 0 : a, currency: r, vatInc: n, culture: e, hideVatMessage: i, hideShippingMessageInVatMessage: !0 };
  return await c.get(d, "rawPrice");
}, Vr = (t, e, n, a, r) => {
  let i = "";
  return i = t ? i + "" + t : i, i = e ? i + ":" + e : i, i = n ? i + ":" + n : i, i = a ? i + ":" + $s(new Date(a)).format("YYYYMMDD") : i, i = r ? i + ":" + r : i, i;
};
class Sd {
  constructor(e, n) {
    U(this, "texts");
    U(this, "locale");
    U(this, "tokenEngine", new Gc());
    U(this, "getTexts", () => this.texts);
    U(this, "getText", (e) => this.texts[e]);
    U(this, "setText", (e, n) => {
      this.texts[e] = n;
    });
    U(this, "getTokenizedShippingOptionsNotFoundMessage", (e) => this.tokenEngine.replace(this.texts.shippingCalculatorNotFoundMessage, { PostalCode: e }));
    U(this, "getTokenizedShippingOptionsNoDeliveryMessage", (e) => this.tokenEngine.replace(this.texts.shippingCalculatorNoDeliveryMessage, { PostalCode: e }));
    U(this, "getTokenizedShippingOptionsSelectedOptionMarkupString", (e, n) => {
      const a = `<b>${this.getTokenizedDeliveryDateText(e)}</b>`;
      return this.tokenEngine.replace(this.texts.selectedOptionMessageWithoutPrice, { DeliveryDate: a, PostalCode: n });
    });
    U(this, "getTokenizedShippingOptionsEstimatedDeliveryMarkupStringForSingleDate", (e, n) => {
      const a = `<b>${this.getTokenizedEstimatedDeliveryRangeDateTextForSingleDeliveryOption(n)}</b>`;
      return this.tokenEngine.replace(this.texts.singleOptionEstimatedMessageWithoutPrice, { DeliveryDate: a, PostalCode: e });
    });
    U(this, "getTokenizedShippingOptionsEstimatedDeliveryRangeMarkupString", (e, n, a) => {
      const r = `<b>${this.getTokenizedEstimatedDeliveryRangeDateText(n)}</b>`, i = `<b>${this.getTokenizedEstimatedDeliveryRangeDateText(a)}</b>`;
      return this.tokenEngine.replace(this.texts.selectedOptionEstimatedMessageWithoutPrice, { FastestDeliveryDate: r, SlowestDeliveryDate: i, PostalCode: e });
    });
    U(this, "getTokenizedFreeShippingOptionsSelectedOptionMarkupString", (e, n) => {
      const a = `<b>${this.getTokenizedDeliveryDateText(e)}</b>`;
      return this.tokenEngine.replace(this.texts.shippingCalculatorFreeShippingOptionMessageWithPostalCode, { DeliveryDate: a, PostalCode: n });
    });
    U(this, "getTokenizedDeliveryDateText", (e) => {
      const n = ao(e);
      return n === 0 ? `${this.texts.shippingCalculatorDeliveryTodayMessage}, ${nt(e, this.locale)}` : n === 1 ? `${this.texts.shippingCalculatorDeliveryTomorrowMessage}, ${nt(e, this.locale)}` : nt(e, this.locale, Dt.SHORT_DATE_W_DOW);
    });
    U(this, "getTokenizedEstimatedDeliveryRangeDateText", (e) => nt(e, this.locale, Dt.SHORT_FMT));
    U(this, "getTokenizedEstimatedDeliveryRangeDateTextForSingleDeliveryOption", (e) => {
      const n = ao(e);
      return n === 0 ? `${this.texts.shippingCalculatorDeliveryTodayMessage}, ${nt(e, this.locale)}` : n === 1 ? `${this.texts.shippingCalculatorDeliveryTomorrowMessage}, ${nt(e, this.locale)}` : nt(e, this.locale, Dt.SHORT_DATE_W_DOW);
    });
    U(this, "getTokenizedFreeShippingOptionItemText", (e) => this.tokenEngine.replace(this.texts.shippingCalculatorFreeShippingLabel, { Price: e }));
    U(this, "getTokenizedFreeShippingOptionMessage", (e) => this.tokenEngine.replace(this.texts.shippingCalculatorFreeShippingOptionMessage, { Price: e }));
    U(this, "getTokenizedCheapestShippingOptionMessage", (e) => this.tokenEngine.replace(this.texts.shippingCalculatorCheapestSelectedOptionMessage, { Price: e }));
    this.locale = this.ensureIsoFormat(e), this.texts = n;
  }
  ensureIsoFormat(e) {
    const [n, a] = e.split("-");
    return n.toLowerCase() + "-" + a.toUpperCase();
  }
}
const Ks = _t(void 0), Zs = ({ children: t }) => {
  const e = G((o) => o.localizedTexts), n = G((o) => o.tenantConfiguration.locale), [a, r] = ne();
  if (i = e, !Object.keys(i).reduce((o, s) => Ys.includes(s) ? !!i[s] && o : o, !0))
    throw Error("ERR: Some localizedTexts are missing");
  var i;
  return Q(() => {
    r(new Sd(n, e));
  }, [n, e]), a ? N(Ks.Provider, { value: a, children: t }) : N(be, { lines: 2 });
}, $e = () => {
  const t = on(Ks);
  if (!t)
    throw Error("TokenizedTextsContext could not be initialized");
  return t;
};
var xt = ((t) => (t.ShippingOptionsError = "Shipping Options Error", t.ShippingOptionsEngaged = "Shipping Options Engaged", t))(xt || {});
const Ws = _t({ trackShippingCalculatorEvent: () => {
} }), Cd = ({ children: t }) => {
  const e = Ra(null), n = G((i) => i.trackingData), a = G((i) => i.productConfiguration.productKey);
  Q(() => {
    const i = () => {
      const o = Yc();
      o && (e.current = o);
    };
    return i(), e.current || window.addEventListener("trackingReady", i), () => {
      e.current || window.removeEventListener("trackingReady", i);
    };
  }, []);
  const r = Te((i, o, s) => {
    e.current ? n.category && n.pageSection && n.pageStage && n.pageName && e.current?.track(i, { category: n.category, label: s || "VIEW", eventDetail: o, pageSection: n.pageSection, pageStage: n.pageStage, pageName: n.pageName, product_id: a }) : console.info("Tracking is not available");
  }, [a, e, n.category, n.pageName, n.pageSection, n.pageStage]);
  return N(se, { children: N(Ws.Provider, { value: { trackShippingCalculatorEvent: r }, children: t }) });
}, cn = () => on(Ws), Js = Xe({ name: "authConfiguration", initialState: null, reducers: { updateAuthConfiguration: (t, e) => e.payload } }), { updateAuthConfiguration: Md } = Js.actions, Dd = Js.reducer, Qs = Xe({ name: "clientConfiguration", initialState: { requestorId: Ve.ShippingCalculatorDev, requestor: Ve.ShippingCalculatorDev }, reducers: { updateClientConfiguration: (t, e) => ({ ...t, ...e.payload }) } }), { updateClientConfiguration: Nd } = Qs.actions, Td = Qs.reducer, Xs = Xe({ name: "clientConfiguration", initialState: {}, reducers: { updateLocalizedTexts: (t, e) => ({ ...t, ...e.payload }) } }), { updateLocalizedTexts: Ed } = Xs.actions, wd = Xs.reducer, el = Xe({ name: "productConfiguration", initialState: { productKey: "PRD-IG9ZMRVW", productVersion: 42, productQuantity: 1, productSelections: {} }, reducers: { updateProductConfiguration: (t, e) => ({ ...t, ...e.payload }) } }), { updateProductConfiguration: _d } = el.actions, xd = el.reducer, tl = Xe({ name: "shippingOptionsWithPricing", initialState: { isInitialized: !1, isLoading: !1, error: { isError: !1, errorReason: void 0 }, currency: "", expiryDate: new Date(Date.now()).toISOString(), fractionDigits: 0, shippingOptions: [], selectedShippingOption: void 0 }, reducers: { updateShippingOptionsWithPricing: (t, e) => ({ ...t, ...e.payload }), updateShippingOptionsWithPricingInitialized: (t, e) => {
  t.isInitialized = e.payload;
}, updateShippingOptionsWithPricingLoading: (t, e) => {
  t.isLoading = e.payload;
}, updateShippingOptionsWithPricingError: (t, e) => {
  t.error = e.payload, t.shippingOptions = [], t.selectedShippingOption = void 0;
}, updateSelectedShippingOption: (t, e) => {
  t.selectedShippingOption = e.payload;
}, resetShippingOptionsWithPricingError: (t) => {
  t.error = { isError: !1, errorReason: void 0 };
}, resetShippingOptionsWithPricing: (t) => {
  t.error = { isError: !1, errorReason: void 0 }, t.shippingOptions = [], t.selectedShippingOption = void 0;
}, updateShippingPricesCurrencyInfo: (t, e) => ({ ...t, ...e.payload }) } }), { updateSelectedShippingOption: nl, updateShippingOptionsWithPricing: kd, updateShippingOptionsWithPricingInitialized: Ad, updateShippingOptionsWithPricingLoading: Ld, updateShippingOptionsWithPricingError: io, updateShippingPricesCurrencyInfo: Id, resetShippingOptionsWithPricingError: oo, resetShippingOptionsWithPricing: Pd } = tl.actions, Od = tl.reducer, al = Xe({ name: "tenantConfiguration", initialState: { tenant: "vistaprint", tenantId: "VP-GB-PROD", locale: F.enGB }, reducers: { updateTenantConfiguration: (t, e) => ({ ...t, ...e.payload }) } }), { updateTenantConfiguration: Rd } = al.actions, Fd = al.reducer, rl = Xe({ name: "trackingData", initialState: {}, reducers: { updateTrackingData: (t, e) => ({ ...t, ...e.payload }) } }), { updateTrackingData: jd } = rl.actions, Bd = rl.reducer, Hr = id({ reducer: { authConfiguration: Dd, clientConfiguration: Td, localizedTexts: wd, productConfiguration: xd, shippingOptionsWithPricing: Od, tenantConfiguration: Fd, userConfiguration: ud, trackingData: Bd } }), Gd = "7.8.0";
function Yd() {
  return { async: !1, breaks: !1, extensions: null, gfm: !0, hooks: null, pedantic: !1, renderer: null, silent: !1, tokenizer: null, walkTokens: null };
}
var mt = { async: !1, breaks: !1, extensions: null, gfm: !0, hooks: null, pedantic: !1, renderer: null, silent: !1, tokenizer: null, walkTokens: null };
function so(t) {
  mt = t;
}
var Ht = { exec: () => null };
function X(t, e = "") {
  let n = typeof t == "string" ? t : t.source, a = { replace: (r, i) => {
    let o = typeof i == "string" ? i : i.source;
    return o = o.replace(me.caret, "$1"), n = n.replace(r, o), a;
  }, getRegex: () => new RegExp(n, e) };
  return a;
}
var me = { codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm, outputLinkReplace: /\\([\[\]])/g, indentCodeCompensation: /^(\s+)(?:```)/, beginningSpace: /^\s+/, endingHash: /#$/, startingSpaceChar: /^ /, endingSpaceChar: / $/, nonSpaceChar: /[^ ]/, newLineCharGlobal: /\n/g, tabCharGlobal: /\t/g, multipleSpaceGlobal: /\s+/g, blankLine: /^[ \t]*$/, doubleBlankLine: /\n[ \t]*\n[ \t]*$/, blockquoteStart: /^ {0,3}>/, blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g, blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm, listReplaceTabs: /^\t+/, listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g, listIsTask: /^\[[ xX]\] /, listReplaceTask: /^\[[ xX]\] +/, anyLine: /\n.*\n/, hrefBrackets: /^<(.*)>$/, tableDelimiter: /[:|]/, tableAlignChars: /^\||\| *$/g, tableRowBlankLine: /\n[ \t]*$/, tableAlignRight: /^ *-+: *$/, tableAlignCenter: /^ *:-+: *$/, tableAlignLeft: /^ *:-+ *$/, startATag: /^<a /i, endATag: /^<\/a>/i, startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i, endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i, startAngleBracket: /^</, endAngleBracket: />$/, pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/, unicodeAlphaNumeric: /[\p{L}\p{N}]/u, escapeTest: /[&<>"']/, escapeReplace: /[&<>"']/g, escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g, unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi, caret: /(^|[^\[])\^/g, percentDecode: /%25/g, findPipe: /\|/g, splitPipe: / \|/, slashPipe: /\\\|/g, carriageReturn: /\r\n|\r/g, spaceLine: /^ +$/gm, notSpaceStart: /^\S*/, endingNewline: /\n$/, listItemRegex: (t) => new RegExp(`^( {0,3}${t})((?:[	 ][^\\n]*)?(?:\\n|$))`), nextBulletRegex: (t) => new RegExp(`^ {0,${Math.min(3, t - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), hrRegex: (t) => new RegExp(`^ {0,${Math.min(3, t - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), fencesBeginRegex: (t) => new RegExp(`^ {0,${Math.min(3, t - 1)}}(?:\`\`\`|~~~)`), headingBeginRegex: (t) => new RegExp(`^ {0,${Math.min(3, t - 1)}}#`), htmlBeginRegex: (t) => new RegExp(`^ {0,${Math.min(3, t - 1)}}<(?:[a-z].*>|!--)`, "i") }, un = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Ur = /(?:[*+-]|\d{1,9}[.)])/, il = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, ol = X(il).replace(/bull/g, Ur).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Vd = X(il).replace(/bull/g, Ur).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), $r = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, zr = /(?!\s*\])(?:\\.|[^\[\]\\])+/, Hd = X(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", zr).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Ud = X(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, Ur).getRegex(), ca = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", qr = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, $d = X("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", qr).replace("tag", ca).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), lo = X($r).replace("hr", un).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ca).getRegex(), Kr = { blockquote: X(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", lo).getRegex(), code: /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, def: Hd, fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, hr: un, html: $d, lheading: ol, list: Ud, newline: /^(?:[ \t]*(?:\n|$))+/, paragraph: lo, table: Ht, text: /^[^\n]+/ }, co = X("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", un).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ca).getRegex(), zd = { ...Kr, lheading: Vd, table: co, paragraph: X($r).replace("hr", un).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", co).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", ca).getRegex() }, qd = { ...Kr, html: X(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", qr).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(), def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/, heading: /^(#{1,6})(.*)(?:\n+|$)/, fences: Ht, lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/, paragraph: X($r).replace("hr", un).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", ol).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex() }, sl = /^( {2,}|\\)\n(?!\s*$)/, ua = /[\p{P}\p{S}]/u, Zr = /[\s\p{P}\p{S}]/u, ll = /[^\s\p{P}\p{S}]/u, Kd = X(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, Zr).getRegex(), cl = /(?!~)[\p{P}\p{S}]/u, ul = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/, Zd = X(ul, "u").replace(/punct/g, ua).getRegex(), Wd = X(ul, "u").replace(/punct/g, cl).getRegex(), dl = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", Jd = X(dl, "gu").replace(/notPunctSpace/g, ll).replace(/punctSpace/g, Zr).replace(/punct/g, ua).getRegex(), Qd = X(dl, "gu").replace(/notPunctSpace/g, /(?:[^\s\p{P}\p{S}]|~)/u).replace(/punctSpace/g, /(?!~)[\s\p{P}\p{S}]/u).replace(/punct/g, cl).getRegex(), Xd = X("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, ll).replace(/punctSpace/g, Zr).replace(/punct/g, ua).getRegex(), ep = X(/\\(punct)/, "gu").replace(/punct/g, ua).getRegex(), tp = X(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), np = X(qr).replace("(?:-->|$)", "-->").getRegex(), ap = X("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", np).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), Zn = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, rp = X(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", Zn).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), uo = X(/^!?\[(label)\]\[(ref)\]/).replace("label", Zn).replace("ref", zr).getRegex(), po = X(/^!?\[(ref)\](?:\[\])?/).replace("ref", zr).getRegex(), Wr = { _backpedal: Ht, anyPunctuation: ep, autolink: tp, blockSkip: /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<(?! )[^<>]*?>/g, br: sl, code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, del: Ht, emStrongLDelim: Zd, emStrongRDelimAst: Jd, emStrongRDelimUnd: Xd, escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, link: rp, nolink: po, punctuation: Kd, reflink: uo, reflinkSearch: X("reflink|nolink(?!\\()", "g").replace("reflink", uo).replace("nolink", po).getRegex(), tag: ap, text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, url: Ht }, ip = { ...Wr, link: X(/^!?\[(label)\]\((.*?)\)/).replace("label", Zn).getRegex(), reflink: X(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", Zn).getRegex() }, Ja = { ...Wr, emStrongRDelimAst: Qd, emStrongLDelim: Wd, url: X(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(), _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/, del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/, text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/ }, op = { ...Ja, br: X(sl).replace("{2,}", "*").getRegex(), text: X(Ja.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex() }, bn = { normal: Kr, gfm: zd, pedantic: qd }, Lt = { normal: Wr, gfm: Ja, breaks: op, pedantic: ip }, sp = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, ho = (t) => sp[t];
function _e(t, e) {
  if (e) {
    if (me.escapeTest.test(t))
      return t.replace(me.escapeReplace, ho);
  } else if (me.escapeTestNoEncode.test(t))
    return t.replace(me.escapeReplaceNoEncode, ho);
  return t;
}
function mo(t) {
  try {
    t = encodeURI(t).replace(me.percentDecode, "%");
  } catch {
    return null;
  }
  return t;
}
function go(t, e) {
  let n = t.replace(me.findPipe, (r, i, o) => {
    let s = !1, l = i;
    for (; --l >= 0 && o[l] === "\\"; )
      s = !s;
    return s ? "|" : " |";
  }).split(me.splitPipe), a = 0;
  if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e)
    if (n.length > e)
      n.splice(e);
    else
      for (; n.length < e; )
        n.push("");
  for (; a < n.length; a++)
    n[a] = n[a].trim().replace(me.slashPipe, "|");
  return n;
}
function It(t, e, n) {
  let a = t.length;
  if (a === 0)
    return "";
  let r = 0;
  for (; r < a; ) {
    let i = t.charAt(a - r - 1);
    if (i !== e || n) {
      if (i === e || !n)
        break;
      r++;
    } else
      r++;
  }
  return t.slice(0, a - r);
}
function fo(t, e, n, a, r) {
  let i = e.href, o = e.title || null, s = t[1].replace(r.other.outputLinkReplace, "$1");
  a.state.inLink = !0;
  let l = { type: t[0].charAt(0) === "!" ? "image" : "link", raw: n, href: i, title: o, text: s, tokens: a.inlineTokens(s) };
  return a.state.inLink = !1, l;
}
var Wn = class {
  constructor(t) {
    U(this, "options");
    U(this, "rules");
    U(this, "lexer");
    this.options = t || mt;
  }
  space(t) {
    let e = this.rules.block.newline.exec(t);
    if (e && e[0].length > 0)
      return { type: "space", raw: e[0] };
  }
  code(t) {
    let e = this.rules.block.code.exec(t);
    if (e) {
      let n = e[0].replace(this.rules.other.codeRemoveIndent, "");
      return { type: "code", raw: e[0], codeBlockStyle: "indented", text: this.options.pedantic ? n : It(n, `
`) };
    }
  }
  fences(t) {
    let e = this.rules.block.fences.exec(t);
    if (e) {
      let n = e[0], a = function(r, i, o) {
        let s = r.match(o.other.indentCodeCompensation);
        if (s === null)
          return i;
        let l = s[1];
        return i.split(`
`).map((u) => {
          let c = u.match(o.other.beginningSpace);
          if (c === null)
            return u;
          let [d] = c;
          return d.length >= l.length ? u.slice(l.length) : u;
        }).join(`
`);
      }(n, e[3] || "", this.rules);
      return { type: "code", raw: n, lang: e[2] ? e[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : e[2], text: a };
    }
  }
  heading(t) {
    let e = this.rules.block.heading.exec(t);
    if (e) {
      let n = e[2].trim();
      if (this.rules.other.endingHash.test(n)) {
        let a = It(n, "#");
        (this.options.pedantic || !a || this.rules.other.endingSpaceChar.test(a)) && (n = a.trim());
      }
      return { type: "heading", raw: e[0], depth: e[1].length, text: n, tokens: this.lexer.inline(n) };
    }
  }
  hr(t) {
    let e = this.rules.block.hr.exec(t);
    if (e)
      return { type: "hr", raw: It(e[0], `
`) };
  }
  blockquote(t) {
    let e = this.rules.block.blockquote.exec(t);
    if (e) {
      let n = It(e[0], `
`).split(`
`), a = "", r = "", i = [];
      for (; n.length > 0; ) {
        let o, s = !1, l = [];
        for (o = 0; o < n.length; o++)
          if (this.rules.other.blockquoteStart.test(n[o]))
            l.push(n[o]), s = !0;
          else {
            if (s)
              break;
            l.push(n[o]);
          }
        n = n.slice(o);
        let u = l.join(`
`), c = u.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
        a = a ? `${a}
${u}` : u, r = r ? `${r}
${c}` : c;
        let d = this.lexer.state.top;
        if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = d, n.length === 0)
          break;
        let p = i.at(-1);
        if (p?.type === "code")
          break;
        if (p?.type === "blockquote") {
          let g = p, f = g.raw + `
` + n.join(`
`), h = this.blockquote(f);
          i[i.length - 1] = h, a = a.substring(0, a.length - g.raw.length) + h.raw, r = r.substring(0, r.length - g.text.length) + h.text;
          break;
        }
        if (p?.type === "list") {
          let g = p, f = g.raw + `
` + n.join(`
`), h = this.list(f);
          i[i.length - 1] = h, a = a.substring(0, a.length - p.raw.length) + h.raw, r = r.substring(0, r.length - g.raw.length) + h.raw, n = f.substring(i.at(-1).raw.length).split(`
`);
          continue;
        }
      }
      return { type: "blockquote", raw: a, tokens: i, text: r };
    }
  }
  list(t) {
    let e = this.rules.block.list.exec(t);
    if (e) {
      let n = e[1].trim(), a = n.length > 1, r = { type: "list", raw: "", ordered: a, start: a ? +n.slice(0, -1) : "", loose: !1, items: [] };
      n = a ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = a ? n : "[*+-]");
      let i = this.rules.other.listItemRegex(n), o = !1;
      for (; t; ) {
        let l = !1, u = "", c = "";
        if (!(e = i.exec(t)) || this.rules.block.hr.test(t))
          break;
        u = e[0], t = t.substring(u.length);
        let d = e[2].split(`
`, 1)[0].replace(this.rules.other.listReplaceTabs, (L) => " ".repeat(3 * L.length)), p = t.split(`
`, 1)[0], g = !d.trim(), f = 0;
        if (this.options.pedantic ? (f = 2, c = d.trimStart()) : g ? f = e[1].length + 1 : (f = e[2].search(this.rules.other.nonSpaceChar), f = f > 4 ? 1 : f, c = d.slice(f), f += e[1].length), g && this.rules.other.blankLine.test(p) && (u += p + `
`, t = t.substring(p.length + 1), l = !0), !l) {
          let L = this.rules.other.nextBulletRegex(f), _ = this.rules.other.hrRegex(f), x = this.rules.other.fencesBeginRegex(f), T = this.rules.other.headingBeginRegex(f), b = this.rules.other.htmlBeginRegex(f);
          for (; t; ) {
            let S, w = t.split(`
`, 1)[0];
            if (p = w, this.options.pedantic ? (p = p.replace(this.rules.other.listReplaceNesting, "  "), S = p) : S = p.replace(this.rules.other.tabCharGlobal, "    "), x.test(p) || T.test(p) || b.test(p) || L.test(p) || _.test(p))
              break;
            if (S.search(this.rules.other.nonSpaceChar) >= f || !p.trim())
              c += `
` + S.slice(f);
            else {
              if (g || d.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || x.test(d) || T.test(d) || _.test(d))
                break;
              c += `
` + p;
            }
            !g && !p.trim() && (g = !0), u += w + `
`, t = t.substring(w.length + 1), d = S.slice(f);
          }
        }
        r.loose || (o ? r.loose = !0 : this.rules.other.doubleBlankLine.test(u) && (o = !0));
        let h, D = null;
        this.options.gfm && (D = this.rules.other.listIsTask.exec(c), D && (h = D[0] !== "[ ] ", c = c.replace(this.rules.other.listReplaceTask, ""))), r.items.push({ type: "list_item", raw: u, task: !!D, checked: h, loose: !1, text: c, tokens: [] }), r.raw += u;
      }
      let s = r.items.at(-1);
      if (!s)
        return;
      s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd(), r.raw = r.raw.trimEnd();
      for (let l = 0; l < r.items.length; l++)
        if (this.lexer.state.top = !1, r.items[l].tokens = this.lexer.blockTokens(r.items[l].text, []), !r.loose) {
          let u = r.items[l].tokens.filter((d) => d.type === "space"), c = u.length > 0 && u.some((d) => this.rules.other.anyLine.test(d.raw));
          r.loose = c;
        }
      if (r.loose)
        for (let l = 0; l < r.items.length; l++)
          r.items[l].loose = !0;
      return r;
    }
  }
  html(t) {
    let e = this.rules.block.html.exec(t);
    if (e)
      return { type: "html", block: !0, raw: e[0], pre: e[1] === "pre" || e[1] === "script" || e[1] === "style", text: e[0] };
  }
  def(t) {
    let e = this.rules.block.def.exec(t);
    if (e) {
      let n = e[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), a = e[2] ? e[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = e[3] ? e[3].substring(1, e[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : e[3];
      return { type: "def", tag: n, raw: e[0], href: a, title: r };
    }
  }
  table(t) {
    let e = this.rules.block.table.exec(t);
    if (!e || !this.rules.other.tableDelimiter.test(e[2]))
      return;
    let n = go(e[1]), a = e[2].replace(this.rules.other.tableAlignChars, "").split("|"), r = e[3]?.trim() ? e[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], i = { type: "table", raw: e[0], header: [], align: [], rows: [] };
    if (n.length === a.length) {
      for (let o of a)
        this.rules.other.tableAlignRight.test(o) ? i.align.push("right") : this.rules.other.tableAlignCenter.test(o) ? i.align.push("center") : this.rules.other.tableAlignLeft.test(o) ? i.align.push("left") : i.align.push(null);
      for (let o = 0; o < n.length; o++)
        i.header.push({ text: n[o], tokens: this.lexer.inline(n[o]), header: !0, align: i.align[o] });
      for (let o of r)
        i.rows.push(go(o, i.header.length).map((s, l) => ({ text: s, tokens: this.lexer.inline(s), header: !1, align: i.align[l] })));
      return i;
    }
  }
  lheading(t) {
    let e = this.rules.block.lheading.exec(t);
    if (e)
      return { type: "heading", raw: e[0], depth: e[2].charAt(0) === "=" ? 1 : 2, text: e[1], tokens: this.lexer.inline(e[1]) };
  }
  paragraph(t) {
    let e = this.rules.block.paragraph.exec(t);
    if (e) {
      let n = e[1].charAt(e[1].length - 1) === `
` ? e[1].slice(0, -1) : e[1];
      return { type: "paragraph", raw: e[0], text: n, tokens: this.lexer.inline(n) };
    }
  }
  text(t) {
    let e = this.rules.block.text.exec(t);
    if (e)
      return { type: "text", raw: e[0], text: e[0], tokens: this.lexer.inline(e[0]) };
  }
  escape(t) {
    let e = this.rules.inline.escape.exec(t);
    if (e)
      return { type: "escape", raw: e[0], text: e[1] };
  }
  tag(t) {
    let e = this.rules.inline.tag.exec(t);
    if (e)
      return !this.lexer.state.inLink && this.rules.other.startATag.test(e[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(e[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(e[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(e[0]) && (this.lexer.state.inRawBlock = !1), { type: "html", raw: e[0], inLink: this.lexer.state.inLink, inRawBlock: this.lexer.state.inRawBlock, block: !1, text: e[0] };
  }
  link(t) {
    let e = this.rules.inline.link.exec(t);
    if (e) {
      let n = e[2].trim();
      if (!this.options.pedantic && this.rules.other.startAngleBracket.test(n)) {
        if (!this.rules.other.endAngleBracket.test(n))
          return;
        let i = It(n.slice(0, -1), "\\");
        if ((n.length - i.length) % 2 == 0)
          return;
      } else {
        let i = function(o, s) {
          if (o.indexOf(s[1]) === -1)
            return -1;
          let l = 0;
          for (let u = 0; u < o.length; u++)
            if (o[u] === "\\")
              u++;
            else if (o[u] === s[0])
              l++;
            else if (o[u] === s[1] && (l--, l < 0))
              return u;
          return l > 0 ? -2 : -1;
        }(e[2], "()");
        if (i === -2)
          return;
        if (i > -1) {
          let o = (e[0].indexOf("!") === 0 ? 5 : 4) + e[1].length + i;
          e[2] = e[2].substring(0, i), e[0] = e[0].substring(0, o).trim(), e[3] = "";
        }
      }
      let a = e[2], r = "";
      if (this.options.pedantic) {
        let i = this.rules.other.pedanticHrefTitle.exec(a);
        i && (a = i[1], r = i[3]);
      } else
        r = e[3] ? e[3].slice(1, -1) : "";
      return a = a.trim(), this.rules.other.startAngleBracket.test(a) && (a = this.options.pedantic && !this.rules.other.endAngleBracket.test(n) ? a.slice(1) : a.slice(1, -1)), fo(e, { href: a && a.replace(this.rules.inline.anyPunctuation, "$1"), title: r && r.replace(this.rules.inline.anyPunctuation, "$1") }, e[0], this.lexer, this.rules);
    }
  }
  reflink(t, e) {
    let n;
    if ((n = this.rules.inline.reflink.exec(t)) || (n = this.rules.inline.nolink.exec(t))) {
      let a = e[(n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " ").toLowerCase()];
      if (!a) {
        let r = n[0].charAt(0);
        return { type: "text", raw: r, text: r };
      }
      return fo(n, a, n[0], this.lexer, this.rules);
    }
  }
  emStrong(t, e, n = "") {
    let a = this.rules.inline.emStrongLDelim.exec(t);
    if (!(!a || a[3] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!a[1] && !a[2] || !n || this.rules.inline.punctuation.exec(n))) {
      let r, i, o = [...a[0]].length - 1, s = o, l = 0, u = a[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      for (u.lastIndex = 0, e = e.slice(-1 * t.length + o); (a = u.exec(e)) != null; ) {
        if (r = a[1] || a[2] || a[3] || a[4] || a[5] || a[6], !r)
          continue;
        if (i = [...r].length, a[3] || a[4]) {
          s += i;
          continue;
        }
        if ((a[5] || a[6]) && o % 3 && !((o + i) % 3)) {
          l += i;
          continue;
        }
        if (s -= i, s > 0)
          continue;
        i = Math.min(i, i + s + l);
        let c = [...a[0]][0].length, d = t.slice(0, o + a.index + c + i);
        if (Math.min(o, i) % 2) {
          let g = d.slice(1, -1);
          return { type: "em", raw: d, text: g, tokens: this.lexer.inlineTokens(g) };
        }
        let p = d.slice(2, -2);
        return { type: "strong", raw: d, text: p, tokens: this.lexer.inlineTokens(p) };
      }
    }
  }
  codespan(t) {
    let e = this.rules.inline.code.exec(t);
    if (e) {
      let n = e[2].replace(this.rules.other.newLineCharGlobal, " "), a = this.rules.other.nonSpaceChar.test(n), r = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
      return a && r && (n = n.substring(1, n.length - 1)), { type: "codespan", raw: e[0], text: n };
    }
  }
  br(t) {
    let e = this.rules.inline.br.exec(t);
    if (e)
      return { type: "br", raw: e[0] };
  }
  del(t) {
    let e = this.rules.inline.del.exec(t);
    if (e)
      return { type: "del", raw: e[0], text: e[2], tokens: this.lexer.inlineTokens(e[2]) };
  }
  autolink(t) {
    let e = this.rules.inline.autolink.exec(t);
    if (e) {
      let n, a;
      return e[2] === "@" ? (n = e[1], a = "mailto:" + n) : (n = e[1], a = n), { type: "link", raw: e[0], text: n, href: a, tokens: [{ type: "text", raw: n, text: n }] };
    }
  }
  url(t) {
    let e;
    if (e = this.rules.inline.url.exec(t)) {
      let n, a;
      if (e[2] === "@")
        n = e[0], a = "mailto:" + n;
      else {
        let r;
        do
          r = e[0], e[0] = this.rules.inline._backpedal.exec(e[0])?.[0] ?? "";
        while (r !== e[0]);
        n = e[0], a = e[1] === "www." ? "http://" + e[0] : e[0];
      }
      return { type: "link", raw: e[0], text: n, href: a, tokens: [{ type: "text", raw: n, text: n }] };
    }
  }
  inlineText(t) {
    let e = this.rules.inline.text.exec(t);
    if (e) {
      let n = this.lexer.state.inRawBlock;
      return { type: "text", raw: e[0], text: e[0], escaped: n };
    }
  }
}, je = class Qa {
  constructor(e) {
    U(this, "tokens");
    U(this, "options");
    U(this, "state");
    U(this, "tokenizer");
    U(this, "inlineQueue");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = e || mt, this.options.tokenizer = this.options.tokenizer || new Wn(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = { inLink: !1, inRawBlock: !1, top: !0 };
    let n = { other: me, block: bn.normal, inline: Lt.normal };
    this.options.pedantic ? (n.block = bn.pedantic, n.inline = Lt.pedantic) : this.options.gfm && (n.block = bn.gfm, this.options.breaks ? n.inline = Lt.breaks : n.inline = Lt.gfm), this.tokenizer.rules = n;
  }
  static get rules() {
    return { block: bn, inline: Lt };
  }
  static lex(e, n) {
    return new Qa(n).lex(e);
  }
  static lexInline(e, n) {
    return new Qa(n).inlineTokens(e);
  }
  lex(e) {
    e = e.replace(me.carriageReturn, `
`), this.blockTokens(e, this.tokens);
    for (let n = 0; n < this.inlineQueue.length; n++) {
      let a = this.inlineQueue[n];
      this.inlineTokens(a.src, a.tokens);
    }
    return this.inlineQueue = [], this.tokens;
  }
  blockTokens(e, n = [], a = !1) {
    for (this.options.pedantic && (e = e.replace(me.tabCharGlobal, "    ").replace(me.spaceLine, "")); e; ) {
      let r;
      if (this.options.extensions?.block?.some((o) => !!(r = o.call({ lexer: this }, e, n)) && (e = e.substring(r.raw.length), n.push(r), !0)))
        continue;
      if (r = this.tokenizer.space(e)) {
        e = e.substring(r.raw.length);
        let o = n.at(-1);
        r.raw.length === 1 && o !== void 0 ? o.raw += `
` : n.push(r);
        continue;
      }
      if (r = this.tokenizer.code(e)) {
        e = e.substring(r.raw.length);
        let o = n.at(-1);
        o?.type === "paragraph" || o?.type === "text" ? (o.raw += (o.raw.endsWith(`
`) ? "" : `
`) + r.raw, o.text += `
` + r.text, this.inlineQueue.at(-1).src = o.text) : n.push(r);
        continue;
      }
      if (r = this.tokenizer.fences(e)) {
        e = e.substring(r.raw.length), n.push(r);
        continue;
      }
      if (r = this.tokenizer.heading(e)) {
        e = e.substring(r.raw.length), n.push(r);
        continue;
      }
      if (r = this.tokenizer.hr(e)) {
        e = e.substring(r.raw.length), n.push(r);
        continue;
      }
      if (r = this.tokenizer.blockquote(e)) {
        e = e.substring(r.raw.length), n.push(r);
        continue;
      }
      if (r = this.tokenizer.list(e)) {
        e = e.substring(r.raw.length), n.push(r);
        continue;
      }
      if (r = this.tokenizer.html(e)) {
        e = e.substring(r.raw.length), n.push(r);
        continue;
      }
      if (r = this.tokenizer.def(e)) {
        e = e.substring(r.raw.length);
        let o = n.at(-1);
        o?.type === "paragraph" || o?.type === "text" ? (o.raw += (o.raw.endsWith(`
`) ? "" : `
`) + r.raw, o.text += `
` + r.raw, this.inlineQueue.at(-1).src = o.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = { href: r.href, title: r.title });
        continue;
      }
      if (r = this.tokenizer.table(e)) {
        e = e.substring(r.raw.length), n.push(r);
        continue;
      }
      if (r = this.tokenizer.lheading(e)) {
        e = e.substring(r.raw.length), n.push(r);
        continue;
      }
      let i = e;
      if (this.options.extensions?.startBlock) {
        let o, s = 1 / 0, l = e.slice(1);
        this.options.extensions.startBlock.forEach((u) => {
          o = u.call({ lexer: this }, l), typeof o == "number" && o >= 0 && (s = Math.min(s, o));
        }), s < 1 / 0 && s >= 0 && (i = e.substring(0, s + 1));
      }
      if (this.state.top && (r = this.tokenizer.paragraph(i))) {
        let o = n.at(-1);
        a && o?.type === "paragraph" ? (o.raw += (o.raw.endsWith(`
`) ? "" : `
`) + r.raw, o.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = o.text) : n.push(r), a = i.length !== e.length, e = e.substring(r.raw.length);
        continue;
      }
      if (r = this.tokenizer.text(e)) {
        e = e.substring(r.raw.length);
        let o = n.at(-1);
        o?.type === "text" ? (o.raw += (o.raw.endsWith(`
`) ? "" : `
`) + r.raw, o.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = o.text) : n.push(r);
        continue;
      }
      if (e) {
        let o = "Infinite loop on byte: " + e.charCodeAt(0);
        if (this.options.silent) {
          console.error(o);
          break;
        }
        throw new Error(o);
      }
    }
    return this.state.top = !0, n;
  }
  inline(e, n = []) {
    return this.inlineQueue.push({ src: e, tokens: n }), n;
  }
  inlineTokens(e, n = []) {
    let a = e, r = null;
    if (this.tokens.links) {
      let s = Object.keys(this.tokens.links);
      if (s.length > 0)
        for (; (r = this.tokenizer.rules.inline.reflinkSearch.exec(a)) != null; )
          s.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (a = a.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (r = this.tokenizer.rules.inline.anyPunctuation.exec(a)) != null; )
      a = a.slice(0, r.index) + "++" + a.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; (r = this.tokenizer.rules.inline.blockSkip.exec(a)) != null; )
      a = a.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    let i = !1, o = "";
    for (; e; ) {
      let s;
      if (i || (o = ""), i = !1, this.options.extensions?.inline?.some((u) => !!(s = u.call({ lexer: this }, e, n)) && (e = e.substring(s.raw.length), n.push(s), !0)))
        continue;
      if (s = this.tokenizer.escape(e)) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.tag(e)) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.link(e)) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.reflink(e, this.tokens.links)) {
        e = e.substring(s.raw.length);
        let u = n.at(-1);
        s.type === "text" && u?.type === "text" ? (u.raw += s.raw, u.text += s.text) : n.push(s);
        continue;
      }
      if (s = this.tokenizer.emStrong(e, a, o)) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.codespan(e)) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.br(e)) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.del(e)) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      if (s = this.tokenizer.autolink(e)) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      if (!this.state.inLink && (s = this.tokenizer.url(e))) {
        e = e.substring(s.raw.length), n.push(s);
        continue;
      }
      let l = e;
      if (this.options.extensions?.startInline) {
        let u, c = 1 / 0, d = e.slice(1);
        this.options.extensions.startInline.forEach((p) => {
          u = p.call({ lexer: this }, d), typeof u == "number" && u >= 0 && (c = Math.min(c, u));
        }), c < 1 / 0 && c >= 0 && (l = e.substring(0, c + 1));
      }
      if (s = this.tokenizer.inlineText(l)) {
        e = e.substring(s.raw.length), s.raw.slice(-1) !== "_" && (o = s.raw.slice(-1)), i = !0;
        let u = n.at(-1);
        u?.type === "text" ? (u.raw += s.raw, u.text += s.text) : n.push(s);
        continue;
      }
      if (e) {
        let u = "Infinite loop on byte: " + e.charCodeAt(0);
        if (this.options.silent) {
          console.error(u);
          break;
        }
        throw new Error(u);
      }
    }
    return n;
  }
}, Jn = class {
  constructor(t) {
    U(this, "options");
    U(this, "parser");
    this.options = t || mt;
  }
  space(t) {
    return "";
  }
  code({ text: t, lang: e, escaped: n }) {
    let a = (e || "").match(me.notSpaceStart)?.[0], r = t.replace(me.endingNewline, "") + `
`;
    return a ? '<pre><code class="language-' + _e(a) + '">' + (n ? r : _e(r, !0)) + `</code></pre>
` : "<pre><code>" + (n ? r : _e(r, !0)) + `</code></pre>
`;
  }
  blockquote({ tokens: t }) {
    return `<blockquote>
${this.parser.parse(t)}</blockquote>
`;
  }
  html({ text: t }) {
    return t;
  }
  heading({ tokens: t, depth: e }) {
    return `<h${e}>${this.parser.parseInline(t)}</h${e}>
`;
  }
  hr(t) {
    return `<hr>
`;
  }
  list(t) {
    let e = t.ordered, n = t.start, a = "";
    for (let i = 0; i < t.items.length; i++) {
      let o = t.items[i];
      a += this.listitem(o);
    }
    let r = e ? "ol" : "ul";
    return "<" + r + (e && n !== 1 ? ' start="' + n + '"' : "") + `>
` + a + "</" + r + `>
`;
  }
  listitem(t) {
    let e = "";
    if (t.task) {
      let n = this.checkbox({ checked: !!t.checked });
      t.loose ? t.tokens[0]?.type === "paragraph" ? (t.tokens[0].text = n + " " + t.tokens[0].text, t.tokens[0].tokens && t.tokens[0].tokens.length > 0 && t.tokens[0].tokens[0].type === "text" && (t.tokens[0].tokens[0].text = n + " " + _e(t.tokens[0].tokens[0].text), t.tokens[0].tokens[0].escaped = !0)) : t.tokens.unshift({ type: "text", raw: n + " ", text: n + " ", escaped: !0 }) : e += n + " ";
    }
    return e += this.parser.parse(t.tokens, !!t.loose), `<li>${e}</li>
`;
  }
  checkbox({ checked: t }) {
    return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph({ tokens: t }) {
    return `<p>${this.parser.parseInline(t)}</p>
`;
  }
  table(t) {
    let e = "", n = "";
    for (let r = 0; r < t.header.length; r++)
      n += this.tablecell(t.header[r]);
    e += this.tablerow({ text: n });
    let a = "";
    for (let r = 0; r < t.rows.length; r++) {
      let i = t.rows[r];
      n = "";
      for (let o = 0; o < i.length; o++)
        n += this.tablecell(i[o]);
      a += this.tablerow({ text: n });
    }
    return a && (a = `<tbody>${a}</tbody>`), `<table>
<thead>
` + e + `</thead>
` + a + `</table>
`;
  }
  tablerow({ text: t }) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t) {
    let e = this.parser.parseInline(t.tokens), n = t.header ? "th" : "td";
    return (t.align ? `<${n} align="${t.align}">` : `<${n}>`) + e + `</${n}>
`;
  }
  strong({ tokens: t }) {
    return `<strong>${this.parser.parseInline(t)}</strong>`;
  }
  em({ tokens: t }) {
    return `<em>${this.parser.parseInline(t)}</em>`;
  }
  codespan({ text: t }) {
    return `<code>${_e(t, !0)}</code>`;
  }
  br(t) {
    return "<br>";
  }
  del({ tokens: t }) {
    return `<del>${this.parser.parseInline(t)}</del>`;
  }
  link({ href: t, title: e, tokens: n }) {
    let a = this.parser.parseInline(n), r = mo(t);
    if (r === null)
      return a;
    let i = '<a href="' + (t = r) + '"';
    return e && (i += ' title="' + _e(e) + '"'), i += ">" + a + "</a>", i;
  }
  image({ href: t, title: e, text: n, tokens: a }) {
    a && (n = this.parser.parseInline(a, this.parser.textRenderer));
    let r = mo(t);
    if (r === null)
      return _e(n);
    let i = `<img src="${t = r}" alt="${n}"`;
    return e && (i += ` title="${_e(e)}"`), i += ">", i;
  }
  text(t) {
    return "tokens" in t && t.tokens ? this.parser.parseInline(t.tokens) : "escaped" in t && t.escaped ? t.text : _e(t.text);
  }
}, Jr = class {
  strong({ text: t }) {
    return t;
  }
  em({ text: t }) {
    return t;
  }
  codespan({ text: t }) {
    return t;
  }
  del({ text: t }) {
    return t;
  }
  html({ text: t }) {
    return t;
  }
  text({ text: t }) {
    return t;
  }
  link({ text: t }) {
    return "" + t;
  }
  image({ text: t }) {
    return "" + t;
  }
  br() {
    return "";
  }
}, Be = class Xa {
  constructor(e) {
    U(this, "options");
    U(this, "renderer");
    U(this, "textRenderer");
    this.options = e || mt, this.options.renderer = this.options.renderer || new Jn(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new Jr();
  }
  static parse(e, n) {
    return new Xa(n).parse(e);
  }
  static parseInline(e, n) {
    return new Xa(n).parseInline(e);
  }
  parse(e, n = !0) {
    let a = "";
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      if (this.options.extensions?.renderers?.[i.type]) {
        let s = i, l = this.options.extensions.renderers[s.type].call({ parser: this }, s);
        if (l !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(s.type)) {
          a += l || "";
          continue;
        }
      }
      let o = i;
      switch (o.type) {
        case "space":
          a += this.renderer.space(o);
          continue;
        case "hr":
          a += this.renderer.hr(o);
          continue;
        case "heading":
          a += this.renderer.heading(o);
          continue;
        case "code":
          a += this.renderer.code(o);
          continue;
        case "table":
          a += this.renderer.table(o);
          continue;
        case "blockquote":
          a += this.renderer.blockquote(o);
          continue;
        case "list":
          a += this.renderer.list(o);
          continue;
        case "html":
          a += this.renderer.html(o);
          continue;
        case "paragraph":
          a += this.renderer.paragraph(o);
          continue;
        case "text": {
          let s = o, l = this.renderer.text(s);
          for (; r + 1 < e.length && e[r + 1].type === "text"; )
            s = e[++r], l += `
` + this.renderer.text(s);
          a += n ? this.renderer.paragraph({ type: "paragraph", raw: l, text: l, tokens: [{ type: "text", raw: l, text: l, escaped: !0 }] }) : l;
          continue;
        }
        default: {
          let s = 'Token with "' + o.type + '" type was not found.';
          if (this.options.silent)
            return console.error(s), "";
          throw new Error(s);
        }
      }
    }
    return a;
  }
  parseInline(e, n = this.renderer) {
    let a = "";
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      if (this.options.extensions?.renderers?.[i.type]) {
        let s = this.options.extensions.renderers[i.type].call({ parser: this }, i);
        if (s !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(i.type)) {
          a += s || "";
          continue;
        }
      }
      let o = i;
      switch (o.type) {
        case "escape":
        case "text":
          a += n.text(o);
          break;
        case "html":
          a += n.html(o);
          break;
        case "link":
          a += n.link(o);
          break;
        case "image":
          a += n.image(o);
          break;
        case "strong":
          a += n.strong(o);
          break;
        case "em":
          a += n.em(o);
          break;
        case "codespan":
          a += n.codespan(o);
          break;
        case "br":
          a += n.br(o);
          break;
        case "del":
          a += n.del(o);
          break;
        default: {
          let s = 'Token with "' + o.type + '" type was not found.';
          if (this.options.silent)
            return console.error(s), "";
          throw new Error(s);
        }
      }
    }
    return a;
  }
}, Oa, Pn = (Oa = class {
  constructor(t) {
    U(this, "options");
    U(this, "block");
    this.options = t || mt;
  }
  preprocess(t) {
    return t;
  }
  postprocess(t) {
    return t;
  }
  processAllTokens(t) {
    return t;
  }
  provideLexer() {
    return this.block ? je.lex : je.lexInline;
  }
  provideParser() {
    return this.block ? Be.parse : Be.parseInline;
  }
}, U(Oa, "passThroughHooks", /* @__PURE__ */ new Set(["preprocess", "postprocess", "processAllTokens"])), Oa), rt = new class {
  constructor(...t) {
    U(this, "defaults", { async: !1, breaks: !1, extensions: null, gfm: !0, hooks: null, pedantic: !1, renderer: null, silent: !1, tokenizer: null, walkTokens: null });
    U(this, "options", this.setOptions);
    U(this, "parse", this.parseMarkdown(!0));
    U(this, "parseInline", this.parseMarkdown(!1));
    U(this, "Parser", Be);
    U(this, "Renderer", Jn);
    U(this, "TextRenderer", Jr);
    U(this, "Lexer", je);
    U(this, "Tokenizer", Wn);
    U(this, "Hooks", Pn);
    this.use(...t);
  }
  walkTokens(t, e) {
    let n = [];
    for (let a of t)
      switch (n = n.concat(e.call(this, a)), a.type) {
        case "table": {
          let r = a;
          for (let i of r.header)
            n = n.concat(this.walkTokens(i.tokens, e));
          for (let i of r.rows)
            for (let o of i)
              n = n.concat(this.walkTokens(o.tokens, e));
          break;
        }
        case "list": {
          let r = a;
          n = n.concat(this.walkTokens(r.items, e));
          break;
        }
        default: {
          let r = a;
          this.defaults.extensions?.childTokens?.[r.type] ? this.defaults.extensions.childTokens[r.type].forEach((i) => {
            let o = r[i].flat(1 / 0);
            n = n.concat(this.walkTokens(o, e));
          }) : r.tokens && (n = n.concat(this.walkTokens(r.tokens, e)));
        }
      }
    return n;
  }
  use(...t) {
    let e = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return t.forEach((n) => {
      let a = { ...n };
      if (a.async = this.defaults.async || a.async || !1, n.extensions && (n.extensions.forEach((r) => {
        if (!r.name)
          throw new Error("extension name required");
        if ("renderer" in r) {
          let i = e.renderers[r.name];
          e.renderers[r.name] = i ? function(...o) {
            let s = r.renderer.apply(this, o);
            return s === !1 && (s = i.apply(this, o)), s;
          } : r.renderer;
        }
        if ("tokenizer" in r) {
          if (!r.level || r.level !== "block" && r.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          let i = e[r.level];
          i ? i.unshift(r.tokenizer) : e[r.level] = [r.tokenizer], r.start && (r.level === "block" ? e.startBlock ? e.startBlock.push(r.start) : e.startBlock = [r.start] : r.level === "inline" && (e.startInline ? e.startInline.push(r.start) : e.startInline = [r.start]));
        }
        "childTokens" in r && r.childTokens && (e.childTokens[r.name] = r.childTokens);
      }), a.extensions = e), n.renderer) {
        let r = this.defaults.renderer || new Jn(this.defaults);
        for (let i in n.renderer) {
          if (!(i in r))
            throw new Error(`renderer '${i}' does not exist`);
          if (["options", "parser"].includes(i))
            continue;
          let o = i, s = n.renderer[o], l = r[o];
          r[o] = (...u) => {
            let c = s.apply(r, u);
            return c === !1 && (c = l.apply(r, u)), c || "";
          };
        }
        a.renderer = r;
      }
      if (n.tokenizer) {
        let r = this.defaults.tokenizer || new Wn(this.defaults);
        for (let i in n.tokenizer) {
          if (!(i in r))
            throw new Error(`tokenizer '${i}' does not exist`);
          if (["options", "rules", "lexer"].includes(i))
            continue;
          let o = i, s = n.tokenizer[o], l = r[o];
          r[o] = (...u) => {
            let c = s.apply(r, u);
            return c === !1 && (c = l.apply(r, u)), c;
          };
        }
        a.tokenizer = r;
      }
      if (n.hooks) {
        let r = this.defaults.hooks || new Pn();
        for (let i in n.hooks) {
          if (!(i in r))
            throw new Error(`hook '${i}' does not exist`);
          if (["options", "block"].includes(i))
            continue;
          let o = i, s = n.hooks[o], l = r[o];
          Pn.passThroughHooks.has(i) ? r[o] = (u) => {
            if (this.defaults.async)
              return Promise.resolve(s.call(r, u)).then((d) => l.call(r, d));
            let c = s.call(r, u);
            return l.call(r, c);
          } : r[o] = (...u) => {
            let c = s.apply(r, u);
            return c === !1 && (c = l.apply(r, u)), c;
          };
        }
        a.hooks = r;
      }
      if (n.walkTokens) {
        let r = this.defaults.walkTokens, i = n.walkTokens;
        a.walkTokens = function(o) {
          let s = [];
          return s.push(i.call(this, o)), r && (s = s.concat(r.call(this, o))), s;
        };
      }
      this.defaults = { ...this.defaults, ...a };
    }), this;
  }
  setOptions(t) {
    return this.defaults = { ...this.defaults, ...t }, this;
  }
  lexer(t, e) {
    return je.lex(t, e ?? this.defaults);
  }
  parser(t, e) {
    return Be.parse(t, e ?? this.defaults);
  }
  parseMarkdown(t) {
    return (e, n) => {
      let a = { ...n }, r = { ...this.defaults, ...a }, i = this.onError(!!r.silent, !!r.async);
      if (this.defaults.async === !0 && a.async === !1)
        return i(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
      if (typeof e > "u" || e === null)
        return i(new Error("marked(): input parameter is undefined or null"));
      if (typeof e != "string")
        return i(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(e) + ", string expected"));
      r.hooks && (r.hooks.options = r, r.hooks.block = t);
      let o = r.hooks ? r.hooks.provideLexer() : t ? je.lex : je.lexInline, s = r.hooks ? r.hooks.provideParser() : t ? Be.parse : Be.parseInline;
      if (r.async)
        return Promise.resolve(r.hooks ? r.hooks.preprocess(e) : e).then((l) => o(l, r)).then((l) => r.hooks ? r.hooks.processAllTokens(l) : l).then((l) => r.walkTokens ? Promise.all(this.walkTokens(l, r.walkTokens)).then(() => l) : l).then((l) => s(l, r)).then((l) => r.hooks ? r.hooks.postprocess(l) : l).catch(i);
      try {
        r.hooks && (e = r.hooks.preprocess(e));
        let l = o(e, r);
        r.hooks && (l = r.hooks.processAllTokens(l)), r.walkTokens && this.walkTokens(l, r.walkTokens);
        let u = s(l, r);
        return r.hooks && (u = r.hooks.postprocess(u)), u;
      } catch (l) {
        return i(l);
      }
    };
  }
  onError(t, e) {
    return (n) => {
      if (n.message += `
Please report this to https://github.com/markedjs/marked.`, t) {
        let a = "<p>An error occurred:</p><pre>" + _e(n.message + "", !0) + "</pre>";
        return e ? Promise.resolve(a) : a;
      }
      if (e)
        return Promise.reject(n);
      throw n;
    };
  }
}();
function J(t, e) {
  return rt.parse(t, e);
}
J.options = J.setOptions = function(t) {
  return rt.setOptions(t), J.defaults = rt.defaults, so(J.defaults), J;
}, J.getDefaults = Yd, J.defaults = mt, J.use = function(...t) {
  return rt.use(...t), J.defaults = rt.defaults, so(J.defaults), J;
}, J.walkTokens = function(t, e) {
  return rt.walkTokens(t, e);
}, J.parseInline = rt.parseInline, J.Parser = Be, J.parser = Be.parse, J.Renderer = Jn, J.TextRenderer = Jr, J.Lexer = je, J.lexer = je.lex, J.Tokenizer = Wn, J.Hooks = Pn, J.parse = J, J.options, J.setOptions, J.use, J.walkTokens, J.parseInline, Be.parse, je.lex;
var pl = {}, Zt = {}, Qr = {}, Wt = {}, er = {};
Object.defineProperty(er, "__esModule", { value: !0 }), er.default = new Uint16Array('ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(t) {
  return t.charCodeAt(0);
}));
var tr = {};
Object.defineProperty(tr, "__esModule", { value: !0 }), tr.default = new Uint16Array("Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(t) {
  return t.charCodeAt(0);
}));
var xa = {};
(function(t) {
  var e;
  Object.defineProperty(t, "__esModule", { value: !0 }), t.replaceCodePoint = t.fromCodePoint = void 0;
  var n = /* @__PURE__ */ new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
  function a(r) {
    var i;
    return r >= 55296 && r <= 57343 || r > 1114111 ? 65533 : (i = n.get(r)) !== null && i !== void 0 ? i : r;
  }
  t.fromCodePoint = (e = String.fromCodePoint) !== null && e !== void 0 ? e : function(r) {
    var i = "";
    return r > 65535 && (r -= 65536, i += String.fromCharCode(r >>> 10 & 1023 | 55296), r = 56320 | 1023 & r), i += String.fromCharCode(r);
  }, t.replaceCodePoint = a, t.default = function(r) {
    return (0, t.fromCodePoint)(a(r));
  };
})(xa), function(t) {
  var e = Y && Y.__createBinding || (Object.create ? function(b, S, w, E) {
    E === void 0 && (E = w);
    var k = Object.getOwnPropertyDescriptor(S, w);
    k && !("get" in k ? !S.__esModule : k.writable || k.configurable) || (k = { enumerable: !0, get: function() {
      return S[w];
    } }), Object.defineProperty(b, E, k);
  } : function(b, S, w, E) {
    E === void 0 && (E = w), b[E] = S[w];
  }), n = Y && Y.__setModuleDefault || (Object.create ? function(b, S) {
    Object.defineProperty(b, "default", { enumerable: !0, value: S });
  } : function(b, S) {
    b.default = S;
  }), a = Y && Y.__importStar || function(b) {
    if (b && b.__esModule)
      return b;
    var S = {};
    if (b != null)
      for (var w in b)
        w !== "default" && Object.prototype.hasOwnProperty.call(b, w) && e(S, b, w);
    return n(S, b), S;
  }, r = Y && Y.__importDefault || function(b) {
    return b && b.__esModule ? b : { default: b };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeXML = t.decodeHTMLStrict = t.decodeHTMLAttribute = t.decodeHTML = t.determineBranch = t.EntityDecoder = t.DecodingMode = t.BinTrieFlags = t.fromCodePoint = t.replaceCodePoint = t.decodeCodePoint = t.xmlDecodeTree = t.htmlDecodeTree = void 0;
  var i = r(er);
  t.htmlDecodeTree = i.default;
  var o = r(tr);
  t.xmlDecodeTree = o.default;
  var s = a(xa);
  t.decodeCodePoint = s.default;
  var l, u = xa;
  Object.defineProperty(t, "replaceCodePoint", { enumerable: !0, get: function() {
    return u.replaceCodePoint;
  } }), Object.defineProperty(t, "fromCodePoint", { enumerable: !0, get: function() {
    return u.fromCodePoint;
  } }), function(b) {
    b[b.NUM = 35] = "NUM", b[b.SEMI = 59] = "SEMI", b[b.EQUALS = 61] = "EQUALS", b[b.ZERO = 48] = "ZERO", b[b.NINE = 57] = "NINE", b[b.LOWER_A = 97] = "LOWER_A", b[b.LOWER_F = 102] = "LOWER_F", b[b.LOWER_X = 120] = "LOWER_X", b[b.LOWER_Z = 122] = "LOWER_Z", b[b.UPPER_A = 65] = "UPPER_A", b[b.UPPER_F = 70] = "UPPER_F", b[b.UPPER_Z = 90] = "UPPER_Z";
  }(l || (l = {}));
  var c, d, p;
  function g(b) {
    return b >= l.ZERO && b <= l.NINE;
  }
  function f(b) {
    return b >= l.UPPER_A && b <= l.UPPER_F || b >= l.LOWER_A && b <= l.LOWER_F;
  }
  function h(b) {
    return b === l.EQUALS || function(S) {
      return S >= l.UPPER_A && S <= l.UPPER_Z || S >= l.LOWER_A && S <= l.LOWER_Z || g(S);
    }(b);
  }
  (function(b) {
    b[b.VALUE_LENGTH = 49152] = "VALUE_LENGTH", b[b.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", b[b.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(c = t.BinTrieFlags || (t.BinTrieFlags = {})), function(b) {
    b[b.EntityStart = 0] = "EntityStart", b[b.NumericStart = 1] = "NumericStart", b[b.NumericDecimal = 2] = "NumericDecimal", b[b.NumericHex = 3] = "NumericHex", b[b.NamedEntity = 4] = "NamedEntity";
  }(d || (d = {})), function(b) {
    b[b.Legacy = 0] = "Legacy", b[b.Strict = 1] = "Strict", b[b.Attribute = 2] = "Attribute";
  }(p = t.DecodingMode || (t.DecodingMode = {}));
  var D = function() {
    function b(S, w, E) {
      this.decodeTree = S, this.emitCodePoint = w, this.errors = E, this.state = d.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = p.Strict;
    }
    return b.prototype.startEntity = function(S) {
      this.decodeMode = S, this.state = d.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
    }, b.prototype.write = function(S, w) {
      switch (this.state) {
        case d.EntityStart:
          return S.charCodeAt(w) === l.NUM ? (this.state = d.NumericStart, this.consumed += 1, this.stateNumericStart(S, w + 1)) : (this.state = d.NamedEntity, this.stateNamedEntity(S, w));
        case d.NumericStart:
          return this.stateNumericStart(S, w);
        case d.NumericDecimal:
          return this.stateNumericDecimal(S, w);
        case d.NumericHex:
          return this.stateNumericHex(S, w);
        case d.NamedEntity:
          return this.stateNamedEntity(S, w);
      }
    }, b.prototype.stateNumericStart = function(S, w) {
      return w >= S.length ? -1 : (32 | S.charCodeAt(w)) === l.LOWER_X ? (this.state = d.NumericHex, this.consumed += 1, this.stateNumericHex(S, w + 1)) : (this.state = d.NumericDecimal, this.stateNumericDecimal(S, w));
    }, b.prototype.addToNumericResult = function(S, w, E, k) {
      if (w !== E) {
        var O = E - w;
        this.result = this.result * Math.pow(k, O) + parseInt(S.substr(w, O), k), this.consumed += O;
      }
    }, b.prototype.stateNumericHex = function(S, w) {
      for (var E = w; w < S.length; ) {
        var k = S.charCodeAt(w);
        if (!g(k) && !f(k))
          return this.addToNumericResult(S, E, w, 16), this.emitNumericEntity(k, 3);
        w += 1;
      }
      return this.addToNumericResult(S, E, w, 16), -1;
    }, b.prototype.stateNumericDecimal = function(S, w) {
      for (var E = w; w < S.length; ) {
        var k = S.charCodeAt(w);
        if (!g(k))
          return this.addToNumericResult(S, E, w, 10), this.emitNumericEntity(k, 2);
        w += 1;
      }
      return this.addToNumericResult(S, E, w, 10), -1;
    }, b.prototype.emitNumericEntity = function(S, w) {
      var E;
      if (this.consumed <= w)
        return (E = this.errors) === null || E === void 0 || E.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      if (S === l.SEMI)
        this.consumed += 1;
      else if (this.decodeMode === p.Strict)
        return 0;
      return this.emitCodePoint((0, s.replaceCodePoint)(this.result), this.consumed), this.errors && (S !== l.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
    }, b.prototype.stateNamedEntity = function(S, w) {
      for (var E = this.decodeTree, k = E[this.treeIndex], O = (k & c.VALUE_LENGTH) >> 14; w < S.length; w++, this.excess++) {
        var $ = S.charCodeAt(w);
        if (this.treeIndex = _(E, k, this.treeIndex + Math.max(1, O), $), this.treeIndex < 0)
          return this.result === 0 || this.decodeMode === p.Attribute && (O === 0 || h($)) ? 0 : this.emitNotTerminatedNamedEntity();
        if ((O = ((k = E[this.treeIndex]) & c.VALUE_LENGTH) >> 14) !== 0) {
          if ($ === l.SEMI)
            return this.emitNamedEntityData(this.treeIndex, O, this.consumed + this.excess);
          this.decodeMode !== p.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
        }
      }
      return -1;
    }, b.prototype.emitNotTerminatedNamedEntity = function() {
      var S, w = this.result, E = (this.decodeTree[w] & c.VALUE_LENGTH) >> 14;
      return this.emitNamedEntityData(w, E, this.consumed), (S = this.errors) === null || S === void 0 || S.missingSemicolonAfterCharacterReference(), this.consumed;
    }, b.prototype.emitNamedEntityData = function(S, w, E) {
      var k = this.decodeTree;
      return this.emitCodePoint(w === 1 ? k[S] & ~c.VALUE_LENGTH : k[S + 1], E), w === 3 && this.emitCodePoint(k[S + 2], E), E;
    }, b.prototype.end = function() {
      var S;
      switch (this.state) {
        case d.NamedEntity:
          return this.result === 0 || this.decodeMode === p.Attribute && this.result !== this.treeIndex ? 0 : this.emitNotTerminatedNamedEntity();
        case d.NumericDecimal:
          return this.emitNumericEntity(0, 2);
        case d.NumericHex:
          return this.emitNumericEntity(0, 3);
        case d.NumericStart:
          return (S = this.errors) === null || S === void 0 || S.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        case d.EntityStart:
          return 0;
      }
    }, b;
  }();
  function L(b) {
    var S = "", w = new D(b, function(E) {
      return S += (0, s.fromCodePoint)(E);
    });
    return function(E, k) {
      for (var O = 0, $ = 0; ($ = E.indexOf("&", $)) >= 0; ) {
        S += E.slice(O, $), w.startEntity(k);
        var v = w.write(E, $ + 1);
        if (v < 0) {
          O = $ + w.end();
          break;
        }
        O = $ + v, $ = v === 0 ? O + 1 : O;
      }
      var y = S + E.slice(O);
      return S = "", y;
    };
  }
  function _(b, S, w, E) {
    var k = (S & c.BRANCH_LENGTH) >> 7, O = S & c.JUMP_TABLE;
    if (k === 0)
      return O !== 0 && E === O ? w : -1;
    if (O) {
      var $ = E - O;
      return $ < 0 || $ >= k ? -1 : b[w + $] - 1;
    }
    for (var v = w, y = v + k - 1; v <= y; ) {
      var m = v + y >>> 1, M = b[m];
      if (M < E)
        v = m + 1;
      else {
        if (!(M > E))
          return b[m + k];
        y = m - 1;
      }
    }
    return -1;
  }
  t.EntityDecoder = D, t.determineBranch = _;
  var x = L(i.default), T = L(o.default);
  t.decodeHTML = function(b, S) {
    return S === void 0 && (S = p.Legacy), x(b, S);
  }, t.decodeHTMLAttribute = function(b) {
    return x(b, p.Attribute);
  }, t.decodeHTMLStrict = function(b) {
    return x(b, p.Strict);
  }, t.decodeXML = function(b) {
    return T(b, p.Strict);
  };
}(Wt), function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.QuoteType = void 0;
  var e, n, a, r = Wt;
  function i(c) {
    return c === e.Space || c === e.NewLine || c === e.Tab || c === e.FormFeed || c === e.CarriageReturn;
  }
  function o(c) {
    return c === e.Slash || c === e.Gt || i(c);
  }
  function s(c) {
    return c >= e.Zero && c <= e.Nine;
  }
  (function(c) {
    c[c.Tab = 9] = "Tab", c[c.NewLine = 10] = "NewLine", c[c.FormFeed = 12] = "FormFeed", c[c.CarriageReturn = 13] = "CarriageReturn", c[c.Space = 32] = "Space", c[c.ExclamationMark = 33] = "ExclamationMark", c[c.Number = 35] = "Number", c[c.Amp = 38] = "Amp", c[c.SingleQuote = 39] = "SingleQuote", c[c.DoubleQuote = 34] = "DoubleQuote", c[c.Dash = 45] = "Dash", c[c.Slash = 47] = "Slash", c[c.Zero = 48] = "Zero", c[c.Nine = 57] = "Nine", c[c.Semi = 59] = "Semi", c[c.Lt = 60] = "Lt", c[c.Eq = 61] = "Eq", c[c.Gt = 62] = "Gt", c[c.Questionmark = 63] = "Questionmark", c[c.UpperA = 65] = "UpperA", c[c.LowerA = 97] = "LowerA", c[c.UpperF = 70] = "UpperF", c[c.LowerF = 102] = "LowerF", c[c.UpperZ = 90] = "UpperZ", c[c.LowerZ = 122] = "LowerZ", c[c.LowerX = 120] = "LowerX", c[c.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(e || (e = {})), function(c) {
    c[c.Text = 1] = "Text", c[c.BeforeTagName = 2] = "BeforeTagName", c[c.InTagName = 3] = "InTagName", c[c.InSelfClosingTag = 4] = "InSelfClosingTag", c[c.BeforeClosingTagName = 5] = "BeforeClosingTagName", c[c.InClosingTagName = 6] = "InClosingTagName", c[c.AfterClosingTagName = 7] = "AfterClosingTagName", c[c.BeforeAttributeName = 8] = "BeforeAttributeName", c[c.InAttributeName = 9] = "InAttributeName", c[c.AfterAttributeName = 10] = "AfterAttributeName", c[c.BeforeAttributeValue = 11] = "BeforeAttributeValue", c[c.InAttributeValueDq = 12] = "InAttributeValueDq", c[c.InAttributeValueSq = 13] = "InAttributeValueSq", c[c.InAttributeValueNq = 14] = "InAttributeValueNq", c[c.BeforeDeclaration = 15] = "BeforeDeclaration", c[c.InDeclaration = 16] = "InDeclaration", c[c.InProcessingInstruction = 17] = "InProcessingInstruction", c[c.BeforeComment = 18] = "BeforeComment", c[c.CDATASequence = 19] = "CDATASequence", c[c.InSpecialComment = 20] = "InSpecialComment", c[c.InCommentLike = 21] = "InCommentLike", c[c.BeforeSpecialS = 22] = "BeforeSpecialS", c[c.SpecialStartSequence = 23] = "SpecialStartSequence", c[c.InSpecialTag = 24] = "InSpecialTag", c[c.BeforeEntity = 25] = "BeforeEntity", c[c.BeforeNumericEntity = 26] = "BeforeNumericEntity", c[c.InNamedEntity = 27] = "InNamedEntity", c[c.InNumericEntity = 28] = "InNumericEntity", c[c.InHexEntity = 29] = "InHexEntity";
  }(n || (n = {})), function(c) {
    c[c.NoValue = 0] = "NoValue", c[c.Unquoted = 1] = "Unquoted", c[c.Single = 2] = "Single", c[c.Double = 3] = "Double";
  }(a = t.QuoteType || (t.QuoteType = {}));
  var l = { Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]), CdataEnd: new Uint8Array([93, 93, 62]), CommentEnd: new Uint8Array([45, 45, 62]), ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]), StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]), TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]) }, u = function() {
    function c(d, p) {
      var g = d.xmlMode, f = g !== void 0 && g, h = d.decodeEntities, D = h === void 0 || h;
      this.cbs = p, this.state = n.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = n.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = f, this.decodeEntities = D, this.entityTrie = f ? r.xmlDecodeTree : r.htmlDecodeTree;
    }
    return c.prototype.reset = function() {
      this.state = n.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = n.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
    }, c.prototype.write = function(d) {
      this.offset += this.buffer.length, this.buffer = d, this.parse();
    }, c.prototype.end = function() {
      this.running && this.finish();
    }, c.prototype.pause = function() {
      this.running = !1;
    }, c.prototype.resume = function() {
      this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
    }, c.prototype.getIndex = function() {
      return this.index;
    }, c.prototype.getSectionStart = function() {
      return this.sectionStart;
    }, c.prototype.stateText = function(d) {
      d === e.Lt || !this.decodeEntities && this.fastForwardTo(e.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = n.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && d === e.Amp && (this.state = n.BeforeEntity);
    }, c.prototype.stateSpecialStartSequence = function(d) {
      var p = this.sequenceIndex === this.currentSequence.length;
      if (p ? o(d) : (32 | d) === this.currentSequence[this.sequenceIndex]) {
        if (!p)
          return void this.sequenceIndex++;
      } else
        this.isSpecial = !1;
      this.sequenceIndex = 0, this.state = n.InTagName, this.stateInTagName(d);
    }, c.prototype.stateInSpecialTag = function(d) {
      if (this.sequenceIndex === this.currentSequence.length) {
        if (d === e.Gt || i(d)) {
          var p = this.index - this.currentSequence.length;
          if (this.sectionStart < p) {
            var g = this.index;
            this.index = p, this.cbs.ontext(this.sectionStart, p), this.index = g;
          }
          return this.isSpecial = !1, this.sectionStart = p + 2, void this.stateInClosingTagName(d);
        }
        this.sequenceIndex = 0;
      }
      (32 | d) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === l.TitleEnd ? this.decodeEntities && d === e.Amp && (this.state = n.BeforeEntity) : this.fastForwardTo(e.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(d === e.Lt);
    }, c.prototype.stateCDATASequence = function(d) {
      d === l.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === l.Cdata.length && (this.state = n.InCommentLike, this.currentSequence = l.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = n.InDeclaration, this.stateInDeclaration(d));
    }, c.prototype.fastForwardTo = function(d) {
      for (; ++this.index < this.buffer.length + this.offset; )
        if (this.buffer.charCodeAt(this.index - this.offset) === d)
          return !0;
      return this.index = this.buffer.length + this.offset - 1, !1;
    }, c.prototype.stateInCommentLike = function(d) {
      d === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === l.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = n.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : d !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
    }, c.prototype.isTagStartChar = function(d) {
      return this.xmlMode ? !o(d) : function(p) {
        return p >= e.LowerA && p <= e.LowerZ || p >= e.UpperA && p <= e.UpperZ;
      }(d);
    }, c.prototype.startSpecial = function(d, p) {
      this.isSpecial = !0, this.currentSequence = d, this.sequenceIndex = p, this.state = n.SpecialStartSequence;
    }, c.prototype.stateBeforeTagName = function(d) {
      if (d === e.ExclamationMark)
        this.state = n.BeforeDeclaration, this.sectionStart = this.index + 1;
      else if (d === e.Questionmark)
        this.state = n.InProcessingInstruction, this.sectionStart = this.index + 1;
      else if (this.isTagStartChar(d)) {
        var p = 32 | d;
        this.sectionStart = this.index, this.xmlMode || p !== l.TitleEnd[2] ? this.state = this.xmlMode || p !== l.ScriptEnd[2] ? n.InTagName : n.BeforeSpecialS : this.startSpecial(l.TitleEnd, 3);
      } else
        d === e.Slash ? this.state = n.BeforeClosingTagName : (this.state = n.Text, this.stateText(d));
    }, c.prototype.stateInTagName = function(d) {
      o(d) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(d));
    }, c.prototype.stateBeforeClosingTagName = function(d) {
      i(d) || (d === e.Gt ? this.state = n.Text : (this.state = this.isTagStartChar(d) ? n.InClosingTagName : n.InSpecialComment, this.sectionStart = this.index));
    }, c.prototype.stateInClosingTagName = function(d) {
      (d === e.Gt || i(d)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = n.AfterClosingTagName, this.stateAfterClosingTagName(d));
    }, c.prototype.stateAfterClosingTagName = function(d) {
      (d === e.Gt || this.fastForwardTo(e.Gt)) && (this.state = n.Text, this.baseState = n.Text, this.sectionStart = this.index + 1);
    }, c.prototype.stateBeforeAttributeName = function(d) {
      d === e.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = n.InSpecialTag, this.sequenceIndex = 0) : this.state = n.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : d === e.Slash ? this.state = n.InSelfClosingTag : i(d) || (this.state = n.InAttributeName, this.sectionStart = this.index);
    }, c.prototype.stateInSelfClosingTag = function(d) {
      d === e.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = n.Text, this.baseState = n.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : i(d) || (this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(d));
    }, c.prototype.stateInAttributeName = function(d) {
      (d === e.Eq || o(d)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = n.AfterAttributeName, this.stateAfterAttributeName(d));
    }, c.prototype.stateAfterAttributeName = function(d) {
      d === e.Eq ? this.state = n.BeforeAttributeValue : d === e.Slash || d === e.Gt ? (this.cbs.onattribend(a.NoValue, this.index), this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(d)) : i(d) || (this.cbs.onattribend(a.NoValue, this.index), this.state = n.InAttributeName, this.sectionStart = this.index);
    }, c.prototype.stateBeforeAttributeValue = function(d) {
      d === e.DoubleQuote ? (this.state = n.InAttributeValueDq, this.sectionStart = this.index + 1) : d === e.SingleQuote ? (this.state = n.InAttributeValueSq, this.sectionStart = this.index + 1) : i(d) || (this.sectionStart = this.index, this.state = n.InAttributeValueNq, this.stateInAttributeValueNoQuotes(d));
    }, c.prototype.handleInAttributeValue = function(d, p) {
      d === p || !this.decodeEntities && this.fastForwardTo(p) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(p === e.DoubleQuote ? a.Double : a.Single, this.index), this.state = n.BeforeAttributeName) : this.decodeEntities && d === e.Amp && (this.baseState = this.state, this.state = n.BeforeEntity);
    }, c.prototype.stateInAttributeValueDoubleQuotes = function(d) {
      this.handleInAttributeValue(d, e.DoubleQuote);
    }, c.prototype.stateInAttributeValueSingleQuotes = function(d) {
      this.handleInAttributeValue(d, e.SingleQuote);
    }, c.prototype.stateInAttributeValueNoQuotes = function(d) {
      i(d) || d === e.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(a.Unquoted, this.index), this.state = n.BeforeAttributeName, this.stateBeforeAttributeName(d)) : this.decodeEntities && d === e.Amp && (this.baseState = this.state, this.state = n.BeforeEntity);
    }, c.prototype.stateBeforeDeclaration = function(d) {
      d === e.OpeningSquareBracket ? (this.state = n.CDATASequence, this.sequenceIndex = 0) : this.state = d === e.Dash ? n.BeforeComment : n.InDeclaration;
    }, c.prototype.stateInDeclaration = function(d) {
      (d === e.Gt || this.fastForwardTo(e.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = n.Text, this.sectionStart = this.index + 1);
    }, c.prototype.stateInProcessingInstruction = function(d) {
      (d === e.Gt || this.fastForwardTo(e.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = n.Text, this.sectionStart = this.index + 1);
    }, c.prototype.stateBeforeComment = function(d) {
      d === e.Dash ? (this.state = n.InCommentLike, this.currentSequence = l.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = n.InDeclaration;
    }, c.prototype.stateInSpecialComment = function(d) {
      (d === e.Gt || this.fastForwardTo(e.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = n.Text, this.sectionStart = this.index + 1);
    }, c.prototype.stateBeforeSpecialS = function(d) {
      var p = 32 | d;
      p === l.ScriptEnd[3] ? this.startSpecial(l.ScriptEnd, 4) : p === l.StyleEnd[3] ? this.startSpecial(l.StyleEnd, 4) : (this.state = n.InTagName, this.stateInTagName(d));
    }, c.prototype.stateBeforeEntity = function(d) {
      this.entityExcess = 1, this.entityResult = 0, d === e.Number ? this.state = n.BeforeNumericEntity : d === e.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = n.InNamedEntity, this.stateInNamedEntity(d));
    }, c.prototype.stateInNamedEntity = function(d) {
      if (this.entityExcess += 1, this.trieIndex = (0, r.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, d), this.trieIndex < 0)
        return this.emitNamedEntity(), void this.index--;
      this.trieCurrent = this.entityTrie[this.trieIndex];
      var p = this.trieCurrent & r.BinTrieFlags.VALUE_LENGTH;
      if (p) {
        var g = (p >> 14) - 1;
        if (this.allowLegacyEntity() || d === e.Semi) {
          var f = this.index - this.entityExcess + 1;
          f > this.sectionStart && this.emitPartial(this.sectionStart, f), this.entityResult = this.trieIndex, this.trieIndex += g, this.entityExcess = 0, this.sectionStart = this.index + 1, g === 0 && this.emitNamedEntity();
        } else
          this.trieIndex += g;
      }
    }, c.prototype.emitNamedEntity = function() {
      if (this.state = this.baseState, this.entityResult !== 0)
        switch ((this.entityTrie[this.entityResult] & r.BinTrieFlags.VALUE_LENGTH) >> 14) {
          case 1:
            this.emitCodePoint(this.entityTrie[this.entityResult] & ~r.BinTrieFlags.VALUE_LENGTH);
            break;
          case 2:
            this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
            break;
          case 3:
            this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    }, c.prototype.stateBeforeNumericEntity = function(d) {
      (32 | d) === e.LowerX ? (this.entityExcess++, this.state = n.InHexEntity) : (this.state = n.InNumericEntity, this.stateInNumericEntity(d));
    }, c.prototype.emitNumericEntity = function(d) {
      var p = this.index - this.entityExcess - 1;
      p + 2 + +(this.state === n.InHexEntity) !== this.index && (p > this.sectionStart && this.emitPartial(this.sectionStart, p), this.sectionStart = this.index + Number(d), this.emitCodePoint((0, r.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
    }, c.prototype.stateInNumericEntity = function(d) {
      d === e.Semi ? this.emitNumericEntity(!0) : s(d) ? (this.entityResult = 10 * this.entityResult + (d - e.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
    }, c.prototype.stateInHexEntity = function(d) {
      d === e.Semi ? this.emitNumericEntity(!0) : s(d) ? (this.entityResult = 16 * this.entityResult + (d - e.Zero), this.entityExcess++) : function(p) {
        return p >= e.UpperA && p <= e.UpperF || p >= e.LowerA && p <= e.LowerF;
      }(d) ? (this.entityResult = 16 * this.entityResult + ((32 | d) - e.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
    }, c.prototype.allowLegacyEntity = function() {
      return !this.xmlMode && (this.baseState === n.Text || this.baseState === n.InSpecialTag);
    }, c.prototype.cleanup = function() {
      this.running && this.sectionStart !== this.index && (this.state === n.Text || this.state === n.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : this.state !== n.InAttributeValueDq && this.state !== n.InAttributeValueSq && this.state !== n.InAttributeValueNq || (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
    }, c.prototype.shouldContinue = function() {
      return this.index < this.buffer.length + this.offset && this.running;
    }, c.prototype.parse = function() {
      for (; this.shouldContinue(); ) {
        var d = this.buffer.charCodeAt(this.index - this.offset);
        switch (this.state) {
          case n.Text:
            this.stateText(d);
            break;
          case n.SpecialStartSequence:
            this.stateSpecialStartSequence(d);
            break;
          case n.InSpecialTag:
            this.stateInSpecialTag(d);
            break;
          case n.CDATASequence:
            this.stateCDATASequence(d);
            break;
          case n.InAttributeValueDq:
            this.stateInAttributeValueDoubleQuotes(d);
            break;
          case n.InAttributeName:
            this.stateInAttributeName(d);
            break;
          case n.InCommentLike:
            this.stateInCommentLike(d);
            break;
          case n.InSpecialComment:
            this.stateInSpecialComment(d);
            break;
          case n.BeforeAttributeName:
            this.stateBeforeAttributeName(d);
            break;
          case n.InTagName:
            this.stateInTagName(d);
            break;
          case n.InClosingTagName:
            this.stateInClosingTagName(d);
            break;
          case n.BeforeTagName:
            this.stateBeforeTagName(d);
            break;
          case n.AfterAttributeName:
            this.stateAfterAttributeName(d);
            break;
          case n.InAttributeValueSq:
            this.stateInAttributeValueSingleQuotes(d);
            break;
          case n.BeforeAttributeValue:
            this.stateBeforeAttributeValue(d);
            break;
          case n.BeforeClosingTagName:
            this.stateBeforeClosingTagName(d);
            break;
          case n.AfterClosingTagName:
            this.stateAfterClosingTagName(d);
            break;
          case n.BeforeSpecialS:
            this.stateBeforeSpecialS(d);
            break;
          case n.InAttributeValueNq:
            this.stateInAttributeValueNoQuotes(d);
            break;
          case n.InSelfClosingTag:
            this.stateInSelfClosingTag(d);
            break;
          case n.InDeclaration:
            this.stateInDeclaration(d);
            break;
          case n.BeforeDeclaration:
            this.stateBeforeDeclaration(d);
            break;
          case n.BeforeComment:
            this.stateBeforeComment(d);
            break;
          case n.InProcessingInstruction:
            this.stateInProcessingInstruction(d);
            break;
          case n.InNamedEntity:
            this.stateInNamedEntity(d);
            break;
          case n.BeforeEntity:
            this.stateBeforeEntity(d);
            break;
          case n.InHexEntity:
            this.stateInHexEntity(d);
            break;
          case n.InNumericEntity:
            this.stateInNumericEntity(d);
            break;
          default:
            this.stateBeforeNumericEntity(d);
        }
        this.index++;
      }
      this.cleanup();
    }, c.prototype.finish = function() {
      this.state === n.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
    }, c.prototype.handleTrailingData = function() {
      var d = this.buffer.length + this.offset;
      this.state === n.InCommentLike ? this.currentSequence === l.CdataEnd ? this.cbs.oncdata(this.sectionStart, d, 0) : this.cbs.oncomment(this.sectionStart, d, 0) : this.state === n.InNumericEntity && this.allowLegacyEntity() || this.state === n.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === n.InTagName || this.state === n.BeforeAttributeName || this.state === n.BeforeAttributeValue || this.state === n.AfterAttributeName || this.state === n.InAttributeName || this.state === n.InAttributeValueSq || this.state === n.InAttributeValueDq || this.state === n.InAttributeValueNq || this.state === n.InClosingTagName || this.cbs.ontext(this.sectionStart, d);
    }, c.prototype.emitPartial = function(d, p) {
      this.baseState !== n.Text && this.baseState !== n.InSpecialTag ? this.cbs.onattribdata(d, p) : this.cbs.ontext(d, p);
    }, c.prototype.emitCodePoint = function(d) {
      this.baseState !== n.Text && this.baseState !== n.InSpecialTag ? this.cbs.onattribentity(d) : this.cbs.ontextentity(d);
    }, c;
  }();
  t.default = u;
}(Qr);
var lp = Y && Y.__createBinding || (Object.create ? function(t, e, n, a) {
  a === void 0 && (a = n);
  var r = Object.getOwnPropertyDescriptor(e, n);
  r && !("get" in r ? !e.__esModule : r.writable || r.configurable) || (r = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, a, r);
} : function(t, e, n, a) {
  a === void 0 && (a = n), t[a] = e[n];
}), cp = Y && Y.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), up = Y && Y.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n in t)
      n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && lp(e, t, n);
  return cp(e, t), e;
};
Object.defineProperty(Zt, "__esModule", { value: !0 }), Zt.Parser = void 0;
var vn = up(Qr), yo = Wt, bt = /* @__PURE__ */ new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]), te = /* @__PURE__ */ new Set(["p"]), bo = /* @__PURE__ */ new Set(["thead", "tbody"]), vo = /* @__PURE__ */ new Set(["dd", "dt"]), So = /* @__PURE__ */ new Set(["rt", "rp"]), dp = /* @__PURE__ */ new Map([["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])], ["th", /* @__PURE__ */ new Set(["th"])], ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])], ["body", /* @__PURE__ */ new Set(["head", "link", "script"])], ["li", /* @__PURE__ */ new Set(["li"])], ["p", te], ["h1", te], ["h2", te], ["h3", te], ["h4", te], ["h5", te], ["h6", te], ["select", bt], ["input", bt], ["output", bt], ["button", bt], ["datalist", bt], ["textarea", bt], ["option", /* @__PURE__ */ new Set(["option"])], ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])], ["dd", vo], ["dt", vo], ["address", te], ["article", te], ["aside", te], ["blockquote", te], ["details", te], ["div", te], ["dl", te], ["fieldset", te], ["figcaption", te], ["figure", te], ["footer", te], ["form", te], ["header", te], ["hr", te], ["main", te], ["nav", te], ["ol", te], ["pre", te], ["section", te], ["table", te], ["ul", te], ["rt", So], ["rp", So], ["tbody", bo], ["tfoot", bo]]), pp = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]), Co = /* @__PURE__ */ new Set(["math", "svg"]), Mo = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignobject", "desc", "title"]), hp = /\s|\//, mp = function() {
  function t(e, n) {
    var a, r, i, o, s;
    n === void 0 && (n = {}), this.options = n, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = e ?? {}, this.lowerCaseTagNames = (a = n.lowerCaseTags) !== null && a !== void 0 ? a : !n.xmlMode, this.lowerCaseAttributeNames = (r = n.lowerCaseAttributeNames) !== null && r !== void 0 ? r : !n.xmlMode, this.tokenizer = new ((i = n.Tokenizer) !== null && i !== void 0 ? i : vn.default)(this.options, this), (s = (o = this.cbs).onparserinit) === null || s === void 0 || s.call(o, this);
  }
  return t.prototype.ontext = function(e, n) {
    var a, r, i = this.getSlice(e, n);
    this.endIndex = n - 1, (r = (a = this.cbs).ontext) === null || r === void 0 || r.call(a, i), this.startIndex = n;
  }, t.prototype.ontextentity = function(e) {
    var n, a, r = this.tokenizer.getSectionStart();
    this.endIndex = r - 1, (a = (n = this.cbs).ontext) === null || a === void 0 || a.call(n, (0, yo.fromCodePoint)(e)), this.startIndex = r;
  }, t.prototype.isVoidElement = function(e) {
    return !this.options.xmlMode && pp.has(e);
  }, t.prototype.onopentagname = function(e, n) {
    this.endIndex = n;
    var a = this.getSlice(e, n);
    this.lowerCaseTagNames && (a = a.toLowerCase()), this.emitOpenTag(a);
  }, t.prototype.emitOpenTag = function(e) {
    var n, a, r, i;
    this.openTagStart = this.startIndex, this.tagname = e;
    var o = !this.options.xmlMode && dp.get(e);
    if (o)
      for (; this.stack.length > 0 && o.has(this.stack[this.stack.length - 1]); ) {
        var s = this.stack.pop();
        (a = (n = this.cbs).onclosetag) === null || a === void 0 || a.call(n, s, !0);
      }
    this.isVoidElement(e) || (this.stack.push(e), Co.has(e) ? this.foreignContext.push(!0) : Mo.has(e) && this.foreignContext.push(!1)), (i = (r = this.cbs).onopentagname) === null || i === void 0 || i.call(r, e), this.cbs.onopentag && (this.attribs = {});
  }, t.prototype.endOpenTag = function(e) {
    var n, a;
    this.startIndex = this.openTagStart, this.attribs && ((a = (n = this.cbs).onopentag) === null || a === void 0 || a.call(n, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }, t.prototype.onopentagend = function(e) {
    this.endIndex = e, this.endOpenTag(!1), this.startIndex = e + 1;
  }, t.prototype.onclosetag = function(e, n) {
    var a, r, i, o, s, l;
    this.endIndex = n;
    var u = this.getSlice(e, n);
    if (this.lowerCaseTagNames && (u = u.toLowerCase()), (Co.has(u) || Mo.has(u)) && this.foreignContext.pop(), this.isVoidElement(u))
      this.options.xmlMode || u !== "br" || ((r = (a = this.cbs).onopentagname) === null || r === void 0 || r.call(a, "br"), (o = (i = this.cbs).onopentag) === null || o === void 0 || o.call(i, "br", {}, !0), (l = (s = this.cbs).onclosetag) === null || l === void 0 || l.call(s, "br", !1));
    else {
      var c = this.stack.lastIndexOf(u);
      if (c !== -1)
        if (this.cbs.onclosetag)
          for (var d = this.stack.length - c; d--; )
            this.cbs.onclosetag(this.stack.pop(), d !== 0);
        else
          this.stack.length = c;
      else
        this.options.xmlMode || u !== "p" || (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = n + 1;
  }, t.prototype.onselfclosingtag = function(e) {
    this.endIndex = e, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = e + 1) : this.onopentagend(e);
  }, t.prototype.closeCurrentTag = function(e) {
    var n, a, r = this.tagname;
    this.endOpenTag(e), this.stack[this.stack.length - 1] === r && ((a = (n = this.cbs).onclosetag) === null || a === void 0 || a.call(n, r, !e), this.stack.pop());
  }, t.prototype.onattribname = function(e, n) {
    this.startIndex = e;
    var a = this.getSlice(e, n);
    this.attribname = this.lowerCaseAttributeNames ? a.toLowerCase() : a;
  }, t.prototype.onattribdata = function(e, n) {
    this.attribvalue += this.getSlice(e, n);
  }, t.prototype.onattribentity = function(e) {
    this.attribvalue += (0, yo.fromCodePoint)(e);
  }, t.prototype.onattribend = function(e, n) {
    var a, r;
    this.endIndex = n, (r = (a = this.cbs).onattribute) === null || r === void 0 || r.call(a, this.attribname, this.attribvalue, e === vn.QuoteType.Double ? '"' : e === vn.QuoteType.Single ? "'" : e === vn.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }, t.prototype.getInstructionName = function(e) {
    var n = e.search(hp), a = n < 0 ? e : e.substr(0, n);
    return this.lowerCaseTagNames && (a = a.toLowerCase()), a;
  }, t.prototype.ondeclaration = function(e, n) {
    this.endIndex = n;
    var a = this.getSlice(e, n);
    if (this.cbs.onprocessinginstruction) {
      var r = this.getInstructionName(a);
      this.cbs.onprocessinginstruction("!".concat(r), "!".concat(a));
    }
    this.startIndex = n + 1;
  }, t.prototype.onprocessinginstruction = function(e, n) {
    this.endIndex = n;
    var a = this.getSlice(e, n);
    if (this.cbs.onprocessinginstruction) {
      var r = this.getInstructionName(a);
      this.cbs.onprocessinginstruction("?".concat(r), "?".concat(a));
    }
    this.startIndex = n + 1;
  }, t.prototype.oncomment = function(e, n, a) {
    var r, i, o, s;
    this.endIndex = n, (i = (r = this.cbs).oncomment) === null || i === void 0 || i.call(r, this.getSlice(e, n - a)), (s = (o = this.cbs).oncommentend) === null || s === void 0 || s.call(o), this.startIndex = n + 1;
  }, t.prototype.oncdata = function(e, n, a) {
    var r, i, o, s, l, u, c, d, p, g;
    this.endIndex = n;
    var f = this.getSlice(e, n - a);
    this.options.xmlMode || this.options.recognizeCDATA ? ((i = (r = this.cbs).oncdatastart) === null || i === void 0 || i.call(r), (s = (o = this.cbs).ontext) === null || s === void 0 || s.call(o, f), (u = (l = this.cbs).oncdataend) === null || u === void 0 || u.call(l)) : ((d = (c = this.cbs).oncomment) === null || d === void 0 || d.call(c, "[CDATA[".concat(f, "]]")), (g = (p = this.cbs).oncommentend) === null || g === void 0 || g.call(p)), this.startIndex = n + 1;
  }, t.prototype.onend = function() {
    var e, n;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (var a = this.stack.length; a > 0; this.cbs.onclosetag(this.stack[--a], !0))
        ;
    }
    (n = (e = this.cbs).onend) === null || n === void 0 || n.call(e);
  }, t.prototype.reset = function() {
    var e, n, a, r;
    (n = (e = this.cbs).onreset) === null || n === void 0 || n.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (r = (a = this.cbs).onparserinit) === null || r === void 0 || r.call(a, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }, t.prototype.parseComplete = function(e) {
    this.reset(), this.end(e);
  }, t.prototype.getSlice = function(e, n) {
    for (; e - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    for (var a = this.buffers[0].slice(e - this.bufferOffset, n - this.bufferOffset); n - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), a += this.buffers[0].slice(0, n - this.bufferOffset);
    return a;
  }, t.prototype.shiftBuffer = function() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }, t.prototype.write = function(e) {
    var n, a;
    this.ended ? (a = (n = this.cbs).onerror) === null || a === void 0 || a.call(n, new Error(".write() after done!")) : (this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++));
  }, t.prototype.end = function(e) {
    var n, a;
    this.ended ? (a = (n = this.cbs).onerror) === null || a === void 0 || a.call(n, new Error(".end() after done!")) : (e && this.write(e), this.ended = !0, this.tokenizer.end());
  }, t.prototype.pause = function() {
    this.tokenizer.pause();
  }, t.prototype.resume = function() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }, t.prototype.parseChunk = function(e) {
    this.write(e);
  }, t.prototype.done = function(e) {
    this.end(e);
  }, t;
}();
Zt.Parser = mp;
var He = {}, kt = {};
(function(t) {
  var e;
  Object.defineProperty(t, "__esModule", { value: !0 }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0, function(n) {
    n.Root = "root", n.Text = "text", n.Directive = "directive", n.Comment = "comment", n.Script = "script", n.Style = "style", n.Tag = "tag", n.CDATA = "cdata", n.Doctype = "doctype";
  }(e = t.ElementType || (t.ElementType = {})), t.isTag = function(n) {
    return n.type === e.Tag || n.type === e.Script || n.type === e.Style;
  }, t.Root = e.Root, t.Text = e.Text, t.Directive = e.Directive, t.Comment = e.Comment, t.Script = e.Script, t.Style = e.Style, t.Tag = e.Tag, t.CDATA = e.CDATA, t.Doctype = e.Doctype;
})(kt);
var Sn, q = {}, et = Y && Y.__extends || (Sn = function(t, e) {
  return Sn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var r in a)
      Object.prototype.hasOwnProperty.call(a, r) && (n[r] = a[r]);
  }, Sn(t, e);
}, function(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function n() {
    this.constructor = t;
  }
  Sn(t, e), t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}), Ut = Y && Y.__assign || function() {
  return Ut = Object.assign || function(t) {
    for (var e, n = 1, a = arguments.length; n < a; n++)
      for (var r in e = arguments[n])
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    return t;
  }, Ut.apply(this, arguments);
};
Object.defineProperty(q, "__esModule", { value: !0 }), q.cloneNode = q.hasChildren = q.isDocument = q.isDirective = q.isComment = q.isText = q.isCDATA = q.isTag = q.Element = q.Document = q.CDATA = q.NodeWithChildren = q.ProcessingInstruction = q.Comment = q.Text = q.DataNode = q.Node = void 0;
var ye = kt, Xr = function() {
  function t() {
    this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
  }
  return Object.defineProperty(t.prototype, "parentNode", { get: function() {
    return this.parent;
  }, set: function(e) {
    this.parent = e;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "previousSibling", { get: function() {
    return this.prev;
  }, set: function(e) {
    this.prev = e;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "nextSibling", { get: function() {
    return this.next;
  }, set: function(e) {
    this.next = e;
  }, enumerable: !1, configurable: !0 }), t.prototype.cloneNode = function(e) {
    return e === void 0 && (e = !1), ei(this, e);
  }, t;
}();
q.Node = Xr;
var da = function(t) {
  function e(n) {
    var a = t.call(this) || this;
    return a.data = n, a;
  }
  return et(e, t), Object.defineProperty(e.prototype, "nodeValue", { get: function() {
    return this.data;
  }, set: function(n) {
    this.data = n;
  }, enumerable: !1, configurable: !0 }), e;
}(Xr);
q.DataNode = da;
var hl = function(t) {
  function e() {
    var n = t !== null && t.apply(this, arguments) || this;
    return n.type = ye.ElementType.Text, n;
  }
  return et(e, t), Object.defineProperty(e.prototype, "nodeType", { get: function() {
    return 3;
  }, enumerable: !1, configurable: !0 }), e;
}(da);
q.Text = hl;
var ml = function(t) {
  function e() {
    var n = t !== null && t.apply(this, arguments) || this;
    return n.type = ye.ElementType.Comment, n;
  }
  return et(e, t), Object.defineProperty(e.prototype, "nodeType", { get: function() {
    return 8;
  }, enumerable: !1, configurable: !0 }), e;
}(da);
q.Comment = ml;
var gl = function(t) {
  function e(n, a) {
    var r = t.call(this, a) || this;
    return r.name = n, r.type = ye.ElementType.Directive, r;
  }
  return et(e, t), Object.defineProperty(e.prototype, "nodeType", { get: function() {
    return 1;
  }, enumerable: !1, configurable: !0 }), e;
}(da);
q.ProcessingInstruction = gl;
var pa = function(t) {
  function e(n) {
    var a = t.call(this) || this;
    return a.children = n, a;
  }
  return et(e, t), Object.defineProperty(e.prototype, "firstChild", { get: function() {
    var n;
    return (n = this.children[0]) !== null && n !== void 0 ? n : null;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "lastChild", { get: function() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "childNodes", { get: function() {
    return this.children;
  }, set: function(n) {
    this.children = n;
  }, enumerable: !1, configurable: !0 }), e;
}(Xr);
q.NodeWithChildren = pa;
var fl = function(t) {
  function e() {
    var n = t !== null && t.apply(this, arguments) || this;
    return n.type = ye.ElementType.CDATA, n;
  }
  return et(e, t), Object.defineProperty(e.prototype, "nodeType", { get: function() {
    return 4;
  }, enumerable: !1, configurable: !0 }), e;
}(pa);
q.CDATA = fl;
var yl = function(t) {
  function e() {
    var n = t !== null && t.apply(this, arguments) || this;
    return n.type = ye.ElementType.Root, n;
  }
  return et(e, t), Object.defineProperty(e.prototype, "nodeType", { get: function() {
    return 9;
  }, enumerable: !1, configurable: !0 }), e;
}(pa);
q.Document = yl;
var bl = function(t) {
  function e(n, a, r, i) {
    r === void 0 && (r = []), i === void 0 && (i = n === "script" ? ye.ElementType.Script : n === "style" ? ye.ElementType.Style : ye.ElementType.Tag);
    var o = t.call(this, r) || this;
    return o.name = n, o.attribs = a, o.type = i, o;
  }
  return et(e, t), Object.defineProperty(e.prototype, "nodeType", { get: function() {
    return 1;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "tagName", { get: function() {
    return this.name;
  }, set: function(n) {
    this.name = n;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "attributes", { get: function() {
    var n = this;
    return Object.keys(this.attribs).map(function(a) {
      var r, i;
      return { name: a, value: n.attribs[a], namespace: (r = n["x-attribsNamespace"]) === null || r === void 0 ? void 0 : r[a], prefix: (i = n["x-attribsPrefix"]) === null || i === void 0 ? void 0 : i[a] };
    });
  }, enumerable: !1, configurable: !0 }), e;
}(pa);
function vl(t) {
  return (0, ye.isTag)(t);
}
function Sl(t) {
  return t.type === ye.ElementType.CDATA;
}
function Cl(t) {
  return t.type === ye.ElementType.Text;
}
function Ml(t) {
  return t.type === ye.ElementType.Comment;
}
function Dl(t) {
  return t.type === ye.ElementType.Directive;
}
function Nl(t) {
  return t.type === ye.ElementType.Root;
}
function ei(t, e) {
  var n;
  if (e === void 0 && (e = !1), Cl(t))
    n = new hl(t.data);
  else if (Ml(t))
    n = new ml(t.data);
  else if (vl(t)) {
    var a = e ? ka(t.children) : [], r = new bl(t.name, Ut({}, t.attribs), a);
    a.forEach(function(l) {
      return l.parent = r;
    }), t.namespace != null && (r.namespace = t.namespace), t["x-attribsNamespace"] && (r["x-attribsNamespace"] = Ut({}, t["x-attribsNamespace"])), t["x-attribsPrefix"] && (r["x-attribsPrefix"] = Ut({}, t["x-attribsPrefix"])), n = r;
  } else if (Sl(t)) {
    a = e ? ka(t.children) : [];
    var i = new fl(a);
    a.forEach(function(l) {
      return l.parent = i;
    }), n = i;
  } else if (Nl(t)) {
    a = e ? ka(t.children) : [];
    var o = new yl(a);
    a.forEach(function(l) {
      return l.parent = o;
    }), t["x-mode"] && (o["x-mode"] = t["x-mode"]), n = o;
  } else {
    if (!Dl(t))
      throw new Error("Not implemented yet: ".concat(t.type));
    var s = new gl(t.name, t.data);
    t["x-name"] != null && (s["x-name"] = t["x-name"], s["x-publicId"] = t["x-publicId"], s["x-systemId"] = t["x-systemId"]), n = s;
  }
  return n.startIndex = t.startIndex, n.endIndex = t.endIndex, t.sourceCodeLocation != null && (n.sourceCodeLocation = t.sourceCodeLocation), n;
}
function ka(t) {
  for (var e = t.map(function(a) {
    return ei(a, !0);
  }), n = 1; n < e.length; n++)
    e[n].prev = e[n - 1], e[n - 1].next = e[n];
  return e;
}
q.Element = bl, q.isTag = vl, q.isCDATA = Sl, q.isText = Cl, q.isComment = Ml, q.isDirective = Dl, q.isDocument = Nl, q.hasChildren = function(t) {
  return Object.prototype.hasOwnProperty.call(t, "children");
}, q.cloneNode = ei, function(t) {
  var e = Y && Y.__createBinding || (Object.create ? function(s, l, u, c) {
    c === void 0 && (c = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    d && !("get" in d ? !l.__esModule : d.writable || d.configurable) || (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(s, c, d);
  } : function(s, l, u, c) {
    c === void 0 && (c = u), s[c] = l[u];
  }), n = Y && Y.__exportStar || function(s, l) {
    for (var u in s)
      u === "default" || Object.prototype.hasOwnProperty.call(l, u) || e(l, s, u);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DomHandler = void 0;
  var a = kt, r = q;
  n(q, t);
  var i = { withStartIndices: !1, withEndIndices: !1, xmlMode: !1 }, o = function() {
    function s(l, u, c) {
      this.dom = [], this.root = new r.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof u == "function" && (c = u, u = i), typeof l == "object" && (u = l, l = void 0), this.callback = l ?? null, this.options = u ?? i, this.elementCB = c ?? null;
    }
    return s.prototype.onparserinit = function(l) {
      this.parser = l;
    }, s.prototype.onreset = function() {
      this.dom = [], this.root = new r.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
    }, s.prototype.onend = function() {
      this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
    }, s.prototype.onerror = function(l) {
      this.handleCallback(l);
    }, s.prototype.onclosetag = function() {
      this.lastNode = null;
      var l = this.tagStack.pop();
      this.options.withEndIndices && (l.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(l);
    }, s.prototype.onopentag = function(l, u) {
      var c = this.options.xmlMode ? a.ElementType.Tag : void 0, d = new r.Element(l, u, void 0, c);
      this.addNode(d), this.tagStack.push(d);
    }, s.prototype.ontext = function(l) {
      var u = this.lastNode;
      if (u && u.type === a.ElementType.Text)
        u.data += l, this.options.withEndIndices && (u.endIndex = this.parser.endIndex);
      else {
        var c = new r.Text(l);
        this.addNode(c), this.lastNode = c;
      }
    }, s.prototype.oncomment = function(l) {
      if (this.lastNode && this.lastNode.type === a.ElementType.Comment)
        this.lastNode.data += l;
      else {
        var u = new r.Comment(l);
        this.addNode(u), this.lastNode = u;
      }
    }, s.prototype.oncommentend = function() {
      this.lastNode = null;
    }, s.prototype.oncdatastart = function() {
      var l = new r.Text(""), u = new r.CDATA([l]);
      this.addNode(u), l.parent = u, this.lastNode = l;
    }, s.prototype.oncdataend = function() {
      this.lastNode = null;
    }, s.prototype.onprocessinginstruction = function(l, u) {
      var c = new r.ProcessingInstruction(l, u);
      this.addNode(c);
    }, s.prototype.handleCallback = function(l) {
      if (typeof this.callback == "function")
        this.callback(l, this.dom);
      else if (l)
        throw l;
    }, s.prototype.addNode = function(l) {
      var u = this.tagStack[this.tagStack.length - 1], c = u.children[u.children.length - 1];
      this.options.withStartIndices && (l.startIndex = this.parser.startIndex), this.options.withEndIndices && (l.endIndex = this.parser.endIndex), u.children.push(l), c && (l.prev = c, c.next = l), l.parent = u, this.lastNode = null;
    }, s;
  }();
  t.DomHandler = o, t.default = o;
}(He);
var Cn = {}, We = {}, Jt = {}, Tl = {}, ut = {}, nr = {};
function Mn(t) {
  for (var e = 1; e < t.length; e++)
    t[e][0] += t[e - 1][0] + 1;
  return t;
}
Object.defineProperty(nr, "__esModule", { value: !0 }), nr.default = new Map(Mn([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(Mn([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(Mn([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(Mn([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var Qn = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.getCodePoint = t.xmlReplacer = void 0, t.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var e = /* @__PURE__ */ new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]);
  function n(r) {
    for (var i, o = "", s = 0; (i = t.xmlReplacer.exec(r)) !== null; ) {
      var l = i.index, u = r.charCodeAt(l), c = e.get(u);
      c !== void 0 ? (o += r.substring(s, l) + c, s = l + 1) : (o += "".concat(r.substring(s, l), "&#x").concat((0, t.getCodePoint)(r, l).toString(16), ";"), s = t.xmlReplacer.lastIndex += +((64512 & u) == 55296));
    }
    return o + r.substr(s);
  }
  function a(r, i) {
    return function(o) {
      for (var s, l = 0, u = ""; s = r.exec(o); )
        l !== s.index && (u += o.substring(l, s.index)), u += i.get(s[0].charCodeAt(0)), l = s.index + 1;
      return u + o.substring(l);
    };
  }
  t.getCodePoint = String.prototype.codePointAt != null ? function(r, i) {
    return r.codePointAt(i);
  } : function(r, i) {
    return (64512 & r.charCodeAt(i)) == 55296 ? 1024 * (r.charCodeAt(i) - 55296) + r.charCodeAt(i + 1) - 56320 + 65536 : r.charCodeAt(i);
  }, t.encodeXML = n, t.escape = n, t.escapeUTF8 = a(/[&<>'"]/g, e), t.escapeAttribute = a(/["&\u00A0]/g, /* @__PURE__ */ new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]])), t.escapeText = a(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));
})(Qn);
var gp = Y && Y.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(ut, "__esModule", { value: !0 }), ut.encodeNonAsciiHTML = ut.encodeHTML = void 0;
var fp = gp(nr), El = Qn, yp = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function Do(t, e) {
  for (var n, a = "", r = 0; (n = t.exec(e)) !== null; ) {
    var i = n.index;
    a += e.substring(r, i);
    var o = e.charCodeAt(i), s = fp.default.get(o);
    if (typeof s == "object") {
      if (i + 1 < e.length) {
        var l = e.charCodeAt(i + 1), u = typeof s.n == "number" ? s.n === l ? s.o : void 0 : s.n.get(l);
        if (u !== void 0) {
          a += u, r = t.lastIndex += 1;
          continue;
        }
      }
      s = s.v;
    }
    if (s !== void 0)
      a += s, r = i + 1;
    else {
      var c = (0, El.getCodePoint)(e, i);
      a += "&#x".concat(c.toString(16), ";"), r = t.lastIndex += +(c !== o);
    }
  }
  return a + e.substr(r);
}
ut.encodeHTML = function(t) {
  return Do(yp, t);
}, ut.encodeNonAsciiHTML = function(t) {
  return Do(El.xmlReplacer, t);
}, function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeXMLStrict = t.decodeHTML5Strict = t.decodeHTML4Strict = t.decodeHTML5 = t.decodeHTML4 = t.decodeHTMLAttribute = t.decodeHTMLStrict = t.decodeHTML = t.decodeXML = t.DecodingMode = t.EntityDecoder = t.encodeHTML5 = t.encodeHTML4 = t.encodeNonAsciiHTML = t.encodeHTML = t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.encode = t.decodeStrict = t.decode = t.EncodingMode = t.EntityLevel = void 0;
  var e, n, a = Wt, r = ut, i = Qn;
  function o(c, d) {
    if (d === void 0 && (d = e.XML), (typeof d == "number" ? d : d.level) === e.HTML) {
      var p = typeof d == "object" ? d.mode : void 0;
      return (0, a.decodeHTML)(c, p);
    }
    return (0, a.decodeXML)(c);
  }
  (function(c) {
    c[c.XML = 0] = "XML", c[c.HTML = 1] = "HTML";
  })(e = t.EntityLevel || (t.EntityLevel = {})), function(c) {
    c[c.UTF8 = 0] = "UTF8", c[c.ASCII = 1] = "ASCII", c[c.Extensive = 2] = "Extensive", c[c.Attribute = 3] = "Attribute", c[c.Text = 4] = "Text";
  }(n = t.EncodingMode || (t.EncodingMode = {})), t.decode = o, t.decodeStrict = function(c, d) {
    var p;
    d === void 0 && (d = e.XML);
    var g = typeof d == "number" ? { level: d } : d;
    return (p = g.mode) !== null && p !== void 0 || (g.mode = a.DecodingMode.Strict), o(c, g);
  }, t.encode = function(c, d) {
    d === void 0 && (d = e.XML);
    var p = typeof d == "number" ? { level: d } : d;
    return p.mode === n.UTF8 ? (0, i.escapeUTF8)(c) : p.mode === n.Attribute ? (0, i.escapeAttribute)(c) : p.mode === n.Text ? (0, i.escapeText)(c) : p.level === e.HTML ? p.mode === n.ASCII ? (0, r.encodeNonAsciiHTML)(c) : (0, r.encodeHTML)(c) : (0, i.encodeXML)(c);
  };
  var s = Qn;
  Object.defineProperty(t, "encodeXML", { enumerable: !0, get: function() {
    return s.encodeXML;
  } }), Object.defineProperty(t, "escape", { enumerable: !0, get: function() {
    return s.escape;
  } }), Object.defineProperty(t, "escapeUTF8", { enumerable: !0, get: function() {
    return s.escapeUTF8;
  } }), Object.defineProperty(t, "escapeAttribute", { enumerable: !0, get: function() {
    return s.escapeAttribute;
  } }), Object.defineProperty(t, "escapeText", { enumerable: !0, get: function() {
    return s.escapeText;
  } });
  var l = ut;
  Object.defineProperty(t, "encodeHTML", { enumerable: !0, get: function() {
    return l.encodeHTML;
  } }), Object.defineProperty(t, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return l.encodeNonAsciiHTML;
  } }), Object.defineProperty(t, "encodeHTML4", { enumerable: !0, get: function() {
    return l.encodeHTML;
  } }), Object.defineProperty(t, "encodeHTML5", { enumerable: !0, get: function() {
    return l.encodeHTML;
  } });
  var u = Wt;
  Object.defineProperty(t, "EntityDecoder", { enumerable: !0, get: function() {
    return u.EntityDecoder;
  } }), Object.defineProperty(t, "DecodingMode", { enumerable: !0, get: function() {
    return u.DecodingMode;
  } }), Object.defineProperty(t, "decodeXML", { enumerable: !0, get: function() {
    return u.decodeXML;
  } }), Object.defineProperty(t, "decodeHTML", { enumerable: !0, get: function() {
    return u.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return u.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return u.decodeHTMLAttribute;
  } }), Object.defineProperty(t, "decodeHTML4", { enumerable: !0, get: function() {
    return u.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTML5", { enumerable: !0, get: function() {
    return u.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return u.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return u.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeXMLStrict", { enumerable: !0, get: function() {
    return u.decodeXML;
  } });
}(Tl);
var vt = {};
Object.defineProperty(vt, "__esModule", { value: !0 }), vt.attributeNames = vt.elementNames = void 0, vt.elementNames = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(function(t) {
  return [t.toLowerCase(), t];
})), vt.attributeNames = new Map(["definitionURL", "attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map(function(t) {
  return [t.toLowerCase(), t];
}));
var Ct = Y && Y.__assign || function() {
  return Ct = Object.assign || function(t) {
    for (var e, n = 1, a = arguments.length; n < a; n++)
      for (var r in e = arguments[n])
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    return t;
  }, Ct.apply(this, arguments);
}, bp = Y && Y.__createBinding || (Object.create ? function(t, e, n, a) {
  a === void 0 && (a = n);
  var r = Object.getOwnPropertyDescriptor(e, n);
  r && !("get" in r ? !e.__esModule : r.writable || r.configurable) || (r = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, a, r);
} : function(t, e, n, a) {
  a === void 0 && (a = n), t[a] = e[n];
}), vp = Y && Y.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), Sp = Y && Y.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n in t)
      n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && bp(e, t, n);
  return vp(e, t), e;
};
Object.defineProperty(Jt, "__esModule", { value: !0 }), Jt.render = void 0;
var Ie = Sp(kt), Dn = Tl, No = vt, Cp = /* @__PURE__ */ new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);
function Mp(t) {
  return t.replace(/"/g, "&quot;");
}
var To = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
function Xn(t, e) {
  e === void 0 && (e = {});
  for (var n = ("length" in t) ? t : [t], a = "", r = 0; r < n.length; r++)
    a += Dp(n[r], e);
  return a;
}
function Dp(t, e) {
  switch (t.type) {
    case Ie.Root:
      return Xn(t.children, e);
    case Ie.Doctype:
    case Ie.Directive:
      return "<".concat(t.data, ">");
    case Ie.Comment:
      return function(n) {
        return "<!--".concat(n.data, "-->");
      }(t);
    case Ie.CDATA:
      return function(n) {
        return "<![CDATA[".concat(n.children[0].data, "]]>");
      }(t);
    case Ie.Script:
    case Ie.Style:
    case Ie.Tag:
      return function(n, a) {
        var r;
        a.xmlMode === "foreign" && (n.name = (r = No.elementNames.get(n.name)) !== null && r !== void 0 ? r : n.name, n.parent && Np.has(n.parent.name) && (a = Ct(Ct({}, a), { xmlMode: !1 }))), !a.xmlMode && Tp.has(n.name) && (a = Ct(Ct({}, a), { xmlMode: "foreign" }));
        var i = "<".concat(n.name), o = function(s, l) {
          var u;
          if (s) {
            var c = ((u = l.encodeEntities) !== null && u !== void 0 ? u : l.decodeEntities) === !1 ? Mp : l.xmlMode || l.encodeEntities !== "utf8" ? Dn.encodeXML : Dn.escapeAttribute;
            return Object.keys(s).map(function(d) {
              var p, g, f = (p = s[d]) !== null && p !== void 0 ? p : "";
              return l.xmlMode === "foreign" && (d = (g = No.attributeNames.get(d)) !== null && g !== void 0 ? g : d), l.emptyAttrs || l.xmlMode || f !== "" ? "".concat(d, '="').concat(c(f), '"') : d;
            }).join(" ");
          }
        }(n.attribs, a);
        return o && (i += " ".concat(o)), n.children.length === 0 && (a.xmlMode ? a.selfClosingTags !== !1 : a.selfClosingTags && To.has(n.name)) ? (a.xmlMode || (i += " "), i += "/>") : (i += ">", n.children.length > 0 && (i += Xn(n.children, a)), !a.xmlMode && To.has(n.name) || (i += "</".concat(n.name, ">"))), i;
      }(t, e);
    case Ie.Text:
      return function(n, a) {
        var r, i = n.data || "";
        return ((r = a.encodeEntities) !== null && r !== void 0 ? r : a.decodeEntities) === !1 || !a.xmlMode && n.parent && Cp.has(n.parent.name) || (i = a.xmlMode || a.encodeEntities !== "utf8" ? (0, Dn.encodeXML)(i) : (0, Dn.escapeText)(i)), i;
      }(t, e);
  }
}
Jt.render = Xn, Jt.default = Xn;
var Np = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]), Tp = /* @__PURE__ */ new Set(["svg", "math"]), Ep = Y && Y.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(We, "__esModule", { value: !0 }), We.getOuterHTML = Eo, We.getInnerHTML = function(t, e) {
  return (0, we.hasChildren)(t) ? t.children.map(function(n) {
    return Eo(n, e);
  }).join("") : "";
}, We.getText = function t(e) {
  return Array.isArray(e) ? e.map(t).join("") : (0, we.isTag)(e) ? e.name === "br" ? `
` : t(e.children) : (0, we.isCDATA)(e) ? t(e.children) : (0, we.isText)(e) ? e.data : "";
}, We.textContent = function t(e) {
  return Array.isArray(e) ? e.map(t).join("") : (0, we.hasChildren)(e) && !(0, we.isComment)(e) ? t(e.children) : (0, we.isText)(e) ? e.data : "";
}, We.innerText = function t(e) {
  return Array.isArray(e) ? e.map(t).join("") : (0, we.hasChildren)(e) && (e.type === _p.ElementType.Tag || (0, we.isCDATA)(e)) ? t(e.children) : (0, we.isText)(e) ? e.data : "";
};
var we = He, wp = Ep(Jt), _p = kt;
function Eo(t, e) {
  return (0, wp.default)(t, e);
}
var xe = {};
Object.defineProperty(xe, "__esModule", { value: !0 }), xe.getChildren = wo, xe.getParent = _o, xe.getSiblings = function(t) {
  var e = _o(t);
  if (e != null)
    return wo(e);
  for (var n = [t], a = t.prev, r = t.next; a != null; )
    n.unshift(a), a = a.prev;
  for (; r != null; )
    n.push(r), r = r.next;
  return n;
}, xe.getAttributeValue = function(t, e) {
  var n;
  return (n = t.attribs) === null || n === void 0 ? void 0 : n[e];
}, xe.hasAttrib = function(t, e) {
  return t.attribs != null && Object.prototype.hasOwnProperty.call(t.attribs, e) && t.attribs[e] != null;
}, xe.getName = function(t) {
  return t.name;
}, xe.nextElementSibling = function(t) {
  for (var e = t.next; e !== null && !(0, ar.isTag)(e); )
    e = e.next;
  return e;
}, xe.prevElementSibling = function(t) {
  for (var e = t.prev; e !== null && !(0, ar.isTag)(e); )
    e = e.prev;
  return e;
};
var ar = He;
function wo(t) {
  return (0, ar.hasChildren)(t) ? t.children : [];
}
function _o(t) {
  return t.parent || null;
}
var Ke = {};
function Pt(t) {
  if (t.prev && (t.prev.next = t.next), t.next && (t.next.prev = t.prev), t.parent) {
    var e = t.parent.children, n = e.lastIndexOf(t);
    n >= 0 && e.splice(n, 1);
  }
  t.next = null, t.prev = null, t.parent = null;
}
Object.defineProperty(Ke, "__esModule", { value: !0 }), Ke.removeElement = Pt, Ke.replaceElement = function(t, e) {
  var n = e.prev = t.prev;
  n && (n.next = e);
  var a = e.next = t.next;
  a && (a.prev = e);
  var r = e.parent = t.parent;
  if (r) {
    var i = r.children;
    i[i.lastIndexOf(t)] = e, t.parent = null;
  }
}, Ke.appendChild = function(t, e) {
  if (Pt(e), e.next = null, e.parent = t, t.children.push(e) > 1) {
    var n = t.children[t.children.length - 2];
    n.next = e, e.prev = n;
  } else
    e.prev = null;
}, Ke.append = function(t, e) {
  Pt(e);
  var n = t.parent, a = t.next;
  if (e.next = a, e.prev = t, t.next = e, e.parent = n, a) {
    if (a.prev = e, n) {
      var r = n.children;
      r.splice(r.lastIndexOf(a), 0, e);
    }
  } else
    n && n.children.push(e);
}, Ke.prependChild = function(t, e) {
  if (Pt(e), e.parent = t, e.prev = null, t.children.unshift(e) !== 1) {
    var n = t.children[1];
    n.prev = e, e.next = n;
  } else
    e.next = null;
}, Ke.prepend = function(t, e) {
  Pt(e);
  var n = t.parent;
  if (n) {
    var a = n.children;
    a.splice(a.indexOf(t), 0, e);
  }
  t.prev && (t.prev.next = e), e.parent = n, e.prev = t.prev, e.next = t, t.prev = e;
};
var Re = {};
Object.defineProperty(Re, "__esModule", { value: !0 }), Re.filter = function(t, e, n, a) {
  return n === void 0 && (n = !0), a === void 0 && (a = 1 / 0), xo(t, Array.isArray(e) ? e : [e], n, a);
}, Re.find = xo, Re.findOneChild = function(t, e) {
  return e.find(t);
}, Re.findOne = function t(e, n, a) {
  a === void 0 && (a = !0);
  for (var r = Array.isArray(n) ? n : [n], i = 0; i < r.length; i++) {
    var o = r[i];
    if ((0, it.isTag)(o) && e(o))
      return o;
    if (a && (0, it.hasChildren)(o) && o.children.length > 0) {
      var s = t(e, o.children, !0);
      if (s)
        return s;
    }
  }
  return null;
}, Re.existsOne = function t(e, n) {
  return (Array.isArray(n) ? n : [n]).some(function(a) {
    return (0, it.isTag)(a) && e(a) || (0, it.hasChildren)(a) && t(e, a.children);
  });
}, Re.findAll = function(t, e) {
  for (var n = [], a = [Array.isArray(e) ? e : [e]], r = [0]; ; )
    if (r[0] >= a[0].length) {
      if (a.length === 1)
        return n;
      a.shift(), r.shift();
    } else {
      var i = a[0][r[0]++];
      (0, it.isTag)(i) && t(i) && n.push(i), (0, it.hasChildren)(i) && i.children.length > 0 && (r.unshift(0), a.unshift(i.children));
    }
};
var it = He;
function xo(t, e, n, a) {
  for (var r = [], i = [Array.isArray(e) ? e : [e]], o = [0]; ; )
    if (o[0] >= i[0].length) {
      if (o.length === 1)
        return r;
      i.shift(), o.shift();
    } else {
      var s = i[0][o[0]++];
      if (t(s) && (r.push(s), --a <= 0))
        return r;
      n && (0, it.hasChildren)(s) && s.children.length > 0 && (o.unshift(0), i.unshift(s.children));
    }
}
var Fe = {};
Object.defineProperty(Fe, "__esModule", { value: !0 }), Fe.testElement = function(t, e) {
  var n = ko(t);
  return !n || n(e);
}, Fe.getElements = function(t, e, n, a) {
  a === void 0 && (a = 1 / 0);
  var r = ko(t);
  return r ? (0, Ot.filter)(r, e, n, a) : [];
}, Fe.getElementById = function(t, e, n) {
  return n === void 0 && (n = !0), Array.isArray(e) || (e = [e]), (0, Ot.findOne)(rr("id", t), e, n);
}, Fe.getElementsByTagName = function(t, e, n, a) {
  return n === void 0 && (n = !0), a === void 0 && (a = 1 / 0), (0, Ot.filter)(ea.tag_name(t), e, n, a);
}, Fe.getElementsByClassName = function(t, e, n, a) {
  return n === void 0 && (n = !0), a === void 0 && (a = 1 / 0), (0, Ot.filter)(rr("class", t), e, n, a);
}, Fe.getElementsByTagType = function(t, e, n, a) {
  return n === void 0 && (n = !0), a === void 0 && (a = 1 / 0), (0, Ot.filter)(ea.tag_type(t), e, n, a);
};
var lt = He, Ot = Re, ea = { tag_name: function(t) {
  return typeof t == "function" ? function(e) {
    return (0, lt.isTag)(e) && t(e.name);
  } : t === "*" ? lt.isTag : function(e) {
    return (0, lt.isTag)(e) && e.name === t;
  };
}, tag_type: function(t) {
  return typeof t == "function" ? function(e) {
    return t(e.type);
  } : function(e) {
    return e.type === t;
  };
}, tag_contains: function(t) {
  return typeof t == "function" ? function(e) {
    return (0, lt.isText)(e) && t(e.data);
  } : function(e) {
    return (0, lt.isText)(e) && e.data === t;
  };
} };
function rr(t, e) {
  return typeof e == "function" ? function(n) {
    return (0, lt.isTag)(n) && e(n.attribs[t]);
  } : function(n) {
    return (0, lt.isTag)(n) && n.attribs[t] === e;
  };
}
function xp(t, e) {
  return function(n) {
    return t(n) || e(n);
  };
}
function ko(t) {
  var e = Object.keys(t).map(function(n) {
    var a = t[n];
    return Object.prototype.hasOwnProperty.call(ea, n) ? ea[n](a) : rr(n, a);
  });
  return e.length === 0 ? null : e.reduce(xp);
}
var ct = {};
Object.defineProperty(ct, "__esModule", { value: !0 }), ct.DocumentPosition = void 0, ct.removeSubsets = function(t) {
  for (var e = t.length; --e >= 0; ) {
    var n = t[e];
    if (e > 0 && t.lastIndexOf(n, e - 1) >= 0)
      t.splice(e, 1);
    else
      for (var a = n.parent; a; a = a.parent)
        if (t.includes(a)) {
          t.splice(e, 1);
          break;
        }
  }
  return t;
}, ct.compareDocumentPosition = Lo, ct.uniqueSort = function(t) {
  return t = t.filter(function(e, n, a) {
    return !a.includes(e, n + 1);
  }), t.sort(function(e, n) {
    var a = Lo(e, n);
    return a & Ne.PRECEDING ? -1 : a & Ne.FOLLOWING ? 1 : 0;
  }), t;
};
var Ne, Ao = He;
function Lo(t, e) {
  var n = [], a = [];
  if (t === e)
    return 0;
  for (var r = (0, Ao.hasChildren)(t) ? t : t.parent; r; )
    n.unshift(r), r = r.parent;
  for (r = (0, Ao.hasChildren)(e) ? e : e.parent; r; )
    a.unshift(r), r = r.parent;
  for (var i = Math.min(n.length, a.length), o = 0; o < i && n[o] === a[o]; )
    o++;
  if (o === 0)
    return Ne.DISCONNECTED;
  var s = n[o - 1], l = s.children, u = n[o], c = a[o];
  return l.indexOf(u) > l.indexOf(c) ? s === e ? Ne.FOLLOWING | Ne.CONTAINED_BY : Ne.FOLLOWING : s === t ? Ne.PRECEDING | Ne.CONTAINS : Ne.PRECEDING;
}
(function(t) {
  t[t.DISCONNECTED = 1] = "DISCONNECTED", t[t.PRECEDING = 2] = "PRECEDING", t[t.FOLLOWING = 4] = "FOLLOWING", t[t.CONTAINS = 8] = "CONTAINS", t[t.CONTAINED_BY = 16] = "CONTAINED_BY";
})(Ne || (ct.DocumentPosition = Ne = {}));
var ir = {};
Object.defineProperty(ir, "__esModule", { value: !0 }), ir.getFeed = function(t) {
  var e = Nn(Ip, t);
  return e ? e.name === "feed" ? function(n) {
    var a, r = n.children, i = { type: "atom", items: (0, Qt.getElementsByTagName)("entry", r).map(function(l) {
      var u, c = l.children, d = { media: Io(c) };
      ge(d, "id", "id", c), ge(d, "title", "title", c);
      var p = (u = Nn("link", c)) === null || u === void 0 ? void 0 : u.attribs.href;
      p && (d.link = p);
      var g = Ze("summary", c) || Ze("content", c);
      g && (d.description = g);
      var f = Ze("updated", c);
      return f && (d.pubDate = new Date(f)), d;
    }) };
    ge(i, "id", "id", r), ge(i, "title", "title", r);
    var o = (a = Nn("link", r)) === null || a === void 0 ? void 0 : a.attribs.href;
    o && (i.link = o), ge(i, "description", "subtitle", r);
    var s = Ze("updated", r);
    return s && (i.updated = new Date(s)), ge(i, "author", "email", r, !0), i;
  }(e) : function(n) {
    var a, r, i = (r = (a = Nn("channel", n.children)) === null || a === void 0 ? void 0 : a.children) !== null && r !== void 0 ? r : [], o = { type: n.name.substr(0, 3), id: "", items: (0, Qt.getElementsByTagName)("item", n.children).map(function(l) {
      var u = l.children, c = { media: Io(u) };
      ge(c, "id", "guid", u), ge(c, "title", "title", u), ge(c, "link", "link", u), ge(c, "description", "description", u);
      var d = Ze("pubDate", u) || Ze("dc:date", u);
      return d && (c.pubDate = new Date(d)), c;
    }) };
    ge(o, "title", "title", i), ge(o, "link", "link", i), ge(o, "description", "description", i);
    var s = Ze("lastBuildDate", i);
    return s && (o.updated = new Date(s)), ge(o, "author", "managingEditor", i, !0), o;
  }(e) : null;
};
var kp = We, Qt = Fe, Ap = ["url", "type", "lang"], Lp = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
function Io(t) {
  return (0, Qt.getElementsByTagName)("media:content", t).map(function(e) {
    for (var n = e.attribs, a = { medium: n.medium, isDefault: !!n.isDefault }, r = 0, i = Ap; r < i.length; r++)
      n[l = i[r]] && (a[l] = n[l]);
    for (var o = 0, s = Lp; o < s.length; o++) {
      var l;
      n[l = s[o]] && (a[l] = parseInt(n[l], 10));
    }
    return n.expression && (a.expression = n.expression), a;
  });
}
function Nn(t, e) {
  return (0, Qt.getElementsByTagName)(t, e, !0, 1)[0];
}
function Ze(t, e, n) {
  return n === void 0 && (n = !1), (0, kp.textContent)((0, Qt.getElementsByTagName)(t, e, n, 1)).trim();
}
function ge(t, e, n, a, r) {
  r === void 0 && (r = !1);
  var i = Ze(n, a, r);
  i && (t[e] = i);
}
function Ip(t) {
  return t === "rss" || t === "feed" || t === "rdf:RDF";
}
(function(t) {
  var e = Y && Y.__createBinding || (Object.create ? function(r, i, o, s) {
    s === void 0 && (s = o);
    var l = Object.getOwnPropertyDescriptor(i, o);
    l && !("get" in l ? !i.__esModule : l.writable || l.configurable) || (l = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, s, l);
  } : function(r, i, o, s) {
    s === void 0 && (s = o), r[s] = i[o];
  }), n = Y && Y.__exportStar || function(r, i) {
    for (var o in r)
      o === "default" || Object.prototype.hasOwnProperty.call(i, o) || e(i, r, o);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.hasChildren = t.isDocument = t.isComment = t.isText = t.isCDATA = t.isTag = void 0, n(We, t), n(xe, t), n(Ke, t), n(Re, t), n(Fe, t), n(ct, t), n(ir, t);
  var a = He;
  Object.defineProperty(t, "isTag", { enumerable: !0, get: function() {
    return a.isTag;
  } }), Object.defineProperty(t, "isCDATA", { enumerable: !0, get: function() {
    return a.isCDATA;
  } }), Object.defineProperty(t, "isText", { enumerable: !0, get: function() {
    return a.isText;
  } }), Object.defineProperty(t, "isComment", { enumerable: !0, get: function() {
    return a.isComment;
  } }), Object.defineProperty(t, "isDocument", { enumerable: !0, get: function() {
    return a.isDocument;
  } }), Object.defineProperty(t, "hasChildren", { enumerable: !0, get: function() {
    return a.hasChildren;
  } });
})(Cn), function(t) {
  var e = Y && Y.__createBinding || (Object.create ? function(h, D, L, _) {
    _ === void 0 && (_ = L);
    var x = Object.getOwnPropertyDescriptor(D, L);
    x && !("get" in x ? !D.__esModule : x.writable || x.configurable) || (x = { enumerable: !0, get: function() {
      return D[L];
    } }), Object.defineProperty(h, _, x);
  } : function(h, D, L, _) {
    _ === void 0 && (_ = L), h[_] = D[L];
  }), n = Y && Y.__setModuleDefault || (Object.create ? function(h, D) {
    Object.defineProperty(h, "default", { enumerable: !0, value: D });
  } : function(h, D) {
    h.default = D;
  }), a = Y && Y.__importStar || function(h) {
    if (h && h.__esModule)
      return h;
    var D = {};
    if (h != null)
      for (var L in h)
        L !== "default" && Object.prototype.hasOwnProperty.call(h, L) && e(D, h, L);
    return n(D, h), D;
  }, r = Y && Y.__importDefault || function(h) {
    return h && h.__esModule ? h : { default: h };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DomUtils = t.parseFeed = t.getFeed = t.ElementType = t.Tokenizer = t.createDomStream = t.parseDOM = t.parseDocument = t.DefaultHandler = t.DomHandler = t.Parser = void 0;
  var i = Zt, o = Zt;
  Object.defineProperty(t, "Parser", { enumerable: !0, get: function() {
    return o.Parser;
  } });
  var s = He, l = He;
  function u(h, D) {
    var L = new s.DomHandler(void 0, D);
    return new i.Parser(L, D).end(h), L.root;
  }
  function c(h, D) {
    return u(h, D).children;
  }
  Object.defineProperty(t, "DomHandler", { enumerable: !0, get: function() {
    return l.DomHandler;
  } }), Object.defineProperty(t, "DefaultHandler", { enumerable: !0, get: function() {
    return l.DomHandler;
  } }), t.parseDocument = u, t.parseDOM = c, t.createDomStream = function(h, D, L) {
    var _ = new s.DomHandler(h, D, L);
    return new i.Parser(_, D);
  };
  var d = Qr;
  Object.defineProperty(t, "Tokenizer", { enumerable: !0, get: function() {
    return r(d).default;
  } }), t.ElementType = a(kt);
  var p = Cn, g = Cn;
  Object.defineProperty(t, "getFeed", { enumerable: !0, get: function() {
    return g.getFeed;
  } });
  var f = { xmlMode: !0 };
  t.parseFeed = function(h, D) {
    return D === void 0 && (D = f), (0, p.getFeed)(c(h, D));
  }, t.DomUtils = a(Cn);
}(pl);
var or = {};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function Po(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
Object.defineProperty(or, "__esModule", { value: !0 }), or.isPlainObject = function(t) {
  var e, n;
  return Po(t) !== !1 && ((e = t.constructor) === void 0 || Po(n = e.prototype) !== !1 && n.hasOwnProperty("isPrototypeOf") !== !1);
};
var Pp = function(t) {
  return function(e) {
    return !!e && typeof e == "object";
  }(t) && !function(e) {
    var n = Object.prototype.toString.call(e);
    return n === "[object RegExp]" || n === "[object Date]" || function(a) {
      return a.$$typeof === Op;
    }(e);
  }(t);
}, Op = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
function Xt(t, e) {
  return e.clone !== !1 && e.isMergeableObject(t) ? wt((n = t, Array.isArray(n) ? [] : {}), t, e) : t;
  var n;
}
function Rp(t, e, n) {
  return t.concat(e).map(function(a) {
    return Xt(a, n);
  });
}
function Oo(t) {
  return Object.keys(t).concat(function(e) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(n) {
      return Object.propertyIsEnumerable.call(e, n);
    }) : [];
  }(t));
}
function Ro(t, e) {
  try {
    return e in t;
  } catch {
    return !1;
  }
}
function Fp(t, e, n) {
  var a = {};
  return n.isMergeableObject(t) && Oo(t).forEach(function(r) {
    a[r] = Xt(t[r], n);
  }), Oo(e).forEach(function(r) {
    (function(i, o) {
      return Ro(i, o) && !(Object.hasOwnProperty.call(i, o) && Object.propertyIsEnumerable.call(i, o));
    })(t, r) || (Ro(t, r) && n.isMergeableObject(e[r]) ? a[r] = function(i, o) {
      if (!o.customMerge)
        return wt;
      var s = o.customMerge(i);
      return typeof s == "function" ? s : wt;
    }(r, n)(t[r], e[r], n) : a[r] = Xt(e[r], n));
  }), a;
}
function wt(t, e, n) {
  (n = n || {}).arrayMerge = n.arrayMerge || Rp, n.isMergeableObject = n.isMergeableObject || Pp, n.cloneUnlessOtherwiseSpecified = Xt;
  var a = Array.isArray(e);
  return a === Array.isArray(t) ? a ? n.arrayMerge(t, e, n) : Fp(t, e, n) : Xt(e, n);
}
wt.all = function(t, e) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(n, a) {
    return wt(n, a, e);
  }, {});
};
var jp = wt, wl = { exports: {} };
(function(t) {
  (function(e, n) {
    t.exports ? t.exports = n() : e.parseSrcset = n();
  })(Y, function() {
    return function(e) {
      function n(T) {
        return T === " " || T === "	" || T === `
` || T === "\f" || T === "\r";
      }
      function a(T) {
        var b, S = T.exec(e.substring(D));
        if (S)
          return b = S[0], D += b.length, b;
      }
      for (var r, i, o, s, l, u = e.length, c = /^[ \t\n\r\u000c]+/, d = /^[, \t\n\r\u000c]+/, p = /^[^ \t\n\r\u000c]+/, g = /[,]+$/, f = /^\d+$/, h = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, D = 0, L = []; ; ) {
        if (a(d), D >= u)
          return L;
        r = a(p), i = [], r.slice(-1) === "," ? (r = r.replace(g, ""), x()) : _();
      }
      function _() {
        for (a(c), o = "", s = "in descriptor"; ; ) {
          if (l = e.charAt(D), s === "in descriptor")
            if (n(l))
              o && (i.push(o), o = "", s = "after descriptor");
            else {
              if (l === ",")
                return D += 1, o && i.push(o), void x();
              if (l === "(")
                o += l, s = "in parens";
              else {
                if (l === "")
                  return o && i.push(o), void x();
                o += l;
              }
            }
          else if (s === "in parens")
            if (l === ")")
              o += l, s = "in descriptor";
            else {
              if (l === "")
                return i.push(o), void x();
              o += l;
            }
          else if (s === "after descriptor" && !n(l)) {
            if (l === "")
              return void x();
            s = "in descriptor", D -= 1;
          }
          D += 1;
        }
      }
      function x() {
        var T, b, S, w, E, k, O, $, v, y = !1, m = {};
        for (w = 0; w < i.length; w++)
          k = (E = i[w])[E.length - 1], O = E.substring(0, E.length - 1), $ = parseInt(O, 10), v = parseFloat(O), f.test(O) && k === "w" ? ((T || b) && (y = !0), $ === 0 ? y = !0 : T = $) : h.test(O) && k === "x" ? ((T || b || S) && (y = !0), v < 0 ? y = !0 : b = v) : f.test(O) && k === "h" ? ((S || b) && (y = !0), $ === 0 ? y = !0 : S = $) : y = !0;
        y ? console && console.log && console.log("Invalid srcset descriptor found in '" + e + "' at '" + E + "'.") : (m.url = r, T && (m.w = T), b && (m.d = b), S && (m.h = S), L.push(m));
      }
    };
  });
})(wl);
var Bp = wl.exports, sr = { exports: {} }, z = String, Fo = function() {
  return { isColorSupported: !1, reset: z, bold: z, dim: z, italic: z, underline: z, inverse: z, hidden: z, strikethrough: z, black: z, red: z, green: z, yellow: z, blue: z, magenta: z, cyan: z, white: z, gray: z, bgBlack: z, bgRed: z, bgGreen: z, bgYellow: z, bgBlue: z, bgMagenta: z, bgCyan: z, bgWhite: z, blackBright: z, redBright: z, greenBright: z, yellowBright: z, blueBright: z, magentaBright: z, cyanBright: z, whiteBright: z, bgBlackBright: z, bgRedBright: z, bgGreenBright: z, bgYellowBright: z, bgBlueBright: z, bgMagentaBright: z, bgCyanBright: z, bgWhiteBright: z };
};
sr.exports = Fo(), sr.exports.createColors = Fo;
var Gp = sr.exports;
const Ee = eu(Object.freeze(Object.defineProperty({ __proto__: null, default: {} }, Symbol.toStringTag, { value: "Module" })));
let jo = Gp, Bo = Ee, lr = class _l extends Error {
  constructor(e, n, a, r, i, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, i && (this.file = i), r && (this.source = r), o && (this.plugin = o), n !== void 0 && a !== void 0 && (typeof n == "number" ? (this.line = n, this.column = a) : (this.line = n.line, this.column = n.column, this.endLine = a.line, this.endColumn = a.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, _l);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", this.line !== void 0 && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source)
      return "";
    let n = this.source;
    e == null && (e = jo.isColorSupported);
    let a = (c) => c, r = (c) => c, i = (c) => c;
    if (e) {
      let { bold: c, gray: d, red: p } = jo.createColors(!0);
      r = (g) => c(p(g)), a = (g) => d(g), Bo && (i = (g) => Bo(g));
    }
    let o = n.split(/\r?\n/), s = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, o.length), u = String(l).length;
    return o.slice(s, l).map((c, d) => {
      let p = s + 1 + d, g = " " + (" " + p).slice(-u) + " | ";
      if (p === this.line) {
        if (c.length > 160) {
          let h = 20, D = Math.max(0, this.column - h), L = Math.max(this.column + h, this.endColumn + h), _ = c.slice(D, L), x = a(g.replace(/\d/g, " ")) + c.slice(0, Math.min(this.column - 1, h - 1)).replace(/[^\t]/g, " ");
          return r(">") + a(g) + i(_) + `
 ` + x + r("^");
        }
        let f = a(g.replace(/\d/g, " ")) + c.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return r(">") + a(g) + i(c) + `
 ` + f + r("^");
      }
      return " " + a(g) + i(c);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var ti = lr;
lr.default = lr;
const Go = { after: `
`, beforeClose: `
`, beforeComment: `
`, beforeDecl: `
`, beforeOpen: " ", beforeRule: `
`, colon: ": ", commentLeft: " ", commentRight: " ", emptyBody: "", indent: "    ", semicolon: !1 };
let cr = class {
  constructor(t) {
    this.builder = t;
  }
  atrule(t, e) {
    let n = "@" + t.name, a = t.params ? this.rawValue(t, "params") : "";
    if (t.raws.afterName !== void 0 ? n += t.raws.afterName : a && (n += " "), t.nodes)
      this.block(t, n + a);
    else {
      let r = (t.raws.between || "") + (e ? ";" : "");
      this.builder(n + a + r, t);
    }
  }
  beforeAfter(t, e) {
    let n;
    n = t.type === "decl" ? this.raw(t, null, "beforeDecl") : t.type === "comment" ? this.raw(t, null, "beforeComment") : e === "before" ? this.raw(t, null, "beforeRule") : this.raw(t, null, "beforeClose");
    let a = t.parent, r = 0;
    for (; a && a.type !== "root"; )
      r += 1, a = a.parent;
    if (n.includes(`
`)) {
      let i = this.raw(t, null, "indent");
      if (i.length)
        for (let o = 0; o < r; o++)
          n += i;
    }
    return n;
  }
  block(t, e) {
    let n, a = this.raw(t, "between", "beforeOpen");
    this.builder(e + a + "{", t, "start"), t.nodes && t.nodes.length ? (this.body(t), n = this.raw(t, "after")) : n = this.raw(t, "after", "emptyBody"), n && this.builder(n), this.builder("}", t, "end");
  }
  body(t) {
    let e = t.nodes.length - 1;
    for (; e > 0 && t.nodes[e].type === "comment"; )
      e -= 1;
    let n = this.raw(t, "semicolon");
    for (let a = 0; a < t.nodes.length; a++) {
      let r = t.nodes[a], i = this.raw(r, "before");
      i && this.builder(i), this.stringify(r, e !== a || n);
    }
  }
  comment(t) {
    let e = this.raw(t, "left", "commentLeft"), n = this.raw(t, "right", "commentRight");
    this.builder("/*" + e + t.text + n + "*/", t);
  }
  decl(t, e) {
    let n = this.raw(t, "between", "colon"), a = t.prop + n + this.rawValue(t, "value");
    t.important && (a += t.raws.important || " !important"), e && (a += ";"), this.builder(a, t);
  }
  document(t) {
    this.body(t);
  }
  raw(t, e, n) {
    let a;
    if (n || (n = e), e && (a = t.raws[e], a !== void 0))
      return a;
    let r = t.parent;
    if (n === "before" && (!r || r.type === "root" && r.first === t || r && r.type === "document"))
      return "";
    if (!r)
      return Go[n];
    let i = t.root();
    if (i.rawCache || (i.rawCache = {}), i.rawCache[n] !== void 0)
      return i.rawCache[n];
    if (n === "before" || n === "after")
      return this.beforeAfter(t, n);
    {
      let s = "raw" + ((o = n)[0].toUpperCase() + o.slice(1));
      this[s] ? a = this[s](i, t) : i.walk((l) => {
        if (a = l.raws[e], a !== void 0)
          return !1;
      });
    }
    var o;
    return a === void 0 && (a = Go[n]), i.rawCache[n] = a, a;
  }
  rawBeforeClose(t) {
    let e;
    return t.walk((n) => {
      if (n.nodes && n.nodes.length > 0 && n.raws.after !== void 0)
        return e = n.raws.after, e.includes(`
`) && (e = e.replace(/[^\n]+$/, "")), !1;
    }), e && (e = e.replace(/\S/g, "")), e;
  }
  rawBeforeComment(t, e) {
    let n;
    return t.walkComments((a) => {
      if (a.raws.before !== void 0)
        return n = a.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), n === void 0 ? n = this.raw(e, null, "beforeDecl") : n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeDecl(t, e) {
    let n;
    return t.walkDecls((a) => {
      if (a.raws.before !== void 0)
        return n = a.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), n === void 0 ? n = this.raw(e, null, "beforeRule") : n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeOpen(t) {
    let e;
    return t.walk((n) => {
      if (n.type !== "decl" && (e = n.raws.between, e !== void 0))
        return !1;
    }), e;
  }
  rawBeforeRule(t) {
    let e;
    return t.walk((n) => {
      if (n.nodes && (n.parent !== t || t.first !== n) && n.raws.before !== void 0)
        return e = n.raws.before, e.includes(`
`) && (e = e.replace(/[^\n]+$/, "")), !1;
    }), e && (e = e.replace(/\S/g, "")), e;
  }
  rawColon(t) {
    let e;
    return t.walkDecls((n) => {
      if (n.raws.between !== void 0)
        return e = n.raws.between.replace(/[^\s:]/g, ""), !1;
    }), e;
  }
  rawEmptyBody(t) {
    let e;
    return t.walk((n) => {
      if (n.nodes && n.nodes.length === 0 && (e = n.raws.after, e !== void 0))
        return !1;
    }), e;
  }
  rawIndent(t) {
    if (t.raws.indent)
      return t.raws.indent;
    let e;
    return t.walk((n) => {
      let a = n.parent;
      if (a && a !== t && a.parent && a.parent === t && n.raws.before !== void 0) {
        let r = n.raws.before.split(`
`);
        return e = r[r.length - 1], e = e.replace(/\S/g, ""), !1;
      }
    }), e;
  }
  rawSemicolon(t) {
    let e;
    return t.walk((n) => {
      if (n.nodes && n.nodes.length && n.last.type === "decl" && (e = n.raws.semicolon, e !== void 0))
        return !1;
    }), e;
  }
  rawValue(t, e) {
    let n = t[e], a = t.raws[e];
    return a && a.value === n ? a.raw : n;
  }
  root(t) {
    this.body(t), t.raws.after && this.builder(t.raws.after);
  }
  rule(t) {
    this.block(t, this.rawValue(t, "selector")), t.raws.ownSemicolon && this.builder(t.raws.ownSemicolon, t, "end");
  }
  stringify(t, e) {
    if (!this[t.type])
      throw new Error("Unknown AST node type " + t.type + ". Maybe you need to change PostCSS stringifier.");
    this[t.type](t, e);
  }
};
var xl = cr;
cr.default = cr;
let Yp = xl;
function ur(t, e) {
  new Yp(e).stringify(t);
}
var ha = ur;
ur.default = ur;
var en = {};
en.isClean = Symbol("isClean"), en.my = Symbol("my");
let Vp = ti, Hp = xl, Up = ha, { isClean: Rt, my: $p } = en;
function dr(t, e) {
  let n = new t.constructor();
  for (let a in t) {
    if (!Object.prototype.hasOwnProperty.call(t, a) || a === "proxyCache")
      continue;
    let r = t[a], i = typeof r;
    a === "parent" && i === "object" ? e && (n[a] = e) : a === "source" ? n[a] = r : Array.isArray(r) ? n[a] = r.map((o) => dr(o, n)) : (i === "object" && r !== null && (r = dr(r)), n[a] = r);
  }
  return n;
}
function Pe(t, e) {
  if (e && e.offset !== void 0)
    return e.offset;
  let n = 1, a = 1, r = 0;
  for (let i = 0; i < t.length; i++) {
    if (a === e.line && n === e.column) {
      r = i;
      break;
    }
    t[i] === `
` ? (n = 1, a += 1) : n += 1;
  }
  return r;
}
let pr = class {
  get proxyOf() {
    return this;
  }
  constructor(t = {}) {
    this.raws = {}, this[Rt] = !1, this[$p] = !0;
    for (let e in t)
      if (e === "nodes") {
        this.nodes = [];
        for (let n of t[e])
          typeof n.clone == "function" ? this.append(n.clone()) : this.append(n);
      } else
        this[e] = t[e];
  }
  addToError(t) {
    if (t.postcssNode = this, t.stack && this.source && /\n\s{4}at /.test(t.stack)) {
      let e = this.source;
      t.stack = t.stack.replace(/\n\s{4}at /, `$&${e.input.from}:${e.start.line}:${e.start.column}$&`);
    }
    return t;
  }
  after(t) {
    return this.parent.insertAfter(this, t), this;
  }
  assign(t = {}) {
    for (let e in t)
      this[e] = t[e];
    return this;
  }
  before(t) {
    return this.parent.insertBefore(this, t), this;
  }
  cleanRaws(t) {
    delete this.raws.before, delete this.raws.after, t || delete this.raws.between;
  }
  clone(t = {}) {
    let e = dr(this);
    for (let n in t)
      e[n] = t[n];
    return e;
  }
  cloneAfter(t = {}) {
    let e = this.clone(t);
    return this.parent.insertAfter(this, e), e;
  }
  cloneBefore(t = {}) {
    let e = this.clone(t);
    return this.parent.insertBefore(this, e), e;
  }
  error(t, e = {}) {
    if (this.source) {
      let { end: n, start: a } = this.rangeBy(e);
      return this.source.input.error(t, { column: a.column, line: a.line }, { column: n.column, line: n.line }, e);
    }
    return new Vp(t);
  }
  getProxyProcessor() {
    return { get: (t, e) => e === "proxyOf" ? t : e === "root" ? () => t.root().toProxy() : t[e], set: (t, e, n) => (t[e] === n || (t[e] = n, e !== "prop" && e !== "value" && e !== "name" && e !== "params" && e !== "important" && e !== "text" || t.markDirty()), !0) };
  }
  markClean() {
    this[Rt] = !0;
  }
  markDirty() {
    if (this[Rt]) {
      this[Rt] = !1;
      let t = this;
      for (; t = t.parent; )
        t[Rt] = !1;
    }
  }
  next() {
    if (!this.parent)
      return;
    let t = this.parent.index(this);
    return this.parent.nodes[t + 1];
  }
  positionBy(t = {}) {
    let e = this.source.start;
    if (t.index)
      e = this.positionInside(t.index);
    else if (t.word) {
      let n = "document" in this.source.input ? this.source.input.document : this.source.input.css, a = n.slice(Pe(n, this.source.start), Pe(n, this.source.end)).indexOf(t.word);
      a !== -1 && (e = this.positionInside(a));
    }
    return e;
  }
  positionInside(t) {
    let e = this.source.start.column, n = this.source.start.line, a = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = Pe(a, this.source.start), i = r + t;
    for (let o = r; o < i; o++)
      a[o] === `
` ? (e = 1, n += 1) : e += 1;
    return { column: e, line: n, offset: i };
  }
  prev() {
    if (!this.parent)
      return;
    let t = this.parent.index(this);
    return this.parent.nodes[t - 1];
  }
  rangeBy(t = {}) {
    let e = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = { column: this.source.start.column, line: this.source.start.line, offset: Pe(e, this.source.start) }, a = this.source.end ? { column: this.source.end.column + 1, line: this.source.end.line, offset: typeof this.source.end.offset == "number" ? this.source.end.offset : Pe(e, this.source.end) + 1 } : { column: n.column + 1, line: n.line, offset: n.offset + 1 };
    if (t.word) {
      let r = e.slice(Pe(e, this.source.start), Pe(e, this.source.end)).indexOf(t.word);
      r !== -1 && (n = this.positionInside(r), a = this.positionInside(r + t.word.length));
    } else
      t.start ? n = { column: t.start.column, line: t.start.line, offset: Pe(e, t.start) } : t.index && (n = this.positionInside(t.index)), t.end ? a = { column: t.end.column, line: t.end.line, offset: Pe(e, t.end) } : typeof t.endIndex == "number" ? a = this.positionInside(t.endIndex) : t.index && (a = this.positionInside(t.index + 1));
    return (a.line < n.line || a.line === n.line && a.column <= n.column) && (a = { column: n.column + 1, line: n.line, offset: n.offset + 1 }), { end: a, start: n };
  }
  raw(t, e) {
    return new Hp().raw(this, t, e);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...t) {
    if (this.parent) {
      let e = this, n = !1;
      for (let a of t)
        a === this ? n = !0 : n ? (this.parent.insertAfter(e, a), e = a) : this.parent.insertBefore(e, a);
      n || this.remove();
    }
    return this;
  }
  root() {
    let t = this;
    for (; t.parent && t.parent.type !== "document"; )
      t = t.parent;
    return t;
  }
  toJSON(t, e) {
    let n = {}, a = e == null;
    e = e || /* @__PURE__ */ new Map();
    let r = 0;
    for (let i in this) {
      if (!Object.prototype.hasOwnProperty.call(this, i) || i === "parent" || i === "proxyCache")
        continue;
      let o = this[i];
      if (Array.isArray(o))
        n[i] = o.map((s) => typeof s == "object" && s.toJSON ? s.toJSON(null, e) : s);
      else if (typeof o == "object" && o.toJSON)
        n[i] = o.toJSON(null, e);
      else if (i === "source") {
        if (o == null)
          continue;
        let s = e.get(o.input);
        s == null && (s = r, e.set(o.input, r), r++), n[i] = { end: o.end, inputId: s, start: o.start };
      } else
        n[i] = o;
    }
    return a && (n.inputs = [...e.keys()].map((i) => i.toJSON())), n;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(t = Up) {
    t.stringify && (t = t.stringify);
    let e = "";
    return t(this, (n) => {
      e += n;
    }), e;
  }
  warn(t, e, n = {}) {
    let a = { node: this };
    for (let r in n)
      a[r] = n[r];
    return t.warn(e, a);
  }
};
var ma = pr;
pr.default = pr;
let zp = ma, hr = class extends zp {
  constructor(t) {
    super(t), this.type = "comment";
  }
};
var ga = hr;
hr.default = hr;
let qp = ma, mr = class extends qp {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(t) {
    t && t.value !== void 0 && typeof t.value != "string" && (t = { ...t, value: String(t.value) }), super(t), this.type = "decl";
  }
};
var fa = mr;
mr.default = mr;
let ni, kl, Al, ai, Ll = ga, Il = fa, Kp = ma, { isClean: Pl, my: Ol } = en;
function Rl(t) {
  return t.map((e) => (e.nodes && (e.nodes = Rl(e.nodes)), delete e.source, e));
}
function Fl(t) {
  if (t[Pl] = !1, t.proxyOf.nodes)
    for (let e of t.proxyOf.nodes)
      Fl(e);
}
let Ge = class jl extends Kp {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let n of e) {
      let a = this.normalize(n, this.last);
      for (let r of a)
        this.proxyOf.nodes.push(r);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let n of this.nodes)
        n.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes)
      return;
    let n, a, r = this.getIterator();
    for (; this.indexes[r] < this.proxyOf.nodes.length && (n = this.indexes[r], a = e(this.proxyOf.nodes[n], n), a !== !1); )
      this.indexes[r] += 1;
    return delete this.indexes[r], a;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return { get: (e, n) => n === "proxyOf" ? e : e[n] ? n === "each" || typeof n == "string" && n.startsWith("walk") ? (...a) => e[n](...a.map((r) => typeof r == "function" ? (i, o) => r(i.toProxy(), o) : r)) : n === "every" || n === "some" ? (a) => e[n]((r, ...i) => a(r.toProxy(), ...i)) : n === "root" ? () => e.root().toProxy() : n === "nodes" ? e.nodes.map((a) => a.toProxy()) : n === "first" || n === "last" ? e[n].toProxy() : e[n] : e[n], set: (e, n, a) => (e[n] === a || (e[n] = a, n !== "name" && n !== "params" && n !== "selector" || e.markDirty()), !0) };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, n) {
    let a, r = this.index(e), i = this.normalize(n, this.proxyOf.nodes[r]).reverse();
    r = this.index(e);
    for (let o of i)
      this.proxyOf.nodes.splice(r + 1, 0, o);
    for (let o in this.indexes)
      a = this.indexes[o], r < a && (this.indexes[o] = a + i.length);
    return this.markDirty(), this;
  }
  insertBefore(e, n) {
    let a, r = this.index(e), i = r === 0 && "prepend", o = this.normalize(n, this.proxyOf.nodes[r], i).reverse();
    r = this.index(e);
    for (let s of o)
      this.proxyOf.nodes.splice(r, 0, s);
    for (let s in this.indexes)
      a = this.indexes[s], r <= a && (this.indexes[s] = a + o.length);
    return this.markDirty(), this;
  }
  normalize(e, n) {
    if (typeof e == "string")
      e = Rl(kl(e).nodes);
    else if (e === void 0)
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let a of e)
        a.parent && a.parent.removeChild(a, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let a of e)
        a.parent && a.parent.removeChild(a, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (e.value === void 0)
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new Il(e)];
    } else if (e.selector || e.selectors)
      e = [new ai(e)];
    else if (e.name)
      e = [new ni(e)];
    else {
      if (!e.text)
        throw new Error("Unknown node type in node creation");
      e = [new Ll(e)];
    }
    return e.map((a) => (a[Ol] || jl.rebuild(a), (a = a.proxyOf).parent && a.parent.removeChild(a), a[Pl] && Fl(a), a.raws || (a.raws = {}), a.raws.before === void 0 && n && n.raws.before !== void 0 && (a.raws.before = n.raws.before.replace(/\S/g, "")), a.parent = this.proxyOf, a));
  }
  prepend(...e) {
    e = e.reverse();
    for (let n of e) {
      let a = this.normalize(n, this.first, "prepend").reverse();
      for (let r of a)
        this.proxyOf.nodes.unshift(r);
      for (let r in this.indexes)
        this.indexes[r] = this.indexes[r] + a.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes)
      e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    let n;
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    for (let a in this.indexes)
      n = this.indexes[a], n >= e && (this.indexes[a] = n - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, n, a) {
    return a || (a = n, n = {}), this.walkDecls((r) => {
      n.props && !n.props.includes(r.prop) || n.fast && !r.value.includes(n.fast) || (r.value = r.value.replace(e, a));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((n, a) => {
      let r;
      try {
        r = e(n, a);
      } catch (i) {
        throw n.addToError(i);
      }
      return r !== !1 && n.walk && (r = n.walk(e)), r;
    });
  }
  walkAtRules(e, n) {
    return n ? e instanceof RegExp ? this.walk((a, r) => {
      if (a.type === "atrule" && e.test(a.name))
        return n(a, r);
    }) : this.walk((a, r) => {
      if (a.type === "atrule" && a.name === e)
        return n(a, r);
    }) : (n = e, this.walk((a, r) => {
      if (a.type === "atrule")
        return n(a, r);
    }));
  }
  walkComments(e) {
    return this.walk((n, a) => {
      if (n.type === "comment")
        return e(n, a);
    });
  }
  walkDecls(e, n) {
    return n ? e instanceof RegExp ? this.walk((a, r) => {
      if (a.type === "decl" && e.test(a.prop))
        return n(a, r);
    }) : this.walk((a, r) => {
      if (a.type === "decl" && a.prop === e)
        return n(a, r);
    }) : (n = e, this.walk((a, r) => {
      if (a.type === "decl")
        return n(a, r);
    }));
  }
  walkRules(e, n) {
    return n ? e instanceof RegExp ? this.walk((a, r) => {
      if (a.type === "rule" && e.test(a.selector))
        return n(a, r);
    }) : this.walk((a, r) => {
      if (a.type === "rule" && a.selector === e)
        return n(a, r);
    }) : (n = e, this.walk((a, r) => {
      if (a.type === "rule")
        return n(a, r);
    }));
  }
};
Ge.registerParse = (t) => {
  kl = t;
}, Ge.registerRule = (t) => {
  ai = t;
}, Ge.registerAtRule = (t) => {
  ni = t;
}, Ge.registerRoot = (t) => {
  Al = t;
};
var gt = Ge;
Ge.default = Ge, Ge.rebuild = (t) => {
  t.type === "atrule" ? Object.setPrototypeOf(t, ni.prototype) : t.type === "rule" ? Object.setPrototypeOf(t, ai.prototype) : t.type === "decl" ? Object.setPrototypeOf(t, Il.prototype) : t.type === "comment" ? Object.setPrototypeOf(t, Ll.prototype) : t.type === "root" && Object.setPrototypeOf(t, Al.prototype), t[Ol] = !0, t.nodes && t.nodes.forEach((e) => {
    Ge.rebuild(e);
  });
};
let Bl = gt, On = class extends Bl {
  constructor(t) {
    super(t), this.type = "atrule";
  }
  append(...t) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...t);
  }
  prepend(...t) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...t);
  }
};
var ri = On;
On.default = On, Bl.registerAtRule(On);
let Gl, Yl, Zp = gt, tn = class extends Zp {
  constructor(t) {
    super({ type: "document", ...t }), this.nodes || (this.nodes = []);
  }
  toResult(t = {}) {
    return new Gl(new Yl(), this, t).stringify();
  }
};
tn.registerLazyResult = (t) => {
  Gl = t;
}, tn.registerProcessor = (t) => {
  Yl = t;
};
var ii = tn;
tn.default = tn;
var Wp = { nanoid: (t = 21) => {
  let e = "", n = 0 | t;
  for (; n--; )
    e += "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"[64 * Math.random() | 0];
  return e;
}, customAlphabet: (t, e = 21) => (n = e) => {
  let a = "", r = 0 | n;
  for (; r--; )
    a += t[Math.random() * t.length | 0];
  return a;
} };
let { existsSync: Jp, readFileSync: Qp } = Ee, { dirname: Aa, join: Xp } = Ee, { SourceMapConsumer: Yo, SourceMapGenerator: Vo } = Ee, gr = class {
  constructor(t, e) {
    if (e.map === !1)
      return;
    this.loadAnnotation(t), this.inline = this.startWith(this.annotation, "data:");
    let n = e.map ? e.map.prev : void 0, a = this.loadMap(e.from, n);
    !this.mapFile && e.from && (this.mapFile = e.from), this.mapFile && (this.root = Aa(this.mapFile)), a && (this.text = a);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new Yo(this.text)), this.consumerCache;
  }
  decodeInline(t) {
    let e = t.match(/^data:application\/json;charset=utf-?8,/) || t.match(/^data:application\/json,/);
    if (e)
      return decodeURIComponent(t.substr(e[0].length));
    let n = t.match(/^data:application\/json;charset=utf-?8;base64,/) || t.match(/^data:application\/json;base64,/);
    if (n)
      return a = t.substr(n[0].length), Buffer ? Buffer.from(a, "base64").toString() : window.atob(a);
    var a;
    let r = t.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + r);
  }
  getAnnotationURL(t) {
    return t.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(t) {
    return typeof t == "object" && (typeof t.mappings == "string" || typeof t._mappings == "string" || Array.isArray(t.sections));
  }
  loadAnnotation(t) {
    let e = t.match(/\/\*\s*# sourceMappingURL=/g);
    if (!e)
      return;
    let n = t.lastIndexOf(e.pop()), a = t.indexOf("*/", n);
    n > -1 && a > -1 && (this.annotation = this.getAnnotationURL(t.substring(n, a)));
  }
  loadFile(t) {
    if (this.root = Aa(t), Jp(t))
      return this.mapFile = t, Qp(t, "utf-8").toString().trim();
  }
  loadMap(t, e) {
    if (e === !1)
      return !1;
    if (e) {
      if (typeof e == "string")
        return e;
      if (typeof e != "function") {
        if (e instanceof Yo)
          return Vo.fromSourceMap(e).toString();
        if (e instanceof Vo)
          return e.toString();
        if (this.isMap(e))
          return JSON.stringify(e);
        throw new Error("Unsupported previous source map format: " + e.toString());
      }
      {
        let n = e(t);
        if (n) {
          let a = this.loadFile(n);
          if (!a)
            throw new Error("Unable to load previous source map: " + n.toString());
          return a;
        }
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let n = this.annotation;
        return t && (n = Xp(Aa(t), n)), this.loadFile(n);
      }
    }
  }
  startWith(t, e) {
    return !!t && t.substr(0, e.length) === e;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Vl = gr;
gr.default = gr;
let { nanoid: eh } = Wp, { isAbsolute: fr, resolve: yr } = Ee, { SourceMapConsumer: th, SourceMapGenerator: nh } = Ee, { fileURLToPath: Ho, pathToFileURL: Tn } = Ee, Uo = ti, ah = Vl, La = Ee, Ia = Symbol("lineToIndexCache"), rh = !!(th && nh), $o = !!(yr && fr);
function zo(t) {
  if (t[Ia])
    return t[Ia];
  let e = t.css.split(`
`), n = new Array(e.length), a = 0;
  for (let r = 0, i = e.length; r < i; r++)
    n[r] = a, a += e[r].length + 1;
  return t[Ia] = n, n;
}
let Rn = class {
  get from() {
    return this.file || this.id;
  }
  constructor(t, e = {}) {
    if (t == null || typeof t == "object" && !t.toString)
      throw new Error(`PostCSS received ${t} instead of CSS string`);
    if (this.css = t.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, e.document && (this.document = e.document.toString()), e.from && (!$o || /^\w+:\/\//.test(e.from) || fr(e.from) ? this.file = e.from : this.file = yr(e.from)), $o && rh) {
      let n = new ah(this.css, e);
      if (n.text) {
        this.map = n;
        let a = n.consumer().file;
        !this.file && a && (this.file = this.mapResolve(a));
      }
    }
    this.file || (this.id = "<input css " + eh(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(t, e, n, a = {}) {
    let r, i, o, s, l;
    if (e && typeof e == "object") {
      let c = e, d = n;
      if (typeof c.offset == "number") {
        s = c.offset;
        let p = this.fromOffset(s);
        e = p.line, n = p.col;
      } else
        e = c.line, n = c.column, s = this.fromLineAndColumn(e, n);
      if (typeof d.offset == "number") {
        o = d.offset;
        let p = this.fromOffset(o);
        i = p.line, r = p.col;
      } else
        i = d.line, r = d.column, o = this.fromLineAndColumn(d.line, d.column);
    } else if (n)
      s = this.fromLineAndColumn(e, n);
    else {
      s = e;
      let c = this.fromOffset(s);
      e = c.line, n = c.col;
    }
    let u = this.origin(e, n, i, r);
    return l = u ? new Uo(t, u.endLine === void 0 ? u.line : { column: u.column, line: u.line }, u.endLine === void 0 ? u.column : { column: u.endColumn, line: u.endLine }, u.source, u.file, a.plugin) : new Uo(t, i === void 0 ? e : { column: n, line: e }, i === void 0 ? n : { column: r, line: i }, this.css, this.file, a.plugin), l.input = { column: n, endColumn: r, endLine: i, endOffset: o, line: e, offset: s, source: this.css }, this.file && (Tn && (l.input.url = Tn(this.file).toString()), l.input.file = this.file), l;
  }
  fromLineAndColumn(t, e) {
    return zo(this)[t - 1] + e - 1;
  }
  fromOffset(t) {
    let e = zo(this), n = 0;
    if (t >= e[e.length - 1])
      n = e.length - 1;
    else {
      let a, r = e.length - 2;
      for (; n < r; )
        if (a = n + (r - n >> 1), t < e[a])
          r = a - 1;
        else {
          if (!(t >= e[a + 1])) {
            n = a;
            break;
          }
          n = a + 1;
        }
    }
    return { col: t - e[n] + 1, line: n + 1 };
  }
  mapResolve(t) {
    return /^\w+:\/\//.test(t) ? t : yr(this.map.consumer().sourceRoot || this.map.root || ".", t);
  }
  origin(t, e, n, a) {
    if (!this.map)
      return !1;
    let r, i, o = this.map.consumer(), s = o.originalPositionFor({ column: e, line: t });
    if (!s.source)
      return !1;
    typeof n == "number" && (r = o.originalPositionFor({ column: a, line: n })), i = fr(s.source) ? Tn(s.source) : new URL(s.source, this.map.consumer().sourceRoot || Tn(this.map.mapFile));
    let l = { column: s.column, endColumn: r && r.column, endLine: r && r.line, line: s.line, url: i.toString() };
    if (i.protocol === "file:") {
      if (!Ho)
        throw new Error("file: protocol is not available in this PostCSS build");
      l.file = Ho(i);
    }
    let u = o.sourceContentFor(s.source);
    return u && (l.source = u), l;
  }
  toJSON() {
    let t = {};
    for (let e of ["hasBOM", "css", "file", "id"])
      this[e] != null && (t[e] = this[e]);
    return this.map && (t.map = { ...this.map }, t.map.consumerCache && (t.map.consumerCache = void 0)), t;
  }
};
var ya = Rn;
Rn.default = Rn, La && La.registerInput && La.registerInput(Rn);
let Hl, Ul, $l = gt, Nt = class extends $l {
  constructor(t) {
    super(t), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(t, e, n) {
    let a = super.normalize(t);
    if (e) {
      if (n === "prepend")
        this.nodes.length > 1 ? e.raws.before = this.nodes[1].raws.before : delete e.raws.before;
      else if (this.first !== e)
        for (let r of a)
          r.raws.before = e.raws.before;
    }
    return a;
  }
  removeChild(t, e) {
    let n = this.index(t);
    return !e && n === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[n].raws.before), super.removeChild(t);
  }
  toResult(t = {}) {
    return new Hl(new Ul(), this, t).stringify();
  }
};
Nt.registerLazyResult = (t) => {
  Hl = t;
}, Nt.registerProcessor = (t) => {
  Ul = t;
};
var dn = Nt;
Nt.default = Nt, $l.registerRoot(Nt);
let nn = { comma: (t) => nn.split(t, [","], !0), space: (t) => nn.split(t, [" ", `
`, "	"]), split(t, e, n) {
  let a = [], r = "", i = !1, o = 0, s = !1, l = "", u = !1;
  for (let c of t)
    u ? u = !1 : c === "\\" ? u = !0 : s ? c === l && (s = !1) : c === '"' || c === "'" ? (s = !0, l = c) : c === "(" ? o += 1 : c === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(c) && (i = !0), i ? (r !== "" && a.push(r.trim()), r = "", i = !1) : r += c;
  return (n || r !== "") && a.push(r.trim()), a;
} };
var zl = nn;
nn.default = nn;
let ql = gt, ih = zl, Fn = class extends ql {
  get selectors() {
    return ih.comma(this.selector);
  }
  set selectors(t) {
    let e = this.selector ? this.selector.match(/,\s*/) : null, n = e ? e[0] : "," + this.raw("between", "beforeOpen");
    this.selector = t.join(n);
  }
  constructor(t) {
    super(t), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var oi = Fn;
Fn.default = Fn, ql.registerRule(Fn);
let oh = ri, sh = ga, lh = fa, ch = ya, uh = Vl, dh = dn, ph = oi;
function an(t, e) {
  if (Array.isArray(t))
    return t.map((r) => an(r));
  let { inputs: n, ...a } = t;
  if (n) {
    e = [];
    for (let r of n) {
      let i = { ...r, __proto__: ch.prototype };
      i.map && (i.map = { ...i.map, __proto__: uh.prototype }), e.push(i);
    }
  }
  if (a.nodes && (a.nodes = t.nodes.map((r) => an(r, e))), a.source) {
    let { inputId: r, ...i } = a.source;
    a.source = i, r != null && (a.source.input = e[r]);
  }
  if (a.type === "root")
    return new dh(a);
  if (a.type === "decl")
    return new lh(a);
  if (a.type === "rule")
    return new ph(a);
  if (a.type === "comment")
    return new sh(a);
  if (a.type === "atrule")
    return new oh(a);
  throw new Error("Unknown node type: " + t.type);
}
var hh = an;
an.default = an;
let { dirname: jn, relative: Kl, resolve: Zl, sep: Wl } = Ee, { SourceMapConsumer: Jl, SourceMapGenerator: Bn } = Ee, { pathToFileURL: qo } = Ee, mh = ya, gh = !!(Jl && Bn), fh = !!(jn && Zl && Kl && Wl);
var Ql = class {
  constructor(t, e, n, a) {
    this.stringify = t, this.mapOpts = n.map || {}, this.root = e, this.opts = n, this.css = a, this.originalCSS = a, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let t;
    t = this.isInline() ? "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? this.mapOpts.annotation(this.opts.to, this.root) : this.outputFile() + ".map";
    let e = `
`;
    this.css.includes(`\r
`) && (e = `\r
`), this.css += e + "/*# sourceMappingURL=" + t + " */";
  }
  applyPrevMaps() {
    for (let t of this.previous()) {
      let e, n = this.toUrl(this.path(t.file)), a = t.root || jn(t.file);
      this.mapOpts.sourcesContent === !1 ? (e = new Jl(t.text), e.sourcesContent && (e.sourcesContent = null)) : e = t.consumer(), this.map.applySourceMap(e, n, this.toUrl(this.path(a)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let t;
        for (let e = this.root.nodes.length - 1; e >= 0; e--)
          t = this.root.nodes[e], t.type === "comment" && t.text.startsWith("# sourceMappingURL=") && this.root.removeChild(e);
      } else
        this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), fh && gh && this.isMap())
      return this.generateMap();
    {
      let t = "";
      return this.stringify(this.root, (e) => {
        t += e;
      }), [t];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let t = this.previous()[0].consumer();
      t.file = this.outputFile(), this.map = Bn.fromSourceMap(t, { ignoreInvalidMapping: !0 });
    } else
      this.map = new Bn({ file: this.outputFile(), ignoreInvalidMapping: !0 }), this.map.addMapping({ generated: { column: 0, line: 1 }, original: { column: 0, line: 1 }, source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>" });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Bn({ file: this.outputFile(), ignoreInvalidMapping: !0 });
    let t, e, n = 1, a = 1, r = "<no source>", i = { generated: { column: 0, line: 0 }, original: { column: 0, line: 0 }, source: "" };
    this.stringify(this.root, (o, s, l) => {
      if (this.css += o, s && l !== "end" && (i.generated.line = n, i.generated.column = a - 1, s.source && s.source.start ? (i.source = this.sourcePath(s), i.original.line = s.source.start.line, i.original.column = s.source.start.column - 1, this.map.addMapping(i)) : (i.source = r, i.original.line = 1, i.original.column = 0, this.map.addMapping(i))), e = o.match(/\n/g), e ? (n += e.length, t = o.lastIndexOf(`
`), a = o.length - t) : a += o.length, s && l !== "start") {
        let u = s.parent || { raws: {} };
        (s.type === "decl" || s.type === "atrule" && !s.nodes) && s === u.last && !u.raws.semicolon || (s.source && s.source.end ? (i.source = this.sourcePath(s), i.original.line = s.source.end.line, i.original.column = s.source.end.column - 1, i.generated.line = n, i.generated.column = a - 2, this.map.addMapping(i)) : (i.source = r, i.original.line = 1, i.original.column = 0, i.generated.line = n, i.generated.column = a - 1, this.map.addMapping(i)));
      }
    });
  }
  isAnnotation() {
    return !!this.isInline() || (this.mapOpts.annotation !== void 0 ? this.mapOpts.annotation : !this.previous().length || this.previous().some((t) => t.annotation));
  }
  isInline() {
    if (this.mapOpts.inline !== void 0)
      return this.mapOpts.inline;
    let t = this.mapOpts.annotation;
    return (t === void 0 || t === !0) && (!this.previous().length || this.previous().some((e) => e.inline));
  }
  isMap() {
    return this.opts.map !== void 0 ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return this.mapOpts.sourcesContent !== void 0 ? this.mapOpts.sourcesContent : !this.previous().length || this.previous().some((t) => t.withContent());
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(t) {
    if (this.mapOpts.absolute || t.charCodeAt(0) === 60 || /^\w+:\/\//.test(t))
      return t;
    let e = this.memoizedPaths.get(t);
    if (e)
      return e;
    let n = this.opts.to ? jn(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (n = jn(Zl(n, this.mapOpts.annotation)));
    let a = Kl(n, t);
    return this.memoizedPaths.set(t, a), a;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((t) => {
          if (t.source && t.source.input.map) {
            let e = t.source.input.map;
            this.previousMaps.includes(e) || this.previousMaps.push(e);
          }
        });
      else {
        let t = new mh(this.originalCSS, this.opts);
        t.map && this.previousMaps.push(t.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let t = {};
    if (this.root)
      this.root.walk((e) => {
        if (e.source) {
          let n = e.source.input.from;
          if (n && !t[n]) {
            t[n] = !0;
            let a = this.usesFileUrls ? this.toFileUrl(n) : this.toUrl(this.path(n));
            this.map.setSourceContent(a, e.source.input.css);
          }
        }
      });
    else if (this.css) {
      let e = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(e, this.css);
    }
  }
  sourcePath(t) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(t.source.input.from) : this.toUrl(this.path(t.source.input.from));
  }
  toBase64(t) {
    return Buffer ? Buffer.from(t).toString("base64") : window.btoa(unescape(encodeURIComponent(t)));
  }
  toFileUrl(t) {
    let e = this.memoizedFileURLs.get(t);
    if (e)
      return e;
    if (qo) {
      let n = qo(t).toString();
      return this.memoizedFileURLs.set(t, n), n;
    }
    throw new Error("`map.absolute` option is not available in this PostCSS build");
  }
  toUrl(t) {
    let e = this.memoizedURLs.get(t);
    if (e)
      return e;
    Wl === "\\" && (t = t.replace(/\\/g, "/"));
    let n = encodeURI(t).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(t, n), n;
  }
};
const Pa = "'".charCodeAt(0), Ko = '"'.charCodeAt(0), En = "\\".charCodeAt(0), Zo = "/".charCodeAt(0), wn = `
`.charCodeAt(0), Ft = " ".charCodeAt(0), _n = "\f".charCodeAt(0), xn = "	".charCodeAt(0), kn = "\r".charCodeAt(0), yh = "[".charCodeAt(0), bh = "]".charCodeAt(0), vh = "(".charCodeAt(0), Sh = ")".charCodeAt(0), Ch = "{".charCodeAt(0), Mh = "}".charCodeAt(0), Dh = ";".charCodeAt(0), Nh = "*".charCodeAt(0), Th = ":".charCodeAt(0), Eh = "@".charCodeAt(0), An = /[\t\n\f\r "#'()/;[\\\]{}]/g, Ln = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, wh = /.[\r\n"'(/\\]/, Wo = /[\da-f]/i;
let _h = ri, xh = ga, kh = fa, Ah = dn, Jo = oi, Lh = function(t, e = {}) {
  let n, a, r, i, o, s, l, u, c, d, p = t.css.valueOf(), g = e.ignoreErrors, f = p.length, h = 0, D = [], L = [];
  function _(x) {
    throw t.error("Unclosed " + x, h);
  }
  return { back: function(x) {
    L.push(x);
  }, endOfFile: function() {
    return L.length === 0 && h >= f;
  }, nextToken: function(x) {
    if (L.length)
      return L.pop();
    if (h >= f)
      return;
    let T = !!x && x.ignoreUnclosed;
    switch (n = p.charCodeAt(h), n) {
      case wn:
      case Ft:
      case xn:
      case kn:
      case _n:
        i = h;
        do
          i += 1, n = p.charCodeAt(i);
        while (n === Ft || n === wn || n === xn || n === kn || n === _n);
        s = ["space", p.slice(h, i)], h = i - 1;
        break;
      case yh:
      case bh:
      case Ch:
      case Mh:
      case Th:
      case Dh:
      case Sh: {
        let b = String.fromCharCode(n);
        s = [b, b, h];
        break;
      }
      case vh:
        if (d = D.length ? D.pop()[1] : "", c = p.charCodeAt(h + 1), d === "url" && c !== Pa && c !== Ko && c !== Ft && c !== wn && c !== xn && c !== _n && c !== kn) {
          i = h;
          do {
            if (l = !1, i = p.indexOf(")", i + 1), i === -1) {
              if (g || T) {
                i = h;
                break;
              }
              _("bracket");
            }
            for (u = i; p.charCodeAt(u - 1) === En; )
              u -= 1, l = !l;
          } while (l);
          s = ["brackets", p.slice(h, i + 1), h, i], h = i;
        } else
          i = p.indexOf(")", h + 1), a = p.slice(h, i + 1), i === -1 || wh.test(a) ? s = ["(", "(", h] : (s = ["brackets", a, h, i], h = i);
        break;
      case Pa:
      case Ko:
        o = n === Pa ? "'" : '"', i = h;
        do {
          if (l = !1, i = p.indexOf(o, i + 1), i === -1) {
            if (g || T) {
              i = h + 1;
              break;
            }
            _("string");
          }
          for (u = i; p.charCodeAt(u - 1) === En; )
            u -= 1, l = !l;
        } while (l);
        s = ["string", p.slice(h, i + 1), h, i], h = i;
        break;
      case Eh:
        An.lastIndex = h + 1, An.test(p), i = An.lastIndex === 0 ? p.length - 1 : An.lastIndex - 2, s = ["at-word", p.slice(h, i + 1), h, i], h = i;
        break;
      case En:
        for (i = h, r = !0; p.charCodeAt(i + 1) === En; )
          i += 1, r = !r;
        if (n = p.charCodeAt(i + 1), r && n !== Zo && n !== Ft && n !== wn && n !== xn && n !== kn && n !== _n && (i += 1, Wo.test(p.charAt(i)))) {
          for (; Wo.test(p.charAt(i + 1)); )
            i += 1;
          p.charCodeAt(i + 1) === Ft && (i += 1);
        }
        s = ["word", p.slice(h, i + 1), h, i], h = i;
        break;
      default:
        n === Zo && p.charCodeAt(h + 1) === Nh ? (i = p.indexOf("*/", h + 2) + 1, i === 0 && (g || T ? i = p.length : _("comment")), s = ["comment", p.slice(h, i + 1), h, i], h = i) : (Ln.lastIndex = h + 1, Ln.test(p), i = Ln.lastIndex === 0 ? p.length - 1 : Ln.lastIndex - 2, s = ["word", p.slice(h, i + 1), h, i], D.push(s), h = i);
    }
    return h++, s;
  }, position: function() {
    return h;
  } };
};
const Qo = { empty: !0, space: !0 };
var Ih = class {
  constructor(t) {
    this.input = t, this.root = new Ah(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: t, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(t) {
    let e, n, a, r = new _h();
    r.name = t[1].slice(1), r.name === "" && this.unnamedAtrule(r, t), this.init(r, t[2]);
    let i = !1, o = !1, s = [], l = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = (t = this.tokenizer.nextToken())[0], e === "(" || e === "[" ? l.push(e === "(" ? ")" : "]") : e === "{" && l.length > 0 ? l.push("}") : e === l[l.length - 1] && l.pop(), l.length === 0) {
        if (e === ";") {
          r.source.end = this.getPosition(t[2]), r.source.end.offset++, this.semicolon = !0;
          break;
        }
        if (e === "{") {
          o = !0;
          break;
        }
        if (e === "}") {
          if (s.length > 0) {
            for (a = s.length - 1, n = s[a]; n && n[0] === "space"; )
              n = s[--a];
            n && (r.source.end = this.getPosition(n[3] || n[2]), r.source.end.offset++);
          }
          this.end(t);
          break;
        }
        s.push(t);
      } else
        s.push(t);
      if (this.tokenizer.endOfFile()) {
        i = !0;
        break;
      }
    }
    r.raws.between = this.spacesAndCommentsFromEnd(s), s.length ? (r.raws.afterName = this.spacesAndCommentsFromStart(s), this.raw(r, "params", s), i && (t = s[s.length - 1], r.source.end = this.getPosition(t[3] || t[2]), r.source.end.offset++, this.spaces = r.raws.between, r.raws.between = "")) : (r.raws.afterName = "", r.params = ""), o && (r.nodes = [], this.current = r);
  }
  checkMissedSemicolon(t) {
    let e = this.colon(t);
    if (e === !1)
      return;
    let n, a = 0;
    for (let r = e - 1; r >= 0 && (n = t[r], n[0] === "space" || (a += 1, a !== 2)); r--)
      ;
    throw this.input.error("Missed semicolon", n[0] === "word" ? n[3] + 1 : n[2]);
  }
  colon(t) {
    let e, n, a, r = 0;
    for (let [i, o] of t.entries()) {
      if (n = o, a = n[0], a === "(" && (r += 1), a === ")" && (r -= 1), r === 0 && a === ":") {
        if (e) {
          if (e[0] === "word" && e[1] === "progid")
            continue;
          return i;
        }
        this.doubleColon(n);
      }
      e = n;
    }
    return !1;
  }
  comment(t) {
    let e = new xh();
    this.init(e, t[2]), e.source.end = this.getPosition(t[3] || t[2]), e.source.end.offset++;
    let n = t[1].slice(2, -2);
    if (/^\s*$/.test(n))
      e.text = "", e.raws.left = n, e.raws.right = "";
    else {
      let a = n.match(/^(\s*)([^]*\S)(\s*)$/);
      e.text = a[2], e.raws.left = a[1], e.raws.right = a[3];
    }
  }
  createTokenizer() {
    this.tokenizer = Lh(this.input);
  }
  decl(t, e) {
    let n = new kh();
    this.init(n, t[0][2]);
    let a, r = t[t.length - 1];
    for (r[0] === ";" && (this.semicolon = !0, t.pop()), n.source.end = this.getPosition(r[3] || r[2] || function(s) {
      for (let l = s.length - 1; l >= 0; l--) {
        let u = s[l], c = u[3] || u[2];
        if (c)
          return c;
      }
    }(t)), n.source.end.offset++; t[0][0] !== "word"; )
      t.length === 1 && this.unknownWord(t), n.raws.before += t.shift()[1];
    for (n.source.start = this.getPosition(t[0][2]), n.prop = ""; t.length; ) {
      let s = t[0][0];
      if (s === ":" || s === "space" || s === "comment")
        break;
      n.prop += t.shift()[1];
    }
    for (n.raws.between = ""; t.length; ) {
      if (a = t.shift(), a[0] === ":") {
        n.raws.between += a[1];
        break;
      }
      a[0] === "word" && /\w/.test(a[1]) && this.unknownWord([a]), n.raws.between += a[1];
    }
    n.prop[0] !== "_" && n.prop[0] !== "*" || (n.raws.before += n.prop[0], n.prop = n.prop.slice(1));
    let i, o = [];
    for (; t.length && (i = t[0][0], i === "space" || i === "comment"); )
      o.push(t.shift());
    this.precheckMissedSemicolon(t);
    for (let s = t.length - 1; s >= 0; s--) {
      if (a = t[s], a[1].toLowerCase() === "!important") {
        n.important = !0;
        let l = this.stringFrom(t, s);
        l = this.spacesFromEnd(t) + l, l !== " !important" && (n.raws.important = l);
        break;
      }
      if (a[1].toLowerCase() === "important") {
        let l = t.slice(0), u = "";
        for (let c = s; c > 0; c--) {
          let d = l[c][0];
          if (u.trim().startsWith("!") && d !== "space")
            break;
          u = l.pop()[1] + u;
        }
        u.trim().startsWith("!") && (n.important = !0, n.raws.important = u, t = l);
      }
      if (a[0] !== "space" && a[0] !== "comment")
        break;
    }
    t.some((s) => s[0] !== "space" && s[0] !== "comment") && (n.raws.between += o.map((s) => s[1]).join(""), o = []), this.raw(n, "value", o.concat(t), e), n.value.includes(":") && !e && this.checkMissedSemicolon(t);
  }
  doubleColon(t) {
    throw this.input.error("Double colon", { offset: t[2] }, { offset: t[2] + t[1].length });
  }
  emptyRule(t) {
    let e = new Jo();
    this.init(e, t[2]), e.selector = "", e.raws.between = "", this.current = e;
  }
  end(t) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(t[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(t);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(t) {
    if (this.spaces += t[1], this.current.nodes) {
      let e = this.current.nodes[this.current.nodes.length - 1];
      e && e.type === "rule" && !e.raws.ownSemicolon && (e.raws.ownSemicolon = this.spaces, this.spaces = "", e.source.end = this.getPosition(t[2]), e.source.end.offset += e.raws.ownSemicolon.length);
    }
  }
  getPosition(t) {
    let e = this.input.fromOffset(t);
    return { column: e.col, line: e.line, offset: t };
  }
  init(t, e) {
    this.current.push(t), t.source = { input: this.input, start: this.getPosition(e) }, t.raws.before = this.spaces, this.spaces = "", t.type !== "comment" && (this.semicolon = !1);
  }
  other(t) {
    let e = !1, n = null, a = !1, r = null, i = [], o = t[1].startsWith("--"), s = [], l = t;
    for (; l; ) {
      if (n = l[0], s.push(l), n === "(" || n === "[")
        r || (r = l), i.push(n === "(" ? ")" : "]");
      else if (o && a && n === "{")
        r || (r = l), i.push("}");
      else if (i.length === 0) {
        if (n === ";") {
          if (a)
            return void this.decl(s, o);
          break;
        }
        if (n === "{")
          return void this.rule(s);
        if (n === "}") {
          this.tokenizer.back(s.pop()), e = !0;
          break;
        }
        n === ":" && (a = !0);
      } else
        n === i[i.length - 1] && (i.pop(), i.length === 0 && (r = null));
      l = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (e = !0), i.length > 0 && this.unclosedBracket(r), e && a) {
      if (!o)
        for (; s.length && (l = s[s.length - 1][0], l === "space" || l === "comment"); )
          this.tokenizer.back(s.pop());
      this.decl(s, o);
    } else
      this.unknownWord(s);
  }
  parse() {
    let t;
    for (; !this.tokenizer.endOfFile(); )
      switch (t = this.tokenizer.nextToken(), t[0]) {
        case "space":
          this.spaces += t[1];
          break;
        case ";":
          this.freeSemicolon(t);
          break;
        case "}":
          this.end(t);
          break;
        case "comment":
          this.comment(t);
          break;
        case "at-word":
          this.atrule(t);
          break;
        case "{":
          this.emptyRule(t);
          break;
        default:
          this.other(t);
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(t, e, n, a) {
    let r, i, o, s, l = n.length, u = "", c = !0;
    for (let d = 0; d < l; d += 1)
      r = n[d], i = r[0], i !== "space" || d !== l - 1 || a ? i === "comment" ? (s = n[d - 1] ? n[d - 1][0] : "empty", o = n[d + 1] ? n[d + 1][0] : "empty", Qo[s] || Qo[o] || u.slice(-1) === "," ? c = !1 : u += r[1]) : u += r[1] : c = !1;
    if (!c) {
      let d = n.reduce((p, g) => p + g[1], "");
      t.raws[e] = { raw: d, value: u };
    }
    t[e] = u;
  }
  rule(t) {
    t.pop();
    let e = new Jo();
    this.init(e, t[0][2]), e.raws.between = this.spacesAndCommentsFromEnd(t), this.raw(e, "selector", t), this.current = e;
  }
  spacesAndCommentsFromEnd(t) {
    let e, n = "";
    for (; t.length && (e = t[t.length - 1][0], e === "space" || e === "comment"); )
      n = t.pop()[1] + n;
    return n;
  }
  spacesAndCommentsFromStart(t) {
    let e, n = "";
    for (; t.length && (e = t[0][0], e === "space" || e === "comment"); )
      n += t.shift()[1];
    return n;
  }
  spacesFromEnd(t) {
    let e, n = "";
    for (; t.length && (e = t[t.length - 1][0], e === "space"); )
      n = t.pop()[1] + n;
    return n;
  }
  stringFrom(t, e) {
    let n = "";
    for (let a = e; a < t.length; a++)
      n += t[a][1];
    return t.splice(e, t.length - e), n;
  }
  unclosedBlock() {
    let t = this.current.source.start;
    throw this.input.error("Unclosed block", t.line, t.column);
  }
  unclosedBracket(t) {
    throw this.input.error("Unclosed bracket", { offset: t[2] }, { offset: t[2] + 1 });
  }
  unexpectedClose(t) {
    throw this.input.error("Unexpected }", { offset: t[2] }, { offset: t[2] + 1 });
  }
  unknownWord(t) {
    throw this.input.error("Unknown word " + t[0][1], { offset: t[0][2] }, { offset: t[0][2] + t[0][1].length });
  }
  unnamedAtrule(t, e) {
    throw this.input.error("At-rule without name", { offset: e[2] }, { offset: e[2] + e[1].length });
  }
};
let Ph = gt, Oh = ya, Rh = Ih;
function Gn(t, e) {
  let n = new Oh(t, e), a = new Rh(n);
  try {
    a.parse();
  } catch (r) {
    throw process.env.NODE_ENV !== "production" && r.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? r.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? r.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (r.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), r;
  }
  return a.root;
}
var si = Gn;
Gn.default = Gn, Ph.registerParse(Gn);
let br = class {
  constructor(t, e = {}) {
    if (this.type = "warning", this.text = t, e.node && e.node.source) {
      let n = e.node.rangeBy(e);
      this.line = n.start.line, this.column = n.start.column, this.endLine = n.end.line, this.endColumn = n.end.column;
    }
    for (let n in e)
      this[n] = e[n];
  }
  toString() {
    return this.node ? this.node.error(this.text, { index: this.index, plugin: this.plugin, word: this.word }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var Xl = br;
br.default = br;
let Fh = Xl, vr = class {
  get content() {
    return this.css;
  }
  constructor(t, e, n) {
    this.processor = t, this.messages = [], this.root = e, this.opts = n, this.css = "", this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(t, e = {}) {
    e.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (e.plugin = this.lastPlugin.postcssPlugin);
    let n = new Fh(t, e);
    return this.messages.push(n), n;
  }
  warnings() {
    return this.messages.filter((t) => t.type === "warning");
  }
};
var li = vr;
vr.default = vr;
let Xo = {};
var ec = function(t) {
  Xo[t] || (Xo[t] = !0, typeof console < "u" && console.warn && console.warn(t));
};
let jh = gt, Bh = ii, Gh = Ql, Yh = si, es = li, Vh = dn, Hh = ha, { isClean: ke, my: Uh } = en, $h = ec;
const zh = { atrule: "AtRule", comment: "Comment", decl: "Declaration", document: "Document", root: "Root", rule: "Rule" }, qh = { AtRule: !0, AtRuleExit: !0, Comment: !0, CommentExit: !0, Declaration: !0, DeclarationExit: !0, Document: !0, DocumentExit: !0, Once: !0, OnceExit: !0, postcssPlugin: !0, prepare: !0, Root: !0, RootExit: !0, Rule: !0, RuleExit: !0 }, Kh = { Once: !0, postcssPlugin: !0, prepare: !0 };
function jt(t) {
  return typeof t == "object" && typeof t.then == "function";
}
function tc(t) {
  let e = !1, n = zh[t.type];
  return t.type === "decl" ? e = t.prop.toLowerCase() : t.type === "atrule" && (e = t.name.toLowerCase()), e && t.append ? [n, n + "-" + e, 0, n + "Exit", n + "Exit-" + e] : e ? [n, n + "-" + e, n + "Exit", n + "Exit-" + e] : t.append ? [n, 0, n + "Exit"] : [n, n + "Exit"];
}
function ts(t) {
  let e;
  return e = t.type === "document" ? ["Document", 0, "DocumentExit"] : t.type === "root" ? ["Root", 0, "RootExit"] : tc(t), { eventIndex: 0, events: e, iterator: 0, node: t, visitorIndex: 0, visitors: [] };
}
function Sr(t) {
  return t[ke] = !1, t.nodes && t.nodes.forEach((e) => Sr(e)), t;
}
let Cr = {}, Mt = class nc {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, n, a) {
    let r;
    if (this.stringified = !1, this.processed = !1, typeof n != "object" || n === null || n.type !== "root" && n.type !== "document")
      if (n instanceof nc || n instanceof es)
        r = Sr(n.root), n.map && (a.map === void 0 && (a.map = {}), a.map.inline || (a.map.inline = !1), a.map.prev = n.map);
      else {
        let i = Yh;
        a.syntax && (i = a.syntax.parse), a.parser && (i = a.parser), i.parse && (i = i.parse);
        try {
          r = i(n, a);
        } catch (o) {
          this.processed = !0, this.error = o;
        }
        r && !r[Uh] && jh.rebuild(r);
      }
    else
      r = Sr(n);
    this.result = new es(e, r, a), this.helpers = { ...Cr, postcss: Cr, result: this.result }, this.plugins = this.processor.plugins.map((i) => typeof i == "object" && i.prepare ? { ...i, ...i.prepare(this.result) } : i);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, n) {
    let a = this.result.lastPlugin;
    try {
      if (n && n.addToError(e), this.error = e, e.name !== "CssSyntaxError" || e.plugin) {
        if (a.postcssVersion && process.env.NODE_ENV !== "production") {
          let r = a.postcssPlugin, i = a.postcssVersion, o = this.result.processor.version, s = i.split("."), l = o.split(".");
          (s[0] !== l[0] || parseInt(s[1]) > parseInt(l[1])) && console.error("Unknown error from PostCSS plugin. Your current PostCSS version is " + o + ", but " + r + " uses " + i + ". Perhaps this is the source of the error below.");
        }
      } else
        e.plugin = a.postcssPlugin, e.setMessage();
    } catch (r) {
      console && console.error && console.error(r);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (n, a, r) => {
      this.listeners[a] || (this.listeners[a] = []), this.listeners[a].push([n, r]);
    };
    for (let n of this.plugins)
      if (typeof n == "object")
        for (let a in n) {
          if (!qh[a] && /^[A-Z]/.test(a))
            throw new Error(`Unknown event ${a} in ${n.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
          if (!Kh[a])
            if (typeof n[a] == "object")
              for (let r in n[a])
                e(n, r === "*" ? a : a + "-" + r.toLowerCase(), n[a][r]);
            else
              typeof n[a] == "function" && e(n, a, n[a]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let e = 0; e < this.plugins.length; e++) {
      let n = this.plugins[e], a = this.runOnRoot(n);
      if (jt(a))
        try {
          await a;
        } catch (r) {
          throw this.handleError(r);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[ke]; ) {
        e[ke] = !0;
        let n = [ts(e)];
        for (; n.length > 0; ) {
          let a = this.visitTick(n);
          if (jt(a))
            try {
              await a;
            } catch (r) {
              let i = n[n.length - 1].node;
              throw this.handleError(r, i);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [n, a] of this.listeners.OnceExit) {
          this.result.lastPlugin = n;
          try {
            if (e.type === "document") {
              let r = e.nodes.map((i) => a(i, this.helpers));
              await Promise.all(r);
            } else
              await a(e, this.helpers);
          } catch (r) {
            throw this.handleError(r);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let n = this.result.root.nodes.map((a) => e.Once(a, this.helpers));
          return jt(n[0]) ? Promise.all(n) : n;
        }
        return e.Once(this.result.root, this.helpers);
      }
      if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (n) {
      throw this.handleError(n);
    }
  }
  stringify() {
    if (this.error)
      throw this.error;
    if (this.stringified)
      return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, n = Hh;
    e.syntax && (n = e.syntax.stringify), e.stringifier && (n = e.stringifier), n.stringify && (n = n.stringify);
    let a = new Gh(n, this.result.root, this.result.opts).generate();
    return this.result.css = a[0], this.result.map = a[1], this.result;
  }
  sync() {
    if (this.error)
      throw this.error;
    if (this.processed)
      return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins)
      if (jt(this.runOnRoot(e)))
        throw this.getAsyncError();
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[ke]; )
        e[ke] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let n of e.nodes)
            this.visitSync(this.listeners.OnceExit, n);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, n) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || $h("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.")), this.async().then(e, n);
  }
  toString() {
    return this.css;
  }
  visitSync(e, n) {
    for (let [a, r] of e) {
      let i;
      this.result.lastPlugin = a;
      try {
        i = r(n, this.helpers);
      } catch (o) {
        throw this.handleError(o, n.proxyOf);
      }
      if (n.type !== "root" && n.type !== "document" && !n.parent)
        return !0;
      if (jt(i))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let n = e[e.length - 1], { node: a, visitors: r } = n;
    if (a.type !== "root" && a.type !== "document" && !a.parent)
      return void e.pop();
    if (r.length > 0 && n.visitorIndex < r.length) {
      let [o, s] = r[n.visitorIndex];
      n.visitorIndex += 1, n.visitorIndex === r.length && (n.visitors = [], n.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return s(a.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, a);
      }
    }
    if (n.iterator !== 0) {
      let o, s = n.iterator;
      for (; o = a.nodes[a.indexes[s]]; )
        if (a.indexes[s] += 1, !o[ke])
          return o[ke] = !0, void e.push(ts(o));
      n.iterator = 0, delete a.indexes[s];
    }
    let i = n.events;
    for (; n.eventIndex < i.length; ) {
      let o = i[n.eventIndex];
      if (n.eventIndex += 1, o === 0)
        return void (a.nodes && a.nodes.length && (a[ke] = !0, n.iterator = a.getIterator()));
      if (this.listeners[o])
        return void (n.visitors = this.listeners[o]);
    }
    e.pop();
  }
  walkSync(e) {
    e[ke] = !0;
    let n = tc(e);
    for (let a of n)
      if (a === 0)
        e.nodes && e.each((r) => {
          r[ke] || this.walkSync(r);
        });
      else {
        let r = this.listeners[a];
        if (r && this.visitSync(r, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
Mt.registerPostcss = (t) => {
  Cr = t;
};
var ac = Mt;
Mt.default = Mt, Vh.registerLazyResult(Mt), Bh.registerLazyResult(Mt);
let Zh = Ql, Wh = si;
const Jh = li;
let Qh = ha, Xh = ec, Mr = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let t, e = Wh;
    try {
      t = e(this._css, this._opts);
    } catch (n) {
      this.error = n;
    }
    if (this.error)
      throw this.error;
    return this._root = t, t;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(t, e, n) {
    let a;
    e = e.toString(), this.stringified = !1, this._processor = t, this._css = e, this._opts = n, this._map = void 0;
    let r = Qh;
    this.result = new Jh(this._processor, a, this._opts), this.result.css = e;
    let i = this;
    Object.defineProperty(this.result, "root", { get: () => i.root });
    let o = new Zh(r, a, this._opts, e);
    if (o.isMap()) {
      let [s, l] = o.generate();
      s && (this.result.css = s), l && (this.result.map = l);
    } else
      o.clearAnnotation(), this.result.css = o.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(t) {
    return this.async().catch(t);
  }
  finally(t) {
    return this.async().then(t, t);
  }
  sync() {
    if (this.error)
      throw this.error;
    return this.result;
  }
  then(t, e) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Xh("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.")), this.async().then(t, e);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var em = Mr;
Mr.default = Mr;
let tm = ii, nm = ac, am = em, rm = dn, Yt = class {
  constructor(t = []) {
    this.version = "8.5.6", this.plugins = this.normalize(t);
  }
  normalize(t) {
    let e = [];
    for (let n of t)
      if (n.postcss === !0 ? n = n() : n.postcss && (n = n.postcss), typeof n == "object" && Array.isArray(n.plugins))
        e = e.concat(n.plugins);
      else if (typeof n == "object" && n.postcssPlugin)
        e.push(n);
      else if (typeof n == "function")
        e.push(n);
      else {
        if (typeof n != "object" || !n.parse && !n.stringify)
          throw new Error(n + " is not a PostCSS plugin");
        if (process.env.NODE_ENV !== "production")
          throw new Error("PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation.");
      }
    return e;
  }
  process(t, e = {}) {
    return this.plugins.length || e.parser || e.stringifier || e.syntax ? new nm(this, t, e) : new am(this, t, e);
  }
  use(t) {
    return this.plugins = this.plugins.concat(this.normalize([t])), this;
  }
};
var im = Yt;
Yt.default = Yt, rm.registerProcessor(Yt), tm.registerProcessor(Yt);
let ns = ri, as = ga, om = gt, sm = ti, rs = fa, is = ii, lm = hh, cm = ya, um = ac, dm = zl, pm = ma, hm = si, Dr = im, mm = li, os = dn, ss = oi, gm = ha, fm = Xl;
function ee(...t) {
  return t.length === 1 && Array.isArray(t[0]) && (t = t[0]), new Dr(t);
}
ee.plugin = function(t, e) {
  let n, a = !1;
  function r(...i) {
    console && console.warn && !a && (a = !0, console.warn(t + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(t + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`));
    let o = e(...i);
    return o.postcssPlugin = t, o.postcssVersion = new Dr().version, o;
  }
  return Object.defineProperty(r, "postcss", { get: () => (n || (n = r()), n) }), r.process = function(i, o, s) {
    return ee([r(s)]).process(i, o);
  }, r;
}, ee.stringify = gm, ee.parse = hm, ee.fromJSON = lm, ee.list = dm, ee.comment = (t) => new as(t), ee.atRule = (t) => new ns(t), ee.decl = (t) => new rs(t), ee.rule = (t) => new ss(t), ee.root = (t) => new os(t), ee.document = (t) => new is(t), ee.CssSyntaxError = sm, ee.Declaration = rs, ee.Container = om, ee.Processor = Dr, ee.Document = is, ee.Comment = as, ee.Warning = fm, ee.AtRule = ns, ee.Result = mm, ee.Input = cm, ee.Rule = ss, ee.Root = os, ee.Node = pm, um.registerPostcss(ee);
var ym = ee;
ee.default = ee;
const bm = pl, ls = (t) => {
  if (typeof t != "string")
    throw new TypeError("Expected a string");
  return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, { isPlainObject: vm } = or, cs = jp, Sm = Bp, { parse: Cm } = ym, Mm = ["img", "audio", "video", "picture", "svg", "object", "map", "iframe", "embed"], Dm = ["script", "style"];
function St(t, e) {
  t && Object.keys(t).forEach(function(n) {
    e(t[n], n);
  });
}
function Oe(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function us(t, e) {
  const n = [];
  return St(t, function(a) {
    e(a) && n.push(a);
  }), n;
}
var Nm = rn;
const Tm = /^[^\0\t\n\f\r /<=>]+$/;
function rn(t, e, n) {
  if (t == null)
    return "";
  typeof t == "number" && (t = t.toString());
  let a = "", r = "";
  function i(v, y) {
    const m = this;
    this.tag = v, this.attribs = y || {}, this.tagPosition = a.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
      D.length && (D[D.length - 1].text += m.text);
    }, this.updateParentNodeMediaChildren = function() {
      D.length && Mm.includes(this.tag) && D[D.length - 1].mediaChildren.push(this.tag);
    };
  }
  (e = Object.assign({}, rn.defaults, e)).parser = Object.assign({}, Em, e.parser);
  const o = function(v) {
    return e.allowedTags === !1 || (e.allowedTags || []).indexOf(v) > -1;
  };
  Dm.forEach(function(v) {
    o(v) && !e.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${v}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const s = e.nonTextTags || ["script", "style", "textarea", "option"];
  let l, u;
  e.allowedAttributes && (l = {}, u = {}, St(e.allowedAttributes, function(v, y) {
    l[y] = [];
    const m = [];
    v.forEach(function(M) {
      typeof M == "string" && M.indexOf("*") >= 0 ? m.push(ls(M).replace(/\\\*/g, ".*")) : l[y].push(M);
    }), m.length && (u[y] = new RegExp("^(" + m.join("|") + ")$"));
  }));
  const c = {}, d = {}, p = {};
  St(e.allowedClasses, function(v, y) {
    if (l && (Oe(l, y) || (l[y] = []), l[y].push("class")), c[y] = v, Array.isArray(v)) {
      const m = [];
      c[y] = [], p[y] = [], v.forEach(function(M) {
        typeof M == "string" && M.indexOf("*") >= 0 ? m.push(ls(M).replace(/\\\*/g, ".*")) : M instanceof RegExp ? p[y].push(M) : c[y].push(M);
      }), m.length && (d[y] = new RegExp("^(" + m.join("|") + ")$"));
    }
  });
  const g = {};
  let f, h, D, L, _, x, T;
  St(e.transformTags, function(v, y) {
    let m;
    typeof v == "function" ? m = v : typeof v == "string" && (m = rn.simpleTransform(v)), y === "*" ? f = m : g[y] = m;
  });
  let b = !1;
  w();
  const S = new bm.Parser({ onopentag: function(v, y) {
    if (e.onOpenTag && e.onOpenTag(v, y), e.enforceHtmlBoundary && v === "html" && w(), x)
      return void T++;
    const m = new i(v, y);
    D.push(m);
    let M = !1;
    const C = !!m.text;
    let I;
    if (Oe(g, v) && (I = g[v](v, y), m.attribs = y = I.attribs, I.text !== void 0 && (m.innerText = I.text), v !== I.tagName && (m.name = v = I.tagName, _[h] = I.tagName)), f && (I = f(v, y), m.attribs = y = I.attribs, v !== I.tagName && (m.name = v = I.tagName, _[h] = I.tagName)), (!o(v) || e.disallowedTagsMode === "recursiveEscape" && !function(A) {
      for (const P in A)
        if (Oe(A, P))
          return !1;
      return !0;
    }(L) || e.nestingLimit != null && h >= e.nestingLimit) && (M = !0, L[h] = !0, e.disallowedTagsMode !== "discard" && e.disallowedTagsMode !== "completelyDiscard" || s.indexOf(v) !== -1 && (x = !0, T = 1)), h++, M) {
      if (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") {
        if (m.innerText && !C) {
          const A = E(m.innerText);
          e.textFilter ? a += e.textFilter(A, v) : a += A, b = !0;
        }
        return;
      }
      r = a, a = "";
    }
    a += "<" + v, v === "script" && (e.allowedScriptHostnames || e.allowedScriptDomains) && (m.innerText = ""), M && (e.disallowedTagsMode === "escape" || e.disallowedTagsMode === "recursiveEscape") && e.preserveEscapedAttributes ? St(y, function(A, P) {
      a += " " + P + '="' + E(A || "", !0) + '"';
    }) : (!l || Oe(l, v) || l["*"]) && St(y, function(A, P) {
      if (!Tm.test(P) || A === "" && !e.allowedEmptyAttributes.includes(P) && (e.nonBooleanAttributes.includes(P) || e.nonBooleanAttributes.includes("*")))
        return void delete m.attribs[P];
      let B = !1;
      if (!l || Oe(l, v) && l[v].indexOf(P) !== -1 || l["*"] && l["*"].indexOf(P) !== -1 || Oe(u, v) && u[v].test(P) || u["*"] && u["*"].test(P))
        B = !0;
      else if (l && l[v]) {
        for (const j of l[v])
          if (vm(j) && j.name && j.name === P) {
            B = !0;
            let R = "";
            if (j.multiple === !0) {
              const W = A.split(" ");
              for (const K of W)
                j.values.indexOf(K) !== -1 && (R === "" ? R = K : R += " " + K);
            } else
              j.values.indexOf(A) >= 0 && (R = A);
            A = R;
          }
      }
      if (B) {
        if (e.allowedSchemesAppliedToAttributes.indexOf(P) !== -1 && k(v, A))
          return void delete m.attribs[P];
        if (v === "script" && P === "src") {
          let j = !0;
          try {
            const R = O(A);
            if (e.allowedScriptHostnames || e.allowedScriptDomains) {
              const W = (e.allowedScriptHostnames || []).find(function(ae) {
                return ae === R.url.hostname;
              }), K = (e.allowedScriptDomains || []).find(function(ae) {
                return R.url.hostname === ae || R.url.hostname.endsWith(`.${ae}`);
              });
              j = W || K;
            }
          } catch {
            j = !1;
          }
          if (!j)
            return void delete m.attribs[P];
        }
        if (v === "iframe" && P === "src") {
          let j = !0;
          try {
            const R = O(A);
            if (R.isRelativeUrl)
              j = Oe(e, "allowIframeRelativeUrls") ? e.allowIframeRelativeUrls : !e.allowedIframeHostnames && !e.allowedIframeDomains;
            else if (e.allowedIframeHostnames || e.allowedIframeDomains) {
              const W = (e.allowedIframeHostnames || []).find(function(ae) {
                return ae === R.url.hostname;
              }), K = (e.allowedIframeDomains || []).find(function(ae) {
                return R.url.hostname === ae || R.url.hostname.endsWith(`.${ae}`);
              });
              j = W || K;
            }
          } catch {
            j = !1;
          }
          if (!j)
            return void delete m.attribs[P];
        }
        if (P === "srcset")
          try {
            let j = Sm(A);
            if (j.forEach(function(R) {
              k("srcset", R.url) && (R.evil = !0);
            }), j = us(j, function(R) {
              return !R.evil;
            }), !j.length)
              return void delete m.attribs[P];
            V = us(j, function(R) {
              return !R.evil;
            }), A = V.map(function(R) {
              if (!R.url)
                throw new Error("URL missing");
              return R.url + (R.w ? ` ${R.w}w` : "") + (R.h ? ` ${R.h}h` : "") + (R.d ? ` ${R.d}x` : "");
            }).join(", "), m.attribs[P] = A;
          } catch {
            return void delete m.attribs[P];
          }
        if (P === "class") {
          const j = c[v], R = c["*"], W = d[v], K = p[v], ae = p["*"], ce = [W, d["*"]].concat(K, ae).filter(function(Z) {
            return Z;
          });
          if (!(A = $(A, j && R ? cs(j, R) : j || R, ce)).length)
            return void delete m.attribs[P];
        }
        if (P === "style") {
          if (e.parseStyleAttributes)
            try {
              const j = function(R, W) {
                if (!W)
                  return R;
                const K = R.nodes[0];
                let ae;
                return ae = W[K.selector] && W["*"] ? cs(W[K.selector], W["*"]) : W[K.selector] || W["*"], ae && (R.nodes[0].nodes = K.nodes.reduce(function(ce) {
                  return function(Z, le) {
                    return Oe(ce, le.prop) && ce[le.prop].some(function(ve) {
                      return ve.test(le.value);
                    }) && Z.push(le), Z;
                  };
                }(ae), [])), R;
              }(Cm(v + " {" + A + "}", { map: !1 }), e.allowedStyles);
              if (A = function(R) {
                return R.nodes[0].nodes.reduce(function(W, K) {
                  return W.push(`${K.prop}:${K.value}${K.important ? " !important" : ""}`), W;
                }, []).join(";");
              }(j), A.length === 0)
                return void delete m.attribs[P];
            } catch {
              return typeof window < "u" && console.warn('Failed to parse "' + v + " {" + A + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), void delete m.attribs[P];
            }
          else if (e.allowedStyles)
            throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
        }
        a += " " + P, A && A.length ? a += '="' + E(A, !0) + '"' : e.allowedEmptyAttributes.includes(P) && (a += '=""');
      } else
        delete m.attribs[P];
      var V;
    }), e.selfClosing.indexOf(v) !== -1 ? a += " />" : (a += ">", !m.innerText || C || e.textFilter || (a += E(m.innerText), b = !0)), M && (a = r + E(a), r = ""), m.openingTagLength = a.length - m.tagPosition;
  }, ontext: function(v) {
    if (x)
      return;
    const y = D[D.length - 1];
    let m;
    if (y && (m = y.tag, v = y.innerText !== void 0 ? y.innerText : v), e.disallowedTagsMode !== "completelyDiscard" || o(m))
      if (e.disallowedTagsMode !== "discard" && e.disallowedTagsMode !== "completelyDiscard" || m !== "script" && m !== "style") {
        if (!b) {
          const M = E(v, !1);
          e.textFilter ? a += e.textFilter(M, m) : a += M;
        }
      } else
        a += v;
    else
      v = "";
    D.length && (D[D.length - 1].text += v);
  }, onclosetag: function(v, y) {
    if (e.onCloseTag && e.onCloseTag(v, y), x) {
      if (T--, T)
        return;
      x = !1;
    }
    const m = D.pop();
    if (!m)
      return;
    if (m.tag !== v)
      return void D.push(m);
    x = !!e.enforceHtmlBoundary && v === "html", h--;
    const M = L[h];
    if (M) {
      if (delete L[h], e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard")
        return void m.updateParentNodeText();
      r = a, a = "";
    }
    if (_[h] && (v = _[h], delete _[h]), e.exclusiveFilter) {
      const C = e.exclusiveFilter(m);
      if (C === "excludeTag")
        return M && (a = r, r = ""), void (a = a.substring(0, m.tagPosition) + a.substring(m.tagPosition + m.openingTagLength));
      if (C)
        return void (a = a.substring(0, m.tagPosition));
    }
    m.updateParentNodeMediaChildren(), m.updateParentNodeText(), e.selfClosing.indexOf(v) !== -1 || y && !o(v) && ["escape", "recursiveEscape"].indexOf(e.disallowedTagsMode) >= 0 ? M && (a = r, r = "") : (a += "</" + v + ">", M && (a = r + E(a), r = ""), b = !1);
  } }, e.parser);
  return S.write(t), S.end(), a;
  function w() {
    a = "", h = 0, D = [], L = {}, _ = {}, x = !1, T = 0;
  }
  function E(v, y) {
    return typeof v != "string" && (v += ""), e.parser.decodeEntities && (v = v.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), y && (v = v.replace(/"/g, "&quot;"))), v = v.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), y && (v = v.replace(/"/g, "&quot;")), v;
  }
  function k(v, y) {
    for (y = y.replace(/[\x00-\x20]+/g, ""); ; ) {
      const C = y.indexOf("<!--");
      if (C === -1)
        break;
      const I = y.indexOf("-->", C + 4);
      if (I === -1)
        break;
      y = y.substring(0, C) + y.substring(I + 3);
    }
    const m = y.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!m)
      return !!y.match(/^[/\\]{2}/) && !e.allowProtocolRelative;
    const M = m[1].toLowerCase();
    return Oe(e.allowedSchemesByTag, v) ? e.allowedSchemesByTag[v].indexOf(M) === -1 : !e.allowedSchemes || e.allowedSchemes.indexOf(M) === -1;
  }
  function O(v) {
    if ((v = v.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//")).startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let y = "relative://relative-site";
    for (let M = 0; M < 100; M++)
      y += `/${M}`;
    const m = new URL(v, y);
    return { isRelativeUrl: m && m.hostname === "relative-site" && m.protocol === "relative:", url: m };
  }
  function $(v, y, m) {
    return y ? (v = v.split(/\s+/)).filter(function(M) {
      return y.indexOf(M) !== -1 || m.some(function(C) {
        return C.test(M);
      });
    }).join(" ") : v;
  }
}
const Em = { decodeEntities: !0 };
rn.defaults = { allowedTags: ["address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4", "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div", "dl", "dt", "figcaption", "figure", "hr", "li", "menu", "ol", "p", "pre", "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn", "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp", "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption", "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr"], nonBooleanAttributes: ["abbr", "accept", "accept-charset", "accesskey", "action", "allow", "alt", "as", "autocapitalize", "autocomplete", "blocking", "charset", "cite", "class", "color", "cols", "colspan", "content", "contenteditable", "coords", "crossorigin", "data", "datetime", "decoding", "dir", "dirname", "download", "draggable", "enctype", "enterkeyhint", "fetchpriority", "for", "form", "formaction", "formenctype", "formmethod", "formtarget", "headers", "height", "hidden", "high", "href", "hreflang", "http-equiv", "id", "imagesizes", "imagesrcset", "inputmode", "integrity", "is", "itemid", "itemprop", "itemref", "itemtype", "kind", "label", "lang", "list", "loading", "low", "max", "maxlength", "media", "method", "min", "minlength", "name", "nonce", "optimum", "pattern", "ping", "placeholder", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "referrerpolicy", "rel", "rows", "rowspan", "sandbox", "scope", "shape", "size", "sizes", "slot", "span", "spellcheck", "src", "srcdoc", "srclang", "srcset", "start", "step", "style", "tabindex", "target", "title", "translate", "type", "usemap", "value", "width", "wrap", "onauxclick", "onafterprint", "onbeforematch", "onbeforeprint", "onbeforeunload", "onbeforetoggle", "onblur", "oncancel", "oncanplay", "oncanplaythrough", "onchange", "onclick", "onclose", "oncontextlost", "oncontextmenu", "oncontextrestored", "oncopy", "oncuechange", "oncut", "ondblclick", "ondrag", "ondragend", "ondragenter", "ondragleave", "ondragover", "ondragstart", "ondrop", "ondurationchange", "onemptied", "onended", "onerror", "onfocus", "onformdata", "onhashchange", "oninput", "oninvalid", "onkeydown", "onkeypress", "onkeyup", "onlanguagechange", "onload", "onloadeddata", "onloadedmetadata", "onloadstart", "onmessage", "onmessageerror", "onmousedown", "onmouseenter", "onmouseleave", "onmousemove", "onmouseout", "onmouseover", "onmouseup", "onoffline", "ononline", "onpagehide", "onpageshow", "onpaste", "onpause", "onplay", "onplaying", "onpopstate", "onprogress", "onratechange", "onreset", "onresize", "onrejectionhandled", "onscroll", "onscrollend", "onsecuritypolicyviolation", "onseeked", "onseeking", "onselect", "onslotchange", "onstalled", "onstorage", "onsubmit", "onsuspend", "ontimeupdate", "ontoggle", "onunhandledrejection", "onunload", "onvolumechange", "onwaiting", "onwheel"], disallowedTagsMode: "discard", allowedAttributes: { a: ["href", "name", "target"], img: ["src", "srcset", "alt", "title", "width", "height", "loading"] }, allowedEmptyAttributes: ["alt"], selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"], allowedSchemes: ["http", "https", "ftp", "mailto", "tel"], allowedSchemesByTag: {}, allowedSchemesAppliedToAttributes: ["href", "src", "cite"], allowProtocolRelative: !0, enforceHtmlBoundary: !1, parseStyleAttributes: !0, preserveEscapedAttributes: !1 }, rn.simpleTransform = function(t, e, n) {
  return n = n === void 0 || n, e = e || {}, function(a, r) {
    let i;
    if (n)
      for (i in e)
        r[i] = e[i];
    else
      r = e;
    return { tagName: t, attribs: r };
  };
};
const wm = kr(Nm), ft = (t) => {
  const { component: e, content: n } = t;
  return N(e, { dangerouslySetInnerHTML: { __html: wm(n, { allowedClasses: { "*": ["*"] } }) } });
}, rc = "https://merchandising-content-service-cdn.prod.merch.vpsvc.com/api/v1", ic = (t) => {
  const e = t?.apiPromise, [n, a] = ne(!1), [r, i] = ne(), [o, s] = ne(), [l, u] = ne(!1);
  return { isLoading: n, error: o, isError: l, data: r, triggerAPI: Te(async (c) => {
    if (e) {
      a(!0), u(!1);
      try {
        const d = await e(c);
        i(d), s(void 0);
      } catch (d) {
        s(d), u(!0), i(void 0);
      } finally {
        a(!1);
      }
    }
  }, [e]) };
}, ta = (t, e = !1) => {
  const n = G((u) => u.tenantConfiguration.tenant), a = G((u) => u.tenantConfiguration.locale), r = Ye(() => ({ apiPromise: () => (async (u) => {
    const c = encodeURI(u.dictionaryEntryKeyOrId), d = u.markdown ? "dictionaryEntryMarkdown" : "dictionaryEntry", p = await fetch(`${rc}/${u.tenant}/types/${d}/entries/${c}/cultures/${u.locale}?requestor=shipping-calculator`), g = await p.text();
    if (!p.ok)
      throw new Error(`Fetch failed with status ${p.status}: ${g}`);
    return g;
  })({ dictionaryEntryKeyOrId: t, tenant: n, locale: a, markdown: e }) }), [t, a, e, n]), { data: i, isLoading: o, isError: s, triggerAPI: l } = ic(r);
  return Ye(() => l(), [l]), { dictionaryEntry: i, dictionaryEntryLoading: o, dictionaryEntryError: s };
}, _m = ue(({ dialogOpen: t, onChangeDialogOpen: e }) => {
  const { dictionaryEntry: n } = ta("Shipping Information", !0), { dictionaryEntry: a } = ta("Product Page > Dismiss Alert");
  if (!n)
    return N(se, {});
  const r = J.parse(n, { async: !1 });
  return N(Nr, { isOpen: t, onRequestDismiss: () => {
    e(!1);
  }, variant: "panel-right", children: oe(Tr, { children: [N(Er, { children: N(wr, { visuallyHiddenLabel: a }) }), N(_r, { children: N(xr, { children: N(ft, { component: "span", content: r }) }) })] }) });
}), xm = ue(() => {
  const t = cn(), e = G((r) => r.shippingOptionsWithPricing.error.errorReason), { dictionaryEntry: n, dictionaryEntryLoading: a } = ta("Shipping exclusion");
  return Q(() => {
    n && t.trackShippingCalculatorEvent(xt.ShippingOptionsError, `${e}`, "Shipping Calculator Error");
  }, [n, t, e]), !n || a ? N(be, {}) : N(De, { fontSize: "small", children: n });
}), oc = ue(() => {
  const [t, e] = ne(!1), n = (a) => e(a);
  return oe(se, { children: [N(Je, { type: "button", onClick: () => n(!0), children: N(xm, {}) }), N(_m, { dialogOpen: t, onChangeDialogOpen: n })] });
}), km = async (t) => {
  const { auth: e, locale: n, productKey: a, version: r, country: i, postalCode: o, selections: s, tenantId: l, quantity: u, tenant: c, requestor: d } = t, p = `https://pricing.large-assortment.vpsvc.com/shipping-options/${c}/${a}/${r}`, g = `requestor=${d}&locale=${n}&tenantId=${l}&quantity=${u}&selections=${encodeURIComponent(JSON.stringify(s))}` + (i ? `&country=${i}` : "") + (o ? `&postalCode=${encodeURIComponent(o)}` : ""), f = await fetch(`${p}?${g}`, { headers: { "Access-Control-Allow-Origin": "*", Accept: "*/*", "Cache-Control": "no-cache", Authorization: e.authHeader } }), h = f.headers.get("content-type"), D = async () => h && h.includes("application/json") ? await f.json() : null;
  if (!f.ok) {
    const L = await D(), _ = new Error(L?.message || "Fetch error");
    throw _.status = f.status, _.messageCode = L?.messageCode, _.upstreamError = L?.upstreamError, _;
  }
  return await D();
}, sc = () => {
  const t = G((g) => g.authConfiguration), e = G((g) => g.productConfiguration), n = G((g) => g.tenantConfiguration), a = G((g) => g.clientConfiguration), r = cn(), i = ra(), o = Ye(() => t ? { apiPromise: (g) => km({ auth: t, productKey: e.productKey, version: e.productVersion, locale: n.locale, tenantId: n.tenantId, selections: e.productSelections, quantity: e.productQuantity, country: g.country, postalCode: g.postalCode, tenant: n.tenant, requestor: "paa-shipping-calc" + a.requestorId }) } : {}, [t, a.requestorId, e.productKey, e.productQuantity, e.productSelections, e.productVersion, n.locale, n.tenant, n.tenantId]), { data: s, isError: l, error: u, isLoading: c, triggerAPI: d } = ic(o), p = Te(({ country: g, postalCode: f }) => {
    const { country: h, postalCode: D } = ro();
    d({ country: g ?? h, postalCode: f ?? D });
  }, [d]);
  return Q(() => {
    i(Ld(c));
  }, [i, c]), Q(() => {
    if (!c) {
      if ((l || s) && i(Ad(!0)), l) {
        const f = "API Error", h = typeof (g = u) == "object" && g !== null ? function(_) {
          return _.messageCode;
        }(u) : f;
        r.trackShippingCalculatorEvent(xt.ShippingOptionsError, `${h}`, "Shipping Calculator Error"), i(io({ isError: !0, errorReason: h }));
        const { country: D, postalCode: L } = ro();
        i(Et({ postalCode: L, country: D }));
      }
      var g;
      s && (i(io({ isError: !1, errorReason: void 0 })), i(kd({ shippingOptions: s?.shippingOptions })), i(Id({ currency: s?.currency, fractionDigits: s?.fractionDigits })), i(nl(zs(s.shippingOptions))), Gr({ country: s.country, postalCode: s.postalCode }), i(Et({ postalCode: s.postalCode, country: s.country })));
    }
  }, [i, s, l, u, c, r]), p;
}, Am = ue(({ fastestShippingOption: t, slowestShippingOption: e, onShippingCalculatorClick: n }) => {
  const a = G((u) => u.userConfiguration).postalCode, r = $e(), [i, o] = ne(), s = r.getText("shippingCalculatorUpdatePostalCodeMessage"), l = t?.shippingMethodId === e?.shippingMethodId;
  if (Q(() => {
    t && e && !l ? o(r.getTokenizedShippingOptionsEstimatedDeliveryRangeMarkupString(a || "", t.promisedArrivalDate, e.promisedArrivalDate)) : t && o(r.getTokenizedShippingOptionsEstimatedDeliveryMarkupStringForSingleDate(a || "", t.promisedArrivalDate));
  }, [e, t, r, a, l]), !t && a) {
    const u = r.getTokenizedShippingOptionsNoDeliveryMessage(a);
    return oe(de, { onClick: () => n(e), children: [u, ". ", N(Je, { component: "button", children: s })] });
  }
  return a && t ? N(de, { children: N(Je, { component: "button", onClick: () => n(e), children: N(ft, { component: "span", content: i || "" }) }) }) : N(a && t ? be : se, {});
}), Lm = ue(({ fastestShippingOption: t, onShippingCalculatorClick: e }) => {
  const n = G((s) => s.userConfiguration?.postalCode), a = $e(), [r, i] = ne(), o = a.getText("shippingCalculatorUpdatePostalCodeMessage");
  if (Q(() => {
    t && n && i(a.getTokenizedShippingOptionsSelectedOptionMarkupString(t.promisedArrivalDate, n));
  }, [n, t, a]), !t && n) {
    const s = a.getTokenizedShippingOptionsNoDeliveryMessage(n);
    return oe(de, { onClick: () => e(t), children: [s, ". ", N(Je, { component: "button", children: o })] });
  }
  return n && t && r ? N(de, { children: N(Je, { component: "button", onClick: () => e(t), children: N(ft, { component: "span", content: r }) }) }) : N(n && (t || r) ? be : se, {});
}), Im = ue(({ freeShippingOption: t, freeShippingThresholdOption: e, onShippingCalculatorClick: n }) => {
  const a = G((d) => d.shippingOptionsWithPricing), r = G((d) => d.tenantConfiguration.locale), i = G((d) => d.tenantConfiguration.tenant), o = G((d) => d.userConfiguration).vatInclusivity, s = G((d) => d.userConfiguration?.postalCode), l = $e(), [u, c] = ne();
  return Q(() => {
    if (s && a.currency && a.fractionDigits)
      if (t)
        c(l.getTokenizedFreeShippingOptionsSelectedOptionMarkupString(t.promisedArrivalDate, s));
      else if (e?.freeShippingDetails) {
        const d = { taxed: e?.freeShippingDetails.orderThreshold, untaxed: e?.freeShippingDetails.orderThreshold, taxedInCents: e?.freeShippingDetails.orderThresholdInCents, untaxedInCents: e?.freeShippingDetails.orderThresholdInCents };
        Yr(i, r, e?.freeShippingDetails.includesTax, a.fractionDigits, a.currency, !1, d).then((p) => {
          c(l.getTokenizedFreeShippingOptionMessage(p));
        });
      } else
        c(void 0);
  }, [t, e, r, s, l, a.currency, a.fractionDigits, i, o]), u ? N(de, { children: N(Je, { className: "free-shipping-link", component: "button", onClick: () => n(e), children: N(ft, { component: "span", content: u }) }) }) : N(t || e || u ? be : se, {});
}), Pm = ue(() => {
  const t = G((h) => h.shippingOptionsWithPricing), e = G((h) => h.userConfiguration.country), n = cn(), a = G((h) => h.clientConfiguration.requestorId), r = a === Ve.ShippingCalculatorDev || a === Ve.CorePDP || a === Ve.LargeAssortmentsPDP, [i, o] = Ye(() => {
    return [(h = t?.shippingOptions, [...h].sort(Kn).find((D) => D.freeShippingDetails)), vd(t?.shippingOptions)];
    var h;
  }, [t?.shippingOptions]), s = Ye(() => zs(t?.shippingOptions), [t?.shippingOptions]), l = sn(), u = Ye(() => ((h) => {
    const D = [...h].sort(Kn);
    return D[D.length - 1];
  })(t?.shippingOptions), [t?.shippingOptions]), c = s?.shippingMethodId === o?.shippingMethodId || s?.shippingMethodId === i?.shippingMethodId, d = (h) => {
    const D = Vr(t.currency, h?.shippingDiscountedPrice.untaxed, h?.shippingDisplayText.name, h?.promisedArrivalDate, e);
    n.trackShippingCalculatorEvent(xt.ShippingOptionsEngaged, s ? D : "No Delivery options found");
  }, p = N(Lm, { fastestShippingOption: s, onShippingCalculatorClick: d }), g = N(Am, { fastestShippingOption: s, slowestShippingOption: u, onShippingCalculatorClick: d }), f = N(Im, { freeShippingOption: o, freeShippingThresholdOption: i, onShippingCalculatorClick: d });
  return l ? oe(de, { children: [g, f] }) : N(de, r && p && f ? { children: o && c ? f : oe(se, { children: [p, f] }) } : { children: o ? f : p });
}), Om = () => {
  const [t, e] = ne(!1), n = $e(), a = n.getText("shippingCalculatorDisclaimerLabel"), r = n.getText("estimatedDeliveryDisclaimerLabel"), i = n.getText("shippingCalculatorHelperText"), o = n.getText("shippingCalculatorDisclaimerPoint1Text"), s = sn();
  return oe(se, { children: [oe(De, { component: "div", textColor: "subtle", fontSkin: "body-small", children: [s ? r : a, " ", oe(Je, { component: "button", onClick: () => e((l) => !l), children: [i, t && N(fs, { skin: "standard", iconType: "caretUp", size: "20p" })] })] }), t && N(de, { mt: 1, children: [o].map((l) => N(De, { component: "div", textColor: "subtle", fontSkin: "body-small", children: l }, l)) })] });
};
var lc = {};
const Rm = { AF: { countryName: "Afghanistan", postalCodeFormat: "4Digits.json", alpha2: "AF", alpha3: "AFG", numeric3: "4" }, AX: { countryName: "Aland Islands", postalCodeFormat: "AX.json", alpha2: "AX", alpha3: "ALA", numeric3: "248" }, AL: { countryName: "Albania", postalCodeFormat: "4Digits.json", alpha2: "AL", alpha3: "ALB", numeric3: "8" }, DZ: { countryName: "Algeria", postalCodeFormat: "5Digits.json", alpha2: "DZ", alpha3: "DZA", numeric3: "12" }, AS: { countryName: "American Samoa", postalCodeFormat: "5Digits.json", alpha2: "AS", alpha3: "ASM", numeric3: "16" }, AD: { countryName: "Andorra", postalCodeFormat: "AD.json", alpha2: "AD", alpha3: "AND", numeric3: "20" }, AO: { countryName: "Angola", alpha2: "AO", alpha3: "AGO", numeric3: "24" }, AI: { countryName: "Anguilla", postalCodeFormat: "AI.json", alpha2: "AI", alpha3: "AIA", numeric3: "660" }, AQ: { countryName: "Antarctica", postalCodeFormat: "AQ.json", alpha2: "AQ", alpha3: "ATA", numeric3: "10" }, AG: { countryName: "Antigua and Barbuda", alpha2: "AG", alpha3: "ATG", numeric3: "28" }, AR: { countryName: "Argentina", postalCodeFormat: "4Digits.json", alpha2: "AR", alpha3: "ARG", numeric3: "32" }, AM: { countryName: "Armenia", postalCodeFormat: "4Digits.json", alpha2: "AM", alpha3: "ARM", numeric3: "51" }, AW: { countryName: "Aruba", alpha2: "AW", alpha3: "ABW", numeric3: "533" }, AU: { countryName: "Australia", postalCodeFormat: "4Digits.json", alpha2: "AU", alpha3: "AUS", numeric3: "36" }, AT: { countryName: "Austria", postalCodeFormat: "4Digits.json", alpha2: "AT", alpha3: "AUT", numeric3: "40" }, AZ: { countryName: "Azerbaijan", postalCodeFormat: "AZ.json", alpha2: "AZ", alpha3: "AZE", numeric3: "31" }, BS: { countryName: "Bahamas", alpha2: "BS", alpha3: "BHS", numeric3: "44" }, BH: { countryName: "Bahrain", postalCodeFormat: "BH.json", alpha2: "BH", alpha3: "BHR", numeric3: "48" }, BD: { countryName: "Bangladesh", postalCodeFormat: "4Digits.json", alpha2: "BD", alpha3: "BGD", numeric3: "50" }, BB: { countryName: "Barbados", postalCodeFormat: "BB.json", alpha2: "BB", alpha3: "BRB", numeric3: "52" }, BY: { countryName: "Belarus", postalCodeFormat: "6Digits.json", alpha2: "BY", alpha3: "BLR", numeric3: "112" }, BE: { countryName: "Belgium", postalCodeFormat: "4Digits.json", alpha2: "BE", alpha3: "BEL", numeric3: "56" }, BZ: { countryName: "Belize", alpha2: "BZ", alpha3: "BLZ", numeric3: "84" }, BJ: { countryName: "Benin", alpha2: "BJ", alpha3: "BEN", numeric3: "204" }, BM: { countryName: "Bermuda", alpha2: "BM", alpha3: "BMU", numeric3: "60" }, BT: { countryName: "Bhutan", postalCodeFormat: "5Digits.json", alpha2: "BT", alpha3: "BTN", numeric3: "64" }, BO: { countryName: "Bolivia", postalCodeFormat: "4Digits.json", alpha2: "BO", alpha3: "BOL", numeric3: "68" }, BA: { countryName: "Bosnia and Herzegovina", postalCodeFormat: "5Digits.json", alpha2: "BA", alpha3: "BIH", numeric3: "70" }, BW: { countryName: "Botswana", alpha2: "BW", alpha3: "BWA", numeric3: "72" }, BV: { countryName: "Bouvet Island", alpha2: "BV", alpha3: "BVT", numeric3: "74" }, BR: { countryName: "Brazil", postalCodeFormat: "8Digits.json", alpha2: "BR", alpha3: "BRA", numeric3: "76" }, VG: { countryName: "British Virgin Islands", postalCodeFormat: "VG.json", alpha2: "VG", alpha3: "VGB", numeric3: "92" }, IO: { countryName: "British Indian Ocean Territory", postalCodeFormat: "IO.json", alpha2: "IO", alpha3: "IOT", numeric3: "86" }, BN: { countryName: "Brunei Darussalam", postalCodeFormat: "BN.json", alpha2: "BN", alpha3: "BRN", numeric3: "96" }, BG: { countryName: "Bulgaria", postalCodeFormat: "4Digits.json", alpha2: "BG", alpha3: "BGR", numeric3: "100" }, BF: { countryName: "Burkina Faso", alpha2: "BF", alpha3: "BFA", numeric3: "854" }, BI: { countryName: "Burundi", alpha2: "BI", alpha3: "BDI", numeric3: "108" }, KH: { countryName: "Cambodia", postalCodeFormat: "5Digits.json", alpha2: "KH", alpha3: "KHM", numeric3: "116" }, CM: { countryName: "Cameroon", alpha2: "CM", alpha3: "CMR", numeric3: "120" }, CA: { countryName: "Canada", postalCodeFormat: "CA.json", alpha2: "CA", alpha3: "CAN", numeric3: "124" }, CV: { countryName: "Cape Verde", postalCodeFormat: "4Digits.json", alpha2: "CV", alpha3: "CPV", numeric3: "132" }, KY: { countryName: "Cayman Islands", postalCodeFormat: "KY.json", alpha2: "KY", alpha3: "CYM", numeric3: "136" }, CF: { countryName: "Central African Republic", alpha2: "CF", alpha3: "CAF", numeric3: "140" }, TD: { countryName: "Chad", postalCodeFormat: "5Digits.json", alpha2: "TD", alpha3: "TCD", numeric3: "148" }, CL: { countryName: "Chile", postalCodeFormat: "7Digits.json", alpha2: "CL", alpha3: "CHL", numeric3: "152" }, CN: { countryName: "China", postalCodeFormat: "6Digits.json", alpha2: "CN", alpha3: "CHN", numeric3: "156" }, HK: { countryName: "Hong Kong, Special Administrative Region of China", alpha2: "HK", alpha3: "HKG", numeric3: "344" }, MO: { countryName: "Macao, Special Administrative Region of China", alpha2: "MO", alpha3: "MAC", numeric3: "446" }, CX: { countryName: "Christmas Island", postalCodeFormat: "4Digits.json", alpha2: "CX", alpha3: "CXR", numeric3: "162" }, CC: { countryName: "Cocos (Keeling) Islands", postalCodeFormat: "4Digits.json", alpha2: "CC", alpha3: "CCK", numeric3: "166" }, CO: { countryName: "Colombia", postalCodeFormat: "6Digits.json", alpha2: "CO", alpha3: "COL", numeric3: "170" }, KM: { countryName: "Comoros", alpha2: "KM", alpha3: "COM", numeric3: "174" }, CG: { countryName: "Congo (Brazzaville)", alpha2: "CG", alpha3: "COG", numeric3: "178" }, CD: { countryName: "Congo, Democratic Republic of the", alpha2: "CD", alpha3: "COD", numeric3: "180" }, CK: { countryName: "Cook Islands", alpha2: "CK", alpha3: "COK", numeric3: "184" }, CR: { countryName: "Costa Rica", postalCodeFormat: "5Digits.json", alpha2: "CR", alpha3: "CRI", numeric3: "188" }, CI: { countryName: "Côte d'Ivoire", alpha2: "CI", alpha3: "CIV", numeric3: "384" }, HR: { countryName: "Croatia", postalCodeFormat: "5Digits.json", alpha2: "HR", alpha3: "HRV", numeric3: "191" }, CU: { countryName: "Cuba", postalCodeFormat: "5Digits.json", alpha2: "CU", alpha3: "CUB", numeric3: "192" }, CY: { countryName: "Cyprus", postalCodeFormat: "4Digits.json", alpha2: "CY", alpha3: "CYP", numeric3: "196" }, CZ: { countryName: "Czech Republic", postalCodeFormat: "5Digits.json", alpha2: "CZ", alpha3: "CZE", numeric3: "203" }, DK: { countryName: "Denmark", postalCodeFormat: "DK.json", alpha2: "DK", alpha3: "DNK", numeric3: "208" }, DJ: { countryName: "Djibouti", alpha2: "DJ", alpha3: "DJI", numeric3: "262" }, DM: { countryName: "Dominica", alpha2: "DM", alpha3: "DMA", numeric3: "212" }, DO: { countryName: "Dominican Republic", postalCodeFormat: "5Digits.json", alpha2: "DO", alpha3: "DOM", numeric3: "214" }, EC: { countryName: "Ecuador", postalCodeFormat: "6Digits.json", alpha2: "EC", alpha3: "ECU", numeric3: "218" }, EG: { countryName: "Egypt", postalCodeFormat: "5Digits.json", alpha2: "EG", alpha3: "EGY", numeric3: "818" }, SV: { countryName: "El Salvador", postalCodeFormat: "4Digits.json", alpha2: "SV", alpha3: "SLV", numeric3: "222" }, GQ: { countryName: "Equatorial Guinea", alpha2: "GQ", alpha3: "GNQ", numeric3: "226" }, ER: { countryName: "Eritrea", alpha2: "ER", alpha3: "ERI", numeric3: "232" }, EE: { countryName: "Estonia", postalCodeFormat: "5Digits.json", alpha2: "EE", alpha3: "EST", numeric3: "233" }, ET: { countryName: "Ethiopia", postalCodeFormat: "4Digits.json", alpha2: "ET", alpha3: "ETH", numeric3: "231" }, FK: { countryName: "Falkland Islands (Malvinas)", postalCodeFormat: "FK.json", alpha2: "FK", alpha3: "FLK", numeric3: "238" }, FO: { countryName: "Faroe Islands", postalCodeFormat: "3Digits.json", alpha2: "FO", alpha3: "FRO", numeric3: "234" }, FJ: { countryName: "Fiji", alpha2: "FJ", alpha3: "FJI", numeric3: "242" }, FI: { countryName: "Finland", postalCodeFormat: "5Digits.json", alpha2: "FI", alpha3: "FIN", numeric3: "246" }, FR: { countryName: "France", postalCodeFormat: "5Digits.json", alpha2: "FR", alpha3: "FRA", numeric3: "250" }, GF: { countryName: "French Guiana", postalCodeFormat: "GF.json", alpha2: "GF", alpha3: "GUF", numeric3: "254" }, PF: { countryName: "French Polynesia", postalCodeFormat: "PF.json", alpha2: "PF", alpha3: "PYF", numeric3: "258" }, TF: { countryName: "French Southern Territories", alpha2: "TF", alpha3: "ATF", numeric3: "260" }, GA: { countryName: "Gabon", alpha2: "GA", alpha3: "GAB", numeric3: "266" }, GM: { countryName: "Gambia", alpha2: "GM", alpha3: "GMB", numeric3: "270" }, GE: { countryName: "Georgia", postalCodeFormat: "4Digits.json", alpha2: "GE", alpha3: "GEO", numeric3: "268" }, DE: { countryName: "Germany", postalCodeFormat: "5Digits.json", alpha2: "DE", alpha3: "DEU", numeric3: "276" }, GH: { countryName: "Ghana", alpha2: "GH", alpha3: "GHA", numeric3: "288" }, GI: { countryName: "Gibraltar", postalCodeFormat: "GI.json", alpha2: "GI", alpha3: "GIB", numeric3: "292" }, GR: { countryName: "Greece", postalCodeFormat: "5Digits.json", alpha2: "GR", alpha3: "GRC", numeric3: "300" }, GL: { countryName: "Greenland", postalCodeFormat: "4Digits.json", alpha2: "GL", alpha3: "GRL", numeric3: "304" }, GD: { countryName: "Grenada", alpha2: "GD", alpha3: "GRD", numeric3: "308" }, GP: { countryName: "Guadeloupe", postalCodeFormat: "GP.json", alpha2: "GP", alpha3: "GLP", numeric3: "312" }, GU: { countryName: "Guam", postalCodeFormat: "US.json", alpha2: "GU", alpha3: "GUM", numeric3: "316" }, GT: { countryName: "Guatemala", postalCodeFormat: "5Digits.json", alpha2: "GT", alpha3: "GTM", numeric3: "320" }, GG: { countryName: "Guernsey", postalCodeFormat: "GG.json", alpha2: "GG", alpha3: "GGY", numeric3: "831" }, GN: { countryName: "Guinea", postalCodeFormat: "3Digits.json", alpha2: "GN", alpha3: "GIN", numeric3: "324" }, GW: { countryName: "Guinea-Bissau", postalCodeFormat: "4Digits.json", alpha2: "GW", alpha3: "GNB", numeric3: "624" }, GY: { countryName: "Guyana", alpha2: "GY", alpha3: "GUY", numeric3: "328" }, HT: { countryName: "Haiti", postalCodeFormat: "4Digits.json", alpha2: "HT", alpha3: "HTI", numeric3: "332" }, HM: { countryName: "Heard Island and Mcdonald Islands", postalCodeFormat: "4Digits.json", alpha2: "HM", alpha3: "HMD", numeric3: "334" }, VA: { countryName: "Holy See (Vatican City State)", postalCodeFormat: "VA.json", alpha2: "VA", alpha3: "VAT", numeric3: "336" }, HN: { countryName: "Honduras", postalCodeFormat: "HN.json", alpha2: "HN", alpha3: "HND", numeric3: "340" }, HU: { countryName: "Hungary", postalCodeFormat: "4Digits.json", alpha2: "HU", alpha3: "HUN", numeric3: "348" }, IS: { countryName: "Iceland", postalCodeFormat: "3Digits.json", alpha2: "IS", alpha3: "ISL", numeric3: "352" }, IN: { countryName: "India", postalCodeFormat: "6Digits.json", alpha2: "IN", alpha3: "IND", numeric3: "356" }, IC: { countryName: "Canary Islands", postalCodeFormat: "5Digits.json", alpha2: "IC", alpha3: "", numeric3: "" }, ID: { countryName: "Indonesia", postalCodeFormat: "5Digits.json", alpha2: "ID", alpha3: "IDN", numeric3: "360" }, IR: { countryName: "Iran, Islamic Republic of", postalCodeFormat: "10Digits.json", alpha2: "IR", alpha3: "IRN", numeric3: "364" }, IQ: { countryName: "Iraq", postalCodeFormat: "5Digits.json", alpha2: "IQ", alpha3: "IRQ", numeric3: "368" }, IE: { countryName: "Ireland", postalCodeFormat: "IE.json", alpha2: "IE", alpha3: "IRL", numeric3: "372" }, IM: { countryName: "Isle of Man", postalCodeFormat: "IM.json", alpha2: "IM", alpha3: "IMN", numeric3: "833" }, IL: { countryName: "Israel", postalCodeFormat: "7Digits.json", alpha2: "IL", alpha3: "ISR", numeric3: "376" }, IT: { countryName: "Italy", postalCodeFormat: "5Digits.json", alpha2: "IT", alpha3: "ITA", numeric3: "380" }, JM: { countryName: "Jamaica", postalCodeFormat: "2Digits.json", alpha2: "JM", alpha3: "JAM", numeric3: "388" }, JP: { countryName: "Japan", postalCodeFormat: "7Digits.json", alpha2: "JP", alpha3: "JPN", numeric3: "392" }, JE: { countryName: "Jersey", postalCodeFormat: "JE.json", alpha2: "JE", alpha3: "JEY", numeric3: "832" }, JO: { countryName: "Jordan", postalCodeFormat: "5Digits.json", alpha2: "JO", alpha3: "JOR", numeric3: "400" }, KZ: { countryName: "Kazakhstan", postalCodeFormat: "6Digits.json", alpha2: "KZ", alpha3: "KAZ", numeric3: "398" }, KE: { countryName: "Kenya", postalCodeFormat: "5Digits.json", alpha2: "KE", alpha3: "KEN", numeric3: "404" }, KI: { countryName: "Kiribati", alpha2: "KI", alpha3: "KIR", numeric3: "296" }, KP: { countryName: "Korea, Democratic People's Republic of", alpha2: "KP", alpha3: "PRK", numeric3: "408" }, KR: { countryName: "Korea, Republic of", postalCodeFormat: "5Digits.json", alpha2: "KR", alpha3: "KOR", numeric3: "410" }, KW: { countryName: "Kuwait", postalCodeFormat: "5Digits.json", alpha2: "KW", alpha3: "KWT", numeric3: "414" }, KG: { countryName: "Kyrgyzstan", postalCodeFormat: "6Digits.json", alpha2: "KG", alpha3: "KGZ", numeric3: "417" }, LA: { countryName: "Lao PDR", postalCodeFormat: "5Digits.json", alpha2: "LA", alpha3: "LAO", numeric3: "418" }, LV: { countryName: "Latvia", postalCodeFormat: "LV.json", alpha2: "LV", alpha3: "LVA", numeric3: "428" }, LB: { countryName: "Lebanon", postalCodeFormat: "LB.json", alpha2: "LB", alpha3: "LBN", numeric3: "422" }, LS: { countryName: "Lesotho", postalCodeFormat: "3Digits.json", alpha2: "LS", alpha3: "LSO", numeric3: "426" }, LR: { countryName: "Liberia", postalCodeFormat: "4Digits.json", alpha2: "LR", alpha3: "LBR", numeric3: "430" }, LY: { countryName: "Libya", postalCodeFormat: "5Digits.json", alpha2: "LY", alpha3: "LBY", numeric3: "434" }, LI: { countryName: "Liechtenstein", postalCodeFormat: "4Digits.json", alpha2: "LI", alpha3: "LIE", numeric3: "438" }, LT: { countryName: "Lithuania", postalCodeFormat: "LT.json", alpha2: "LT", alpha3: "LTU", numeric3: "440" }, LU: { countryName: "Luxembourg", postalCodeFormat: "LU.json", alpha2: "LU", alpha3: "LUX", numeric3: "442" }, MK: { countryName: "Macedonia, Republic of", postalCodeFormat: "4Digits.json", alpha2: "MK", alpha3: "MKD", numeric3: "807" }, MG: { countryName: "Madagascar", postalCodeFormat: "3Digits.json", alpha2: "MG", alpha3: "MDG", numeric3: "450" }, MW: { countryName: "Malawi", alpha2: "MW", alpha3: "MWI", numeric3: "454" }, MY: { countryName: "Malaysia", postalCodeFormat: "5Digits.json", alpha2: "MY", alpha3: "MYS", numeric3: "458" }, MV: { countryName: "Maldives", postalCodeFormat: "5Digits.json", alpha2: "MV", alpha3: "MDV", numeric3: "462" }, ML: { countryName: "Mali", alpha2: "ML", alpha3: "MLI", numeric3: "466" }, MT: { countryName: "Malta", postalCodeFormat: "MT.json", alpha2: "MT", alpha3: "MLT", numeric3: "470" }, MH: { countryName: "Marshall Islands", postalCodeFormat: "US.json", alpha2: "MH", alpha3: "MHL", numeric3: "584" }, MQ: { countryName: "Martinique", postalCodeFormat: "5Digits.json", alpha2: "MQ", alpha3: "MTQ", numeric3: "474" }, MR: { countryName: "Mauritania", alpha2: "MR", alpha3: "MRT", numeric3: "478" }, MU: { countryName: "Mauritius", postalCodeFormat: "5Digits.json", alpha2: "MU", alpha3: "MUS", numeric3: "480" }, YT: { countryName: "Mayotte", postalCodeFormat: "5Digits.json", alpha2: "YT", alpha3: "MYT", numeric3: "175" }, MX: { countryName: "Mexico", postalCodeFormat: "5Digits.json", alpha2: "MX", alpha3: "MEX", numeric3: "484" }, FM: { countryName: "Micronesia, Federated States of", postalCodeFormat: "US.json", alpha2: "FM", alpha3: "FSM", numeric3: "583" }, MD: { countryName: "Moldova", postalCodeFormat: "MD.json", alpha2: "MD", alpha3: "MDA", numeric3: "498" }, MC: { countryName: "Monaco", postalCodeFormat: "MC.json", alpha2: "MC", alpha3: "MCO", numeric3: "492" }, MN: { countryName: "Mongolia", postalCodeFormat: "5Digits.json", alpha2: "MN", alpha3: "MNG", numeric3: "496" }, ME: { countryName: "Montenegro", postalCodeFormat: "5Digits.json", alpha2: "ME", alpha3: "MNE", numeric3: "499" }, MS: { countryName: "Montserrat", postalCodeFormat: "MS.json", alpha2: "MS", alpha3: "MSR", numeric3: "500" }, MA: { countryName: "Morocco", postalCodeFormat: "5Digits.json", alpha2: "MA", alpha3: "MAR", numeric3: "504" }, MZ: { countryName: "Mozambique", postalCodeFormat: "4Digits.json", alpha2: "MZ", alpha3: "MOZ", numeric3: "508" }, MM: { countryName: "Myanmar", postalCodeFormat: "5Digits.json", alpha2: "MM", alpha3: "MMR", numeric3: "104" }, NA: { countryName: "Namibia", postalCodeFormat: "5Digits.json", alpha2: "NA", alpha3: "NAM", numeric3: "516" }, NR: { countryName: "Nauru", alpha2: "NR", alpha3: "NRU", numeric3: "520" }, NP: { countryName: "Nepal", postalCodeFormat: "5Digits.json", alpha2: "NP", alpha3: "NPL", numeric3: "524" }, NL: { countryName: "Netherlands", postalCodeFormat: "NL.json", alpha2: "NL", alpha3: "NLD", numeric3: "528" }, AN: { countryName: "Netherlands Antilles", alpha2: "AN", alpha3: "ANT", numeric3: "530" }, NC: { countryName: "New Caledonia", postalCodeFormat: "NC.json", alpha2: "NC", alpha3: "NCL", numeric3: "540" }, NZ: { countryName: "New Zealand", postalCodeFormat: "4Digits.json", alpha2: "NZ", alpha3: "NZL", numeric3: "554" }, NI: { countryName: "Nicaragua", postalCodeFormat: "5Digits.json", alpha2: "NI", alpha3: "NIC", numeric3: "558" }, NE: { countryName: "Niger", postalCodeFormat: "4Digits.json", alpha2: "NE", alpha3: "NER", numeric3: "562" }, NG: { countryName: "Nigeria", postalCodeFormat: "6Digits.json", alpha2: "NG", alpha3: "NGA", numeric3: "566" }, NU: { countryName: "Niue", alpha2: "NU", alpha3: "NIU", numeric3: "570" }, NF: { countryName: "Norfolk Island", postalCodeFormat: "4Digits.json", alpha2: "NF", alpha3: "NFK", numeric3: "574" }, MP: { countryName: "Northern Mariana Islands", postalCodeFormat: "US.json", alpha2: "MP", alpha3: "MNP", numeric3: "580" }, NO: { countryName: "Norway", postalCodeFormat: "4Digits.json", alpha2: "NO", alpha3: "NOR", numeric3: "578" }, OM: { countryName: "Oman", postalCodeFormat: "3Digits.json", alpha2: "OM", alpha3: "OMN", numeric3: "512" }, PK: { countryName: "Pakistan", postalCodeFormat: "5Digits.json", alpha2: "PK", alpha3: "PAK", numeric3: "586" }, PW: { countryName: "Palau", postalCodeFormat: "US.json", alpha2: "PW", alpha3: "PLW", numeric3: "585" }, PS: { countryName: "Palestinian Territory, Occupied", postalCodeFormat: "3Digits.json", alpha2: "PS", alpha3: "PSE", numeric3: "275" }, PA: { countryName: "Panama", postalCodeFormat: "4Digits.json", alpha2: "PA", alpha3: "PAN", numeric3: "591" }, PG: { countryName: "Papua New Guinea", postalCodeFormat: "3Digits.json", alpha2: "PG", alpha3: "PNG", numeric3: "598" }, PY: { countryName: "Paraguay", postalCodeFormat: "4Digits.json", alpha2: "PY", alpha3: "PRY", numeric3: "600" }, PE: { countryName: "Peru", postalCodeFormat: "5Digits.json", alpha2: "PE", alpha3: "PER", numeric3: "604" }, PH: { countryName: "Philippines", postalCodeFormat: "4Digits.json", alpha2: "PH", alpha3: "PHL", numeric3: "608" }, PN: { countryName: "Pitcairn", postalCodeFormat: "PN.json", alpha2: "PN", alpha3: "PCN", numeric3: "612" }, PL: { countryName: "Poland", postalCodeFormat: "PL.json", alpha2: "PL", alpha3: "POL", numeric3: "616" }, PT: { countryName: "Portugal", postalCodeFormat: "PT.json", alpha2: "PT", alpha3: "PRT", numeric3: "620" }, PR: { countryName: "Puerto Rico", postalCodeFormat: "US.json", alpha2: "PR", alpha3: "PRI", numeric3: "630" }, QA: { countryName: "Qatar", alpha2: "QA", alpha3: "QAT", numeric3: "634" }, RE: { countryName: "Réunion", postalCodeFormat: "RE.json", alpha2: "RE", alpha3: "REU", numeric3: "638" }, RO: { countryName: "Romania", postalCodeFormat: "6Digits.json", alpha2: "RO", alpha3: "ROU", numeric3: "642" }, RU: { countryName: "Russian Federation", postalCodeFormat: "RU.json", alpha2: "RU", alpha3: "RUS", numeric3: "643" }, RW: { countryName: "Rwanda", alpha2: "RW", alpha3: "RWA", numeric3: "646" }, BL: { countryName: "Saint-Barthélemy", postalCodeFormat: "BL.json", alpha2: "BL", alpha3: "BLM", numeric3: "652" }, SH: { countryName: "Saint Helena", postalCodeFormat: "SH.json", alpha2: "SH", alpha3: "SHN", numeric3: "654" }, KN: { countryName: "Saint Kitts and Nevis", alpha2: "KN", alpha3: "KNA", numeric3: "659" }, LC: { countryName: "Saint Lucia", postalCodeFormat: "LC.json", alpha2: "LC", alpha3: "LCA", numeric3: "662" }, MF: { countryName: "Saint-Martin (French part)", postalCodeFormat: "MF.json", alpha2: "MF", alpha3: "MAF", numeric3: "663" }, PM: { countryName: "Saint Pierre and Miquelon", postalCodeFormat: "PM.json", alpha2: "PM", alpha3: "SPM", numeric3: "666" }, VC: { countryName: "Saint Vincent and Grenadines", postalCodeFormat: "VC.json", alpha2: "VC", alpha3: "VCT", numeric3: "670" }, WS: { countryName: "Samoa", postalCodeFormat: "WS.json", alpha2: "WS", alpha3: "WSM", numeric3: "882" }, SM: { countryName: "San Marino", postalCodeFormat: "SM.json", alpha2: "SM", alpha3: "SMR", numeric3: "674" }, ST: { countryName: "Sao Tome and Principe", alpha2: "ST", alpha3: "STP", numeric3: "678" }, SA: { countryName: "Saudi Arabia", postalCodeFormat: "US.json", alpha2: "SA", alpha3: "SAU", numeric3: "682" }, SN: { countryName: "Senegal", postalCodeFormat: "5Digits.json", alpha2: "SN", alpha3: "SEN", numeric3: "686" }, RS: { countryName: "Serbia", postalCodeFormat: "5Digits.json", alpha2: "RS", alpha3: "SRB", numeric3: "688" }, SC: { countryName: "Seychelles", alpha2: "SC", alpha3: "SYC", numeric3: "690" }, SL: { countryName: "Sierra Leone", alpha2: "SL", alpha3: "SLE", numeric3: "694" }, SG: { countryName: "Singapore", postalCodeFormat: "6Digits.json", alpha2: "SG", alpha3: "SGP", numeric3: "702" }, SK: { countryName: "Slovakia", postalCodeFormat: "5Digits.json", alpha2: "SK", alpha3: "SVK", numeric3: "703" }, SI: { countryName: "Slovenia", postalCodeFormat: "4Digits.json", alpha2: "SI", alpha3: "SVN", numeric3: "705" }, SB: { countryName: "Solomon Islands", alpha2: "SB", alpha3: "SLB", numeric3: "90" }, SO: { countryName: "Somalia", postalCodeFormat: "SO.json", alpha2: "SO", alpha3: "SOM", numeric3: "706" }, ZA: { countryName: "South Africa", postalCodeFormat: "4Digits.json", alpha2: "ZA", alpha3: "ZAF", numeric3: "710" }, GS: { countryName: "South Georgia and the South Sandwich Islands", postalCodeFormat: "GS.json", alpha2: "GS", alpha3: "SGS", numeric3: "239" }, SS: { countryName: "South Sudan", alpha2: "SS", alpha3: "SSD", numeric3: "728" }, ES: { countryName: "Spain", postalCodeFormat: "5Digits.json", alpha2: "ES", alpha3: "ESP", numeric3: "724" }, LK: { countryName: "Sri Lanka", postalCodeFormat: "5Digits.json", alpha2: "LK", alpha3: "LKA", numeric3: "144" }, SD: { countryName: "Sudan", postalCodeFormat: "5Digits.json", alpha2: "SD", alpha3: "SDN", numeric3: "736" }, SR: { countryName: "Suriname *", alpha2: "SR", alpha3: "SUR", numeric3: "740" }, SJ: { countryName: "Svalbard and Jan Mayen Islands", postalCodeFormat: "4Digits.json", alpha2: "SJ", alpha3: "SJM", numeric3: "744" }, SZ: { countryName: "Swaziland", postalCodeFormat: "SZ.json", alpha2: "SZ", alpha3: "SWZ", numeric3: "748" }, SE: { countryName: "Sweden", postalCodeFormat: "5Digits.json", alpha2: "SE", alpha3: "SWE", numeric3: "752" }, CH: { countryName: "Switzerland", postalCodeFormat: "4Digits.json", alpha2: "CH", alpha3: "CHE", numeric3: "756" }, SY: { countryName: "Syrian Arab Republic (Syria)", alpha2: "SY", alpha3: "SYR", numeric3: "760" }, TW: { countryName: "Taiwan, Republic of China", postalCodeFormat: "TW.json", alpha2: "TW", alpha3: "TWN", numeric3: "158" }, TJ: { countryName: "Tajikistan", postalCodeFormat: "6Digits.json", alpha2: "TJ", alpha3: "TJK", numeric3: "762" }, TZ: { countryName: "Tanzania *, United Republic of", postalCodeFormat: "5Digits.json", alpha2: "TZ", alpha3: "TZA", numeric3: "834" }, TH: { countryName: "Thailand", postalCodeFormat: "5Digits.json", alpha2: "TH", alpha3: "THA", numeric3: "764" }, TL: { countryName: "Timor-Leste", alpha2: "TL", alpha3: "TLS", numeric3: "626" }, TG: { countryName: "Togo", alpha2: "TG", alpha3: "TGO", numeric3: "768" }, TK: { countryName: "Tokelau", alpha2: "TK", alpha3: "TKL", numeric3: "772" }, TO: { countryName: "Tonga", alpha2: "TO", alpha3: "TON", numeric3: "776" }, TT: { countryName: "Trinidad and Tobago", postalCodeFormat: "6Digits.json", alpha2: "TT", alpha3: "TTO", numeric3: "780" }, TN: { countryName: "Tunisia", postalCodeFormat: "4Digits.json", alpha2: "TN", alpha3: "TUN", numeric3: "788" }, TR: { countryName: "Turkey", postalCodeFormat: "5Digits.json", alpha2: "TR", alpha3: "TUR", numeric3: "792" }, TM: { countryName: "Turkmenistan", postalCodeFormat: "6Digits.json", alpha2: "TM", alpha3: "TKM", numeric3: "795" }, TC: { countryName: "Turks and Caicos Islands", postalCodeFormat: "TC.json", alpha2: "TC", alpha3: "TCA", numeric3: "796" }, TV: { countryName: "Tuvalu", alpha2: "TV", alpha3: "TUV", numeric3: "798" }, UG: { countryName: "Uganda", alpha2: "UG", alpha3: "UGA", numeric3: "800" }, UA: { countryName: "Ukraine", postalCodeFormat: "5Digits.json", alpha2: "UA", alpha3: "UKR", numeric3: "804" }, AE: { countryName: "United Arab Emirates", alpha2: "AE", alpha3: "ARE", numeric3: "784" }, GB: { countryName: "United Kingdom", postalCodeFormat: "GB.json", alpha2: "GB", alpha3: "GBR", numeric3: "826" }, US: { countryName: "United States of America", postalCodeFormat: "US.json", alpha2: "US", alpha3: "USA", numeric3: "840" }, UM: { countryName: "United States Minor Outlying Islands", alpha2: "UM", alpha3: "UMI", numeric3: "581" }, UY: { countryName: "Uruguay", postalCodeFormat: "5Digits.json", alpha2: "UY", alpha3: "URY", numeric3: "858" }, UZ: { countryName: "Uzbekistan", postalCodeFormat: "6Digits.json", alpha2: "UZ", alpha3: "UZB", numeric3: "860" }, VU: { countryName: "Vanuatu", alpha2: "VU", alpha3: "VUT", numeric3: "548" }, VE: { countryName: "Venezuela (Bolivarian Republic of)", postalCodeFormat: "VE.json", alpha2: "VE", alpha3: "VEN", numeric3: "862" }, VN: { countryName: "Viet Nam", postalCodeFormat: "6Digits.json", alpha2: "VN", alpha3: "VNM", numeric3: "704" }, VI: { countryName: "Virgin Islands, US", postalCodeFormat: "US.json", alpha2: "VI", alpha3: "VIR", numeric3: "850" }, WF: { countryName: "Wallis and Futuna Islands", postalCodeFormat: "WF.json", alpha2: "WF", alpha3: "WLF", numeric3: "876" }, EH: { countryName: "Western Sahara", alpha2: "EH", alpha3: "ESH", numeric3: "732" }, YE: { countryName: "Yemen", alpha2: "YE", alpha3: "YEM", numeric3: "887" }, ZM: { countryName: "Zambia", postalCodeFormat: "5Digits.json", alpha2: "ZM", alpha3: "ZMB", numeric3: "894" }, ZW: { countryName: "Zimbabwe", alpha2: "ZW", alpha3: "ZWE", numeric3: "716" } }, Fm = { AFG: { countryName: "Afghanistan", postalCodeFormat: "4Digits.json", alpha2: "AF", alpha3: "AFG", numeric3: "4" }, ALA: { countryName: "Aland Islands", postalCodeFormat: "AX.json", alpha2: "AX", alpha3: "ALA", numeric3: "248" }, ALB: { countryName: "Albania", postalCodeFormat: "4Digits.json", alpha2: "AL", alpha3: "ALB", numeric3: "8" }, DZA: { countryName: "Algeria", postalCodeFormat: "5Digits.json", alpha2: "DZ", alpha3: "DZA", numeric3: "12" }, ASM: { countryName: "American Samoa", postalCodeFormat: "5Digits.json", alpha2: "AS", alpha3: "ASM", numeric3: "16" }, AND: { countryName: "Andorra", postalCodeFormat: "AD.json", alpha2: "AD", alpha3: "AND", numeric3: "20" }, AGO: { countryName: "Angola", alpha2: "AO", alpha3: "AGO", numeric3: "24" }, AIA: { countryName: "Anguilla", postalCodeFormat: "AI.json", alpha2: "AI", alpha3: "AIA", numeric3: "660" }, ATA: { countryName: "Antarctica", postalCodeFormat: "AQ.json", alpha2: "AQ", alpha3: "ATA", numeric3: "10" }, ATG: { countryName: "Antigua and Barbuda", alpha2: "AG", alpha3: "ATG", numeric3: "28" }, ARG: { countryName: "Argentina", postalCodeFormat: "4Digits.json", alpha2: "AR", alpha3: "ARG", numeric3: "32" }, ARM: { countryName: "Armenia", postalCodeFormat: "4Digits.json", alpha2: "AM", alpha3: "ARM", numeric3: "51" }, ABW: { countryName: "Aruba", alpha2: "AW", alpha3: "ABW", numeric3: "533" }, AUS: { countryName: "Australia", postalCodeFormat: "4Digits.json", alpha2: "AU", alpha3: "AUS", numeric3: "36" }, AUT: { countryName: "Austria", postalCodeFormat: "4Digits.json", alpha2: "AT", alpha3: "AUT", numeric3: "40" }, AZE: { countryName: "Azerbaijan", postalCodeFormat: "AZ.json", alpha2: "AZ", alpha3: "AZE", numeric3: "31" }, BHS: { countryName: "Bahamas", alpha2: "BS", alpha3: "BHS", numeric3: "44" }, BHR: { countryName: "Bahrain", postalCodeFormat: "BH.json", alpha2: "BH", alpha3: "BHR", numeric3: "48" }, BGD: { countryName: "Bangladesh", postalCodeFormat: "4Digits.json", alpha2: "BD", alpha3: "BGD", numeric3: "50" }, BRB: { countryName: "Barbados", postalCodeFormat: "BB.json", alpha2: "BB", alpha3: "BRB", numeric3: "52" }, BLR: { countryName: "Belarus", postalCodeFormat: "6Digits.json", alpha2: "BY", alpha3: "BLR", numeric3: "112" }, BEL: { countryName: "Belgium", postalCodeFormat: "4Digits.json", alpha2: "BE", alpha3: "BEL", numeric3: "56" }, BLZ: { countryName: "Belize", alpha2: "BZ", alpha3: "BLZ", numeric3: "84" }, BEN: { countryName: "Benin", alpha2: "BJ", alpha3: "BEN", numeric3: "204" }, BMU: { countryName: "Bermuda", alpha2: "BM", alpha3: "BMU", numeric3: "60" }, BTN: { countryName: "Bhutan", postalCodeFormat: "5Digits.json", alpha2: "BT", alpha3: "BTN", numeric3: "64" }, BOL: { countryName: "Bolivia", postalCodeFormat: "4Digits.json", alpha2: "BO", alpha3: "BOL", numeric3: "68" }, BIH: { countryName: "Bosnia and Herzegovina", postalCodeFormat: "5Digits.json", alpha2: "BA", alpha3: "BIH", numeric3: "70" }, BWA: { countryName: "Botswana", alpha2: "BW", alpha3: "BWA", numeric3: "72" }, BVT: { countryName: "Bouvet Island", alpha2: "BV", alpha3: "BVT", numeric3: "74" }, BRA: { countryName: "Brazil", postalCodeFormat: "8Digits.json", alpha2: "BR", alpha3: "BRA", numeric3: "76" }, VGB: { countryName: "British Virgin Islands", postalCodeFormat: "VG.json", alpha2: "VG", alpha3: "VGB", numeric3: "92" }, IOT: { countryName: "British Indian Ocean Territory", postalCodeFormat: "IO.json", alpha2: "IO", alpha3: "IOT", numeric3: "86" }, BRN: { countryName: "Brunei Darussalam", postalCodeFormat: "BN.json", alpha2: "BN", alpha3: "BRN", numeric3: "96" }, BGR: { countryName: "Bulgaria", postalCodeFormat: "4Digits.json", alpha2: "BG", alpha3: "BGR", numeric3: "100" }, BFA: { countryName: "Burkina Faso", alpha2: "BF", alpha3: "BFA", numeric3: "854" }, BDI: { countryName: "Burundi", alpha2: "BI", alpha3: "BDI", numeric3: "108" }, KHM: { countryName: "Cambodia", postalCodeFormat: "5Digits.json", alpha2: "KH", alpha3: "KHM", numeric3: "116" }, CMR: { countryName: "Cameroon", alpha2: "CM", alpha3: "CMR", numeric3: "120" }, CAN: { countryName: "Canada", postalCodeFormat: "CA.json", alpha2: "CA", alpha3: "CAN", numeric3: "124" }, CPV: { countryName: "Cape Verde", postalCodeFormat: "4Digits.json", alpha2: "CV", alpha3: "CPV", numeric3: "132" }, CYM: { countryName: "Cayman Islands", postalCodeFormat: "KY.json", alpha2: "KY", alpha3: "CYM", numeric3: "136" }, CAF: { countryName: "Central African Republic", alpha2: "CF", alpha3: "CAF", numeric3: "140" }, TCD: { countryName: "Chad", postalCodeFormat: "5Digits.json", alpha2: "TD", alpha3: "TCD", numeric3: "148" }, CHL: { countryName: "Chile", postalCodeFormat: "7Digits.json", alpha2: "CL", alpha3: "CHL", numeric3: "152" }, CHN: { countryName: "China", postalCodeFormat: "6Digits.json", alpha2: "CN", alpha3: "CHN", numeric3: "156" }, HKG: { countryName: "Hong Kong, Special Administrative Region of China", alpha2: "HK", alpha3: "HKG", numeric3: "344" }, MAC: { countryName: "Macao, Special Administrative Region of China", alpha2: "MO", alpha3: "MAC", numeric3: "446" }, CXR: { countryName: "Christmas Island", postalCodeFormat: "4Digits.json", alpha2: "CX", alpha3: "CXR", numeric3: "162" }, CCK: { countryName: "Cocos (Keeling) Islands", postalCodeFormat: "4Digits.json", alpha2: "CC", alpha3: "CCK", numeric3: "166" }, COL: { countryName: "Colombia", postalCodeFormat: "6Digits.json", alpha2: "CO", alpha3: "COL", numeric3: "170" }, COM: { countryName: "Comoros", alpha2: "KM", alpha3: "COM", numeric3: "174" }, COG: { countryName: "Congo (Brazzaville)", alpha2: "CG", alpha3: "COG", numeric3: "178" }, COD: { countryName: "Congo, Democratic Republic of the", alpha2: "CD", alpha3: "COD", numeric3: "180" }, COK: { countryName: "Cook Islands", alpha2: "CK", alpha3: "COK", numeric3: "184" }, CRI: { countryName: "Costa Rica", postalCodeFormat: "5Digits.json", alpha2: "CR", alpha3: "CRI", numeric3: "188" }, CIV: { countryName: "Côte d'Ivoire", alpha2: "CI", alpha3: "CIV", numeric3: "384" }, HRV: { countryName: "Croatia", postalCodeFormat: "5Digits.json", alpha2: "HR", alpha3: "HRV", numeric3: "191" }, CUB: { countryName: "Cuba", postalCodeFormat: "5Digits.json", alpha2: "CU", alpha3: "CUB", numeric3: "192" }, CYP: { countryName: "Cyprus", postalCodeFormat: "4Digits.json", alpha2: "CY", alpha3: "CYP", numeric3: "196" }, CZE: { countryName: "Czech Republic", postalCodeFormat: "5Digits.json", alpha2: "CZ", alpha3: "CZE", numeric3: "203" }, DNK: { countryName: "Denmark", postalCodeFormat: "DK.json", alpha2: "DK", alpha3: "DNK", numeric3: "208" }, DJI: { countryName: "Djibouti", alpha2: "DJ", alpha3: "DJI", numeric3: "262" }, DMA: { countryName: "Dominica", alpha2: "DM", alpha3: "DMA", numeric3: "212" }, DOM: { countryName: "Dominican Republic", postalCodeFormat: "5Digits.json", alpha2: "DO", alpha3: "DOM", numeric3: "214" }, ECU: { countryName: "Ecuador", postalCodeFormat: "6Digits.json", alpha2: "EC", alpha3: "ECU", numeric3: "218" }, EGY: { countryName: "Egypt", postalCodeFormat: "5Digits.json", alpha2: "EG", alpha3: "EGY", numeric3: "818" }, SLV: { countryName: "El Salvador", postalCodeFormat: "4Digits.json", alpha2: "SV", alpha3: "SLV", numeric3: "222" }, GNQ: { countryName: "Equatorial Guinea", alpha2: "GQ", alpha3: "GNQ", numeric3: "226" }, ERI: { countryName: "Eritrea", alpha2: "ER", alpha3: "ERI", numeric3: "232" }, EST: { countryName: "Estonia", postalCodeFormat: "5Digits.json", alpha2: "EE", alpha3: "EST", numeric3: "233" }, ETH: { countryName: "Ethiopia", postalCodeFormat: "4Digits.json", alpha2: "ET", alpha3: "ETH", numeric3: "231" }, FLK: { countryName: "Falkland Islands (Malvinas)", postalCodeFormat: "FK.json", alpha2: "FK", alpha3: "FLK", numeric3: "238" }, FRO: { countryName: "Faroe Islands", postalCodeFormat: "3Digits.json", alpha2: "FO", alpha3: "FRO", numeric3: "234" }, FJI: { countryName: "Fiji", alpha2: "FJ", alpha3: "FJI", numeric3: "242" }, FIN: { countryName: "Finland", postalCodeFormat: "5Digits.json", alpha2: "FI", alpha3: "FIN", numeric3: "246" }, FRA: { countryName: "France", postalCodeFormat: "5Digits.json", alpha2: "FR", alpha3: "FRA", numeric3: "250" }, GUF: { countryName: "French Guiana", postalCodeFormat: "GF.json", alpha2: "GF", alpha3: "GUF", numeric3: "254" }, PYF: { countryName: "French Polynesia", postalCodeFormat: "PF.json", alpha2: "PF", alpha3: "PYF", numeric3: "258" }, ATF: { countryName: "French Southern Territories", alpha2: "TF", alpha3: "ATF", numeric3: "260" }, GAB: { countryName: "Gabon", alpha2: "GA", alpha3: "GAB", numeric3: "266" }, GMB: { countryName: "Gambia", alpha2: "GM", alpha3: "GMB", numeric3: "270" }, GEO: { countryName: "Georgia", postalCodeFormat: "4Digits.json", alpha2: "GE", alpha3: "GEO", numeric3: "268" }, DEU: { countryName: "Germany", postalCodeFormat: "5Digits.json", alpha2: "DE", alpha3: "DEU", numeric3: "276" }, GHA: { countryName: "Ghana", alpha2: "GH", alpha3: "GHA", numeric3: "288" }, GIB: { countryName: "Gibraltar", postalCodeFormat: "GI.json", alpha2: "GI", alpha3: "GIB", numeric3: "292" }, GRC: { countryName: "Greece", postalCodeFormat: "5Digits.json", alpha2: "GR", alpha3: "GRC", numeric3: "300" }, GRL: { countryName: "Greenland", postalCodeFormat: "4Digits.json", alpha2: "GL", alpha3: "GRL", numeric3: "304" }, GRD: { countryName: "Grenada", alpha2: "GD", alpha3: "GRD", numeric3: "308" }, GLP: { countryName: "Guadeloupe", postalCodeFormat: "GP.json", alpha2: "GP", alpha3: "GLP", numeric3: "312" }, GUM: { countryName: "Guam", postalCodeFormat: "US.json", alpha2: "GU", alpha3: "GUM", numeric3: "316" }, GTM: { countryName: "Guatemala", postalCodeFormat: "5Digits.json", alpha2: "GT", alpha3: "GTM", numeric3: "320" }, GGY: { countryName: "Guernsey", postalCodeFormat: "GG.json", alpha2: "GG", alpha3: "GGY", numeric3: "831" }, GIN: { countryName: "Guinea", postalCodeFormat: "3Digits.json", alpha2: "GN", alpha3: "GIN", numeric3: "324" }, GNB: { countryName: "Guinea-Bissau", postalCodeFormat: "4Digits.json", alpha2: "GW", alpha3: "GNB", numeric3: "624" }, GUY: { countryName: "Guyana", alpha2: "GY", alpha3: "GUY", numeric3: "328" }, HTI: { countryName: "Haiti", postalCodeFormat: "4Digits.json", alpha2: "HT", alpha3: "HTI", numeric3: "332" }, HMD: { countryName: "Heard Island and Mcdonald Islands", postalCodeFormat: "4Digits.json", alpha2: "HM", alpha3: "HMD", numeric3: "334" }, VAT: { countryName: "Holy See (Vatican City State)", postalCodeFormat: "VA.json", alpha2: "VA", alpha3: "VAT", numeric3: "336" }, HND: { countryName: "Honduras", postalCodeFormat: "HN.json", alpha2: "HN", alpha3: "HND", numeric3: "340" }, HUN: { countryName: "Hungary", postalCodeFormat: "4Digits.json", alpha2: "HU", alpha3: "HUN", numeric3: "348" }, ISL: { countryName: "Iceland", postalCodeFormat: "3Digits.json", alpha2: "IS", alpha3: "ISL", numeric3: "352" }, IND: { countryName: "India", postalCodeFormat: "6Digits.json", alpha2: "IN", alpha3: "IND", numeric3: "356" }, IDN: { countryName: "Indonesia", postalCodeFormat: "5Digits.json", alpha2: "ID", alpha3: "IDN", numeric3: "360" }, IRN: { countryName: "Iran, Islamic Republic of", postalCodeFormat: "10Digits.json", alpha2: "IR", alpha3: "IRN", numeric3: "364" }, IRQ: { countryName: "Iraq", postalCodeFormat: "5Digits.json", alpha2: "IQ", alpha3: "IRQ", numeric3: "368" }, IRL: { countryName: "Ireland", postalCodeFormat: "IE.json", alpha2: "IE", alpha3: "IRL", numeric3: "372" }, IMN: { countryName: "Isle of Man", postalCodeFormat: "IM.json", alpha2: "IM", alpha3: "IMN", numeric3: "833" }, ISR: { countryName: "Israel", postalCodeFormat: "7Digits.json", alpha2: "IL", alpha3: "ISR", numeric3: "376" }, ITA: { countryName: "Italy", postalCodeFormat: "5Digits.json", alpha2: "IT", alpha3: "ITA", numeric3: "380" }, JAM: { countryName: "Jamaica", postalCodeFormat: "2Digits.json", alpha2: "JM", alpha3: "JAM", numeric3: "388" }, JPN: { countryName: "Japan", postalCodeFormat: "7Digits.json", alpha2: "JP", alpha3: "JPN", numeric3: "392" }, JEY: { countryName: "Jersey", postalCodeFormat: "JE.json", alpha2: "JE", alpha3: "JEY", numeric3: "832" }, JOR: { countryName: "Jordan", postalCodeFormat: "5Digits.json", alpha2: "JO", alpha3: "JOR", numeric3: "400" }, KAZ: { countryName: "Kazakhstan", postalCodeFormat: "6Digits.json", alpha2: "KZ", alpha3: "KAZ", numeric3: "398" }, KEN: { countryName: "Kenya", postalCodeFormat: "5Digits.json", alpha2: "KE", alpha3: "KEN", numeric3: "404" }, KIR: { countryName: "Kiribati", alpha2: "KI", alpha3: "KIR", numeric3: "296" }, PRK: { countryName: "Korea, Democratic People's Republic of", alpha2: "KP", alpha3: "PRK", numeric3: "408" }, KOR: { countryName: "Korea, Republic of", postalCodeFormat: "5Digits.json", alpha2: "KR", alpha3: "KOR", numeric3: "410" }, KWT: { countryName: "Kuwait", postalCodeFormat: "5Digits.json", alpha2: "KW", alpha3: "KWT", numeric3: "414" }, KGZ: { countryName: "Kyrgyzstan", postalCodeFormat: "6Digits.json", alpha2: "KG", alpha3: "KGZ", numeric3: "417" }, LAO: { countryName: "Lao PDR", postalCodeFormat: "5Digits.json", alpha2: "LA", alpha3: "LAO", numeric3: "418" }, LVA: { countryName: "Latvia", postalCodeFormat: "LV.json", alpha2: "LV", alpha3: "LVA", numeric3: "428" }, LBN: { countryName: "Lebanon", postalCodeFormat: "LB.json", alpha2: "LB", alpha3: "LBN", numeric3: "422" }, LSO: { countryName: "Lesotho", postalCodeFormat: "3Digits.json", alpha2: "LS", alpha3: "LSO", numeric3: "426" }, LBR: { countryName: "Liberia", postalCodeFormat: "4Digits.json", alpha2: "LR", alpha3: "LBR", numeric3: "430" }, LBY: { countryName: "Libya", postalCodeFormat: "5Digits.json", alpha2: "LY", alpha3: "LBY", numeric3: "434" }, LIE: { countryName: "Liechtenstein", postalCodeFormat: "4Digits.json", alpha2: "LI", alpha3: "LIE", numeric3: "438" }, LTU: { countryName: "Lithuania", postalCodeFormat: "LT.json", alpha2: "LT", alpha3: "LTU", numeric3: "440" }, LUX: { countryName: "Luxembourg", postalCodeFormat: "LU.json", alpha2: "LU", alpha3: "LUX", numeric3: "442" }, MKD: { countryName: "Macedonia, Republic of", postalCodeFormat: "4Digits.json", alpha2: "MK", alpha3: "MKD", numeric3: "807" }, MDG: { countryName: "Madagascar", postalCodeFormat: "3Digits.json", alpha2: "MG", alpha3: "MDG", numeric3: "450" }, MWI: { countryName: "Malawi", alpha2: "MW", alpha3: "MWI", numeric3: "454" }, MYS: { countryName: "Malaysia", postalCodeFormat: "5Digits.json", alpha2: "MY", alpha3: "MYS", numeric3: "458" }, MDV: { countryName: "Maldives", postalCodeFormat: "5Digits.json", alpha2: "MV", alpha3: "MDV", numeric3: "462" }, MLI: { countryName: "Mali", alpha2: "ML", alpha3: "MLI", numeric3: "466" }, MLT: { countryName: "Malta", postalCodeFormat: "MT.json", alpha2: "MT", alpha3: "MLT", numeric3: "470" }, MHL: { countryName: "Marshall Islands", postalCodeFormat: "US.json", alpha2: "MH", alpha3: "MHL", numeric3: "584" }, MTQ: { countryName: "Martinique", postalCodeFormat: "5Digits.json", alpha2: "MQ", alpha3: "MTQ", numeric3: "474" }, MRT: { countryName: "Mauritania", alpha2: "MR", alpha3: "MRT", numeric3: "478" }, MUS: { countryName: "Mauritius", postalCodeFormat: "5Digits.json", alpha2: "MU", alpha3: "MUS", numeric3: "480" }, MYT: { countryName: "Mayotte", postalCodeFormat: "5Digits.json", alpha2: "YT", alpha3: "MYT", numeric3: "175" }, MEX: { countryName: "Mexico", postalCodeFormat: "5Digits.json", alpha2: "MX", alpha3: "MEX", numeric3: "484" }, FSM: { countryName: "Micronesia, Federated States of", postalCodeFormat: "US.json", alpha2: "FM", alpha3: "FSM", numeric3: "583" }, MDA: { countryName: "Moldova", postalCodeFormat: "MD.json", alpha2: "MD", alpha3: "MDA", numeric3: "498" }, MCO: { countryName: "Monaco", postalCodeFormat: "MC.json", alpha2: "MC", alpha3: "MCO", numeric3: "492" }, MNG: { countryName: "Mongolia", postalCodeFormat: "5Digits.json", alpha2: "MN", alpha3: "MNG", numeric3: "496" }, MNE: { countryName: "Montenegro", postalCodeFormat: "5Digits.json", alpha2: "ME", alpha3: "MNE", numeric3: "499" }, MSR: { countryName: "Montserrat", postalCodeFormat: "MS.json", alpha2: "MS", alpha3: "MSR", numeric3: "500" }, MAR: { countryName: "Morocco", postalCodeFormat: "5Digits.json", alpha2: "MA", alpha3: "MAR", numeric3: "504" }, MOZ: { countryName: "Mozambique", postalCodeFormat: "4Digits.json", alpha2: "MZ", alpha3: "MOZ", numeric3: "508" }, MMR: { countryName: "Myanmar", postalCodeFormat: "5Digits.json", alpha2: "MM", alpha3: "MMR", numeric3: "104" }, NAM: { countryName: "Namibia", postalCodeFormat: "5Digits.json", alpha2: "NA", alpha3: "NAM", numeric3: "516" }, NRU: { countryName: "Nauru", alpha2: "NR", alpha3: "NRU", numeric3: "520" }, NPL: { countryName: "Nepal", postalCodeFormat: "5Digits.json", alpha2: "NP", alpha3: "NPL", numeric3: "524" }, NLD: { countryName: "Netherlands", postalCodeFormat: "NL.json", alpha2: "NL", alpha3: "NLD", numeric3: "528" }, ANT: { countryName: "Netherlands Antilles", alpha2: "AN", alpha3: "ANT", numeric3: "530" }, NCL: { countryName: "New Caledonia", postalCodeFormat: "NC.json", alpha2: "NC", alpha3: "NCL", numeric3: "540" }, NZL: { countryName: "New Zealand", postalCodeFormat: "4Digits.json", alpha2: "NZ", alpha3: "NZL", numeric3: "554" }, NIC: { countryName: "Nicaragua", postalCodeFormat: "5Digits.json", alpha2: "NI", alpha3: "NIC", numeric3: "558" }, NER: { countryName: "Niger", postalCodeFormat: "4Digits.json", alpha2: "NE", alpha3: "NER", numeric3: "562" }, NGA: { countryName: "Nigeria", postalCodeFormat: "6Digits.json", alpha2: "NG", alpha3: "NGA", numeric3: "566" }, NIU: { countryName: "Niue", alpha2: "NU", alpha3: "NIU", numeric3: "570" }, NFK: { countryName: "Norfolk Island", postalCodeFormat: "4Digits.json", alpha2: "NF", alpha3: "NFK", numeric3: "574" }, MNP: { countryName: "Northern Mariana Islands", postalCodeFormat: "US.json", alpha2: "MP", alpha3: "MNP", numeric3: "580" }, NOR: { countryName: "Norway", postalCodeFormat: "4Digits.json", alpha2: "NO", alpha3: "NOR", numeric3: "578" }, OMN: { countryName: "Oman", postalCodeFormat: "3Digits.json", alpha2: "OM", alpha3: "OMN", numeric3: "512" }, PAK: { countryName: "Pakistan", postalCodeFormat: "5Digits.json", alpha2: "PK", alpha3: "PAK", numeric3: "586" }, PLW: { countryName: "Palau", postalCodeFormat: "US.json", alpha2: "PW", alpha3: "PLW", numeric3: "585" }, PSE: { countryName: "Palestinian Territory, Occupied", postalCodeFormat: "3Digits.json", alpha2: "PS", alpha3: "PSE", numeric3: "275" }, PAN: { countryName: "Panama", postalCodeFormat: "4Digits.json", alpha2: "PA", alpha3: "PAN", numeric3: "591" }, PNG: { countryName: "Papua New Guinea", postalCodeFormat: "3Digits.json", alpha2: "PG", alpha3: "PNG", numeric3: "598" }, PRY: { countryName: "Paraguay", postalCodeFormat: "4Digits.json", alpha2: "PY", alpha3: "PRY", numeric3: "600" }, PER: { countryName: "Peru", postalCodeFormat: "5Digits.json", alpha2: "PE", alpha3: "PER", numeric3: "604" }, PHL: { countryName: "Philippines", postalCodeFormat: "4Digits.json", alpha2: "PH", alpha3: "PHL", numeric3: "608" }, PCN: { countryName: "Pitcairn", postalCodeFormat: "PN.json", alpha2: "PN", alpha3: "PCN", numeric3: "612" }, POL: { countryName: "Poland", postalCodeFormat: "PL.json", alpha2: "PL", alpha3: "POL", numeric3: "616" }, PRT: { countryName: "Portugal", postalCodeFormat: "PT.json", alpha2: "PT", alpha3: "PRT", numeric3: "620" }, PRI: { countryName: "Puerto Rico", postalCodeFormat: "US.json", alpha2: "PR", alpha3: "PRI", numeric3: "630" }, QAT: { countryName: "Qatar", alpha2: "QA", alpha3: "QAT", numeric3: "634" }, REU: { countryName: "Réunion", postalCodeFormat: "RE.json", alpha2: "RE", alpha3: "REU", numeric3: "638" }, ROU: { countryName: "Romania", postalCodeFormat: "6Digits.json", alpha2: "RO", alpha3: "ROU", numeric3: "642" }, RUS: { countryName: "Russian Federation", postalCodeFormat: "RU.json", alpha2: "RU", alpha3: "RUS", numeric3: "643" }, RWA: { countryName: "Rwanda", alpha2: "RW", alpha3: "RWA", numeric3: "646" }, BLM: { countryName: "Saint-Barthélemy", postalCodeFormat: "BL.json", alpha2: "BL", alpha3: "BLM", numeric3: "652" }, SHN: { countryName: "Saint Helena", postalCodeFormat: "SH.json", alpha2: "SH", alpha3: "SHN", numeric3: "654" }, KNA: { countryName: "Saint Kitts and Nevis", alpha2: "KN", alpha3: "KNA", numeric3: "659" }, LCA: { countryName: "Saint Lucia", postalCodeFormat: "LC.json", alpha2: "LC", alpha3: "LCA", numeric3: "662" }, MAF: { countryName: "Saint-Martin (French part)", postalCodeFormat: "MF.json", alpha2: "MF", alpha3: "MAF", numeric3: "663" }, SPM: { countryName: "Saint Pierre and Miquelon", postalCodeFormat: "PM.json", alpha2: "PM", alpha3: "SPM", numeric3: "666" }, VCT: { countryName: "Saint Vincent and Grenadines", postalCodeFormat: "VC.json", alpha2: "VC", alpha3: "VCT", numeric3: "670" }, WSM: { countryName: "Samoa", postalCodeFormat: "WS.json", alpha2: "WS", alpha3: "WSM", numeric3: "882" }, SMR: { countryName: "San Marino", postalCodeFormat: "SM.json", alpha2: "SM", alpha3: "SMR", numeric3: "674" }, STP: { countryName: "Sao Tome and Principe", alpha2: "ST", alpha3: "STP", numeric3: "678" }, SAU: { countryName: "Saudi Arabia", postalCodeFormat: "US.json", alpha2: "SA", alpha3: "SAU", numeric3: "682" }, SEN: { countryName: "Senegal", postalCodeFormat: "5Digits.json", alpha2: "SN", alpha3: "SEN", numeric3: "686" }, SRB: { countryName: "Serbia", postalCodeFormat: "5Digits.json", alpha2: "RS", alpha3: "SRB", numeric3: "688" }, SYC: { countryName: "Seychelles", alpha2: "SC", alpha3: "SYC", numeric3: "690" }, SLE: { countryName: "Sierra Leone", alpha2: "SL", alpha3: "SLE", numeric3: "694" }, SGP: { countryName: "Singapore", postalCodeFormat: "6Digits.json", alpha2: "SG", alpha3: "SGP", numeric3: "702" }, SVK: { countryName: "Slovakia", postalCodeFormat: "5Digits.json", alpha2: "SK", alpha3: "SVK", numeric3: "703" }, SVN: { countryName: "Slovenia", postalCodeFormat: "4Digits.json", alpha2: "SI", alpha3: "SVN", numeric3: "705" }, SLB: { countryName: "Solomon Islands", alpha2: "SB", alpha3: "SLB", numeric3: "90" }, SOM: { countryName: "Somalia", postalCodeFormat: "SO.json", alpha2: "SO", alpha3: "SOM", numeric3: "706" }, ZAF: { countryName: "South Africa", postalCodeFormat: "4Digits.json", alpha2: "ZA", alpha3: "ZAF", numeric3: "710" }, SGS: { countryName: "South Georgia and the South Sandwich Islands", postalCodeFormat: "GS.json", alpha2: "GS", alpha3: "SGS", numeric3: "239" }, SSD: { countryName: "South Sudan", alpha2: "SS", alpha3: "SSD", numeric3: "728" }, ESP: { countryName: "Spain", postalCodeFormat: "5Digits.json", alpha2: "ES", alpha3: "ESP", numeric3: "724" }, LKA: { countryName: "Sri Lanka", postalCodeFormat: "5Digits.json", alpha2: "LK", alpha3: "LKA", numeric3: "144" }, SDN: { countryName: "Sudan", postalCodeFormat: "5Digits.json", alpha2: "SD", alpha3: "SDN", numeric3: "736" }, SUR: { countryName: "Suriname *", alpha2: "SR", alpha3: "SUR", numeric3: "740" }, SJM: { countryName: "Svalbard and Jan Mayen Islands", postalCodeFormat: "4Digits.json", alpha2: "SJ", alpha3: "SJM", numeric3: "744" }, SWZ: { countryName: "Swaziland", postalCodeFormat: "SZ.json", alpha2: "SZ", alpha3: "SWZ", numeric3: "748" }, SWE: { countryName: "Sweden", postalCodeFormat: "5Digits.json", alpha2: "SE", alpha3: "SWE", numeric3: "752" }, CHE: { countryName: "Switzerland", postalCodeFormat: "4Digits.json", alpha2: "CH", alpha3: "CHE", numeric3: "756" }, SYR: { countryName: "Syrian Arab Republic (Syria)", alpha2: "SY", alpha3: "SYR", numeric3: "760" }, TWN: { countryName: "Taiwan, Republic of China", postalCodeFormat: "TW.json", alpha2: "TW", alpha3: "TWN", numeric3: "158" }, TJK: { countryName: "Tajikistan", postalCodeFormat: "6Digits.json", alpha2: "TJ", alpha3: "TJK", numeric3: "762" }, TZA: { countryName: "Tanzania *, United Republic of", postalCodeFormat: "5Digits.json", alpha2: "TZ", alpha3: "TZA", numeric3: "834" }, THA: { countryName: "Thailand", postalCodeFormat: "5Digits.json", alpha2: "TH", alpha3: "THA", numeric3: "764" }, TLS: { countryName: "Timor-Leste", alpha2: "TL", alpha3: "TLS", numeric3: "626" }, TGO: { countryName: "Togo", alpha2: "TG", alpha3: "TGO", numeric3: "768" }, TKL: { countryName: "Tokelau", alpha2: "TK", alpha3: "TKL", numeric3: "772" }, TON: { countryName: "Tonga", alpha2: "TO", alpha3: "TON", numeric3: "776" }, TTO: { countryName: "Trinidad and Tobago", postalCodeFormat: "6Digits.json", alpha2: "TT", alpha3: "TTO", numeric3: "780" }, TUN: { countryName: "Tunisia", postalCodeFormat: "4Digits.json", alpha2: "TN", alpha3: "TUN", numeric3: "788" }, TUR: { countryName: "Turkey", postalCodeFormat: "5Digits.json", alpha2: "TR", alpha3: "TUR", numeric3: "792" }, TKM: { countryName: "Turkmenistan", postalCodeFormat: "6Digits.json", alpha2: "TM", alpha3: "TKM", numeric3: "795" }, TCA: { countryName: "Turks and Caicos Islands", postalCodeFormat: "TC.json", alpha2: "TC", alpha3: "TCA", numeric3: "796" }, TUV: { countryName: "Tuvalu", alpha2: "TV", alpha3: "TUV", numeric3: "798" }, UGA: { countryName: "Uganda", alpha2: "UG", alpha3: "UGA", numeric3: "800" }, UKR: { countryName: "Ukraine", postalCodeFormat: "5Digits.json", alpha2: "UA", alpha3: "UKR", numeric3: "804" }, ARE: { countryName: "United Arab Emirates", alpha2: "AE", alpha3: "ARE", numeric3: "784" }, GBR: { countryName: "United Kingdom", postalCodeFormat: "GB.json", alpha2: "GB", alpha3: "GBR", numeric3: "826" }, USA: { countryName: "United States of America", postalCodeFormat: "US.json", alpha2: "US", alpha3: "USA", numeric3: "840" }, UMI: { countryName: "United States Minor Outlying Islands", alpha2: "UM", alpha3: "UMI", numeric3: "581" }, URY: { countryName: "Uruguay", postalCodeFormat: "5Digits.json", alpha2: "UY", alpha3: "URY", numeric3: "858" }, UZB: { countryName: "Uzbekistan", postalCodeFormat: "6Digits.json", alpha2: "UZ", alpha3: "UZB", numeric3: "860" }, VUT: { countryName: "Vanuatu", alpha2: "VU", alpha3: "VUT", numeric3: "548" }, VEN: { countryName: "Venezuela (Bolivarian Republic of)", postalCodeFormat: "VE.json", alpha2: "VE", alpha3: "VEN", numeric3: "862" }, VNM: { countryName: "Viet Nam", postalCodeFormat: "6Digits.json", alpha2: "VN", alpha3: "VNM", numeric3: "704" }, VIR: { countryName: "Virgin Islands, US", postalCodeFormat: "US.json", alpha2: "VI", alpha3: "VIR", numeric3: "850" }, WLF: { countryName: "Wallis and Futuna Islands", postalCodeFormat: "WF.json", alpha2: "WF", alpha3: "WLF", numeric3: "876" }, ESH: { countryName: "Western Sahara", alpha2: "EH", alpha3: "ESH", numeric3: "732" }, YEM: { countryName: "Yemen", alpha2: "YE", alpha3: "YEM", numeric3: "887" }, ZMB: { countryName: "Zambia", postalCodeFormat: "5Digits.json", alpha2: "ZM", alpha3: "ZMB", numeric3: "894" }, ZWE: { countryName: "Zimbabwe", alpha2: "ZW", alpha3: "ZWE", numeric3: "716" } }, jm = { Description: "10-Digits - NNNNNNNNNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{10}$", TestData: { Valid: ["1234567890", "5678567833"], Invalid: ["12334545698", "123s33s12", "123456789"] } }, Bm = { Description: "2-Digits - NN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{2}$", TestData: { Valid: ["12", "56"], Invalid: ["012", "1s", "1", "x3"] } }, Gm = { Description: "3-Digits - NNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{3}$", TestData: { Valid: ["123", "567"], Invalid: ["1234", "13s", "1x3"] } }, Ym = { Description: "4-Digits - NNNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{4}$", TestData: { Valid: ["1234", "5678"], Invalid: ["12345", "123s", "12x3"] } }, Vm = { Description: "5-Digits - NNNNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{5}$", TestData: { Valid: ["12345", "56785"], Invalid: ["123456", "1233s", "123x3"] } }, Hm = { Description: "6-Digits - NNNNNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{6}$", TestData: { Valid: ["123456", "567856"], Invalid: ["1233456", "123s3s", "1s23x3"] } }, Um = { Description: "7-Digits - NNNNNNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{7}$", TestData: { Valid: ["1234567", "5678567"], Invalid: ["123345456", "123s33s", "1s23x3"] } }, $m = { Description: "8-Digits - NNNNNNNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{8}$", TestData: { Valid: ["12345678", "56785678"], Invalid: ["123345456", "123s33s", "1s23x3"] } }, zm = { Description: "AD : CCNNN", RedundantCharacters: " -", ValidationRegex: "^AD[0-9]{3}$", TestData: { Valid: ["AD123", "AD001"], Invalid: ["A1234", "AD12", "AD1234"] } }, qm = { Description: "AI : CC2640", RedundantCharacters: " -", ValidationRegex: "^AI2640$", TestData: { Valid: ["AI2640", "AI-2640"], Invalid: ["A2640", "AI02640", "AI-02640"] } }, Km = { Description: "AQ : BIQQ 1ZZ", RedundantCharacters: " -", ValidationRegex: "^BIQQ1ZZ$", TestData: { Valid: ["BIQQ 1ZZ", "BIQQ1ZZ"], Invalid: ["BIQQ1Z", "BIQQ01ZZ"] } }, Zm = { Description: "AX : NNNNN, CC-NNNNN", RedundantCharacters: " -", ValidationRegex: "^(AX)?[0-9]{5}$", TestData: { Valid: ["12345", "AX-12345", "AX12345"], Invalid: ["AX123", "A1234", "AX-1234"] } }, Wm = { Description: "AZ : CCNNNNN", RedundantCharacters: " -", ValidationRegex: "^AZ[0-9]{4}$", TestData: { Valid: ["AZ1234", "AZ-1234"], Invalid: ["AZ123", "A1234", "AZ-12345"] } }, Jm = { Description: "BB : CCNNNNN", RedundantCharacters: " -", ValidationRegex: "^(BB)?[0-9]{5}$", TestData: { Valid: ["BB12345", "12345"], Invalid: ["x1231s", "1231sd"] } }, Qm = { Description: "BH : NNN, NNNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{3,4}$", TestData: { Valid: ["123", "1234"], Invalid: ["12", "12345"] } }, Xm = { Description: "BL : 97133", RedundantCharacters: " -", ValidationRegex: "^97133$", TestData: { Valid: ["97133"], Invalid: ["971330", "9713"] } }, eg = { Description: "BN : LLNNNN", RedundantCharacters: " -", ValidationRegex: "^[a-zA-Z]{2}[0-9]{4}$", TestData: { Valid: ["AB1234", "tK0987"], Invalid: ["abc123", "a12345", "at123", "BH12345"] } }, tg = { Description: "CA : A0A 0A0", RedundantCharacters: " -", ValidationRegex: "^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][\\s\\-]?\\d[ABCEGHJ-NPRSTV-Z]\\d$", TestData: { Valid: ["A4B5X5", "A4B5A5"], Invalid: ["123AAA", "12A5AA"] } }, ng = { Description: "DK", RedundantCharacters: " -", ValidationRegex: "^(DK){0,1}\\d{4}$", TestData: { Valid: ["1124", "DK1054", "DK-1120", "DK1120", "DK 1125", "DK - 1234", "dk-1123"], Invalid: ["1125DK", "DK12345", "DK123", "123", ""] } }, ag = { Description: "FK : FIQQ 1ZZ", RedundantCharacters: " -", ValidationRegex: "^FIQQ1ZZ$", TestData: { Valid: ["FIQQ 1ZZ", "FIQQ1ZZ"], Invalid: ["FIQQ01ZZ", "FIQQ1ZZZ"] } }, rg = { Description: "GB", RedundantCharacters: " -", ValidationRegex: "((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[0-9][A-Za-z]{2})|GIR0AA", "ValidationRegex.DOC": "https://www.gov.uk/government/uploads/system/uploads/attachment_data/file/488478/Bulk_Data_Transfer_-_additional_validation_valid_from_12_November_2015.pdf", TestData: { Valid: ["CW3 9SS", "SE5 0EG", "SE50EG", "WC2H 7LT", "se5 0eg", "Z29ZZ", "Z699ZZ", "ZX99ZZ", "ZC999ZZ", "EC1A 1BB", "W1A 0AX", "M1 1AE", "B33 8TH", "CR2 6XH", "DN55 1PT", "GIR 0AA", "W1U 1BW", "SK8 7NA"], Invalid: ["WC2H 7LTa", "WC2H"] } }, ig = { Description: "GF : 973NN", RedundantCharacters: " -", ValidationRegex: "^973[0-9]{2}$", TestData: { Valid: ["97300", "97390"], Invalid: ["9732", "973999", "97290", "097390"] } }, og = { Description: "GG", RedundantCharacters: " -", ValidationRegex: "^GY[0-9]{2,3}[A-Za-z]{2}$", TestData: { Valid: ["GY1 1AA", "GY111AA"], Invalid: ["CW3 9SS", "GG1 1AA", "SE5 0EG", "SE50EG", "WC2H 7LTa", "WC2H"] } }, sg = { Description: "GI : GX11 1AA", RedundantCharacters: " -", ValidationRegex: "^GX111AA$", TestData: { Valid: ["GX111AA", "GX11 1AA"], Invalid: ["GX1101AA", "GX111AAA"] } }, lg = { Description: "GP : 971NN", RedundantCharacters: " -", ValidationRegex: "^971[0-9]{2}$", TestData: { Valid: ["97100", "97190"], Invalid: ["9712", "971999", "97290", "097190"] } }, cg = { Description: "GS : SIQQ 1ZZ", RedundantCharacters: " -", ValidationRegex: "^SIQQ1ZZ$", TestData: { Valid: ["SIQQ 1ZZ", "SIqq 1zz", "SIQQ1ZZ"], Invalid: ["SIQQ01ZZ", "SIQQ1ZZZ"] } }, ug = { Description: "HN : CCNNNNN", RedundantCharacters: " -", ValidationRegex: "^(HN)?[0-9]{5}$", TestData: { Valid: ["HN12345", "12345"], Invalid: ["123456", "HN123456", "HN1234"] } }, dg = { Description: "IE", RedundantCharacters: "", ValidationRegex: "^[AaC-Fc-fHhKkNnPpRrTtV-Yv-y]\\d[0-9Ww][ -]?[0-9AaC-Fc-fHhKkNnPpRrTtV-Yv-y]{4}$", "ValidationRegex.DOC": "https://www.eircode.ie/docs/default-source/Common/prepareyourbusinessforeircode-edition3published.pdf?sfvrsn=2", TestData: { Valid: ["D6W1234", "A23 0984", "D00-AV92", "y631fhk", "a00 0000", "d44-n4x4", "A65F4E2"], Invalid: ["D6Z1234", "y63  1fhk"] } }, pg = { Description: "IM", RedundantCharacters: " -", ValidationRegex: "^IM[0-9]{2,3}[A-Za-z]{2}$", TestData: { Valid: ["IM1 1AA", "IM111AA"], Invalid: ["CW3 9SS", "SE5 0EG", "SE50EG", "WC2H 7LTa", "WC2H"] } }, hg = { Description: "IO : BBND 1ZZ", RedundantCharacters: " -", ValidationRegex: "^BBND1ZZ$", TestData: { Valid: ["BBND 1ZZ", "BBND1ZZ"], Invalid: ["BBND01ZZ", "BBND1ZZZ"] } }, mg = { Description: "JE", RedundantCharacters: " -", ValidationRegex: "^JE[0-9]{2,3}[A-Za-z]{2}$", TestData: { Valid: ["JE1 1AA", "JE111AA"], Invalid: ["CW3 9SS", "SE5 0EG", "SE50EG", "WC2H 7LTa", "WC2H"] } }, gg = { Description: "KY : CCN-NNNN", RedundantCharacters: " -", ValidationRegex: "^KY[0-9]{5}$", TestData: { Valid: ["KY1-1234", "KY12345"], Invalid: ["KY1234", "KY123456", "K1-1234"] } }, fg = { Description: "LB : NNNNN, NNNN NNNN", RedundantCharacters: " -", ValidationRegex: "^[0-9]{4}(?:[0-9]{4})?$", TestData: { Valid: ["1234", "1234 1234", "12341234"], Invalid: ["123", "1234567", "123456789"] } }, yg = { Description: "LC : CCNN NNN", RedundantCharacters: " -", ValidationRegex: "^LC[0-9]{5}$", TestData: { Valid: ["LC12 345", "LC12345"], Invalid: ["12345", "x1231s", "1231sd"] } }, bg = { Description: "LT : LT-NNNNN", RedundantCharacters: " -", ValidationRegex: "^(LT)?[0-9]{5}$", TestData: { Valid: ["12345", "LT12345", "LT-12345"], Invalid: ["1234", "123456", "LT-1234"] } }, vg = { Description: "LU", RedundantCharacters: " -", ValidationRegex: "^(L){0,1}\\d{4}$", TestData: { Valid: ["1124", "L1054", "L-1120", "L1120", "L 1125", "L - 1234", "l-1123"], Invalid: ["1125L", "L12345", "L123", "123", ""] } }, Sg = { Description: "LV : NNNNN, CC-NNNNN", RedundantCharacters: " -", ValidationRegex: "^(LV)?[0-9]{4}$", TestData: { Valid: ["1234", "LV-1234", "LV1234"], Invalid: ["LV123", "L1234", "LV-12345"] } }, Cg = { Description: "MC : 980NN", RedundantCharacters: " -", ValidationRegex: "^980[0-9]{2}$", TestData: { Valid: ["98000", "98099"], Invalid: ["98100", "97099"] } }, Mg = { Description: "MD : CCNNNN, CC-NNNN", RedundantCharacters: " -", ValidationRegex: "^(MD)?[0-9]{4}$", TestData: { Valid: ["1234", "MD1234", "MD-1234"], Invalid: ["MD123", "M1234", "MD-12345"] } }, Dg = { Description: "MF : 97150", RedundantCharacters: " -", ValidationRegex: "^97150$", TestData: { Valid: ["97150"], Invalid: ["971500", "9715"] } }, Ng = { Description: "MS : MSR NNNN", RedundantCharacters: " -", ValidationRegex: "^(MSR)?[0-9]{4}$", TestData: { Valid: ["MSR 1110", "MSR 1350", "1350"], Invalid: ["MS1110", "MSR01350", "12345"] } }, Tg = { Description: "MA : LLL NNNN", RedundantCharacters: " -", ValidationRegex: "^[A-Z]{3}[0-9]{4}$", TestData: { Valid: ["abc1234", "ABC1234", "SHD4783"], Invalid: ["ABCABC", "123ABCD"] } }, Eg = { Description: "NC : 988NN", RedundantCharacters: " -", ValidationRegex: "^988[0-9]{2}$", TestData: { Valid: ["98800", "98890"], Invalid: ["9882", "988999", "98990", "098890"] } }, wg = { Description: "NL : NNNN LL", RedundantCharacters: " -", ValidationRegex: "^[1-9][0-9]{3}(?!SA|SD|SS)[A-Z]{2}$", TestData: { Valid: ["1235DF", "5983DH", "1000 AP"], Invalid: ["1235D", "12j4h", "k3j51l", "1945SS"] } }, _g = { Description: "PF : 987NN", RedundantCharacters: " -", ValidationRegex: "^987[0-9]{2}$", TestData: { Valid: ["98700", "98790"], Invalid: ["9872", "987999", "98690", "098790"] } }, xg = { Description: "PL : 99-999", RedundantCharacters: " ", ValidationRegex: "^[0-9]{2}-[0-9]{3}$", TestData: { Valid: ["44-100 ", "44-100"], Invalid: ["44100", "44f00", "e4410", "44-100d", "c44-100", "b44100", "44100a"] } }, kg = { Description: "PM : 97500", RedundantCharacters: " -", ValidationRegex: "^97500$", TestData: { Valid: ["97500"], Invalid: ["975000", "9750"] } }, Ag = { Description: "PN : PCRN 1ZZ", RedundantCharacters: " -", ValidationRegex: "^PCRN1ZZ$", TestData: { Valid: ["PCRN 1ZZ", "PCRN1ZZ"], Invalid: ["PCRN01ZZ", "PCRN1ZZZ"] } }, Lg = { Description: "PT : NNNN-NNN", RedundantCharacters: " ", ValidationRegex: "^[0-9]{4}-[0-9]{3}$", TestData: { Valid: ["1234-123"], Invalid: ["1255", "1234567", "1234 123", "x1231s", "1231sd", "1010101010", "1234 12"] } }, Ig = { Description: "RE : 974NN", RedundantCharacters: " -", ValidationRegex: "^974[0-9]{2}$", TestData: { Valid: ["97400", "97490"], Invalid: ["9742", "974999", "97390", "097490"] } }, Pg = { Description: "RU : NNN[-NNN]", RedundantCharacters: " -", ValidationRegex: "^[0-9]{3}([0-9]{3})?$", TestData: { Valid: ["125", "123456"], Invalid: ["x1231s", "1231sd", "1010101010"] } }, Og = { Description: "SH : STHL 1ZZ", RedundantCharacters: " -", ValidationRegex: "^STHL1ZZ$", TestData: { Valid: ["STHL 1ZZ", "STHL1ZZ"], Invalid: ["STHL01ZZ", "STHL1ZZZ"] } }, Rg = { Description: "SM : 4789N", RedundantCharacters: " -", ValidationRegex: "^4789[0-9]{1}$", TestData: { Valid: ["47890", "47899"], Invalid: ["4789", "478900", "47889"] } }, Fg = { Description: "SO : AA NNNNN", RedundantCharacters: " -", ValidationRegex: "^[a-zA-Z]{2}[0-9]{5}$", TestData: { Valid: ["AW12345", "BN47899"], Invalid: ["12345", "A12345", "SL123456"] } }, jg = { Description: "SZ : ANNN", RedundantCharacters: " -", ValidationRegex: "^[a-zA-Z]{1}[0-9]{3}$", TestData: { Valid: ["S123", "a789"], Invalid: ["F1234", "D12"] } }, Bg = { Description: "TC : TKCA 1ZZ", RedundantCharacters: " -", ValidationRegex: "^TKCA1ZZ$", TestData: { Valid: ["TKCA1ZZ", "TKCA 1ZZ"], Invalid: ["TKCA01ZZ", "TKCA1ZZZ"] } }, Gg = { Description: "TW : NNN[-NN]", RedundantCharacters: " -", ValidationRegex: "^[0-9]{3}([0-9]{2})?$", TestData: { Valid: ["123", "123-45", "12345"], Invalid: ["12", "1234", "101010"] } }, Yg = { Description: "US : NNNNN[-NNNN]", RedundantCharacters: " -", ValidationRegex: "^[0-9]{5}([0-9]{4})?$", TestData: { Valid: ["12345", "12345-7689"], Invalid: ["x1231s", "1231sd", "1010101010"] } }, Vg = { Description: "VA : 00120", RedundantCharacters: " -", ValidationRegex: "^00120$", TestData: { Valid: ["00120"], Invalid: ["0012", "001200"] } }, Hg = { Description: "VC : CCNNNNN", RedundantCharacters: " -", ValidationRegex: "^(VC)?[0-9]{4}$", TestData: { Valid: ["1234", "VC1234", "VC-1234"], Invalid: ["VC123", "V1234", "VC-12345"] } }, Ug = { Description: "VE : NNNN, NNNN-A", RedundantCharacters: " -", ValidationRegex: "^[0-9]{4}[a-zA-Z]?$", TestData: { Valid: ["1234", "1234-A"], Invalid: ["123", "1234AA"] } }, $g = { Description: "VG : CCNNNN", RedundantCharacters: " -", ValidationRegex: "^(VG)?[0-9]{4}$", TestData: { Valid: ["1234", "VG1234", "VG-1234"], Invalid: ["VG123", "V1234", "VG-12345"] } }, zg = { Description: "WF : 986NN", RedundantCharacters: " -", ValidationRegex: "^986[0-9]{2}$", TestData: { Valid: ["98600", "98690"], Invalid: ["9862", "986999", "98990", "098690"] } }, qg = { Description: "WS : CCNNNNN", RedundantCharacters: " -", ValidationRegex: "^(WS)?[0-9]{4}$", TestData: { Valid: ["1234", "WS1234", "WS-1234"], Invalid: ["WS123", "V1234", "WS-12345"] } };
var ds, ps;
const Kg = Rm, Zg = Fm;
var hs = null;
hs = function() {
  if (ps)
    return ds;
  ps = 1;
  const t = {};
  return t["10Digits.json"] = jm, t["2Digits.json"] = Bm, t["3Digits.json"] = Gm, t["4Digits.json"] = Ym, t["5Digits.json"] = Vm, t["6Digits.json"] = Hm, t["7Digits.json"] = Um, t["8Digits.json"] = $m, t["AD.json"] = zm, t["AI.json"] = qm, t["AQ.json"] = Km, t["AX.json"] = Zm, t["AZ.json"] = Wm, t["BB.json"] = Jm, t["BH.json"] = Qm, t["BL.json"] = Xm, t["BN.json"] = eg, t["CA.json"] = tg, t["DK.json"] = ng, t["FK.json"] = ag, t["GB.json"] = rg, t["GF.json"] = ig, t["GG.json"] = og, t["GI.json"] = sg, t["GP.json"] = lg, t["GS.json"] = cg, t["HN.json"] = ug, t["IE.json"] = dg, t["IM.json"] = pg, t["IO.json"] = hg, t["JE.json"] = mg, t["KY.json"] = gg, t["LB.json"] = fg, t["LC.json"] = yg, t["LT.json"] = bg, t["LU.json"] = vg, t["LV.json"] = Sg, t["MC.json"] = Cg, t["MD.json"] = Mg, t["MF.json"] = Dg, t["MS.json"] = Ng, t["MT.json"] = Tg, t["NC.json"] = Eg, t["NL.json"] = wg, t["PF.json"] = _g, t["PL.json"] = xg, t["PM.json"] = kg, t["PN.json"] = Ag, t["PT.json"] = Lg, t["RE.json"] = Ig, t["RU.json"] = Pg, t["SH.json"] = Og, t["SM.json"] = Rg, t["SO.json"] = Fg, t["SZ.json"] = jg, t["TC.json"] = Bg, t["TW.json"] = Gg, t["US.json"] = Yg, t["VA.json"] = Vg, t["VC.json"] = Hg, t["VE.json"] = Ug, t["VG.json"] = $g, t["WF.json"] = zg, t["WS.json"] = qg, ds = function(e) {
    return t[e];
  };
}(), lc.validate = function(t, e) {
  if (!t)
    return "Missing country code.";
  if (!e)
    return "Missing postal code.";
  var n = void 0, a = t.trim().toUpperCase();
  if (a.length == 2 && (n = Kg[a]), a.length == 3 && (n = Zg[a]), !n)
    return "Unknown alpha2/alpha3 country code: " + a;
  if (!n.postalCodeFormat)
    return !0;
  var r = hs(n.postalCodeFormat);
  if (!r)
    return 'Failed to load postal code format "' + n.postalCodeFormat + '".';
  for (var i = e.toString().trim().slice(0), o = 0; o < r.RedundantCharacters.length; o++)
    i = i.replace(new RegExp(r.RedundantCharacters[o], "g"), "");
  var s = r.ValidationRegex;
  s instanceof Array && (s = "^" + s.join("|") + "$");
  var l = new RegExp(s, "i").exec(i);
  return l && l[0].toLowerCase() == i.toLowerCase() || "Postal code " + i + " is not valid for country " + a;
};
const Wg = { "PROMO-AT-DEV": ["AT", "GB", "ES", "IT", "BE", "NL", "FR", "PT", "DE", "IE", "DK", "GR", "SE", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-AT-PROD": ["AT", "GB", "ES", "IT", "BE", "NL", "FR", "PT", "DE", "IE", "DK", "GR", "SE", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-AU-DEV": ["AU", "NZ", "SG"], "PROMO-AU-PROD": ["AU", "NZ", "SG"], "PROMO-BE-DEV": ["BE", "GB", "FR", "DE", "ES", "AT", "DK", "NL", "SE", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-BE-PROD": ["BE", "GB", "FR", "DE", "ES", "AT", "DK", "NL", "SE", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-CA-DEV": ["CA"], "PROMO-CA-PROD": ["CA"], "PROMO-DE-DEV": ["DE", "GB", "ES", "IT", "BE", "NL", "FR", "PT", "AT", "IE", "DK", "GR", "SE", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-DE-PROD": ["DE", "GB", "ES", "IT", "BE", "NL", "FR", "PT", "AT", "IE", "DK", "GR", "SE", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-DK-DEV": ["DK", "GB", "FR", "DE", "ES", "AT", "NL", "BE", "SE", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-DK-PROD": ["DK", "GB", "FR", "DE", "ES", "AT", "NL", "BE", "SE", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-ES-DEV": ["ES", "GB", "FR", "DE", "AT", "NL", "BE", "SE", "DK", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-ES-PROD": ["ES", "GB", "FR", "DE", "AT", "NL", "BE", "SE", "DK", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-FR-DEV": ["FR", "GB", "ES", "IT", "BE", "NL", "AT", "PT", "DE", "IE", "DK", "GR", "SE", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-FR-PROD": ["FR", "GB", "ES", "IT", "BE", "NL", "AT", "PT", "DE", "IE", "DK", "GR", "SE", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-GB-DEV": ["GB", "IE", "ES", "IT", "BE", "DE", "FR", "PT", "AT", "DK", "SE", "GR", "NL", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-GB-PROD": ["GB", "IE", "ES", "IT", "BE", "DE", "FR", "PT", "AT", "DK", "SE", "GR", "NL", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-IE-DEV": ["IE", "GB", "FR", "DE", "AT", "NL", "BE", "SE", "DK", "ES", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-IE-PROD": ["IE", "GB", "FR", "DE", "AT", "NL", "BE", "SE", "DK", "ES", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-IN-DEV": ["IN"], "PROMO-IN-PROD": ["IN"], "PROMO-IT-DEV": ["IT", "GB", "FR", "DE", "AT", "NL", "BE", "SE", "DK", "ES", "IE", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-IT-PROD": ["IT", "GB", "FR", "DE", "AT", "NL", "BE", "SE", "DK", "ES", "IE", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-JP-DEV": ["JP"], "PROMO-JP-PROD": ["JP"], "PROMO-NL-DEV": ["NL", "GB", "FR", "DE", "ES", "AT", "DK", "BE", "SE", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-NL-PROD": ["NL", "GB", "FR", "DE", "ES", "AT", "DK", "BE", "SE", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-SE-DEV": ["SE", "GB", "FR", "DE", "ES", "AT", "NL", "BE", "DK", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-SE-PROD": ["SE", "GB", "FR", "DE", "ES", "AT", "NL", "BE", "DK", "IE", "IT", "PT", "GR", "CH", "CY", "CZ", "FI", "GI", "IS", "LI", "LU", "MC", "MT", "NO", "PL"], "PROMO-US-DEV": ["US", "CA"], "PROMO-US-PROD": ["US", "CA"], "VP-AT-DEV": ["AT", "DE", "CH", "LU", "LI", "BE", "CY", "CZ", "DK", "FI", "FR", "GI", "GR", "IS", "IE", "IT", "MT", "MC", "NL", "NO", "PL", "PT", "ES", "SE", "GB"], "VP-AT-MASK-DEV": ["AT"], "VP-AT-MASK-PROD": ["AT"], "VP-AT-PROD": ["AT", "DE", "CH", "LU", "LI", "BE", "CY", "CZ", "DK", "FI", "FR", "GI", "GR", "IS", "IE", "IT", "MT", "MC", "NL", "NO", "PL", "PT", "ES", "SE", "GB"], "VP-AU-DEV": ["AU"], "VP-AU-MASK-DEV": ["AU"], "VP-AU-MASK-PROD": ["AU"], "VP-AU-PROD": ["AU"], "VP-BE-DEV": ["BE", "NL", "DE", "ES", "IT", "FR", "PT", "GB", "IE", "AT", "LI", "MC", "CH", "NO", "DK", "SE", "FI", "PL", "GR", "CZ", "CY", "MT", "GI", "IS", "LU"], "VP-BE-MASK-DEV": ["BE"], "VP-BE-MASK-PROD": ["BE"], "VP-BE-PROD": ["BE", "NL", "DE", "ES", "IT", "FR", "PT", "GB", "IE", "AT", "LI", "MC", "CH", "NO", "DK", "SE", "FI", "PL", "GR", "CZ", "CY", "MT", "GI", "IS", "LU"], "VP-CA-DEV": ["CA", "US", "AT", "AU", "BE", "CH", "CZ", "DE", "DK", "ES", "FI", "FR", "GR", "IE", "IS", "IT", "NL", "NO", "NZ", "PL", "PT", "SE", "GB"], "VP-CA-MASK-DEV": ["CA"], "VP-CA-MASK-PROD": ["CA"], "VP-CA-PROD": ["CA", "US", "AT", "AU", "BE", "CH", "CZ", "DE", "DK", "ES", "FI", "FR", "GR", "IE", "IS", "IT", "NL", "NO", "NZ", "PL", "PT", "SE", "GB"], "VP-CH-DEV": ["CH", "AT", "DE", "LU", "LI", "BE", "CY", "CZ", "DK", "FI", "FR", "GI", "GR", "IS", "IE", "IT", "MT", "MC", "NL", "NO", "PL", "PT", "ES", "SE", "GB"], "VP-CH-MASK-DEV": ["CH"], "VP-CH-MASK-PROD": ["CH"], "VP-CH-PROD": ["CH", "AT", "DE", "LU", "LI", "BE", "CY", "CZ", "DK", "FI", "FR", "GI", "GR", "IS", "IE", "IT", "MT", "MC", "NL", "NO", "PL", "PT", "ES", "SE", "GB"], "VP-DE-DEV": ["DE", "AT", "CH", "LU", "LI", "BE", "CY", "CZ", "DK", "FI", "FR", "GI", "GR", "IS", "IE", "IT", "MT", "MC", "NL", "NO", "PL", "PT", "ES", "SE", "GB"], "VP-DE-MASK-DEV": ["DE"], "VP-DE-MASK-PROD": ["DE"], "VP-DE-PROD": ["DE", "AT", "CH", "LU", "LI", "BE", "CY", "CZ", "DK", "FI", "FR", "GI", "GR", "IS", "IE", "IT", "MT", "MC", "NL", "NO", "PL", "PT", "ES", "SE", "GB"], "VP-DK-DEV": ["DK", "AT", "BE", "CH", "CY", "CZ", "DE", "ES", "FI", "FR", "GB", "GI", "GR", "IE", "IS", "IT", "LI", "LU", "MC", "MT", "NL", "NO", "PL", "PT", "SE"], "VP-DK-MASK-DEV": ["DK"], "VP-DK-MASK-PROD": ["DK"], "VP-DK-PROD": ["DK", "AT", "BE", "CH", "CY", "CZ", "DE", "ES", "FI", "FR", "GB", "GI", "GR", "IE", "IS", "IT", "LI", "LU", "MC", "MT", "NL", "NO", "PL", "PT", "SE"], "VP-ES-DEV": ["ES", "BE", "DE", "IT", "FR", "PT", "GB", "IE", "LI", "MC", "CH", "NO", "NL", "DK", "SE", "FI", "PL", "GR", "CZ", "LU"], "VP-ES-MASK-DEV": ["ES"], "VP-ES-MASK-PROD": ["ES"], "VP-ES-PROD": ["ES", "BE", "DE", "IT", "FR", "PT", "GB", "IE", "LI", "MC", "CH", "NO", "NL", "DK", "SE", "FI", "PL", "GR", "CZ", "LU"], "VP-FI-DEV": ["FI", "AT", "BE", "CH", "CY", "CZ", "DE", "DK", "ES", "FR", "GB", "GI", "GR", "IE", "IS", "IT", "LI", "LU", "MC", "MT", "NL", "NO", "PL", "PT", "SE"], "VP-FI-MASK-DEV": ["FI"], "VP-FI-MASK-PROD": ["FI"], "VP-FI-PROD": ["FI", "AT", "BE", "CH", "CY", "CZ", "DE", "DK", "ES", "FR", "GB", "GI", "GR", "IE", "IS", "IT", "LI", "LU", "MC", "MT", "NL", "NO", "PL", "PT", "SE"], "VP-FR-DEV": ["FR", "AT", "CH", "LU", "LI", "BE", "CY", "CZ", "DE", "DK", "FI", "GI", "GP", "GR", "IS", "IE", "IT", "MF", "MT", "MC", "MQ", "NC", "NL", "NO", "PF", "PL", "PT", "RE", "ES", "SE", "GB"], "VP-FR-MASK-DEV": ["FR"], "VP-FR-MASK-PROD": ["FR"], "VP-FR-PROD": ["FR", "AT", "CH", "LU", "LI", "BE", "CY", "CZ", "DE", "DK", "FI", "GI", "GP", "GR", "IS", "IE", "IT", "MF", "MT", "MC", "MQ", "NC", "NL", "NO", "PF", "PL", "PT", "RE", "ES", "SE", "GB"], "VP-GB-DEV": ["GB", "BE", "ES", "DE", "IT", "FR", "PT", "IE", "LI", "MC", "CH", "NO", "NL", "DK", "SE", "FI", "PL", "GR", "CZ", "LU", "CY", "GI", "AT", "IS", "MT"], "VP-GB-MASK-DEV": ["GB", "CZ"], "VP-GB-MASK-PROD": ["GB", "CZ"], "VP-GB-PROD": ["GB", "BE", "ES", "DE", "IT", "FR", "PT", "IE", "LI", "MC", "CH", "NO", "NL", "DK", "SE", "FI", "PL", "GR", "CZ", "LU", "CY", "GI", "AT", "IS", "MT"], "VP-IE-DEV": ["IE", "GB", "IS", "MT", "GI", "CY", "AT", "BE", "CZ", "DK", "FI", "FR", "DE", "GR", "IT", "LI", "LU", "MC", "NL", "NO", "PL", "PT", "ES", "SE", "CH"], "VP-IE-MASK-DEV": ["IE"], "VP-IE-MASK-PROD": ["IE"], "VP-IE-PROD": ["IE", "GB", "IS", "MT", "GI", "CY", "AT", "BE", "CZ", "DK", "FI", "FR", "DE", "GR", "IT", "LI", "LU", "MC", "NL", "NO", "PL", "PT", "ES", "SE", "CH"], "VP-IN-DEV": ["IN"], "VP-IN-PROD": ["IN"], "VP-IT-DEV": ["IT", "BE", "DE", "ES", "FR", "PT", "GB", "IE", "AT", "LI", "MC", "CH", "NO", "NL", "DK", "SE", "FI", "PL", "GR", "CZ"], "VP-IT-MASK-DEV": ["IT"], "VP-IT-MASK-PROD": ["IT"], "VP-IT-PROD": ["IT", "BE", "DE", "ES", "FR", "PT", "GB", "IE", "AT", "LI", "MC", "CH", "NO", "NL", "DK", "SE", "FI", "PL", "GR", "CZ"], "VP-JP-DEV": ["JP"], "VP-JP-MASK-DEV": ["JP"], "VP-JP-MASK-PROD": ["JP"], "VP-JP-PROD": ["JP"], "VP-NL-DEV": ["NL", "BE", "DE", "ES", "IT", "FR", "PT", "GB", "IE", "AT", "LI", "MC", "CH", "NO", "DK", "SE", "FI", "PL", "GR", "CZ", "CY", "MT", "GI", "IS", "LU"], "VP-NL-MASK-DEV": ["NL"], "VP-NL-MASK-PROD": ["NL"], "VP-NL-PROD": ["NL", "BE", "DE", "ES", "IT", "FR", "PT", "GB", "IE", "AT", "LI", "MC", "CH", "NO", "DK", "SE", "FI", "PL", "GR", "CZ", "CY", "MT", "GI", "IS", "LU"], "VP-NO-DEV": ["NO", "AT", "BE", "CH", "CY", "CZ", "DE", "DK", "ES", "FI", "FR", "GB", "GI", "GR", "IE", "IS", "IT", "LI", "LU", "MC", "MT", "NL", "PL", "PT", "SE"], "VP-NO-MASK-DEV": ["NO"], "VP-NO-MASK-PROD": ["NO"], "VP-NO-PROD": ["NO", "AT", "BE", "CH", "CY", "CZ", "DE", "DK", "ES", "FI", "FR", "GB", "GI", "GR", "IE", "IS", "IT", "LI", "LU", "MC", "MT", "NL", "PL", "PT", "SE"], "VP-NZ-DEV": ["NZ"], "VP-NZ-PROD": ["NZ"], "VP-PT-DEV": ["PT", "BE", "DE", "ES", "FR", "IT", "GB", "IE", "LI", "MC", "CH", "NO", "NL", "DK", "SE", "FI", "PL", "GR", "CZ", "LU"], "VP-PT-MASK-DEV": ["PT"], "VP-PT-MASK-PROD": ["PT"], "VP-PT-PROD": ["PT", "BE", "DE", "ES", "FR", "IT", "GB", "IE", "LI", "MC", "CH", "NO", "NL", "DK", "SE", "FI", "PL", "GR", "CZ", "LU"], "VP-SE-DEV": ["SE", "AT", "BE", "CH", "CY", "CZ", "DE", "DK", "ES", "FI", "FR", "GB", "GI", "GR", "IE", "IS", "IT", "LI", "LU", "MC", "MT", "NL", "NO", "PL", "PT"], "VP-SE-MASK-DEV": ["SE"], "VP-SE-MASK-PROD": ["SE"], "VP-SE-PROD": ["SE", "AT", "BE", "CH", "CY", "CZ", "DE", "DK", "ES", "FI", "FR", "GB", "GI", "GR", "IE", "IS", "IT", "LI", "LU", "MC", "MT", "NL", "NO", "PL", "PT"], "VP-SG-DEV": ["SG", "AU", "NZ"], "VP-SG-PROD": ["SG", "AU", "NZ"], "VP-US-DEV": ["US", "CA", "AT", "AU", "BE", "CH", "CZ", "DE", "DK", "ES", "FI", "FR", "GR", "IE", "IS", "IT", "NL", "NO", "NZ", "PL", "PT", "SE", "GB"], "VP-US-MASK-DEV": ["US"], "VP-US-MASK-PROD": ["US"], "VP-US-PAYPAL-DEV": ["US"], "VP-US-PAYPAL-PROD": ["US"], "VP-US-PROD": ["US", "CA", "AT", "AU", "BE", "CH", "CZ", "DE", "DK", "ES", "FI", "FR", "GR", "IE", "IS", "IT", "NL", "NO", "NZ", "PL", "PT", "SE", "GB"] }, Jg = ue(() => {
  const t = sc(), e = G((O) => O.shippingOptionsWithPricing), n = G((O) => O.userConfiguration), a = G((O) => O.tenantConfiguration.tenantId), r = $e(), i = cn(), { t: o } = aa(), s = ra(), l = r.getText("shippingCalculatorCountryLabel"), u = r.getText("shippingCalculatorPostalCodeLabel"), c = r.getText("shippingCalculatorPostalCodeValidationErrorMessage"), d = r.getText("shippingCalculatorApplyCtaText"), [p, g] = ne(n?.postalCode || ""), [f, h] = ne(n?.country || "us");
  Q(() => {
    g(n?.postalCode || ""), h(n?.country || "us");
  }, [n?.postalCode, n?.country]);
  const [D, L] = ne(!0), _ = G((O) => O.shippingOptionsWithPricing.selectedShippingOption), x = G((O) => O.shippingOptionsWithPricing.error), T = Ye(() => (Wg[a] || []).sort(), [a]), b = _?.shippingDiscountedPrice.untaxed, S = _?.promisedArrivalDate, w = _?.shippingDisplayText.name, E = Te(() => {
    if (p != n?.postalCode || f != n?.country) {
      const O = Vr(e.currency, b, w, S, f);
      i.trackShippingCalculatorEvent(xt.ShippingOptionsEngaged, O, "Edit:Zip Code");
    }
  }, [f, p, i, n?.country, n?.postalCode, b, S, e.currency, w]), k = Te(() => {
    if (!p)
      return;
    const O = lc.validate(f, p.toString());
    typeof O == "boolean" && O ? (L(!0), s(Pd()), s(Et({ postalCode: p })), Gr({ country: f, postalCode: p }), t({ country: f, postalCode: p }), E()) : L(!1);
  }, [f, t, p, E, s]);
  return oe(Sc, { skin: "tight", children: [N(di, { children: N(pi, { children: oe(Cc, { fullWidth: !0, children: [N(Mc, { value: f, onChange: (O) => {
    const $ = O.target.value;
    h($), s(Et({ country: $ })), s(oo());
  }, fullWidth: !0, children: T.map((O) => N(Dc, { value: O, children: o(`country-localization-map.${O}`) }, O)) }), N(Nc, { children: l })] }) }) }), oe($t, { flexWrap: "nowrap", justifyContent: "space-between", mt: 4, children: [N(di, { className: "flex-input-text-button flex-input-margin-right", children: oe(pi, { children: [oe(Tc, { mr: "to-actions", children: [N(Ec, { width: "fullWidth", "aria-label": u, value: p, onChange: (O) => {
    g(O.target.value), s(oo());
  } }), N(wc, { children: u })] }), !D && N(hi, { children: c }), x.isError && x.errorReason === jr.NOT_DELIVERABLE && N(hi, { children: r.getTokenizedShippingOptionsNoDeliveryMessage((p ?? "").toString()) })] }) }), N("div", { className: "flex-input-text-button", children: N(_c, { skin: "primary", onClick: k, width: "full-width", children: d }) })] })] });
}), Qg = ({ locale: t, currency: e, fractionDigits: n, vatInclusivity: a, hideVatMessage: r, shippingDiscountedPrice: i, shippingListPrice: o }) => {
  const s = G((d) => d.tenantConfiguration.tenant), l = a ? "taxed" : "untaxed", [u, c] = ne();
  return Q(() => {
    Yr(s, t, a, n, e, r, o, i).then((d) => {
      c(d);
    });
  }, [e, n, r, t, i, o, l, s, a]), u ? N(xr, { children: N(ft, { component: "span", content: u }) }) : N(se, {});
}, Xg = [F.enIN], ef = ({ shippingOption: t }) => {
  const e = $e(), n = G((d) => d.tenantConfiguration.locale), a = G((d) => d.tenantConfiguration.tenant), r = G((d) => d.userConfiguration.vatInclusivity), i = G((d) => d.shippingOptionsWithPricing), o = e.getText("shippingCalculatorFreeShippingQualifiedLabel"), [s, l] = ne(), u = qs(i.shippingOptions), c = sn() && n === F.enAU;
  return Q(() => {
    if (i.currency && i.fractionDigits && t.freeShippingDetails) {
      const d = { taxed: t.freeShippingDetails.orderThreshold, untaxed: t.freeShippingDetails.orderThreshold, taxedInCents: t.freeShippingDetails.orderThresholdInCents, untaxedInCents: t.freeShippingDetails.orderThresholdInCents };
      Yr(a, n, t.freeShippingDetails.includesTax, i.fractionDigits, i.currency, !1, d).then((p) => {
        l(e.getTokenizedFreeShippingOptionItemText(p));
      });
    }
  }, [n, t, e, i.currency, a, r, i.fractionDigits, c, u?.shippingMethodId]), function(d) {
    return Xg.includes(d);
  }(n) ? N(se, {}) : t.shippingDiscountedPrice.taxed === 0 ? N(ms, { typographyContent: o }) : N(se, { children: s && N(ms, { typographyContent: s }) });
}, ms = ({ typographyContent: t }) => N(De, { fontSkin: "body-small", component: "span", fontWeight: "normal", textAlign: "left", className: "shipping-calculator-option-item-free-messaging", children: N(ft, { component: "span", content: t }) }), tf = ue(({ shippingOption: t }) => {
  const e = G((l) => l.shippingOptionsWithPricing), n = G((l) => l.tenantConfiguration.locale), a = G((l) => l.userConfiguration.vatInclusivity), r = $e(), i = gs(), o = r.getTokenizedDeliveryDateText(t.promisedArrivalDate), s = t.shippingDisplayText.values.find((l) => l.locale.toLowerCase() === n.toLowerCase())?.name;
  return s && e.fractionDigits && e.currency ? oe($t, { justifyContent: "space-between", flexDirection: i === "xs" ? "column" : "row", children: [oe(de, { marginRight: 2, children: [N(De, { fontSkin: "body-standard-bold", noWrap: !0, children: `${s}: ${o}` }), N($t, { children: N(ef, { shippingOption: t }) })] }), N(de, { children: N(De, { fontSkin: "body-standard-bold", component: "div", textAlign: i === "xs" ? "left" : "right", children: N(Qg, { shippingListPrice: t.shippingListPrice, shippingDiscountedPrice: t.shippingDiscountedPrice, freeShippingDetails: t.freeShippingDetails, fractionDigits: e.fractionDigits, locale: n, vatInclusivity: a ?? !1, currency: e.currency, hideVatMessage: t.shippingDiscountedPrice.taxed === 0 }) }) })] }) : N(se, {});
}), nf = ue(({ onSelectShippingOption: t }) => {
  const e = ra(), n = G((h) => h.shippingOptionsWithPricing), a = G((h) => h.productConfiguration.productKey), r = G((h) => h.userConfiguration.postalCode), i = G((h) => h.userConfiguration.country), o = $e(), s = cn(), l = o.getText("shippingCalculatorLoaderText"), u = o.getText("shippingCalculatorDeliveryOptionsTitleLabel"), c = o.getText("shippingCalculatorEstimatedDeliveryTitleLabel"), d = Te((h, D, L) => {
    const _ = Vr(n.currency, h, D, L, i);
    s.trackShippingCalculatorEvent(xt.ShippingOptionsEngaged, _, "Edit:Delivery Option");
  }, [s, i, n.currency]), p = Te((h) => {
    if (h) {
      const D = n?.shippingOptions.find((L) => L.shippingMethodId === h);
      D && (e(nl(D)), t?.(), d(D.shippingDiscountedPrice.untaxed, D.shippingDisplayText.name, D.promisedArrivalDate));
    }
  }, [e, t, n?.shippingOptions, d]), g = Ye(() => {
    if (n?.isLoading)
      return N(de, { mb: 2, className: "shipping-calculator-options-loader", children: N($t, { justifyContent: "center", children: N(xc, { accessibleText: l, showText: !0, size: "super", className: "shipping-calculator-spinner" }) }) });
    if (!r)
      return N(se, {});
    if (n && n.shippingOptions.length <= 0) {
      const h = o.getTokenizedShippingOptionsNotFoundMessage(r);
      return N(De, { component: "div", fontSize: "xsmall", children: oe($t, { alignItems: "center", children: [N(fs, { skin: "standard", iconType: "info", mr: 1, size: "20p" }), N("span", { children: h })] }) });
    }
    return N(kc, { variant: "single-select", onSelectedValueChange: p, selectedValue: n?.selectedShippingOption?.shippingMethodId, defaultSelectedValue: n?.selectedShippingOption?.shippingMethodId, children: n?.shippingOptions && n.shippingOptions.map((h) => N(Ac, { value: h.shippingMethodId, children: N(Lc, { children: N(tf, { shippingOption: h }) }) }, `${a}-${h.shippingMethodId}`)) });
  }, [n, p, l, o, r, a]), f = sn();
  return oe(se, { children: [N(de, { mb: 4, children: N(De, { fontSkin: "body-small", children: f ? c : u }) }), g] });
}), af = ue(({ onSelectShippingOption: t }) => {
  const e = G((n) => n.userConfiguration.postalCode);
  return G((n) => n.shippingOptionsWithPricing.isInitialized) ? oe(de, { className: "shipping-calculator-content-container", children: [N(Om, {}), N(de, { mt: "between-subsections", children: N(Jg, {}) }), N(de, { mt: "between-subsections", children: e && N(nf, { onSelectShippingOption: t }) })] }) : N(be, {});
}), rf = ({ isDrawer: t, isModalOpen: e, onModalToggle: n, children: a }) => {
  const r = $e(), i = r.getText("shippingCalculatorCloseModalAriaLabel"), o = r.getText("shippingCalculatorContentAriaLabel"), s = r.getText("shippingCalculatorTitleLabel"), l = (u) => () => {
    n(u);
  };
  return oe(se, { children: [N(de, { component: "span", onClick: l(!0), children: a }), N(Nr, { variant: t ? "panel-bottom" : void 0, bodyWidth: t ? "capped" : void 0, isOpen: e, onRequestDismiss: l(!1), children: oe(Tr, { "aria-label": o, children: [N(Er, { children: N(wr, { visuallyHiddenLabel: i }) }), N(Ic, { children: N(Pc, { children: s }) }), N(_r, { children: N(af, { onSelectShippingOption: () => {
    l(!1)();
  } }) })] }) })] });
}, of = ue(() => {
  const [t, e] = ne(!1), n = (a) => {
    e(a);
  };
  return G((a) => a.shippingOptionsWithPricing.isInitialized) ? N(rf, { isDrawer: !1, isModalOpen: t, onModalToggle: n, children: N(Pm, {}) }) : N(be, { lines: 2 });
}), sf = ue(() => {
  const t = G((o) => o.shippingOptionsWithPricing.error.isError), e = G((o) => o.shippingOptionsWithPricing.error.errorReason), n = G((o) => o.shippingOptionsWithPricing.isInitialized), a = G((o) => o.productConfiguration.productQuantity), r = G((o) => o.productConfiguration.productSelections), i = sc();
  return Q(() => {
    a && i({});
  }, [i, a, r]), t && e !== jr.NOT_DELIVERABLE ? N(oc, {}) : n ? N(de, { className: "shipping-calculator-container", marginTop: 1, children: N(De, { component: "div", fontSkin: "body-standard", children: N(of, {}) }) }) : N(be, { lines: 2 });
}), ci = (t) => {
  const { i18n: e, ready: n } = aa(), [a, r] = ne(!1);
  return Q(() => {
    n && (t !== e.language && e.changeLanguage(t), r(!0));
  }, [e, t, n]), a;
}, ui = ({ clientConfiguration: t, productConfiguration: e, tenantConfiguration: n, userConfiguration: a, trackingData: r }) => {
  const i = ra(), o = (() => {
    const { t: s, i18n: l } = aa(), u = Ir();
    return Te(() => {
      const d = Ys.reduce((p, g) => ({ ...p, [g]: s(md[g]) }), {});
      u(Ed(d));
    }, [u, s, l.language]);
  })();
  Q(() => {
    const s = new Vc.WebAuth();
    s.onUserIdentityUpdate(() => {
      const l = s.getAuthorization(), u = { authHeader: s.getAuthorizationHeader(), token: l.token, tokenType: l.type };
      i(Md(u));
    });
  }, [i]), Q(() => {
    t && i(Nd(t));
  }, [t, i]), Q(() => {
    e && i(_d(e));
  }, [i, e]), Q(() => {
    n && i(Rd(n));
  }, [i, n]), Q(() => {
    a && (Gr({ country: a.country, postalCode: a.postalCode }), i(Et(a)));
  }, [i, a]), Q(() => {
    o();
  }, [o]), Q(() => {
    r && i(jd(r));
  }, [i, r]);
}, lf = ue(({ children: t, initialConfigurationState: e }) => {
  const n = ci(e.tenantConfiguration.locale), a = G((r) => r.authConfiguration);
  return ui(e), n && a ? N(se, { children: t }) : N(be, { lines: 2 });
}, Cs), cf = ({ tenantConfiguration: t, developmentMode: e }) => {
  const n = sn();
  dd(t.tenant, t.locale, e), (() => {
    const r = Gd;
    typeof window > "u" || window.SHIPPING_CALCULATOR_VERSION || (window.SHIPPING_CALCULATOR_VERSION = r);
  })();
  const a = !Fu.includes(t.locale) || n;
  return N(a ? sf : oc, {});
}, Df = ue(({ clientConfiguration: t, productConfiguration: e, tenantConfiguration: n, userConfiguration: a, trackingData: r, developmentMode: i }) => N(Rr, { fallbackUi: N(se, {}), children: N(Or, { children: N(Ar, { store: Hr, children: N(lf, { initialConfigurationState: { clientConfiguration: t, productConfiguration: e, tenantConfiguration: n, userConfiguration: a, trackingData: r }, children: N(Cd, { children: N(Zs, { children: N(Bu, { loadingComponent: N(be, { lines: 2 }), children: N(hd, { children: N(cf, { clientConfiguration: t, productConfiguration: e, tenantConfiguration: n, userConfiguration: a, trackingData: r, developmentMode: i }) }) }) }) }) }) }) }) }), Cs), cc = _t(void 0), uc = ({ children: t }) => {
  const [e, n] = ne({}), a = Te(async (r, i, o) => {
    const s = `${r}-${i}-${o}`;
    if (e[s])
      return e[s];
    const l = await (async (u) => {
      const c = encodeURI(u.entryId), d = await fetch(`${rc}/${u.tenant}/types/${u.type}/entries/${c}?requestor=shipping-calculator`), p = await d.json();
      if (!d.ok)
        throw new Error(`Failed to fetch entry: ${d.status} ${p.message}`);
      return p;
    })({ entryId: r, tenant: o, type: i });
    return n((u) => ({ ...u, [s]: l })), l;
  }, [e]);
  return N(cc.Provider, { value: { getEntryData: a }, children: t });
}, dc = () => {
  const t = on(cc);
  if (!t)
    throw new Error("useShippingInformationContext must be used within ShippingInformationProvider");
  return t;
}, uf = ue(({ children: t, initialConfigurationState: e }) => {
  const n = ci(e.tenantConfiguration.locale);
  return ui(e), n ? N(se, { children: t }) : N(be, {});
}), pc = "ShippingFAQPage", hc = "pageStatic", mc = ue(({ isSmallerTitle: t }) => {
  const e = G((l) => l.tenantConfiguration.tenant), { getEntryData: n } = dc(), a = Pr((l) => l.tenantConfiguration.locale), [r, i] = ne();
  Q(() => {
    (async () => {
      const l = await n(pc, hc, e);
      i(l);
    })();
  }, [n, e]);
  const o = r?.[a], s = J.parse(o?.content ?? "", { async: !1 });
  return oe(se, { children: [N(t ? Oc : Rc, { children: o?.title }), N(De, { fontSkin: "body-small", children: N(xr, { children: N(ft, { component: "span", content: s }) }) })] });
}), df = ue(({ dialogOpen: t, displaySmallerTitle: e, onChangeDialogOpen: n }) => {
  const { dictionaryEntry: a } = ta("Product Page > Dismiss Alert");
  return N(Nr, { isOpen: t, onRequestDismiss: () => {
    n(!1);
  }, variant: "panel-right", children: oe(Tr, { pb: 8, children: [N(Er, { children: N(wr, { visuallyHiddenLabel: a }) }), N(_r, { children: N(mc, { isSmallerTitle: e }) })] }) });
}), pf = ({ shippingInfoText: t, displaySmallerTitle: e }) => {
  const { t: n } = aa(), a = G((f) => f.tenantConfiguration.tenant), [r, i] = ne(!1), { getEntryData: o } = dc(), [s, l] = ne(), [u, c] = ne(!1), d = (f) => i(f), p = Pr((f) => f.tenantConfiguration.locale);
  Q(() => {
    (async () => {
      const f = await o(pc, hc, a);
      l(f);
      const h = !!(f && f[p]);
      c(h);
    })();
  }, [a, o, s, p]);
  const g = n("shipping-information.shipping-information-button-text");
  return N(se, { children: u && oe(Zs, { children: [N(Je, { type: "button", role: "button", onClick: () => d(!0), children: N(De, { fontSize: "small", children: t || g }) }), N(df, { dialogOpen: r, displaySmallerTitle: e, onChangeDialogOpen: d })] }) });
}, Nf = ({ shippingInfoText: t, displaySmallerTitle: e, tenantConfiguration: n, clientConfiguration: a }) => N(Rr, { fallbackUi: N(se, {}), children: N(Or, { children: N(Ar, { store: Hr, children: N(uf, { initialConfigurationState: { clientConfiguration: a, tenantConfiguration: n }, children: N(uc, { children: N(pf, { shippingInfoText: t, displaySmallerTitle: e }) }) }) }) }) }), hf = ue(({ children: t, initialConfigurationState: e }) => {
  const n = ci(e.tenantConfiguration.locale);
  return ui(e), n ? N(se, { children: t }) : N(be, {});
}), Tf = ({ displaySmallerTitle: t, clientConfiguration: e, tenantConfiguration: n }) => N(Rr, { fallbackUi: N(se, {}), children: N(Or, { children: N(Ar, { store: Hr, children: N(uc, { children: N(hf, { initialConfigurationState: { clientConfiguration: e, tenantConfiguration: n }, children: N(mc, { isSmallerTitle: t }) }) }) }) }) });
export {
  F as Locale,
  Ve as RequestorId,
  Mf as SWAN_STYLE_KEYS,
  Df as ShippingCalculator,
  Nf as ShippingInformation,
  Tf as ShippingInformationContent,
  Df as default,
  km as getShippingOptionsWithPricing
};
